var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/utils/defaultMessageBox.ts
var closeIcon;
if (typeof window !== "undefined") {
  closeIcon = document.createElement("div");
  closeIcon.setAttribute("id", "ms-status-close");
  closeIcon.setAttribute("data-ms-message-close", "");
  closeIcon.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="white"/></svg>`;
}
var addSuccessBox = () => {
  const successStatusIcon = document.createElement("div");
  successStatusIcon.setAttribute("id", "ms-status-icon");
  successStatusIcon.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="10" fill="#62d37f"/><path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm4.59-12.42L8 12.17 5.41 9.59 4 11l4 4 8-8-1.41-1.42Z" fill="#fff"/></svg>`;
  const successHTML = `<div data-ms-message class="ms-error-message">
		${successStatusIcon.outerHTML}
		<div id="ms-message" data-ms-message-text></div>
		${closeIcon.outerHTML}
		</div>`;
  const successdiv = document.createElement("div");
  successdiv.setAttribute("data-ms-message", "success");
  successdiv.innerHTML = successHTML;
  successdiv.style.display = "none";
  document.body.appendChild(successdiv);
};
var addErrorBox = () => {
  const errorStatusIcon = document.createElement("div");
  errorStatusIcon.setAttribute("id", "ms-status-icon");
  errorStatusIcon.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="#E40023"/></svg>`;
  const errorHTML = `<div data-ms-message class="ms-error-message">
		${errorStatusIcon.outerHTML}
		<div id="ms-message" data-ms-message-text></div>
		${closeIcon.outerHTML}
		</div>`;
  const errordiv = document.createElement("div");
  errordiv.setAttribute("data-ms-message", "error");
  errordiv.innerHTML = errorHTML;
  errordiv.style.display = "none";
  document.body.appendChild(errordiv);
};
var initCSS = () => {
  const cssEl = document.createElement("style");
  const css = `
		@keyframes fadeIn {
			0% {
				opacity: 0;
			}
			100% {
				opacity: 1;
			}
		}
		.ms-error-message { 
				position: fixed;
				left: 50%;
				bottom: 3%;
				transform: translate(-50%, -50%);
				margin: 0 auto;
				z-index: 10000000; 
				display: flex; 
				align-items: center;
				padding: 12px 16px;
				border-radius: 8px; 
				background-color: #0A0A0A; 
				color: #fff; 
				font-size: 16.8px; 
				line-height: 28px; 
				font-weight: 500; 
				transform-origin: center;
				animation: fadeIn 0.2s ease-in;
				-webkit-animation: fadeIn 0.2s ease-in;
				-moz-animation: fadeIn 0.2s ease-in;
				-o-animation: fadeIn 0.2s ease-in;
				-ms-animation: fadeIn 0.2s ease-in;
			}
			#ms-status-icon {
				width: 20px;
				height: 20px;
				margin-right: 12px;
				}
				#ms-status-close {
					margin-left: 20px;
					cursor: pointer;
					}
					#ms-status-close svg {
						height: 12px;
					}`;
  cssEl.setAttribute("data-ms-style", "");
  cssEl.appendChild(document.createTextNode(css));
  document.head.appendChild(cssEl);
};

// src/methods/dom/main-dom.js
function noop() {
}
var identity = (x) => x;
function assign(tar, src) {
  for (const k in src)
    tar[k] = src[k];
  return tar;
}
function is_promise(value) {
  return !!value && (typeof value === "object" || typeof value === "function") && typeof value.then === "function";
}
function run(fn) {
  return fn();
}
function blank_object() {
  return /* @__PURE__ */ Object.create(null);
}
function run_all(fns) {
  fns.forEach(run);
}
function is_function(thing) {
  return typeof thing === "function";
}
function safe_not_equal(a, b) {
  return a != a ? b == b : a !== b || (a && typeof a === "object" || typeof a === "function");
}
var src_url_equal_anchor;
function src_url_equal(element_src, url) {
  if (!src_url_equal_anchor) {
    src_url_equal_anchor = document.createElement("a");
  }
  src_url_equal_anchor.href = url;
  return element_src === src_url_equal_anchor.href;
}
function is_empty(obj) {
  return Object.keys(obj).length === 0;
}
function subscribe(store, ...callbacks) {
  if (store == null) {
    return noop;
  }
  const unsub = store.subscribe(...callbacks);
  return unsub.unsubscribe ? () => unsub.unsubscribe() : unsub;
}
function get_store_value(store) {
  let value;
  subscribe(store, (_) => value = _)();
  return value;
}
function component_subscribe(component, store, callback) {
  component.$$.on_destroy.push(subscribe(store, callback));
}
function create_slot(definition, ctx, $$scope, fn) {
  if (definition) {
    const slot_ctx = get_slot_context(definition, ctx, $$scope, fn);
    return definition[0](slot_ctx);
  }
}
function get_slot_context(definition, ctx, $$scope, fn) {
  return definition[1] && fn ? assign($$scope.ctx.slice(), definition[1](fn(ctx))) : $$scope.ctx;
}
function get_slot_changes(definition, $$scope, dirty, fn) {
  if (definition[2] && fn) {
    const lets = definition[2](fn(dirty));
    if ($$scope.dirty === void 0) {
      return lets;
    }
    if (typeof lets === "object") {
      const merged = [];
      const len = Math.max($$scope.dirty.length, lets.length);
      for (let i = 0; i < len; i += 1) {
        merged[i] = $$scope.dirty[i] | lets[i];
      }
      return merged;
    }
    return $$scope.dirty | lets;
  }
  return $$scope.dirty;
}
function update_slot_base(slot, slot_definition, ctx, $$scope, slot_changes, get_slot_context_fn) {
  if (slot_changes) {
    const slot_context = get_slot_context(slot_definition, ctx, $$scope, get_slot_context_fn);
    slot.p(slot_context, slot_changes);
  }
}
function get_all_dirty_from_scope($$scope) {
  if ($$scope.ctx.length > 32) {
    const dirty = [];
    const length = $$scope.ctx.length / 32;
    for (let i = 0; i < length; i++) {
      dirty[i] = -1;
    }
    return dirty;
  }
  return -1;
}
function exclude_internal_props(props) {
  const result = {};
  for (const k in props)
    if (k[0] !== "$")
      result[k] = props[k];
  return result;
}
function compute_rest_props(props, keys) {
  const rest = {};
  keys = new Set(keys);
  for (const k in props)
    if (!keys.has(k) && k[0] !== "$")
      rest[k] = props[k];
  return rest;
}
function null_to_empty(value) {
  return value == null ? "" : value;
}
var is_client = typeof window !== "undefined";
var now = is_client ? () => window.performance.now() : () => Date.now();
var raf = is_client ? (cb) => requestAnimationFrame(cb) : noop;
var tasks = /* @__PURE__ */ new Set();
function run_tasks(now2) {
  tasks.forEach((task) => {
    if (!task.c(now2)) {
      tasks.delete(task);
      task.f();
    }
  });
  if (tasks.size !== 0)
    raf(run_tasks);
}
function loop(callback) {
  let task;
  if (tasks.size === 0)
    raf(run_tasks);
  return {
    promise: new Promise((fulfill) => {
      tasks.add(task = { c: callback, f: fulfill });
    }),
    abort() {
      tasks.delete(task);
    }
  };
}
function append(target, node) {
  target.appendChild(node);
}
function append_styles(target, style_sheet_id, styles) {
  const append_styles_to = get_root_for_style(target);
  if (!append_styles_to.getElementById(style_sheet_id)) {
    const style = element("style");
    style.id = style_sheet_id;
    style.textContent = styles;
    append_stylesheet(append_styles_to, style);
  }
}
function get_root_for_style(node) {
  if (!node)
    return document;
  const root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
  if (root && root.host) {
    return root;
  }
  return node.ownerDocument;
}
function append_empty_stylesheet(node) {
  const style_element = element("style");
  append_stylesheet(get_root_for_style(node), style_element);
  return style_element.sheet;
}
function append_stylesheet(node, style) {
  append(node.head || node, style);
  return style.sheet;
}
function insert(target, node, anchor) {
  target.insertBefore(node, anchor || null);
}
function detach(node) {
  if (node.parentNode) {
    node.parentNode.removeChild(node);
  }
}
function destroy_each(iterations, detaching) {
  for (let i = 0; i < iterations.length; i += 1) {
    if (iterations[i])
      iterations[i].d(detaching);
  }
}
function element(name) {
  return document.createElement(name);
}
function svg_element(name) {
  return document.createElementNS("http://www.w3.org/2000/svg", name);
}
function text(data) {
  return document.createTextNode(data);
}
function space() {
  return text(" ");
}
function empty() {
  return text("");
}
function listen(node, event, handler, options) {
  node.addEventListener(event, handler, options);
  return () => node.removeEventListener(event, handler, options);
}
function prevent_default(fn) {
  return function(event) {
    event.preventDefault();
    return fn.call(this, event);
  };
}
function stop_propagation(fn) {
  return function(event) {
    event.stopPropagation();
    return fn.call(this, event);
  };
}
function attr(node, attribute, value) {
  if (value == null)
    node.removeAttribute(attribute);
  else if (node.getAttribute(attribute) !== value)
    node.setAttribute(attribute, value);
}
function children(element2) {
  return Array.from(element2.childNodes);
}
function set_data(text2, data) {
  data = "" + data;
  if (text2.data === data)
    return;
  text2.data = data;
}
function set_input_value(input, value) {
  input.value = value == null ? "" : value;
}
function set_style(node, key, value, important) {
  if (value == null) {
    node.style.removeProperty(key);
  } else {
    node.style.setProperty(key, value, important ? "important" : "");
  }
}
function toggle_class(element2, name, toggle) {
  element2.classList[toggle ? "add" : "remove"](name);
}
function custom_event(type, detail, { bubbles = false, cancelable = false } = {}) {
  const e = document.createEvent("CustomEvent");
  e.initCustomEvent(type, bubbles, cancelable, detail);
  return e;
}
var HtmlTag = class {
  constructor(is_svg = false) {
    this.is_svg = false;
    this.is_svg = is_svg;
    this.e = this.n = null;
  }
  c(html) {
    this.h(html);
  }
  m(html, target, anchor = null) {
    if (!this.e) {
      if (this.is_svg)
        this.e = svg_element(target.nodeName);
      else
        this.e = element(target.nodeType === 11 ? "TEMPLATE" : target.nodeName);
      this.t = target.tagName !== "TEMPLATE" ? target : target.content;
      this.c(html);
    }
    this.i(anchor);
  }
  h(html) {
    this.e.innerHTML = html;
    this.n = Array.from(this.e.nodeName === "TEMPLATE" ? this.e.content.childNodes : this.e.childNodes);
  }
  i(anchor) {
    for (let i = 0; i < this.n.length; i += 1) {
      insert(this.t, this.n[i], anchor);
    }
  }
  p(html) {
    this.d();
    this.h(html);
    this.i(this.a);
  }
  d() {
    this.n.forEach(detach);
  }
};
function construct_svelte_component(component, props) {
  return new component(props);
}
var managed_styles = /* @__PURE__ */ new Map();
var active = 0;
function hash(str) {
  let hash2 = 5381;
  let i = str.length;
  while (i--)
    hash2 = (hash2 << 5) - hash2 ^ str.charCodeAt(i);
  return hash2 >>> 0;
}
function create_style_information(doc, node) {
  const info = { stylesheet: append_empty_stylesheet(node), rules: {} };
  managed_styles.set(doc, info);
  return info;
}
function create_rule(node, a, b, duration, delay, ease, fn, uid = 0) {
  const step = 16.666 / duration;
  let keyframes = "{\n";
  for (let p = 0; p <= 1; p += step) {
    const t = a + (b - a) * ease(p);
    keyframes += p * 100 + `%{${fn(t, 1 - t)}}
`;
  }
  const rule = keyframes + `100% {${fn(b, 1 - b)}}
}`;
  const name = `__svelte_${hash(rule)}_${uid}`;
  const doc = get_root_for_style(node);
  const { stylesheet, rules } = managed_styles.get(doc) || create_style_information(doc, node);
  if (!rules[name]) {
    rules[name] = true;
    stylesheet.insertRule(`@keyframes ${name} ${rule}`, stylesheet.cssRules.length);
  }
  const animation = node.style.animation || "";
  node.style.animation = `${animation ? `${animation}, ` : ""}${name} ${duration}ms linear ${delay}ms 1 both`;
  active += 1;
  return name;
}
function delete_rule(node, name) {
  const previous = (node.style.animation || "").split(", ");
  const next = previous.filter(
    name ? (anim) => anim.indexOf(name) < 0 : (anim) => anim.indexOf("__svelte") === -1
    // remove all Svelte animations
  );
  const deleted = previous.length - next.length;
  if (deleted) {
    node.style.animation = next.join(", ");
    active -= deleted;
    if (!active)
      clear_rules();
  }
}
function clear_rules() {
  raf(() => {
    if (active)
      return;
    managed_styles.forEach((info) => {
      const { ownerNode } = info.stylesheet;
      if (ownerNode)
        detach(ownerNode);
    });
    managed_styles.clear();
  });
}
var current_component;
function set_current_component(component) {
  current_component = component;
}
function get_current_component() {
  if (!current_component)
    throw new Error("Function called outside component initialization");
  return current_component;
}
function onMount(fn) {
  get_current_component().$$.on_mount.push(fn);
}
function onDestroy(fn) {
  get_current_component().$$.on_destroy.push(fn);
}
var dirty_components = [];
var binding_callbacks = [];
var render_callbacks = [];
var flush_callbacks = [];
var resolved_promise = /* @__PURE__ */ Promise.resolve();
var update_scheduled = false;
function schedule_update() {
  if (!update_scheduled) {
    update_scheduled = true;
    resolved_promise.then(flush);
  }
}
function add_render_callback(fn) {
  render_callbacks.push(fn);
}
function add_flush_callback(fn) {
  flush_callbacks.push(fn);
}
var seen_callbacks = /* @__PURE__ */ new Set();
var flushidx = 0;
function flush() {
  if (flushidx !== 0) {
    return;
  }
  const saved_component = current_component;
  do {
    try {
      while (flushidx < dirty_components.length) {
        const component = dirty_components[flushidx];
        flushidx++;
        set_current_component(component);
        update(component.$$);
      }
    } catch (e) {
      dirty_components.length = 0;
      flushidx = 0;
      throw e;
    }
    set_current_component(null);
    dirty_components.length = 0;
    flushidx = 0;
    while (binding_callbacks.length)
      binding_callbacks.pop()();
    for (let i = 0; i < render_callbacks.length; i += 1) {
      const callback = render_callbacks[i];
      if (!seen_callbacks.has(callback)) {
        seen_callbacks.add(callback);
        callback();
      }
    }
    render_callbacks.length = 0;
  } while (dirty_components.length);
  while (flush_callbacks.length) {
    flush_callbacks.pop()();
  }
  update_scheduled = false;
  seen_callbacks.clear();
  set_current_component(saved_component);
}
function update($$) {
  if ($$.fragment !== null) {
    $$.update();
    run_all($$.before_update);
    const dirty = $$.dirty;
    $$.dirty = [-1];
    $$.fragment && $$.fragment.p($$.ctx, dirty);
    $$.after_update.forEach(add_render_callback);
  }
}
function flush_render_callbacks(fns) {
  const filtered = [];
  const targets = [];
  render_callbacks.forEach((c) => fns.indexOf(c) === -1 ? filtered.push(c) : targets.push(c));
  targets.forEach((c) => c());
  render_callbacks = filtered;
}
var promise;
function wait() {
  if (!promise) {
    promise = Promise.resolve();
    promise.then(() => {
      promise = null;
    });
  }
  return promise;
}
function dispatch(node, direction, kind) {
  node.dispatchEvent(custom_event(`${direction ? "intro" : "outro"}${kind}`));
}
var outroing = /* @__PURE__ */ new Set();
var outros;
function group_outros() {
  outros = {
    r: 0,
    c: [],
    p: outros
    // parent group
  };
}
function check_outros() {
  if (!outros.r) {
    run_all(outros.c);
  }
  outros = outros.p;
}
function transition_in(block, local) {
  if (block && block.i) {
    outroing.delete(block);
    block.i(local);
  }
}
function transition_out(block, local, detach2, callback) {
  if (block && block.o) {
    if (outroing.has(block))
      return;
    outroing.add(block);
    outros.c.push(() => {
      outroing.delete(block);
      if (callback) {
        if (detach2)
          block.d(1);
        callback();
      }
    });
    block.o(local);
  } else if (callback) {
    callback();
  }
}
var null_transition = { duration: 0 };
function create_bidirectional_transition(node, fn, params, intro) {
  const options = { direction: "both" };
  let config = fn(node, params, options);
  let t = intro ? 0 : 1;
  let running_program = null;
  let pending_program = null;
  let animation_name = null;
  function clear_animation() {
    if (animation_name)
      delete_rule(node, animation_name);
  }
  function init3(program, duration) {
    const d = program.b - t;
    duration *= Math.abs(d);
    return {
      a: t,
      b: program.b,
      d,
      duration,
      start: program.start,
      end: program.start + duration,
      group: program.group
    };
  }
  function go(b) {
    const { delay = 0, duration = 300, easing = identity, tick = noop, css } = config || null_transition;
    const program = {
      start: now() + delay,
      b
    };
    if (!b) {
      program.group = outros;
      outros.r += 1;
    }
    if (running_program || pending_program) {
      pending_program = program;
    } else {
      if (css) {
        clear_animation();
        animation_name = create_rule(node, t, b, duration, delay, easing, css);
      }
      if (b)
        tick(0, 1);
      running_program = init3(program, duration);
      add_render_callback(() => dispatch(node, b, "start"));
      loop((now2) => {
        if (pending_program && now2 > pending_program.start) {
          running_program = init3(pending_program, duration);
          pending_program = null;
          dispatch(node, running_program.b, "start");
          if (css) {
            clear_animation();
            animation_name = create_rule(node, t, running_program.b, running_program.duration, 0, easing, config.css);
          }
        }
        if (running_program) {
          if (now2 >= running_program.end) {
            tick(t = running_program.b, 1 - t);
            dispatch(node, running_program.b, "end");
            if (!pending_program) {
              if (running_program.b) {
                clear_animation();
              } else {
                if (!--running_program.group.r)
                  run_all(running_program.group.c);
              }
            }
            running_program = null;
          } else if (now2 >= running_program.start) {
            const p = now2 - running_program.start;
            t = running_program.a + running_program.d * easing(p / running_program.duration);
            tick(t, 1 - t);
          }
        }
        return !!(running_program || pending_program);
      });
    }
  }
  return {
    run(b) {
      if (is_function(config)) {
        wait().then(() => {
          config = config(options);
          go(b);
        });
      } else {
        go(b);
      }
    },
    end() {
      clear_animation();
      running_program = pending_program = null;
    }
  };
}
function handle_promise(promise2, info) {
  const token = info.token = {};
  function update2(type, index, key, value) {
    if (info.token !== token)
      return;
    info.resolved = value;
    let child_ctx = info.ctx;
    if (key !== void 0) {
      child_ctx = child_ctx.slice();
      child_ctx[key] = value;
    }
    const block = type && (info.current = type)(child_ctx);
    let needs_flush = false;
    if (info.block) {
      if (info.blocks) {
        info.blocks.forEach((block2, i) => {
          if (i !== index && block2) {
            group_outros();
            transition_out(block2, 1, 1, () => {
              if (info.blocks[i] === block2) {
                info.blocks[i] = null;
              }
            });
            check_outros();
          }
        });
      } else {
        info.block.d(1);
      }
      block.c();
      transition_in(block, 1);
      block.m(info.mount(), info.anchor);
      needs_flush = true;
    }
    info.block = block;
    if (info.blocks)
      info.blocks[index] = block;
    if (needs_flush) {
      flush();
    }
  }
  if (is_promise(promise2)) {
    const current_component2 = get_current_component();
    promise2.then((value) => {
      set_current_component(current_component2);
      update2(info.then, 1, info.value, value);
      set_current_component(null);
    }, (error) => {
      set_current_component(current_component2);
      update2(info.catch, 2, info.error, error);
      set_current_component(null);
      if (!info.hasCatch) {
        throw error;
      }
    });
    if (info.current !== info.pending) {
      update2(info.pending, 0);
      return true;
    }
  } else {
    if (info.current !== info.then) {
      update2(info.then, 1, info.value, promise2);
      return true;
    }
    info.resolved = promise2;
  }
}
function update_await_block_branch(info, ctx, dirty) {
  const child_ctx = ctx.slice();
  const { resolved } = info;
  if (info.current === info.then) {
    child_ctx[info.value] = resolved;
  }
  if (info.current === info.catch) {
    child_ctx[info.error] = resolved;
  }
  info.block.p(child_ctx, dirty);
}
function destroy_block(block, lookup) {
  block.d(1);
  lookup.delete(block.key);
}
function outro_and_destroy_block(block, lookup) {
  transition_out(block, 1, 1, () => {
    lookup.delete(block.key);
  });
}
function update_keyed_each(old_blocks, dirty, get_key, dynamic, ctx, list, lookup, node, destroy, create_each_block2, next, get_context) {
  let o = old_blocks.length;
  let n = list.length;
  let i = o;
  const old_indexes = {};
  while (i--)
    old_indexes[old_blocks[i].key] = i;
  const new_blocks = [];
  const new_lookup = /* @__PURE__ */ new Map();
  const deltas = /* @__PURE__ */ new Map();
  const updates = [];
  i = n;
  while (i--) {
    const child_ctx = get_context(ctx, list, i);
    const key = get_key(child_ctx);
    let block = lookup.get(key);
    if (!block) {
      block = create_each_block2(key, child_ctx);
      block.c();
    } else if (dynamic) {
      updates.push(() => block.p(child_ctx, dirty));
    }
    new_lookup.set(key, new_blocks[i] = block);
    if (key in old_indexes)
      deltas.set(key, Math.abs(i - old_indexes[key]));
  }
  const will_move = /* @__PURE__ */ new Set();
  const did_move = /* @__PURE__ */ new Set();
  function insert2(block) {
    transition_in(block, 1);
    block.m(node, next);
    lookup.set(block.key, block);
    next = block.first;
    n--;
  }
  while (o && n) {
    const new_block = new_blocks[n - 1];
    const old_block = old_blocks[o - 1];
    const new_key = new_block.key;
    const old_key = old_block.key;
    if (new_block === old_block) {
      next = new_block.first;
      o--;
      n--;
    } else if (!new_lookup.has(old_key)) {
      destroy(old_block, lookup);
      o--;
    } else if (!lookup.has(new_key) || will_move.has(new_key)) {
      insert2(new_block);
    } else if (did_move.has(old_key)) {
      o--;
    } else if (deltas.get(new_key) > deltas.get(old_key)) {
      did_move.add(new_key);
      insert2(new_block);
    } else {
      will_move.add(old_key);
      o--;
    }
  }
  while (o--) {
    const old_block = old_blocks[o];
    if (!new_lookup.has(old_block.key))
      destroy(old_block, lookup);
  }
  while (n)
    insert2(new_blocks[n - 1]);
  run_all(updates);
  return new_blocks;
}
function bind(component, name, callback) {
  const index = component.$$.props[name];
  if (index !== void 0) {
    component.$$.bound[index] = callback;
    callback(component.$$.ctx[index]);
  }
}
function create_component(block) {
  block && block.c();
}
function mount_component(component, target, anchor, customElement) {
  const { fragment, after_update } = component.$$;
  fragment && fragment.m(target, anchor);
  if (!customElement) {
    add_render_callback(() => {
      const new_on_destroy = component.$$.on_mount.map(run).filter(is_function);
      if (component.$$.on_destroy) {
        component.$$.on_destroy.push(...new_on_destroy);
      } else {
        run_all(new_on_destroy);
      }
      component.$$.on_mount = [];
    });
  }
  after_update.forEach(add_render_callback);
}
function destroy_component(component, detaching) {
  const $$ = component.$$;
  if ($$.fragment !== null) {
    flush_render_callbacks($$.after_update);
    run_all($$.on_destroy);
    $$.fragment && $$.fragment.d(detaching);
    $$.on_destroy = $$.fragment = null;
    $$.ctx = [];
  }
}
function make_dirty(component, i) {
  if (component.$$.dirty[0] === -1) {
    dirty_components.push(component);
    schedule_update();
    component.$$.dirty.fill(0);
  }
  component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}
function init(component, options, instance2, create_fragment2, not_equal, props, append_styles2, dirty = [-1]) {
  const parent_component = current_component;
  set_current_component(component);
  const $$ = component.$$ = {
    fragment: null,
    ctx: [],
    // state
    props,
    update: noop,
    not_equal,
    bound: blank_object(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
    // everything else
    callbacks: blank_object(),
    dirty,
    skip_bound: false,
    root: options.target || parent_component.$$.root
  };
  append_styles2 && append_styles2($$.root);
  let ready = false;
  $$.ctx = instance2 ? instance2(component, options.props || {}, (i, ret, ...rest) => {
    const value = rest.length ? rest[0] : ret;
    if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
      if (!$$.skip_bound && $$.bound[i])
        $$.bound[i](value);
      if (ready)
        make_dirty(component, i);
    }
    return ret;
  }) : [];
  $$.update();
  ready = true;
  run_all($$.before_update);
  $$.fragment = create_fragment2 ? create_fragment2($$.ctx) : false;
  if (options.target) {
    if (options.hydrate) {
      const nodes = children(options.target);
      $$.fragment && $$.fragment.l(nodes);
      nodes.forEach(detach);
    } else {
      $$.fragment && $$.fragment.c();
    }
    if (options.intro)
      transition_in(component.$$.fragment);
    mount_component(component, options.target, options.anchor, options.customElement);
    flush();
  }
  set_current_component(parent_component);
}
var SvelteComponent = class {
  $destroy() {
    destroy_component(this, 1);
    this.$destroy = noop;
  }
  $on(type, callback) {
    if (!is_function(callback)) {
      return noop;
    }
    const callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
    callbacks.push(callback);
    return () => {
      const index = callbacks.indexOf(callback);
      if (index !== -1)
        callbacks.splice(index, 1);
    };
  }
  $set($$props) {
    if (this.$$set && !is_empty($$props)) {
      this.$$.skip_bound = true;
      this.$$set($$props);
      this.$$.skip_bound = false;
    }
  }
};
var subscriber_queue = [];
function writable(value, start = noop) {
  let stop;
  const subscribers = /* @__PURE__ */ new Set();
  function set(new_value) {
    if (safe_not_equal(value, new_value)) {
      value = new_value;
      if (stop) {
        const run_queue = !subscriber_queue.length;
        for (const subscriber of subscribers) {
          subscriber[1]();
          subscriber_queue.push(subscriber, value);
        }
        if (run_queue) {
          for (let i = 0; i < subscriber_queue.length; i += 2) {
            subscriber_queue[i][0](subscriber_queue[i + 1]);
          }
          subscriber_queue.length = 0;
        }
      }
    }
  }
  function update2(fn) {
    set(fn(value));
  }
  function subscribe2(run2, invalidate = noop) {
    const subscriber = [run2, invalidate];
    subscribers.add(subscriber);
    if (subscribers.size === 1) {
      stop = start(set) || noop;
    }
    run2(value);
    return () => {
      subscribers.delete(subscriber);
      if (subscribers.size === 0 && stop) {
        stop();
        stop = null;
      }
    };
  }
  return { set, update: update2, subscribe: subscribe2 };
}
var AppStore = writable({
  initialValue: true,
  customFields: [],
  isPaid: false,
  branding: {
    logo: "",
    colors: {
      lightMode: {}
    }
  },
  authProviders: [],
  additionalAuthMethods: {
    passwordless: {
      enabled: false,
      isDefault: false
    }
  }
});
var TextStore = writable({
  text: {
    // "login_to_your_account": "Login to your account (T)",
    // "dont_have_an_account": "Don't have an account? (T)",
    // "email_address": "Email Address (T)",
    // "email_error_message": "Please enter a valid email address (T)",
    // "password": "Password (T)",
    // "password_placeholder": "Enter password (T)",
    // "password_error_message": "Minimum 8 characters required (T)",
    // "forgot_password": "Forgot password? (T)",
    // "login": "Log in (T)",
    // "continue_with": "Continue with (T)",
    // "or": "or (T)",
    // "reset_your_password": "Reset your password (T)",
    // "reset_instructions": "We’ll email you a secure link to reset the password for your account. (T)",
    // "reset": "Send link (T)",
    // "reset_already_have_code": "I already have a code (T)",
    // "reset_enter_code": "Enter your 6-digit code (T)",
    // "reset_confirm_reset": "Confirm & Reset (T)",
  }
});
var get_default_slot_changes = (dirty) => ({ matches: dirty & /*matches*/
1 });
var get_default_slot_context = (ctx) => ({ matches: (
  /*matches*/
  ctx[0]
) });
function create_fragment$1n(ctx) {
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[4].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[3],
    get_default_slot_context
  );
  return {
    c() {
      if (default_slot)
        default_slot.c();
    },
    m(target, anchor) {
      if (default_slot) {
        default_slot.m(target, anchor);
      }
      current = true;
    },
    p(ctx2, [dirty]) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope, matches*/
        9)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[3],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[3]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[3],
              dirty,
              get_default_slot_changes
            ),
            get_default_slot_context
          );
        }
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (default_slot)
        default_slot.d(detaching);
    }
  };
}
function instance$J($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { query } = $$props;
  let mql;
  let mqlListener;
  let wasMounted = false;
  let matches = false;
  onMount(() => {
    $$invalidate(2, wasMounted = true);
    return () => {
      removeActiveListener();
    };
  });
  function addNewListener(query2) {
    mql = window.matchMedia(query2);
    mqlListener = (v) => $$invalidate(0, matches = v.matches);
    mql.addListener(mqlListener);
    $$invalidate(0, matches = mql.matches);
  }
  function removeActiveListener() {
    if (mql && mqlListener) {
      mql.removeListener(mqlListener);
    }
  }
  $$self.$$set = ($$props2) => {
    if ("query" in $$props2)
      $$invalidate(1, query = $$props2.query);
    if ("$$scope" in $$props2)
      $$invalidate(3, $$scope = $$props2.$$scope);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*wasMounted, query*/
    6) {
      {
        if (wasMounted) {
          removeActiveListener();
          addNewListener(query);
        }
      }
    }
  };
  return [matches, query, wasMounted, $$scope, slots];
}
var MediaQuery = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$J, create_fragment$1n, safe_not_equal, { query: 1 });
  }
};
function create_fragment$1m(ctx) {
  let svg;
  let path;
  let animateTransform;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      animateTransform = svg_element("animateTransform");
      attr(animateTransform, "attributeName", "transform");
      attr(animateTransform, "attributeType", "xml");
      attr(animateTransform, "dur", "0.6s");
      attr(animateTransform, "from", "0 25 25");
      attr(animateTransform, "repeatCount", "indefinite");
      attr(animateTransform, "to", "360 25 25");
      attr(animateTransform, "type", "rotate");
      attr(path, "fill", "currentColor");
      attr(path, "d", "m43.935 25.145c0-10.318-8.364-18.683-18.683-18.683-10.318 0-18.683 8.365-18.683 18.683h4.068c0-8.071 6.543-14.615 14.615-14.615s14.615 6.543 14.615 14.615h4.068z");
      attr(svg, "width", "40px");
      attr(svg, "height", "40px");
      attr(svg, "enable-background", "new 0 0 50 50");
      set_style(svg, "z-index", "1000000");
      attr(svg, "version", "1.1");
      attr(svg, "viewBox", "0 0 50 50");
      attr(svg, "xml:space", "preserve");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
      append(path, animateTransform);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var LoadingIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$1m, safe_not_equal, {});
  }
};
function create_fragment$1l(ctx) {
  let div;
  let loadingicon;
  let current;
  loadingicon = new LoadingIcon({});
  return {
    c() {
      div = element("div");
      create_component(loadingicon.$$.fragment);
      attr(div, "class", "ms__loader");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(loadingicon, div, null);
      current = true;
    },
    p: noop,
    i(local) {
      if (current)
        return;
      transition_in(loadingicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(loadingicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      destroy_component(loadingicon);
    }
  };
}
var Loader = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$1l, safe_not_equal, {});
  }
};
function create_fragment$1k(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "shape-rendering", "geometricPrecision");
      attr(path, "d", "M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z");
      attr(svg, "fill", "none");
      set_style(svg, "width", "100%");
      attr(svg, "viewBox", "0 0 14 14");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var CloseIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$1k, safe_not_equal, {});
  }
};
function create_fragment$1j(ctx) {
  let div;
  let button;
  let closeicon;
  let current;
  let mounted;
  let dispose;
  closeicon = new CloseIcon({});
  return {
    c() {
      div = element("div");
      button = element("button");
      create_component(closeicon.$$.fragment);
      attr(div, "class", "ms-modal__close");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, button);
      mount_component(closeicon, button, null);
      current = true;
      if (!mounted) {
        dispose = listen(button, "click", function() {
          if (is_function(
            /*closeModal*/
            ctx[0]
          ))
            ctx[0].apply(this, arguments);
        });
        mounted = true;
      }
    },
    p(new_ctx, [dirty]) {
      ctx = new_ctx;
    },
    i(local) {
      if (current)
        return;
      transition_in(closeicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(closeicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      destroy_component(closeicon);
      mounted = false;
      dispose();
    }
  };
}
function instance$I($$self, $$props, $$invalidate) {
  let { closeModal } = $$props;
  $$self.$$set = ($$props2) => {
    if ("closeModal" in $$props2)
      $$invalidate(0, closeModal = $$props2.closeModal);
  };
  return [closeModal];
}
var CloseButton = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$I, create_fragment$1j, safe_not_equal, { closeModal: 0 });
  }
};
function create_fragment$1i(ctx) {
  let svg;
  let path0;
  let path1;
  let path2;
  let path3;
  let path4;
  let path5;
  return {
    c() {
      svg = svg_element("svg");
      path0 = svg_element("path");
      path1 = svg_element("path");
      path2 = svg_element("path");
      path3 = svg_element("path");
      path4 = svg_element("path");
      path5 = svg_element("path");
      attr(path0, "d", "m259.078 190.582 16.797-39.611c7.315-20.421 26.982-34.665 49.897-34.665 13.187 0 25.344 4.817 34.6 12.818l32.818 73.118c9.656 21.709-.097 47.144-21.786 56.809-21.688 9.666-47.097-.098-56.753-21.807l-38.573-86.723-17 40.088v-.027Z");
      attr(path0, "fill", "#2AA8FF");
      attr(path1, "d", "m111.31 169.64 8.002-18.679c-7.22-20.585-26.82-35.345-49.866-35.345-12.678 0-24.901 4.865-34.007 12.314 6.6063-2.796 14.34-3.575 21.988-3.575 26.999 0 49.435 19.445 53.884 45.285z");
      attr(path2, "d", "m111.31 169.64-28.66 68.126c-9.2762 21.875-34.511 32.081-56.365 22.795-21.853-9.285-32.049-34.545-22.773-56.42l31.925-76.211c6.7448-2.988 14.142-3.575 21.988-3.575 27.086 0 49.537 19.321 53.884 45.285z");
      attr(path2, "fill", "#393939");
      attr(path3, "d", "m197.57 115.46-39.756-89.506c-7.148-16.07-22.929-25.595-39.443-25.537-16.786-0.058576-32.766 9.7896-39.736 26.227l-43.199 101.28c9.1064-7.45 21.329-12.314 34.008-12.314 23.046 0 42.646 14.76 49.866 35.345l0.093 0.337c5.784 1.658 11.893 2.546 18.21 2.546 26.578 0 49.487-15.722 59.958-38.382z");
      attr(path3, "fill", "#017ACE");
      attr(path4, "d", "m197.57 115.46c-10.071 21.796-31.651 37.172-56.934 38.314-1.052 0.05-2.11 0.075-3.175 0.075-6.316 0-12.425-0.888-18.21-2.546l38.425 86.387c3.996 8.986 10.692 15.926 18.706 20.288 1.908 1.196 3.935 2.257 6.073 3.165 21.853 9.286 47.088-0.92 56.364-22.795l37.055-87.381c7.315-20.421 26.982-34.665 49.896-34.665 13.188 0 25.345 4.817 34.601 12.818l-45.994-103.17c-7.148-16.07-22.929-25.595-39.442-25.537-16.786-0.058576-32.767 9.7896-39.737 26.227l-37.628 88.816z");
      attr(path4, "fill", "#AEDEFF");
      attr(path5, "d", "m325.77 116.31c-22.915 0-42.379 13.795-49.694 34.216l8.919 20.052c5.873-25.763 28.931-44.989 56.481-44.989 6.67 0 12.931 1.465 18.894 3.539-9.256-8-21.413-12.818-34.6-12.818z");
      attr(path5, "fill", "#2D91D7");
      set_style(svg, "width", "100%");
      attr(svg, "viewBox", "0 0 397 265");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path0);
      append(svg, path1);
      append(svg, path2);
      append(svg, path3);
      append(svg, path4);
      append(svg, path5);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var MemberstackIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$1i, safe_not_equal, {});
  }
};
function create_else_block$i(ctx) {
  let memberstackicon;
  let current;
  memberstackicon = new MemberstackIcon({});
  return {
    c() {
      create_component(memberstackicon.$$.fragment);
    },
    m(target, anchor) {
      mount_component(memberstackicon, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current)
        return;
      transition_in(memberstackicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(memberstackicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(memberstackicon, detaching);
    }
  };
}
function create_if_block$A(ctx) {
  let img;
  let img_src_value;
  let img_alt_value;
  return {
    c() {
      img = element("img");
      if (!src_url_equal(img.src, img_src_value = /*app*/
      ctx[0].branding.logo))
        attr(img, "src", img_src_value);
      attr(img, "alt", img_alt_value = /*app*/
      ctx[0].name);
      attr(img, "data-cy", "logo");
    },
    m(target, anchor) {
      insert(target, img, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*app*/
      1 && !src_url_equal(img.src, img_src_value = /*app*/
      ctx2[0].branding.logo)) {
        attr(img, "src", img_src_value);
      }
      if (dirty & /*app*/
      1 && img_alt_value !== (img_alt_value = /*app*/
      ctx2[0].name)) {
        attr(img, "alt", img_alt_value);
      }
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(img);
    }
  };
}
function create_fragment$1h(ctx) {
  let figure;
  let current_block_type_index;
  let if_block;
  let current;
  const if_block_creators = [create_if_block$A, create_else_block$i];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*app*/
      ctx2[0].branding.logo
    )
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      figure = element("figure");
      if_block.c();
      attr(figure, "class", "ms-modal__figure");
    },
    m(target, anchor) {
      insert(target, figure, anchor);
      if_blocks[current_block_type_index].m(figure, null);
      current = true;
    },
    p(ctx2, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(figure, null);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(figure);
      if_blocks[current_block_type_index].d();
    }
  };
}
function instance$H($$self, $$props, $$invalidate) {
  let app = {};
  AppStore.subscribe((data) => {
    $$invalidate(0, app = data);
  });
  return [app];
}
var FigureElement = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$H, create_fragment$1h, safe_not_equal, {});
  }
};
function create_else_block$h(ctx) {
  let button;
  let loadingicon;
  let current;
  loadingicon = new LoadingIcon({});
  return {
    c() {
      button = element("button");
      create_component(loadingicon.$$.fragment);
      attr(button, "class", "ms-form__button");
      attr(button, "type", "button");
      set_style(
        button,
        "background-color",
        /*buttonColor*/
        ctx[2]
      );
      button.disabled = true;
    },
    m(target, anchor) {
      insert(target, button, anchor);
      mount_component(loadingicon, button, null);
      current = true;
    },
    p(ctx2, dirty) {
      if (!current || dirty & /*buttonColor*/
      4) {
        set_style(
          button,
          "background-color",
          /*buttonColor*/
          ctx2[2]
        );
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(loadingicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(loadingicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(button);
      destroy_component(loadingicon);
    }
  };
}
function create_if_block$z(ctx) {
  let button;
  let t;
  return {
    c() {
      button = element("button");
      t = text(
        /*buttonText*/
        ctx[0]
      );
      attr(button, "class", "ms-form__button");
      attr(button, "type", "submit");
      set_style(
        button,
        "background-color",
        /*buttonColor*/
        ctx[2]
      );
    },
    m(target, anchor) {
      insert(target, button, anchor);
      append(button, t);
    },
    p(ctx2, dirty) {
      if (dirty & /*buttonText*/
      1)
        set_data(
          t,
          /*buttonText*/
          ctx2[0]
        );
      if (dirty & /*buttonColor*/
      4) {
        set_style(
          button,
          "background-color",
          /*buttonColor*/
          ctx2[2]
        );
      }
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(button);
    }
  };
}
function create_fragment$1g(ctx) {
  let div;
  let current_block_type_index;
  let if_block;
  let current;
  const if_block_creators = [create_if_block$z, create_else_block$h];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (!/*isLoading*/
    ctx2[1])
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      div = element("div");
      if_block.c();
    },
    m(target, anchor) {
      insert(target, div, anchor);
      if_blocks[current_block_type_index].m(div, null);
      current = true;
    },
    p(ctx2, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(div, null);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      if_blocks[current_block_type_index].d();
    }
  };
}
function instance$G($$self, $$props, $$invalidate) {
  let $app;
  component_subscribe($$self, AppStore, ($$value) => $$invalidate(3, $app = $$value));
  let { buttonText = "Submit" } = $$props;
  let { isLoading = false } = $$props;
  let buttonColor = "rgb(41, 98, 255)";
  if ($app.branding.colors.lightMode.primaryButton) {
    buttonColor = $app.branding.colors.lightMode.primaryButton;
  }
  $$self.$$set = ($$props2) => {
    if ("buttonText" in $$props2)
      $$invalidate(0, buttonText = $$props2.buttonText);
    if ("isLoading" in $$props2)
      $$invalidate(1, isLoading = $$props2.isLoading);
  };
  return [buttonText, isLoading, buttonColor];
}
var SubmitButton = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$G, create_fragment$1g, safe_not_equal, { buttonText: 0, isLoading: 1 });
  }
};
function create_fragment$1f(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "m10 0c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm1 15h-2v-2h2v2zm0-4h-2v-6h2v6z");
      attr(svg, "fill", "none");
      attr(svg, "viewBox", "0 0 20 20");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var ErrorIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$1f, safe_not_equal, {});
  }
};
function create_if_block$y(ctx) {
  let div;
  let erroricon;
  let t0;
  let t1;
  let current;
  erroricon = new ErrorIcon({});
  return {
    c() {
      div = element("div");
      create_component(erroricon.$$.fragment);
      t0 = space();
      t1 = text(
        /*errorMessage*/
        ctx[4]
      );
      attr(div, "class", "ms-form__error");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(erroricon, div, null);
      append(div, t0);
      append(div, t1);
      current = true;
    },
    p: noop,
    i(local) {
      if (current)
        return;
      transition_in(erroricon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(erroricon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      destroy_component(erroricon);
    }
  };
}
function create_fragment$1e(ctx) {
  let div;
  let label;
  let t0;
  let t1;
  let input;
  let t2;
  let current;
  let mounted;
  let dispose;
  let if_block = (
    /*inputError*/
    ctx[2] && create_if_block$y(ctx)
  );
  return {
    c() {
      div = element("div");
      label = element("label");
      t0 = text(
        /*emailLabel*/
        ctx[3]
      );
      t1 = space();
      input = element("input");
      t2 = space();
      if (if_block)
        if_block.c();
      attr(label, "class", "ms-form__label");
      attr(label, "for", "eml-" + /*randomId*/
      ctx[5]);
      attr(input, "class", "ms-form__input");
      attr(input, "id", "eml-" + /*randomId*/
      ctx[5]);
      attr(input, "type", "email");
      attr(
        input,
        "placeholder",
        /*placeholder*/
        ctx[1]
      );
      attr(input, "name", "eml");
      input.required = true;
      attr(div, "class", "ms-form__group");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, label);
      append(label, t0);
      append(div, t1);
      append(div, input);
      set_input_value(
        input,
        /*emailValue*/
        ctx[0]
      );
      append(div, t2);
      if (if_block)
        if_block.m(div, null);
      current = true;
      if (!mounted) {
        dispose = [
          listen(
            input,
            "input",
            /*validateField*/
            ctx[6]
          ),
          listen(
            input,
            "input",
            /*input_input_handler*/
            ctx[8]
          )
        ];
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (!current || dirty & /*placeholder*/
      2) {
        attr(
          input,
          "placeholder",
          /*placeholder*/
          ctx2[1]
        );
      }
      if (dirty & /*emailValue*/
      1 && input.value !== /*emailValue*/
      ctx2[0]) {
        set_input_value(
          input,
          /*emailValue*/
          ctx2[0]
        );
      }
      if (
        /*inputError*/
        ctx2[2]
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
          if (dirty & /*inputError*/
          4) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$y(ctx2);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(div, null);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      if (if_block)
        if_block.d();
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$F($$self, $$props, $$invalidate) {
  let $textStore;
  component_subscribe($$self, TextStore, ($$value) => $$invalidate(9, $textStore = $$value));
  let { emailInputValid = false } = $$props;
  let { emailValue } = $$props;
  let { placeholder = "example@domain.com" } = $$props;
  let text2 = $textStore.text;
  let emailLabel = text2["email_address"] || "Email Address";
  let inputError = false;
  let errorMessage = text2["email_error_message"] || "Please enter a valid email address";
  const randomId = Math.random().toString(36).substring(2, 10);
  const validateField = (e) => {
    const emailInput = e.target;
    const hasValidEmail = emailInput.value.match(/.+@.+\..{2,}/);
    if (!hasValidEmail && e.target.value.length > 0) {
      $$invalidate(7, emailInputValid = false);
      $$invalidate(2, inputError = true);
    } else {
      $$invalidate(7, emailInputValid = true);
      $$invalidate(2, inputError = false);
    }
  };
  function input_input_handler() {
    emailValue = this.value;
    $$invalidate(0, emailValue);
  }
  $$self.$$set = ($$props2) => {
    if ("emailInputValid" in $$props2)
      $$invalidate(7, emailInputValid = $$props2.emailInputValid);
    if ("emailValue" in $$props2)
      $$invalidate(0, emailValue = $$props2.emailValue);
    if ("placeholder" in $$props2)
      $$invalidate(1, placeholder = $$props2.placeholder);
  };
  return [
    emailValue,
    placeholder,
    inputError,
    emailLabel,
    errorMessage,
    randomId,
    validateField,
    emailInputValid,
    input_input_handler
  ];
}
var EmailInput = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$F, create_fragment$1e, safe_not_equal, {
      emailInputValid: 7,
      emailValue: 0,
      placeholder: 1
    });
  }
};
function create_fragment$1d(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "m11 0.5c-5 0-9.27 3.11-11 7.5 1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z");
      attr(svg, "class", "ms-form__eye");
      attr(svg, "fill", "none");
      attr(svg, "viewBox", "0 0 22 16");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var EyeIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$1d, safe_not_equal, {});
  }
};
function create_fragment$1c(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "m11 4c2.76 0 5 2.24 5 5 0 0.65-0.13 1.26-0.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74 0.25-3.98 0.7l2.16 2.16c0.57-0.23 1.18-0.36 1.83-0.36zm-10-2.73 2.74 2.74c-1.66 1.29-2.96 3.01-3.74 4.99 1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-0.3 4.38-0.84l0.42 0.42 2.93 2.92 1.27-1.27-17.73-17.73-1.27 1.27zm5.53 5.53 1.55 1.55c-0.05 0.21-0.08 0.43-0.08 0.65 0 1.66 1.34 3 3 3 0.22 0 0.44-0.03 0.65-0.08l1.55 1.55c-0.67 0.33-1.41 0.53-2.2 0.53-2.76 0-5-2.24-5-5 0-0.79 0.2-1.53 0.53-2.2zm4.31-0.78 3.15 3.15 0.02-0.16c0-1.66-1.34-3-3-3l-0.17 0.01z");
      attr(svg, "class", "ms-form__eye-slash");
      attr(svg, "fill", "none");
      attr(svg, "viewBox", "0 0 22 19");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var EyeSlashIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$1c, safe_not_equal, {});
  }
};
function create_if_block_2$k(ctx) {
  let div;
  let button;
  let mounted;
  let dispose;
  return {
    c() {
      div = element("div");
      button = element("button");
      button.textContent = `${/*text*/
      ctx[8]["forgot_password"] || "Forgot Password?"}`;
      attr(button, "data-cy", "forgot-password-btn");
      attr(button, "class", "ms-form__button ms-form__button--text");
      attr(button, "tabindex", "-1");
      attr(button, "type", "button");
      attr(div, "class", "ms-form__label ms-form__label--right");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, button);
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler*/
          ctx[14]
        );
        mounted = true;
      }
    },
    p: noop,
    d(detaching) {
      if (detaching)
        detach(div);
      mounted = false;
      dispose();
    }
  };
}
function create_else_block$g(ctx) {
  let eyeslashicon;
  let current;
  eyeslashicon = new EyeSlashIcon({});
  return {
    c() {
      create_component(eyeslashicon.$$.fragment);
    },
    m(target, anchor) {
      mount_component(eyeslashicon, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(eyeslashicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(eyeslashicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(eyeslashicon, detaching);
    }
  };
}
function create_if_block_1$p(ctx) {
  let eyeicon;
  let current;
  eyeicon = new EyeIcon({});
  return {
    c() {
      create_component(eyeicon.$$.fragment);
    },
    m(target, anchor) {
      mount_component(eyeicon, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(eyeicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(eyeicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(eyeicon, detaching);
    }
  };
}
function create_if_block$x(ctx) {
  let div;
  let erroricon;
  let t0;
  let t1;
  let current;
  erroricon = new ErrorIcon({});
  return {
    c() {
      div = element("div");
      create_component(erroricon.$$.fragment);
      t0 = space();
      t1 = text(
        /*errorMessage*/
        ctx[9]
      );
      attr(div, "class", "ms-form__error");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(erroricon, div, null);
      append(div, t0);
      append(div, t1);
      current = true;
    },
    p: noop,
    i(local) {
      if (current)
        return;
      transition_in(erroricon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(erroricon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      destroy_component(erroricon);
    }
  };
}
function create_fragment$1b(ctx) {
  let div3;
  let div0;
  let label;
  let t0;
  let t1;
  let t2;
  let div2;
  let input;
  let input_value_value;
  let t3;
  let div1;
  let current_block_type_index;
  let if_block1;
  let t4;
  let current;
  let mounted;
  let dispose;
  let if_block0 = (
    /*showForgotPasswordLabel*/
    ctx[2] && create_if_block_2$k(ctx)
  );
  const if_block_creators = [create_if_block_1$p, create_else_block$g];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (!/*passwordVisible*/
    ctx2[5])
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  let if_block2 = (
    /*inputError*/
    ctx[6] && create_if_block$x(ctx)
  );
  return {
    c() {
      div3 = element("div");
      div0 = element("div");
      label = element("label");
      t0 = text(
        /*passwordLabel*/
        ctx[3]
      );
      t1 = space();
      if (if_block0)
        if_block0.c();
      t2 = space();
      div2 = element("div");
      input = element("input");
      t3 = space();
      div1 = element("div");
      if_block1.c();
      t4 = space();
      if (if_block2)
        if_block2.c();
      attr(label, "class", "ms-form__label");
      attr(label, "for", "psw-" + /*randomId*/
      ctx[10]);
      attr(div0, "class", "ms-form__flex");
      attr(input, "data-ms-internal-password", "");
      attr(input, "class", "ms-form__input ms-form__input--password");
      attr(input, "id", "psw-" + /*randomId*/
      ctx[10]);
      attr(
        input,
        "type",
        /*type*/
        ctx[7]
      );
      attr(
        input,
        "placeholder",
        /*passwordPlaceholder*/
        ctx[4]
      );
      input.value = input_value_value = /*passwordValue*/
      ctx[0] || "";
      attr(input, "name", "psw");
      input.required = true;
      attr(div1, "class", "ms-form__show-toggle");
      attr(div1, "id", "togglePassword");
      attr(div2, "class", "ms-form__password-container");
      attr(div3, "class", "ms-form__group");
    },
    m(target, anchor) {
      insert(target, div3, anchor);
      append(div3, div0);
      append(div0, label);
      append(label, t0);
      append(div0, t1);
      if (if_block0)
        if_block0.m(div0, null);
      append(div3, t2);
      append(div3, div2);
      append(div2, input);
      append(div2, t3);
      append(div2, div1);
      if_blocks[current_block_type_index].m(div1, null);
      append(div3, t4);
      if (if_block2)
        if_block2.m(div3, null);
      current = true;
      if (!mounted) {
        dispose = [
          listen(
            input,
            "input",
            /*handleInput*/
            ctx[12]
          ),
          listen(
            div1,
            "click",
            /*togglePassword*/
            ctx[11]
          )
        ];
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (!current || dirty & /*passwordLabel*/
      8)
        set_data(
          t0,
          /*passwordLabel*/
          ctx2[3]
        );
      if (
        /*showForgotPasswordLabel*/
        ctx2[2]
      ) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
        } else {
          if_block0 = create_if_block_2$k(ctx2);
          if_block0.c();
          if_block0.m(div0, null);
        }
      } else if (if_block0) {
        if_block0.d(1);
        if_block0 = null;
      }
      if (!current || dirty & /*type*/
      128) {
        attr(
          input,
          "type",
          /*type*/
          ctx2[7]
        );
      }
      if (!current || dirty & /*passwordPlaceholder*/
      16) {
        attr(
          input,
          "placeholder",
          /*passwordPlaceholder*/
          ctx2[4]
        );
      }
      if (!current || dirty & /*passwordValue*/
      1 && input_value_value !== (input_value_value = /*passwordValue*/
      ctx2[0] || "") && input.value !== input_value_value) {
        input.value = input_value_value;
      }
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index !== previous_block_index) {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block1 = if_blocks[current_block_type_index];
        if (!if_block1) {
          if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block1.c();
        }
        transition_in(if_block1, 1);
        if_block1.m(div1, null);
      }
      if (
        /*inputError*/
        ctx2[6]
      ) {
        if (if_block2) {
          if_block2.p(ctx2, dirty);
          if (dirty & /*inputError*/
          64) {
            transition_in(if_block2, 1);
          }
        } else {
          if_block2 = create_if_block$x(ctx2);
          if_block2.c();
          transition_in(if_block2, 1);
          if_block2.m(div3, null);
        }
      } else if (if_block2) {
        group_outros();
        transition_out(if_block2, 1, 1, () => {
          if_block2 = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block1);
      transition_in(if_block2);
      current = true;
    },
    o(local) {
      transition_out(if_block1);
      transition_out(if_block2);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div3);
      if (if_block0)
        if_block0.d();
      if_blocks[current_block_type_index].d();
      if (if_block2)
        if_block2.d();
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$E($$self, $$props, $$invalidate) {
  let type;
  let $textStore;
  component_subscribe($$self, TextStore, ($$value) => $$invalidate(15, $textStore = $$value));
  let text2 = $textStore.text;
  let { showForgotPasswordLabel = false } = $$props;
  let { passwordInputValid = false } = $$props;
  let { passwordLabel = text2["password"] || "Password" } = $$props;
  let { passwordPlaceholder = "Enter Password" } = $$props;
  let { passwordValue } = $$props;
  let { display } = $$props;
  let inputError = false;
  let errorMessage = text2["password_error_message"] || "Minimum 8 characters required";
  let passwordVisible = false;
  const randomId = Math.random().toString(36).substring(2, 10);
  function togglePassword() {
    $$invalidate(5, passwordVisible = !passwordVisible);
  }
  function handleInput(e) {
    $$invalidate(0, passwordValue = e.target.value);
    validateField(e);
  }
  const validateField = (e) => {
    const hasValidPassword = e.target.value.length >= 8 ? true : false;
    if (!hasValidPassword) {
      $$invalidate(13, passwordInputValid = false);
      $$invalidate(6, inputError = true);
    } else {
      $$invalidate(13, passwordInputValid = true);
      $$invalidate(6, inputError = false);
    }
  };
  const click_handler = () => $$invalidate(1, display = "forgot_password");
  $$self.$$set = ($$props2) => {
    if ("showForgotPasswordLabel" in $$props2)
      $$invalidate(2, showForgotPasswordLabel = $$props2.showForgotPasswordLabel);
    if ("passwordInputValid" in $$props2)
      $$invalidate(13, passwordInputValid = $$props2.passwordInputValid);
    if ("passwordLabel" in $$props2)
      $$invalidate(3, passwordLabel = $$props2.passwordLabel);
    if ("passwordPlaceholder" in $$props2)
      $$invalidate(4, passwordPlaceholder = $$props2.passwordPlaceholder);
    if ("passwordValue" in $$props2)
      $$invalidate(0, passwordValue = $$props2.passwordValue);
    if ("display" in $$props2)
      $$invalidate(1, display = $$props2.display);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*passwordVisible*/
    32) {
      $$invalidate(7, type = passwordVisible ? "text" : "password");
    }
  };
  return [
    passwordValue,
    display,
    showForgotPasswordLabel,
    passwordLabel,
    passwordPlaceholder,
    passwordVisible,
    inputError,
    type,
    text2,
    errorMessage,
    randomId,
    togglePassword,
    handleInput,
    passwordInputValid,
    click_handler
  ];
}
var PasswordInput = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$E, create_fragment$1b, safe_not_equal, {
      showForgotPasswordLabel: 2,
      passwordInputValid: 13,
      passwordLabel: 3,
      passwordPlaceholder: 4,
      passwordValue: 0,
      display: 1
    });
  }
};
function create_fragment$1a(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "shape-rendering", "geometricPrecision");
      attr(path, "d", "m9 0-9 4v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12v-6l-9-4zm-2 16-4-4 1.41-1.41 2.59 2.58 6.59-6.59 1.41 1.42-8 8z");
      attr(svg, "fill", "none");
      attr(svg, "viewBox", "0 0 18 22");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var SecuredIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$1a, safe_not_equal, {});
  }
};
function create_if_block$w(ctx) {
  let div;
  let a;
  let securedicon;
  let t;
  let current;
  securedicon = new SecuredIcon({});
  return {
    c() {
      div = element("div");
      a = element("a");
      create_component(securedicon.$$.fragment);
      t = text(" Secured by Memberstack");
      attr(a, "href", "https://www.memberstack.com");
      attr(a, "target", "_blank");
      attr(div, "class", "ms-modal__footer");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, a);
      mount_component(securedicon, a, null);
      append(a, t);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(securedicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(securedicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      destroy_component(securedicon);
    }
  };
}
function create_fragment$19(ctx) {
  let if_block_anchor;
  let current;
  let if_block = !/*$app*/
  ctx[0].isPaid && create_if_block$w();
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (!/*$app*/
      ctx2[0].isPaid) {
        if (if_block) {
          if (dirty & /*$app*/
          1) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$w();
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (if_block)
        if_block.d(detaching);
      if (detaching)
        detach(if_block_anchor);
    }
  };
}
function instance$D($$self, $$props, $$invalidate) {
  let $app;
  component_subscribe($$self, AppStore, ($$value) => $$invalidate(0, $app = $$value));
  return [$app];
}
var ModalFooter = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$D, create_fragment$19, safe_not_equal, {});
  }
};
function create_fragment$18(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "d", "M19,4H5A3,3,0,0,0,2,7V17a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V7A3,3,0,0,0,19,4ZM5,6H19a1,1,0,0,1,1,1l-8,4.88L4,7A1,1,0,0,1,5,6ZM20,17a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V9.28l7.48,4.57a1,1,0,0,0,1,0L20,9.28Z");
      attr(svg, "class", "ms-email");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "viewBox", "0 0 24 24");
      attr(svg, "fill", "currentColor");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var EmailIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$18, safe_not_equal, {});
  }
};
var PasswordlessStore = writable({
  passwordlessModalType: "",
  passwordlessEmail: "",
  passwordlessMode: false,
  passwordlessCustomFields: [],
  passwordlessPlans: []
});
var setPasswordlessModalType = (type) => {
  PasswordlessStore.update((store) => {
    store.passwordlessModalType = type;
    return store;
  });
};
var setPasswordlessEmail = (email) => {
  PasswordlessStore.update((store) => {
    store.passwordlessEmail = email;
    return store;
  });
};
var setPasswordlessCustomFields = (customFields) => {
  PasswordlessStore.update((store) => {
    store.passwordlessCustomFields = customFields;
    return store;
  });
};
var setPasswordlessPlans = (plans) => {
  PasswordlessStore.update((store) => {
    store.passwordlessPlans = plans;
    return store;
  });
};
var setPasswordlessMode = (mode) => {
  PasswordlessStore.update((store) => {
    store.passwordlessMode = mode;
    return store;
  });
};
function get_each_context$d(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[22] = list[i];
  return child_ctx;
}
function create_if_block_6$5(ctx) {
  let closebutton;
  let current;
  closebutton = new CloseButton({
    props: { closeModal: (
      /*closeModal*/
      ctx[1]
    ) }
  });
  return {
    c() {
      create_component(closebutton.$$.fragment);
    },
    m(target, anchor) {
      mount_component(closebutton, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const closebutton_changes = {};
      if (dirty & /*closeModal*/
      2)
        closebutton_changes.closeModal = /*closeModal*/
        ctx2[1];
      closebutton.$set(closebutton_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(closebutton.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(closebutton.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(closebutton, detaching);
    }
  };
}
function create_else_block_1$8(ctx) {
  let submitbutton;
  let current;
  submitbutton = new SubmitButton({
    props: {
      buttonText: (
        /*text*/
        ctx[8]["login_with_email"] || "Continue with Email"
      ),
      isLoading: (
        /*showLoader*/
        ctx[3]
      )
    }
  });
  return {
    c() {
      create_component(submitbutton.$$.fragment);
    },
    m(target, anchor) {
      mount_component(submitbutton, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const submitbutton_changes = {};
      if (dirty & /*showLoader*/
      8)
        submitbutton_changes.isLoading = /*showLoader*/
        ctx2[3];
      submitbutton.$set(submitbutton_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(submitbutton.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(submitbutton.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(submitbutton, detaching);
    }
  };
}
function create_if_block_5$7(ctx) {
  let passwordinput;
  let updating_passwordInputValid;
  let updating_display;
  let t;
  let submitbutton;
  let current;
  function passwordinput_passwordInputValid_binding(value) {
    ctx[14](value);
  }
  function passwordinput_display_binding(value) {
    ctx[15](value);
  }
  let passwordinput_props = {
    passwordPlaceholder: (
      /*text*/
      ctx[8]["login_password_placeholder"]
    ),
    "||": true,
    showForgotPasswordLabel: true
  };
  if (
    /*passwordInputValid*/
    ctx[5] !== void 0
  ) {
    passwordinput_props.passwordInputValid = /*passwordInputValid*/
    ctx[5];
  }
  if (
    /*display*/
    ctx[0] !== void 0
  ) {
    passwordinput_props.display = /*display*/
    ctx[0];
  }
  passwordinput = new PasswordInput({ props: passwordinput_props });
  binding_callbacks.push(() => bind(passwordinput, "passwordInputValid", passwordinput_passwordInputValid_binding));
  binding_callbacks.push(() => bind(passwordinput, "display", passwordinput_display_binding));
  submitbutton = new SubmitButton({
    props: {
      buttonText: (
        /*text*/
        ctx[8]["login"] || "Log in"
      ),
      isLoading: (
        /*showLoader*/
        ctx[3]
      ),
      "data-cy": "submit-button"
    }
  });
  return {
    c() {
      create_component(passwordinput.$$.fragment);
      t = space();
      create_component(submitbutton.$$.fragment);
    },
    m(target, anchor) {
      mount_component(passwordinput, target, anchor);
      insert(target, t, anchor);
      mount_component(submitbutton, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const passwordinput_changes = {};
      if (!updating_passwordInputValid && dirty & /*passwordInputValid*/
      32) {
        updating_passwordInputValid = true;
        passwordinput_changes.passwordInputValid = /*passwordInputValid*/
        ctx2[5];
        add_flush_callback(() => updating_passwordInputValid = false);
      }
      if (!updating_display && dirty & /*display*/
      1) {
        updating_display = true;
        passwordinput_changes.display = /*display*/
        ctx2[0];
        add_flush_callback(() => updating_display = false);
      }
      passwordinput.$set(passwordinput_changes);
      const submitbutton_changes = {};
      if (dirty & /*showLoader*/
      8)
        submitbutton_changes.isLoading = /*showLoader*/
        ctx2[3];
      submitbutton.$set(submitbutton_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(passwordinput.$$.fragment, local);
      transition_in(submitbutton.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(passwordinput.$$.fragment, local);
      transition_out(submitbutton.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(passwordinput, detaching);
      if (detaching)
        detach(t);
      destroy_component(submitbutton, detaching);
    }
  };
}
function create_if_block_4$8(ctx) {
  let div;
  let button;
  let mounted;
  let dispose;
  return {
    c() {
      div = element("div");
      button = element("button");
      button.textContent = `${/*text*/
      ctx[8]["dont_have_an_account"] || "Don't have an account?"}`;
      attr(button, "class", "ms-form__button ms-form__button--text");
      attr(button, "type", "button");
      attr(div, "class", "ms-form__flex ms-form__flex--centered");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, button);
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler_1*/
          ctx[17]
        );
        mounted = true;
      }
    },
    p: noop,
    d(detaching) {
      if (detaching)
        detach(div);
      mounted = false;
      dispose();
    }
  };
}
function create_if_block_3$b(ctx) {
  let div;
  let button;
  let mounted;
  let dispose;
  return {
    c() {
      div = element("div");
      button = element("button");
      button.textContent = `${/*text*/
      ctx[8]["dont_have_an_account"] || "Don't have an account?"}`;
      attr(button, "class", "ms-form__button ms-form__button--text");
      attr(button, "type", "button");
      attr(div, "class", "ms-form__flex ms-form__flex--centered");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, button);
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler*/
          ctx[16]
        );
        mounted = true;
      }
    },
    p: noop,
    d(detaching) {
      if (detaching)
        detach(div);
      mounted = false;
      dispose();
    }
  };
}
function create_if_block$v(ctx) {
  let div4;
  let div3;
  let div0;
  let t0;
  let div1;
  let t2;
  let div2;
  let t3;
  let t4;
  let current;
  let if_block = (
    /*$app*/
    ctx[7].additionalAuthMethods.passwordless.enabled === true && create_if_block_1$o(ctx)
  );
  let each_value = (
    /*$app*/
    ctx[7].authProviders
  );
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$d(get_each_context$d(ctx, each_value, i));
  }
  return {
    c() {
      div4 = element("div");
      div3 = element("div");
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      div1.textContent = `${/*text*/
      ctx[8]["or"] || "or"}`;
      t2 = space();
      div2 = element("div");
      t3 = space();
      if (if_block)
        if_block.c();
      t4 = space();
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      attr(div0, "class", "ms-modal__divider-line");
      attr(div1, "class", "ms-modal__divider-text");
      attr(div2, "class", "ms-modal__divider-line");
      attr(div3, "class", "ms-modal__social-divider");
      attr(div4, "class", "ms-modal__social");
    },
    m(target, anchor) {
      insert(target, div4, anchor);
      append(div4, div3);
      append(div3, div0);
      append(div3, t0);
      append(div3, div1);
      append(div3, t2);
      append(div3, div2);
      append(div4, t3);
      if (if_block)
        if_block.m(div4, null);
      append(div4, t4);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(div4, null);
        }
      }
      current = true;
    },
    p(ctx2, dirty) {
      if (
        /*$app*/
        ctx2[7].additionalAuthMethods.passwordless.enabled === true
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
          if (dirty & /*$app*/
          128) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block_1$o(ctx2);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(div4, t4);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
      if (dirty & /*submitLoginWithProvider, $app, text*/
      2432) {
        each_value = /*$app*/
        ctx2[7].authProviders;
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context$d(ctx2, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
          } else {
            each_blocks[i] = create_each_block$d(child_ctx);
            each_blocks[i].c();
            each_blocks[i].m(div4, null);
          }
        }
        for (; i < each_blocks.length; i += 1) {
          each_blocks[i].d(1);
        }
        each_blocks.length = each_value.length;
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div4);
      if (if_block)
        if_block.d();
      destroy_each(each_blocks, detaching);
    }
  };
}
function create_if_block_1$o(ctx) {
  let div;
  let current_block_type_index;
  let if_block;
  let current;
  const if_block_creators = [create_if_block_2$j, create_else_block$f];
  const if_blocks = [];
  function select_block_type_2(ctx2, dirty) {
    if (
      /*$PasswordlessStore*/
      ctx2[6].passwordlessMode === false
    )
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type_2(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      div = element("div");
      if_block.c();
      attr(div, "class", "ms-modal__social-buttons");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      if_blocks[current_block_type_index].m(div, null);
      current = true;
    },
    p(ctx2, dirty) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type_2(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(div, null);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      if_blocks[current_block_type_index].d();
    }
  };
}
function create_else_block$f(ctx) {
  let button;
  let span;
  let mounted;
  let dispose;
  return {
    c() {
      button = element("button");
      span = element("span");
      span.textContent = `${/*text*/
      ctx[8]["login_with_password"] || "Log in with Password"}`;
      attr(button, "class", "ms-modal__social-button");
      attr(button, "data-cy", "continue-with-password");
      attr(button, "type", "button");
    },
    m(target, anchor) {
      insert(target, button, anchor);
      append(button, span);
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler_3*/
          ctx[19]
        );
        mounted = true;
      }
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(button);
      mounted = false;
      dispose();
    }
  };
}
function create_if_block_2$j(ctx) {
  let button;
  let emailicon;
  let t0;
  let span;
  let current;
  let mounted;
  let dispose;
  emailicon = new EmailIcon({});
  return {
    c() {
      button = element("button");
      create_component(emailicon.$$.fragment);
      t0 = space();
      span = element("span");
      span.textContent = `${/*text*/
      ctx[8]["login_with_email"] || "Continue with Email"}`;
      attr(button, "class", "ms-modal__social-button");
      attr(button, "data-cy", "continue-with-email");
      attr(button, "type", "button");
    },
    m(target, anchor) {
      insert(target, button, anchor);
      mount_component(emailicon, button, null);
      append(button, t0);
      append(button, span);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler_2*/
          ctx[18]
        );
        mounted = true;
      }
    },
    p: noop,
    i(local) {
      if (current)
        return;
      transition_in(emailicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(emailicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(button);
      destroy_component(emailicon);
      mounted = false;
      dispose();
    }
  };
}
function create_each_block$d(ctx) {
  let div;
  let button;
  let img;
  let img_src_value;
  let img_alt_value;
  let t0;
  let span;
  let t1_value = (
    /*text*/
    (ctx[8]["continue_with"] || "Continue with") + ""
  );
  let t1;
  let t2;
  let t3_value = (
    /*provider*/
    ctx[22].name + ""
  );
  let t3;
  let t4;
  let mounted;
  let dispose;
  function click_handler_4() {
    return (
      /*click_handler_4*/
      ctx[20](
        /*provider*/
        ctx[22]
      )
    );
  }
  return {
    c() {
      div = element("div");
      button = element("button");
      img = element("img");
      t0 = space();
      span = element("span");
      t1 = text(t1_value);
      t2 = space();
      t3 = text(t3_value);
      t4 = space();
      if (!src_url_equal(img.src, img_src_value = /*provider*/
      ctx[22].icon))
        attr(img, "src", img_src_value);
      attr(img, "alt", img_alt_value = /*provider*/
      ctx[22].name);
      attr(button, "class", "ms-modal__social-button");
      attr(button, "type", "button");
      attr(div, "class", "ms-modal__social-buttons");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, button);
      append(button, img);
      append(button, t0);
      append(button, span);
      append(span, t1);
      append(span, t2);
      append(span, t3);
      append(div, t4);
      if (!mounted) {
        dispose = listen(button, "click", click_handler_4);
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*$app*/
      128 && !src_url_equal(img.src, img_src_value = /*provider*/
      ctx[22].icon)) {
        attr(img, "src", img_src_value);
      }
      if (dirty & /*$app*/
      128 && img_alt_value !== (img_alt_value = /*provider*/
      ctx[22].name)) {
        attr(img, "alt", img_alt_value);
      }
      if (dirty & /*$app*/
      128 && t3_value !== (t3_value = /*provider*/
      ctx[22].name + ""))
        set_data(t3, t3_value);
    },
    d(detaching) {
      if (detaching)
        detach(div);
      mounted = false;
      dispose();
    }
  };
}
function create_fragment$17(ctx) {
  let div1;
  let t0;
  let div0;
  let figureelement;
  let t1;
  let h2;
  let t3;
  let form;
  let emailinput;
  let updating_emailInputValid;
  let t4;
  let current_block_type_index;
  let if_block1;
  let t5;
  let t6;
  let t7;
  let modalfooter;
  let current;
  let mounted;
  let dispose;
  let if_block0 = (!/*params*/
  ctx[2] || !/*params*/
  ctx[2].hideCloseButton) && create_if_block_6$5(ctx);
  figureelement = new FigureElement({});
  function emailinput_emailInputValid_binding(value) {
    ctx[13](value);
  }
  let emailinput_props = {
    placeholder: (
      /*text*/
      ctx[8]["login_email_placeholder"]
    )
  };
  if (
    /*emailInputValid*/
    ctx[4] !== void 0
  ) {
    emailinput_props.emailInputValid = /*emailInputValid*/
    ctx[4];
  }
  emailinput = new EmailInput({ props: emailinput_props });
  binding_callbacks.push(() => bind(emailinput, "emailInputValid", emailinput_emailInputValid_binding));
  const if_block_creators = [create_if_block_5$7, create_else_block_1$8];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (!/*$PasswordlessStore*/
    ctx2[6].passwordlessMode)
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  function select_block_type_1(ctx2, dirty) {
    if (
      /*params*/
      ctx2[2] && /*params*/
      ctx2[2].signup && /*params*/
      ctx2[2].signup.plans
    )
      return create_if_block_3$b;
    if (
      /*signupButtonURL*/
      ctx2[9]
    )
      return create_if_block_4$8;
  }
  let current_block_type = select_block_type_1(ctx);
  let if_block2 = current_block_type && current_block_type(ctx);
  let if_block3 = (
    /*$app*/
    (ctx[7].authProviders.length > 0 || /*$app*/
    ctx[7].additionalAuthMethods.passwordless.enabled === true) && create_if_block$v(ctx)
  );
  modalfooter = new ModalFooter({});
  return {
    c() {
      div1 = element("div");
      if (if_block0)
        if_block0.c();
      t0 = space();
      div0 = element("div");
      create_component(figureelement.$$.fragment);
      t1 = space();
      h2 = element("h2");
      h2.textContent = `${/*text*/
      ctx[8]["login_to_your_account"] || "Login to your account"}`;
      t3 = space();
      form = element("form");
      create_component(emailinput.$$.fragment);
      t4 = space();
      if_block1.c();
      t5 = space();
      if (if_block2)
        if_block2.c();
      t6 = space();
      if (if_block3)
        if_block3.c();
      t7 = space();
      create_component(modalfooter.$$.fragment);
      attr(h2, "class", "ms-modal__title");
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(div0, "class", "ms-modal__content");
      attr(div1, "class", "ms-modal");
      attr(div1, "id", "LoginModal");
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      if (if_block0)
        if_block0.m(div1, null);
      append(div1, t0);
      append(div1, div0);
      mount_component(figureelement, div0, null);
      append(div0, t1);
      append(div0, h2);
      append(div0, t3);
      append(div0, form);
      mount_component(emailinput, form, null);
      append(form, t4);
      if_blocks[current_block_type_index].m(form, null);
      append(form, t5);
      if (if_block2)
        if_block2.m(form, null);
      append(div0, t6);
      if (if_block3)
        if_block3.m(div0, null);
      append(div1, t7);
      mount_component(modalfooter, div1, null);
      current = true;
      if (!mounted) {
        dispose = listen(form, "submit", stop_propagation(prevent_default(
          /*submitLogin*/
          ctx[10]
        )));
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (!/*params*/
      ctx2[2] || !/*params*/
      ctx2[2].hideCloseButton) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
          if (dirty & /*params*/
          4) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_6$5(ctx2);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(div1, t0);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      const emailinput_changes = {};
      if (!updating_emailInputValid && dirty & /*emailInputValid*/
      16) {
        updating_emailInputValid = true;
        emailinput_changes.emailInputValid = /*emailInputValid*/
        ctx2[4];
        add_flush_callback(() => updating_emailInputValid = false);
      }
      emailinput.$set(emailinput_changes);
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block1 = if_blocks[current_block_type_index];
        if (!if_block1) {
          if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block1.c();
        } else {
          if_block1.p(ctx2, dirty);
        }
        transition_in(if_block1, 1);
        if_block1.m(form, t5);
      }
      if (current_block_type === (current_block_type = select_block_type_1(ctx2)) && if_block2) {
        if_block2.p(ctx2, dirty);
      } else {
        if (if_block2)
          if_block2.d(1);
        if_block2 = current_block_type && current_block_type(ctx2);
        if (if_block2) {
          if_block2.c();
          if_block2.m(form, null);
        }
      }
      if (
        /*$app*/
        ctx2[7].authProviders.length > 0 || /*$app*/
        ctx2[7].additionalAuthMethods.passwordless.enabled === true
      ) {
        if (if_block3) {
          if_block3.p(ctx2, dirty);
          if (dirty & /*$app*/
          128) {
            transition_in(if_block3, 1);
          }
        } else {
          if_block3 = create_if_block$v(ctx2);
          if_block3.c();
          transition_in(if_block3, 1);
          if_block3.m(div0, null);
        }
      } else if (if_block3) {
        group_outros();
        transition_out(if_block3, 1, 1, () => {
          if_block3 = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block0);
      transition_in(figureelement.$$.fragment, local);
      transition_in(emailinput.$$.fragment, local);
      transition_in(if_block1);
      transition_in(if_block3);
      transition_in(modalfooter.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(figureelement.$$.fragment, local);
      transition_out(emailinput.$$.fragment, local);
      transition_out(if_block1);
      transition_out(if_block3);
      transition_out(modalfooter.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div1);
      if (if_block0)
        if_block0.d();
      destroy_component(figureelement);
      destroy_component(emailinput);
      if_blocks[current_block_type_index].d();
      if (if_block2) {
        if_block2.d();
      }
      if (if_block3)
        if_block3.d();
      destroy_component(modalfooter);
      mounted = false;
      dispose();
    }
  };
}
function instance$C($$self, $$props, $$invalidate) {
  let $PasswordlessStore;
  let $app;
  let $textStore;
  component_subscribe($$self, PasswordlessStore, ($$value) => $$invalidate(6, $PasswordlessStore = $$value));
  component_subscribe($$self, AppStore, ($$value) => $$invalidate(7, $app = $$value));
  component_subscribe($$self, TextStore, ($$value) => $$invalidate(21, $textStore = $$value));
  let { closeModal } = $$props;
  let { display } = $$props;
  let { onSuccessLogin } = $$props;
  let { params } = $$props;
  let text2 = $textStore.text;
  let showLoader2 = false;
  let emailInputValid = false;
  let passwordInputValid = false;
  if ($app.additionalAuthMethods.passwordless.isDefault === true) {
    setPasswordlessMode(true);
  }
  let signupButtonURL = Boolean(window.ssoUI) && $app.ssoSignupButtonURL;
  function submitLogin(e) {
    return __async(this, null, function* () {
      const emailInput = e.target.querySelector("[name=eml]");
      const passwordInput = e.target.querySelector("[name=psw]");
      if ($PasswordlessStore.passwordlessMode !== true) {
        if (!emailInputValid || !passwordInputValid)
          return;
        $$invalidate(3, showLoader2 = true);
        try {
          const { data } = yield window.$memberstackDom.loginMemberEmailPassword(
            {
              email: emailInput.value,
              password: passwordInput.value
            },
            { includeContentGroups: true }
          );
          onSuccessLogin({ type: "LOGIN", data });
          $$invalidate(3, showLoader2 = false);
        } catch (err) {
          $$invalidate(3, showLoader2 = false);
          window.$memberstackDom._showMessage(err.message, true);
        }
      } else {
        if (!emailInputValid)
          return;
        $$invalidate(3, showLoader2 = true);
        try {
          yield window.$memberstackDom.sendMemberLoginPasswordlessEmail({ email: emailInput.value });
          setPasswordlessModalType("login");
          setPasswordlessEmail(emailInput.value);
          $$invalidate(0, display = "passwordless_token");
          $$invalidate(3, showLoader2 = false);
        } catch (err) {
          $$invalidate(3, showLoader2 = false);
          window.$memberstackDom._showMessage(err.message, true);
        }
      }
    });
  }
  function submitLoginWithProvider(provider) {
    return __async(this, null, function* () {
      try {
        const { data } = yield window.$memberstackDom.loginWithProvider({
          provider,
          allowSignup: params && params.login && params.login.allowSignup
        });
        onSuccessLogin({ type: "LOGIN", data });
      } catch (err) {
        $$invalidate(3, showLoader2 = false);
        window.$memberstackDom._showMessage(err.message, true);
      }
    });
  }
  function emailinput_emailInputValid_binding(value) {
    emailInputValid = value;
    $$invalidate(4, emailInputValid);
  }
  function passwordinput_passwordInputValid_binding(value) {
    passwordInputValid = value;
    $$invalidate(5, passwordInputValid);
  }
  function passwordinput_display_binding(value) {
    display = value;
    $$invalidate(0, display);
  }
  const click_handler = () => $$invalidate(0, display = "signup");
  const click_handler_1 = () => window.location.href = signupButtonURL;
  const click_handler_2 = () => setPasswordlessMode(true);
  const click_handler_3 = () => setPasswordlessMode(false);
  const click_handler_4 = (provider) => submitLoginWithProvider(provider.provider);
  $$self.$$set = ($$props2) => {
    if ("closeModal" in $$props2)
      $$invalidate(1, closeModal = $$props2.closeModal);
    if ("display" in $$props2)
      $$invalidate(0, display = $$props2.display);
    if ("onSuccessLogin" in $$props2)
      $$invalidate(12, onSuccessLogin = $$props2.onSuccessLogin);
    if ("params" in $$props2)
      $$invalidate(2, params = $$props2.params);
  };
  return [
    display,
    closeModal,
    params,
    showLoader2,
    emailInputValid,
    passwordInputValid,
    $PasswordlessStore,
    $app,
    text2,
    signupButtonURL,
    submitLogin,
    submitLoginWithProvider,
    onSuccessLogin,
    emailinput_emailInputValid_binding,
    passwordinput_passwordInputValid_binding,
    passwordinput_display_binding,
    click_handler,
    click_handler_1,
    click_handler_2,
    click_handler_3,
    click_handler_4
  ];
}
var LoginModal = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$C, create_fragment$17, safe_not_equal, {
      closeModal: 1,
      display: 0,
      onSuccessLogin: 12,
      params: 2
    });
  }
};
function add_css$l(target) {
  append_styles(target, "svelte-1w8lbd8", ".rey-was-here.svelte-1w8lbd8{display:none !important}");
}
function get_each_context$c(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[25] = list[i];
  return child_ctx;
}
function get_each_context_1$5(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[28] = list[i];
  child_ctx[30] = i;
  return child_ctx;
}
function create_if_block_6$4(ctx) {
  let closebutton;
  let current;
  closebutton = new CloseButton({
    props: { closeModal: (
      /*closeModal*/
      ctx[1]
    ) }
  });
  return {
    c() {
      create_component(closebutton.$$.fragment);
    },
    m(target, anchor) {
      mount_component(closebutton, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const closebutton_changes = {};
      if (dirty & /*closeModal*/
      2)
        closebutton_changes.closeModal = /*closeModal*/
        ctx2[1];
      closebutton.$set(closebutton_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(closebutton.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(closebutton.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(closebutton, detaching);
    }
  };
}
function create_if_block_5$6(ctx) {
  let div1;
  let div0;
  let label;
  let t0_value = (
    /*customField*/
    ctx[28].label + ""
  );
  let t0;
  let label_for_value;
  let t1;
  let input;
  let input_placeholder_value;
  let input_name_value;
  return {
    c() {
      div1 = element("div");
      div0 = element("div");
      label = element("label");
      t0 = text(t0_value);
      t1 = space();
      input = element("input");
      attr(label, "class", "ms-form__label");
      attr(label, "for", label_for_value = /*customField*/
      ctx[28].key);
      attr(input, "class", "ms-form__input");
      attr(input, "data-ms-custom-field", "");
      attr(input, "type", "text");
      attr(input, "placeholder", input_placeholder_value = /*customField*/
      ctx[28].label);
      attr(input, "name", input_name_value = /*customField*/
      ctx[28].key);
      attr(div0, "class", "ms-form__group");
      attr(div1, "class", "ms-modal__custom-field-container");
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);
      append(div0, label);
      append(label, t0);
      append(div0, t1);
      append(div0, input);
    },
    p(ctx2, dirty) {
      if (dirty & /*$app*/
      128 && t0_value !== (t0_value = /*customField*/
      ctx2[28].label + ""))
        set_data(t0, t0_value);
      if (dirty & /*$app*/
      128 && label_for_value !== (label_for_value = /*customField*/
      ctx2[28].key)) {
        attr(label, "for", label_for_value);
      }
      if (dirty & /*$app*/
      128 && input_placeholder_value !== (input_placeholder_value = /*customField*/
      ctx2[28].label)) {
        attr(input, "placeholder", input_placeholder_value);
      }
      if (dirty & /*$app*/
      128 && input_name_value !== (input_name_value = /*customField*/
      ctx2[28].key)) {
        attr(input, "name", input_name_value);
      }
    },
    d(detaching) {
      if (detaching)
        detach(div1);
    }
  };
}
function create_each_block_1$5(ctx) {
  let if_block_anchor;
  let if_block = (
    /*customField*/
    ctx[28].hidden !== true && create_if_block_5$6(ctx)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx2, dirty) {
      if (
        /*customField*/
        ctx2[28].hidden !== true
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
        } else {
          if_block = create_if_block_5$6(ctx2);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    d(detaching) {
      if (if_block)
        if_block.d(detaching);
      if (detaching)
        detach(if_block_anchor);
    }
  };
}
function create_if_block_4$7(ctx) {
  let passwordinput;
  let updating_passwordInputValid;
  let current;
  function passwordinput_passwordInputValid_binding(value) {
    ctx[13](value);
  }
  let passwordinput_props = {};
  if (
    /*passwordInputValid*/
    ctx[5] !== void 0
  ) {
    passwordinput_props.passwordInputValid = /*passwordInputValid*/
    ctx[5];
  }
  passwordinput = new PasswordInput({ props: passwordinput_props });
  binding_callbacks.push(() => bind(passwordinput, "passwordInputValid", passwordinput_passwordInputValid_binding));
  return {
    c() {
      create_component(passwordinput.$$.fragment);
    },
    m(target, anchor) {
      mount_component(passwordinput, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const passwordinput_changes = {};
      if (!updating_passwordInputValid && dirty & /*passwordInputValid*/
      32) {
        updating_passwordInputValid = true;
        passwordinput_changes.passwordInputValid = /*passwordInputValid*/
        ctx2[5];
        add_flush_callback(() => updating_passwordInputValid = false);
      }
      passwordinput.$set(passwordinput_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(passwordinput.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(passwordinput.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(passwordinput, detaching);
    }
  };
}
function create_else_block_1$7(ctx) {
  let submitbutton;
  let current;
  submitbutton = new SubmitButton({
    props: {
      buttonText: "Continue with Email",
      isLoading: (
        /*showLoader*/
        ctx[3]
      )
    }
  });
  return {
    c() {
      create_component(submitbutton.$$.fragment);
    },
    m(target, anchor) {
      mount_component(submitbutton, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const submitbutton_changes = {};
      if (dirty & /*showLoader*/
      8)
        submitbutton_changes.isLoading = /*showLoader*/
        ctx2[3];
      submitbutton.$set(submitbutton_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(submitbutton.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(submitbutton.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(submitbutton, detaching);
    }
  };
}
function create_if_block_3$a(ctx) {
  let submitbutton;
  let current;
  submitbutton = new SubmitButton({
    props: {
      buttonText: "Sign up",
      isLoading: (
        /*showLoader*/
        ctx[3]
      )
    }
  });
  return {
    c() {
      create_component(submitbutton.$$.fragment);
    },
    m(target, anchor) {
      mount_component(submitbutton, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const submitbutton_changes = {};
      if (dirty & /*showLoader*/
      8)
        submitbutton_changes.isLoading = /*showLoader*/
        ctx2[3];
      submitbutton.$set(submitbutton_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(submitbutton.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(submitbutton.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(submitbutton, detaching);
    }
  };
}
function create_if_block$u(ctx) {
  let div4;
  let div3;
  let t3;
  let t4;
  let current;
  let if_block = (
    /*$app*/
    ctx[7].additionalAuthMethods.passwordless.enabled === true && create_if_block_1$n(ctx)
  );
  let each_value = (
    /*$app*/
    ctx[7].authProviders
  );
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$c(get_each_context$c(ctx, each_value, i));
  }
  return {
    c() {
      div4 = element("div");
      div3 = element("div");
      div3.innerHTML = `<div class="ms-modal__divider-line"></div> 
          <div class="ms-modal__divider-text">or</div> 
          <div class="ms-modal__divider-line"></div>`;
      t3 = space();
      if (if_block)
        if_block.c();
      t4 = space();
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      attr(div3, "class", "ms-modal__social-divider");
      attr(div4, "class", "ms-modal__social");
    },
    m(target, anchor) {
      insert(target, div4, anchor);
      append(div4, div3);
      append(div4, t3);
      if (if_block)
        if_block.m(div4, null);
      append(div4, t4);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(div4, null);
        }
      }
      current = true;
    },
    p(ctx2, dirty) {
      if (
        /*$app*/
        ctx2[7].additionalAuthMethods.passwordless.enabled === true
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
          if (dirty & /*$app*/
          128) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block_1$n(ctx2);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(div4, t4);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
      if (dirty & /*submitSignupWithProvider, $app*/
      1152) {
        each_value = /*$app*/
        ctx2[7].authProviders;
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context$c(ctx2, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
          } else {
            each_blocks[i] = create_each_block$c(child_ctx);
            each_blocks[i].c();
            each_blocks[i].m(div4, null);
          }
        }
        for (; i < each_blocks.length; i += 1) {
          each_blocks[i].d(1);
        }
        each_blocks.length = each_value.length;
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div4);
      if (if_block)
        if_block.d();
      destroy_each(each_blocks, detaching);
    }
  };
}
function create_if_block_1$n(ctx) {
  let div;
  let current_block_type_index;
  let if_block;
  let current;
  const if_block_creators = [create_if_block_2$i, create_else_block$e];
  const if_blocks = [];
  function select_block_type_1(ctx2, dirty) {
    if (
      /*$PasswordlessStore*/
      ctx2[6].passwordlessMode === false
    )
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type_1(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      div = element("div");
      if_block.c();
      attr(div, "class", "ms-modal__social-buttons");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      if_blocks[current_block_type_index].m(div, null);
      current = true;
    },
    p(ctx2, dirty) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type_1(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(div, null);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      if_blocks[current_block_type_index].d();
    }
  };
}
function create_else_block$e(ctx) {
  let button;
  let span;
  let mounted;
  let dispose;
  return {
    c() {
      button = element("button");
      span = element("span");
      span.textContent = `${/*text*/
      ctx[8]["signup_with_password"] || "Signup with Password"}`;
      attr(button, "class", "ms-modal__social-button");
      attr(button, "data-cy", "continue-with-password");
      attr(button, "type", "button");
    },
    m(target, anchor) {
      insert(target, button, anchor);
      append(button, span);
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler_2*/
          ctx[16]
        );
        mounted = true;
      }
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(button);
      mounted = false;
      dispose();
    }
  };
}
function create_if_block_2$i(ctx) {
  let button;
  let emailicon;
  let t0;
  let span;
  let current;
  let mounted;
  let dispose;
  emailicon = new EmailIcon({});
  return {
    c() {
      button = element("button");
      create_component(emailicon.$$.fragment);
      t0 = space();
      span = element("span");
      span.textContent = `${/*text*/
      ctx[8]["continue_with_email"] || "Continue with Email"}`;
      attr(button, "class", "ms-modal__social-button");
      attr(button, "data-cy", "continue-with-email");
      attr(button, "type", "button");
    },
    m(target, anchor) {
      insert(target, button, anchor);
      mount_component(emailicon, button, null);
      append(button, t0);
      append(button, span);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler_1*/
          ctx[15]
        );
        mounted = true;
      }
    },
    p: noop,
    i(local) {
      if (current)
        return;
      transition_in(emailicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(emailicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(button);
      destroy_component(emailicon);
      mounted = false;
      dispose();
    }
  };
}
function create_each_block$c(ctx) {
  let div;
  let button;
  let img;
  let img_src_value;
  let img_alt_value;
  let t0;
  let span;
  let t1;
  let t2_value = (
    /*provider*/
    ctx[25].name + ""
  );
  let t2;
  let t3;
  let mounted;
  let dispose;
  function click_handler_3() {
    return (
      /*click_handler_3*/
      ctx[17](
        /*provider*/
        ctx[25]
      )
    );
  }
  return {
    c() {
      div = element("div");
      button = element("button");
      img = element("img");
      t0 = space();
      span = element("span");
      t1 = text("Continue with ");
      t2 = text(t2_value);
      t3 = space();
      if (!src_url_equal(img.src, img_src_value = /*provider*/
      ctx[25].icon))
        attr(img, "src", img_src_value);
      attr(img, "alt", img_alt_value = /*provider*/
      ctx[25].name);
      attr(button, "class", "ms-modal__social-button");
      attr(button, "type", "button");
      attr(div, "class", "ms-modal__social-buttons");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, button);
      append(button, img);
      append(button, t0);
      append(button, span);
      append(span, t1);
      append(span, t2);
      append(div, t3);
      if (!mounted) {
        dispose = listen(button, "click", click_handler_3);
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*$app*/
      128 && !src_url_equal(img.src, img_src_value = /*provider*/
      ctx[25].icon)) {
        attr(img, "src", img_src_value);
      }
      if (dirty & /*$app*/
      128 && img_alt_value !== (img_alt_value = /*provider*/
      ctx[25].name)) {
        attr(img, "alt", img_alt_value);
      }
      if (dirty & /*$app*/
      128 && t2_value !== (t2_value = /*provider*/
      ctx[25].name + ""))
        set_data(t2, t2_value);
    },
    d(detaching) {
      if (detaching)
        detach(div);
      mounted = false;
      dispose();
    }
  };
}
function create_fragment$16(ctx) {
  let div4;
  let t0;
  let div3;
  let figureelement;
  let t1;
  let h2;
  let t3;
  let form;
  let t4;
  let emailinput;
  let updating_emailInputValid;
  let t5;
  let div0;
  let t8;
  let t9;
  let div1;
  let t10;
  let current_block_type_index;
  let if_block2;
  let t11;
  let div2;
  let button;
  let t13;
  let t14;
  let modalfooter;
  let current;
  let mounted;
  let dispose;
  let if_block0 = (!/*params*/
  ctx[2] || !/*params*/
  ctx[2].hideCloseButton) && create_if_block_6$4(ctx);
  figureelement = new FigureElement({});
  let each_value_1 = (
    /*$app*/
    ctx[7].customFields
  );
  let each_blocks = [];
  for (let i = 0; i < each_value_1.length; i += 1) {
    each_blocks[i] = create_each_block_1$5(get_each_context_1$5(ctx, each_value_1, i));
  }
  function emailinput_emailInputValid_binding(value) {
    ctx[12](value);
  }
  let emailinput_props = {};
  if (
    /*emailInputValid*/
    ctx[4] !== void 0
  ) {
    emailinput_props.emailInputValid = /*emailInputValid*/
    ctx[4];
  }
  emailinput = new EmailInput({ props: emailinput_props });
  binding_callbacks.push(() => bind(emailinput, "emailInputValid", emailinput_emailInputValid_binding));
  let if_block1 = (
    /*$PasswordlessStore*/
    ctx[6].passwordlessMode === false && create_if_block_4$7(ctx)
  );
  const if_block_creators = [create_if_block_3$a, create_else_block_1$7];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*$PasswordlessStore*/
      ctx2[6].passwordlessMode === false
    )
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  let if_block3 = (
    /*$app*/
    (ctx[7].authProviders.length > 0 || /*$app*/
    ctx[7].additionalAuthMethods.passwordless.enabled === true) && create_if_block$u(ctx)
  );
  modalfooter = new ModalFooter({});
  return {
    c() {
      div4 = element("div");
      if (if_block0)
        if_block0.c();
      t0 = space();
      div3 = element("div");
      create_component(figureelement.$$.fragment);
      t1 = space();
      h2 = element("h2");
      h2.textContent = "Create an account";
      t3 = space();
      form = element("form");
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      t4 = space();
      create_component(emailinput.$$.fragment);
      t5 = space();
      div0 = element("div");
      div0.innerHTML = `<label class="ms-form__label" for="Rey">Rey was here</label> 
        <input class="ms-form__input" type="text" placeholder="Rey&#39;s Favorite Color" name="Rey"/>`;
      t8 = space();
      if (if_block1)
        if_block1.c();
      t9 = space();
      div1 = element("div");
      t10 = space();
      if_block2.c();
      t11 = space();
      div2 = element("div");
      button = element("button");
      button.textContent = "Already have an account?";
      t13 = space();
      if (if_block3)
        if_block3.c();
      t14 = space();
      create_component(modalfooter.$$.fragment);
      attr(h2, "class", "ms-modal__title");
      attr(div0, "class", "ms-form__group rey-was-here svelte-1w8lbd8");
      attr(div1, "id", "hcaptcha");
      attr(div1, "class", "h-captcha");
      attr(button, "class", "ms-form__button ms-form__button--text ms-form__button--top-spacing");
      attr(div2, "class", "ms-form__flex ms-form__flex--centered");
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(div3, "class", "ms-modal__content");
      attr(div4, "class", "ms-modal");
      attr(div4, "id", "SignupModal");
    },
    m(target, anchor) {
      insert(target, div4, anchor);
      if (if_block0)
        if_block0.m(div4, null);
      append(div4, t0);
      append(div4, div3);
      mount_component(figureelement, div3, null);
      append(div3, t1);
      append(div3, h2);
      append(div3, t3);
      append(div3, form);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(form, null);
        }
      }
      append(form, t4);
      mount_component(emailinput, form, null);
      append(form, t5);
      append(form, div0);
      append(form, t8);
      if (if_block1)
        if_block1.m(form, null);
      append(form, t9);
      append(form, div1);
      append(form, t10);
      if_blocks[current_block_type_index].m(form, null);
      append(form, t11);
      append(form, div2);
      append(div2, button);
      append(div3, t13);
      if (if_block3)
        if_block3.m(div3, null);
      append(div4, t14);
      mount_component(modalfooter, div4, null);
      current = true;
      if (!mounted) {
        dispose = [
          listen(
            button,
            "click",
            /*click_handler*/
            ctx[14]
          ),
          listen(form, "submit", stop_propagation(prevent_default(
            /*submitSignup*/
            ctx[9]
          )))
        ];
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (!/*params*/
      ctx2[2] || !/*params*/
      ctx2[2].hideCloseButton) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
          if (dirty & /*params*/
          4) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_6$4(ctx2);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(div4, t0);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      if (dirty & /*$app*/
      128) {
        each_value_1 = /*$app*/
        ctx2[7].customFields;
        let i;
        for (i = 0; i < each_value_1.length; i += 1) {
          const child_ctx = get_each_context_1$5(ctx2, each_value_1, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
          } else {
            each_blocks[i] = create_each_block_1$5(child_ctx);
            each_blocks[i].c();
            each_blocks[i].m(form, t4);
          }
        }
        for (; i < each_blocks.length; i += 1) {
          each_blocks[i].d(1);
        }
        each_blocks.length = each_value_1.length;
      }
      const emailinput_changes = {};
      if (!updating_emailInputValid && dirty & /*emailInputValid*/
      16) {
        updating_emailInputValid = true;
        emailinput_changes.emailInputValid = /*emailInputValid*/
        ctx2[4];
        add_flush_callback(() => updating_emailInputValid = false);
      }
      emailinput.$set(emailinput_changes);
      if (
        /*$PasswordlessStore*/
        ctx2[6].passwordlessMode === false
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty & /*$PasswordlessStore*/
          64) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block_4$7(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(form, t9);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block2 = if_blocks[current_block_type_index];
        if (!if_block2) {
          if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block2.c();
        } else {
          if_block2.p(ctx2, dirty);
        }
        transition_in(if_block2, 1);
        if_block2.m(form, t11);
      }
      if (
        /*$app*/
        ctx2[7].authProviders.length > 0 || /*$app*/
        ctx2[7].additionalAuthMethods.passwordless.enabled === true
      ) {
        if (if_block3) {
          if_block3.p(ctx2, dirty);
          if (dirty & /*$app*/
          128) {
            transition_in(if_block3, 1);
          }
        } else {
          if_block3 = create_if_block$u(ctx2);
          if_block3.c();
          transition_in(if_block3, 1);
          if_block3.m(div3, null);
        }
      } else if (if_block3) {
        group_outros();
        transition_out(if_block3, 1, 1, () => {
          if_block3 = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block0);
      transition_in(figureelement.$$.fragment, local);
      transition_in(emailinput.$$.fragment, local);
      transition_in(if_block1);
      transition_in(if_block2);
      transition_in(if_block3);
      transition_in(modalfooter.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(figureelement.$$.fragment, local);
      transition_out(emailinput.$$.fragment, local);
      transition_out(if_block1);
      transition_out(if_block2);
      transition_out(if_block3);
      transition_out(modalfooter.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div4);
      if (if_block0)
        if_block0.d();
      destroy_component(figureelement);
      destroy_each(each_blocks, detaching);
      destroy_component(emailinput);
      if (if_block1)
        if_block1.d();
      if_blocks[current_block_type_index].d();
      if (if_block3)
        if_block3.d();
      destroy_component(modalfooter);
      mounted = false;
      run_all(dispose);
    }
  };
}
var hcaptchaSitekey = "838711f9-0e30-48e9-89e6-8f1ec4b79705";
function executeCaptcha() {
  return __async(this, null, function* () {
    const { response } = yield window.hcaptcha.execute({ async: true });
    return response;
  });
}
function instance$B($$self, $$props, $$invalidate) {
  var _a;
  let $PasswordlessStore;
  let $app;
  let $textStore;
  component_subscribe($$self, PasswordlessStore, ($$value) => $$invalidate(6, $PasswordlessStore = $$value));
  component_subscribe($$self, AppStore, ($$value) => $$invalidate(7, $app = $$value));
  component_subscribe($$self, TextStore, ($$value) => $$invalidate(19, $textStore = $$value));
  let { closeModal } = $$props;
  let { display } = $$props;
  let { onSuccessSignup } = $$props;
  let { params } = $$props;
  if ($app.additionalAuthMethods.passwordless.isDefault === true) {
    setPasswordlessMode(true);
  }
  let text2 = $textStore.text;
  let showLoader2 = false;
  let emailInputValid = false;
  let passwordInputValid = false;
  let captchaRequired = $app.captchaRequired;
  let hcaptchaWidgetID;
  const plans = (((_a = params == null ? void 0 : params.signup) == null ? void 0 : _a.plans) || []).map((plan) => {
    return { planId: plan };
  });
  function renderCaptcha() {
    return __async(this, null, function* () {
      if (captchaRequired) {
        yield window.$memberstackDom._captchaReady;
        hcaptchaWidgetID = window.hcaptcha.render("hcaptcha", { sitekey: hcaptchaSitekey, theme: "light" });
      }
    });
  }
  renderCaptcha();
  function getCaptcha() {
    return window.hcaptcha.getResponse(hcaptchaWidgetID);
  }
  function resetCaptcha() {
    if (captchaRequired && window.hcaptcha) {
      window.hcaptcha.reset(hcaptchaWidgetID);
    }
  }
  function submitSignup(e) {
    return __async(this, null, function* () {
      var _a2;
      const emailInput = e.target.querySelector("[type=email]");
      const passwordInput = e.target.querySelector("[data-ms-internal-password]");
      const customFields = {};
      const customFieldInputs = Array.from(e.target.querySelectorAll("[data-ms-custom-field]"));
      customFieldInputs.map((input) => {
        customFields[input.getAttribute("name")] = input.value;
      }).length;
      if ($PasswordlessStore.passwordlessMode !== true) {
        if (!emailInputValid || !passwordInputValid)
          return;
      } else {
        if (!emailInputValid)
          return;
      }
      $$invalidate(3, showLoader2 = true);
      if (e.target.querySelector("[name=Rey]").value) {
        e.target.reset();
        $$invalidate(3, showLoader2 = false);
        return;
      }
      let captchaToken;
      if (captchaRequired) {
        yield window.$memberstackDom._captchaReady;
        captchaToken = getCaptcha();
        if (!captchaToken) {
          try {
            captchaToken = yield executeCaptcha();
          } catch (err) {
            $$invalidate(3, showLoader2 = false);
            return;
          }
        }
      }
      if ($PasswordlessStore.passwordlessMode !== true) {
        try {
          const { data } = yield window.$memberstackDom.signupMemberEmailPassword(
            {
              email: emailInput.value,
              password: passwordInput.value,
              plans,
              customFields,
              captchaToken
            },
            { includeContentGroups: true }
          );
          onSuccessSignup({ type: "SIGNUP", data });
          $$invalidate(3, showLoader2 = false);
        } catch (err) {
          $$invalidate(3, showLoader2 = false);
          window.$memberstackDom._showMessage(err.message, true);
          resetCaptcha();
        }
      } else {
        try {
          yield window.$memberstackDom.sendMemberSignupPasswordlessEmail({ email: emailInput.value });
          setPasswordlessModalType("signup");
          setPasswordlessEmail(emailInput.value);
          setPasswordlessPlans(((_a2 = params == null ? void 0 : params.signup) == null ? void 0 : _a2.plans) || []);
          setPasswordlessCustomFields(customFields);
          $$invalidate(0, display = "passwordless_token");
          $$invalidate(3, showLoader2 = false);
        } catch (err) {
          $$invalidate(3, showLoader2 = false);
          window.$memberstackDom._showMessage(err.message, true);
          resetCaptcha();
        }
      }
    });
  }
  function submitSignupWithProvider(provider) {
    return __async(this, null, function* () {
      try {
        const { data } = yield window.$memberstackDom.signupWithProvider({ provider, plans });
        onSuccessSignup({ type: "SIGNUP", data });
      } catch (err) {
        $$invalidate(3, showLoader2 = false);
        window.$memberstackDom._showMessage(err.message, true);
      }
    });
  }
  function emailinput_emailInputValid_binding(value) {
    emailInputValid = value;
    $$invalidate(4, emailInputValid);
  }
  function passwordinput_passwordInputValid_binding(value) {
    passwordInputValid = value;
    $$invalidate(5, passwordInputValid);
  }
  const click_handler = () => $$invalidate(0, display = "login");
  const click_handler_1 = () => setPasswordlessMode(true);
  const click_handler_2 = () => setPasswordlessMode(false);
  const click_handler_3 = (provider) => submitSignupWithProvider(provider.provider);
  $$self.$$set = ($$props2) => {
    if ("closeModal" in $$props2)
      $$invalidate(1, closeModal = $$props2.closeModal);
    if ("display" in $$props2)
      $$invalidate(0, display = $$props2.display);
    if ("onSuccessSignup" in $$props2)
      $$invalidate(11, onSuccessSignup = $$props2.onSuccessSignup);
    if ("params" in $$props2)
      $$invalidate(2, params = $$props2.params);
  };
  return [
    display,
    closeModal,
    params,
    showLoader2,
    emailInputValid,
    passwordInputValid,
    $PasswordlessStore,
    $app,
    text2,
    submitSignup,
    submitSignupWithProvider,
    onSuccessSignup,
    emailinput_emailInputValid_binding,
    passwordinput_passwordInputValid_binding,
    click_handler,
    click_handler_1,
    click_handler_2,
    click_handler_3
  ];
}
var SignupModal = class extends SvelteComponent {
  constructor(options) {
    super();
    init(
      this,
      options,
      instance$B,
      create_fragment$16,
      safe_not_equal,
      {
        closeModal: 1,
        display: 0,
        onSuccessSignup: 11,
        params: 2
      },
      add_css$l
    );
  }
};
function create_fragment$15(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M7.41 1.41L6 0L0 6L6 12L7.41 10.59L2.83 6L7.41 1.41Z");
      attr(svg, "fill", "none");
      attr(svg, "viewBox", "0 0 8 12");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var BackIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$15, safe_not_equal, {});
  }
};
function create_fragment$14(ctx) {
  let div4;
  let div0;
  let button;
  let backicon;
  let t0;
  let div3;
  let figureelement;
  let t1;
  let h2;
  let t3;
  let p;
  let t5;
  let form;
  let emailinput;
  let updating_emailInputValid;
  let t6;
  let submitbutton;
  let t7;
  let div2;
  let div1;
  let t9;
  let modalfooter;
  let current;
  let mounted;
  let dispose;
  backicon = new BackIcon({});
  figureelement = new FigureElement({});
  function emailinput_emailInputValid_binding(value) {
    ctx[7](value);
  }
  let emailinput_props = {
    placeholder: (
      /*text*/
      ctx[3]["reset_email_placeholder"]
    )
  };
  if (
    /*emailInputValid*/
    ctx[1] !== void 0
  ) {
    emailinput_props.emailInputValid = /*emailInputValid*/
    ctx[1];
  }
  emailinput = new EmailInput({ props: emailinput_props });
  binding_callbacks.push(() => bind(emailinput, "emailInputValid", emailinput_emailInputValid_binding));
  submitbutton = new SubmitButton({
    props: {
      buttonText: (
        /*text*/
        ctx[3]["reset"] || "Send Link"
      ),
      isLoading: (
        /*showLoader*/
        ctx[2]
      )
    }
  });
  modalfooter = new ModalFooter({});
  return {
    c() {
      div4 = element("div");
      div0 = element("div");
      button = element("button");
      create_component(backicon.$$.fragment);
      t0 = space();
      div3 = element("div");
      create_component(figureelement.$$.fragment);
      t1 = space();
      h2 = element("h2");
      h2.textContent = `${/*text*/
      ctx[3]["reset_your_password"] || "Reset your password"}`;
      t3 = space();
      p = element("p");
      p.textContent = `${/*text*/
      ctx[3]["reset_instructions"] || "We\u2019ll email you a secure link to reset the password for your account."}`;
      t5 = space();
      form = element("form");
      create_component(emailinput.$$.fragment);
      t6 = space();
      create_component(submitbutton.$$.fragment);
      t7 = space();
      div2 = element("div");
      div1 = element("div");
      div1.textContent = `${/*text*/
      ctx[3]["reset_already_have_code"] || "I already have a code"}`;
      t9 = space();
      create_component(modalfooter.$$.fragment);
      attr(div0, "data-cy", "back-btn");
      attr(div0, "class", "ms-modal__back");
      attr(h2, "class", "ms-modal__title ms-modal__title--sub-text");
      attr(p, "class", "ms-modal__text");
      attr(div1, "class", "ms-form__link");
      attr(div2, "class", "ms-form__flex ms-form__flex--centered");
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(form, "autocomplete", "off");
      attr(div3, "class", "ms-modal__content");
      attr(div4, "class", "ms-modal");
      attr(div4, "id", "PasswordResetModal");
    },
    m(target, anchor) {
      insert(target, div4, anchor);
      append(div4, div0);
      append(div0, button);
      mount_component(backicon, button, null);
      append(div4, t0);
      append(div4, div3);
      mount_component(figureelement, div3, null);
      append(div3, t1);
      append(div3, h2);
      append(div3, t3);
      append(div3, p);
      append(div3, t5);
      append(div3, form);
      mount_component(emailinput, form, null);
      append(form, t6);
      mount_component(submitbutton, form, null);
      append(form, t7);
      append(form, div2);
      append(div2, div1);
      append(div4, t9);
      mount_component(modalfooter, div4, null);
      current = true;
      if (!mounted) {
        dispose = [
          listen(
            button,
            "click",
            /*click_handler*/
            ctx[6]
          ),
          listen(
            div1,
            "click",
            /*click_handler_1*/
            ctx[8]
          ),
          listen(form, "submit", stop_propagation(prevent_default(
            /*submitPasswordReset*/
            ctx[4]
          )))
        ];
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      const emailinput_changes = {};
      if (!updating_emailInputValid && dirty & /*emailInputValid*/
      2) {
        updating_emailInputValid = true;
        emailinput_changes.emailInputValid = /*emailInputValid*/
        ctx2[1];
        add_flush_callback(() => updating_emailInputValid = false);
      }
      emailinput.$set(emailinput_changes);
      const submitbutton_changes = {};
      if (dirty & /*showLoader*/
      4)
        submitbutton_changes.isLoading = /*showLoader*/
        ctx2[2];
      submitbutton.$set(submitbutton_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(backicon.$$.fragment, local);
      transition_in(figureelement.$$.fragment, local);
      transition_in(emailinput.$$.fragment, local);
      transition_in(submitbutton.$$.fragment, local);
      transition_in(modalfooter.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(backicon.$$.fragment, local);
      transition_out(figureelement.$$.fragment, local);
      transition_out(emailinput.$$.fragment, local);
      transition_out(submitbutton.$$.fragment, local);
      transition_out(modalfooter.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div4);
      destroy_component(backicon);
      destroy_component(figureelement);
      destroy_component(emailinput);
      destroy_component(submitbutton);
      destroy_component(modalfooter);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$A($$self, $$props, $$invalidate) {
  let $textStore;
  component_subscribe($$self, TextStore, ($$value) => $$invalidate(9, $textStore = $$value));
  let text2 = $textStore.text;
  let { closeModal } = $$props;
  let { display } = $$props;
  let emailInputValid = false;
  let showLoader2 = false;
  function submitPasswordReset(e) {
    return __async(this, null, function* () {
      const emailInput = e.target[0];
      if (!emailInputValid)
        return;
      $$invalidate(2, showLoader2 = true);
      try {
        yield window.$memberstackDom.sendMemberResetPasswordEmail({ email: emailInput.value });
        $$invalidate(0, display = "reset_password");
      } catch (err) {
        console.log(err);
        $$invalidate(2, showLoader2 = false);
        if (err.message) {
          window.$memberstackDom._showMessage(err.message, false);
        }
      }
    });
  }
  const click_handler = () => $$invalidate(0, display = "login");
  function emailinput_emailInputValid_binding(value) {
    emailInputValid = value;
    $$invalidate(1, emailInputValid);
  }
  const click_handler_1 = () => $$invalidate(0, display = "reset_password");
  $$self.$$set = ($$props2) => {
    if ("closeModal" in $$props2)
      $$invalidate(5, closeModal = $$props2.closeModal);
    if ("display" in $$props2)
      $$invalidate(0, display = $$props2.display);
  };
  return [
    display,
    emailInputValid,
    showLoader2,
    text2,
    submitPasswordReset,
    closeModal,
    click_handler,
    emailinput_emailInputValid_binding,
    click_handler_1
  ];
}
var PassResetModal = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$A, create_fragment$14, safe_not_equal, { closeModal: 5, display: 0 });
  }
};
function create_if_block$t(ctx) {
  let div;
  let erroricon;
  let t;
  let current;
  erroricon = new ErrorIcon({});
  return {
    c() {
      div = element("div");
      create_component(erroricon.$$.fragment);
      t = text(" Please enter a valid code");
      attr(div, "class", "ms-form__error");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(erroricon, div, null);
      append(div, t);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(erroricon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(erroricon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      destroy_component(erroricon);
    }
  };
}
function create_fragment$13(ctx) {
  let div3;
  let div0;
  let button;
  let backicon;
  let t0;
  let closebutton;
  let t1;
  let div2;
  let figureelement;
  let t2;
  let h2;
  let t4;
  let form;
  let div1;
  let label;
  let t6;
  let fieldset;
  let t12;
  let t13;
  let passwordinput;
  let updating_passwordInputValid;
  let t14;
  let submitbutton;
  let t15;
  let modalfooter;
  let current;
  let mounted;
  let dispose;
  backicon = new BackIcon({});
  closebutton = new CloseButton({
    props: { closeModal: (
      /*closeModal*/
      ctx[1]
    ) }
  });
  figureelement = new FigureElement({});
  let if_block = !/*tokenInputValid*/
  ctx[3] && create_if_block$t();
  function passwordinput_passwordInputValid_binding(value) {
    ctx[9](value);
  }
  let passwordinput_props = {
    passwordPlaceholder: (
      /*text*/
      ctx[5]["reset_password_placeholder"] || "New password"
    ),
    passwordLabel: (
      /*text*/
      ctx[5]["password"] || "Enter a new password"
    )
  };
  if (
    /*passwordInputValid*/
    ctx[4] !== void 0
  ) {
    passwordinput_props.passwordInputValid = /*passwordInputValid*/
    ctx[4];
  }
  passwordinput = new PasswordInput({ props: passwordinput_props });
  binding_callbacks.push(() => bind(passwordinput, "passwordInputValid", passwordinput_passwordInputValid_binding));
  submitbutton = new SubmitButton({
    props: {
      buttonText: (
        /*text*/
        ctx[5]["reset_confirm_reset"] || "Confirm & Reset"
      ),
      isLoading: (
        /*showLoader*/
        ctx[2]
      )
    }
  });
  modalfooter = new ModalFooter({});
  return {
    c() {
      div3 = element("div");
      div0 = element("div");
      button = element("button");
      create_component(backicon.$$.fragment);
      t0 = space();
      create_component(closebutton.$$.fragment);
      t1 = space();
      div2 = element("div");
      create_component(figureelement.$$.fragment);
      t2 = space();
      h2 = element("h2");
      h2.textContent = `${/*text*/
      ctx[5]["reset_your_password"] || "Reset your password"}`;
      t4 = space();
      form = element("form");
      div1 = element("div");
      label = element("label");
      label.textContent = `${/*text*/
      ctx[5]["reset_enter_code"] || "Enter your 6-digit code"}`;
      t6 = space();
      fieldset = element("fieldset");
      fieldset.innerHTML = `<input type="tel" name="token" class="ms-form__input ms-form__input--token" required=""/> 
          <input type="tel" name="token" class="ms-form__input ms-form__input--token" required=""/> 
          <input type="tel" name="token" class="ms-form__input ms-form__input--token" required=""/> 
          <input type="tel" name="token" class="ms-form__input ms-form__input--token" required=""/> 
          <input type="tel" name="token" class="ms-form__input ms-form__input--token" required=""/> 
          <input type="tel" name="token" class="ms-form__input ms-form__input--token"/>`;
      t12 = space();
      if (if_block)
        if_block.c();
      t13 = space();
      create_component(passwordinput.$$.fragment);
      t14 = space();
      create_component(submitbutton.$$.fragment);
      t15 = space();
      create_component(modalfooter.$$.fragment);
      attr(div0, "class", "ms-modal__back");
      attr(h2, "class", "ms-modal__title");
      attr(label, "class", "ms-form__label");
      attr(label, "for", "token-fieldset");
      attr(fieldset, "class", "ms-form__fieldset");
      attr(fieldset, "name", "token-fieldset");
      attr(div1, "class", "ms-form__group");
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(form, "autocomplete", "off");
      attr(div2, "class", "ms-modal__content");
      attr(div3, "class", "ms-modal");
      attr(div3, "id", "PasswordTokenModal");
    },
    m(target, anchor) {
      insert(target, div3, anchor);
      append(div3, div0);
      append(div0, button);
      mount_component(backicon, button, null);
      append(div3, t0);
      mount_component(closebutton, div3, null);
      append(div3, t1);
      append(div3, div2);
      mount_component(figureelement, div2, null);
      append(div2, t2);
      append(div2, h2);
      append(div2, t4);
      append(div2, form);
      append(form, div1);
      append(div1, label);
      append(div1, t6);
      append(div1, fieldset);
      append(div1, t12);
      if (if_block)
        if_block.m(div1, null);
      append(form, t13);
      mount_component(passwordinput, form, null);
      append(form, t14);
      mount_component(submitbutton, form, null);
      append(div3, t15);
      mount_component(modalfooter, div3, null);
      current = true;
      if (!mounted) {
        dispose = [
          listen(
            button,
            "click",
            /*click_handler*/
            ctx[8]
          ),
          listen(form, "submit", stop_propagation(prevent_default(
            /*submitPasswordToken*/
            ctx[6]
          )))
        ];
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      const closebutton_changes = {};
      if (dirty & /*closeModal*/
      2)
        closebutton_changes.closeModal = /*closeModal*/
        ctx2[1];
      closebutton.$set(closebutton_changes);
      if (!/*tokenInputValid*/
      ctx2[3]) {
        if (if_block) {
          if (dirty & /*tokenInputValid*/
          8) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$t();
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(div1, null);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
      const passwordinput_changes = {};
      if (!updating_passwordInputValid && dirty & /*passwordInputValid*/
      16) {
        updating_passwordInputValid = true;
        passwordinput_changes.passwordInputValid = /*passwordInputValid*/
        ctx2[4];
        add_flush_callback(() => updating_passwordInputValid = false);
      }
      passwordinput.$set(passwordinput_changes);
      const submitbutton_changes = {};
      if (dirty & /*showLoader*/
      4)
        submitbutton_changes.isLoading = /*showLoader*/
        ctx2[2];
      submitbutton.$set(submitbutton_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(backicon.$$.fragment, local);
      transition_in(closebutton.$$.fragment, local);
      transition_in(figureelement.$$.fragment, local);
      transition_in(if_block);
      transition_in(passwordinput.$$.fragment, local);
      transition_in(submitbutton.$$.fragment, local);
      transition_in(modalfooter.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(backicon.$$.fragment, local);
      transition_out(closebutton.$$.fragment, local);
      transition_out(figureelement.$$.fragment, local);
      transition_out(if_block);
      transition_out(passwordinput.$$.fragment, local);
      transition_out(submitbutton.$$.fragment, local);
      transition_out(modalfooter.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div3);
      destroy_component(backicon);
      destroy_component(closebutton);
      destroy_component(figureelement);
      if (if_block)
        if_block.d();
      destroy_component(passwordinput);
      destroy_component(submitbutton);
      destroy_component(modalfooter);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$z($$self, $$props, $$invalidate) {
  let $textStore;
  component_subscribe($$self, TextStore, ($$value) => $$invalidate(10, $textStore = $$value));
  let text2 = $textStore.text;
  let { closeModal } = $$props;
  let { display } = $$props;
  let { onSuccessPasswordReset } = $$props;
  let showLoader2 = false;
  let tokenInputValid = true;
  let passwordInputValid = true;
  onMount(() => {
    const tokenElements = [...document.querySelectorAll("input.ms-form__input--token")];
    tokenElements.forEach((ele, index) => {
      ele.addEventListener("keydown", (e) => {
        if (e.keyCode === 8 && e.target.value === "")
          tokenElements[Math.max(0, index - 1)].focus();
      });
      ele.addEventListener("input", (e) => {
        const [first, ...rest] = e.target.value;
        e.target.value = first != null ? first : "";
        const lastInputBox = index === tokenElements.length - 1;
        const insertedContent = first !== void 0;
        if (insertedContent && !lastInputBox) {
          tokenElements[index + 1].focus();
          tokenElements[index + 1].value = rest.join("");
          tokenElements[index + 1].dispatchEvent(new Event("input"));
        }
      });
    });
  });
  const validateFields = (e) => {
    const tokenElements = [...document.querySelectorAll("input.ms-form__input--token")];
    const hasEmpty = tokenElements.some((el) => {
      if (!el.value) {
        return true;
      }
      return false;
    });
    if (hasEmpty) {
      $$invalidate(3, tokenInputValid = false);
    } else {
      $$invalidate(3, tokenInputValid = true);
    }
    return !hasEmpty;
  };
  function submitPasswordToken(e) {
    return __async(this, null, function* () {
      const passwordInput = e.target[7];
      const isValid = validateFields();
      if (!isValid)
        return;
      const token = [...document.getElementsByName("token")].filter(({ name }) => name).map(({ value }) => value).join("");
      try {
        $$invalidate(2, showLoader2 = true);
        const { _internalUseOnly: { message } } = yield window.$memberstackDom.resetMemberPassword({ token, newPassword: passwordInput.value });
        window.$memberstackDom._showMessage(message, false);
        onSuccessPasswordReset({ type: "PASSWORD_RESET", data: {} });
        $$invalidate(2, showLoader2 = false);
        $$invalidate(0, display = "reset_password_success");
      } catch (err) {
        $$invalidate(2, showLoader2 = false);
        console.log(err);
        if (err.message) {
          window.$memberstackDom._showMessage(err.message, true);
        }
      }
    });
  }
  const click_handler = () => $$invalidate(0, display = "forgot_password");
  function passwordinput_passwordInputValid_binding(value) {
    passwordInputValid = value;
    $$invalidate(4, passwordInputValid);
  }
  $$self.$$set = ($$props2) => {
    if ("closeModal" in $$props2)
      $$invalidate(1, closeModal = $$props2.closeModal);
    if ("display" in $$props2)
      $$invalidate(0, display = $$props2.display);
    if ("onSuccessPasswordReset" in $$props2)
      $$invalidate(7, onSuccessPasswordReset = $$props2.onSuccessPasswordReset);
  };
  return [
    display,
    closeModal,
    showLoader2,
    tokenInputValid,
    passwordInputValid,
    text2,
    submitPasswordToken,
    onSuccessPasswordReset,
    click_handler,
    passwordinput_passwordInputValid_binding
  ];
}
var PassTokenModal = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$z, create_fragment$13, safe_not_equal, {
      closeModal: 1,
      display: 0,
      onSuccessPasswordReset: 7
    });
  }
};
function create_fragment$12(ctx) {
  let div2;
  let div0;
  let t0;
  let closebutton;
  let t1;
  let div1;
  let figureelement;
  let t2;
  let h2;
  let t4;
  let p;
  let t7;
  let modalfooter;
  let current;
  closebutton = new CloseButton({
    props: { closeModal: (
      /*closeModal*/
      ctx[0]
    ) }
  });
  figureelement = new FigureElement({});
  modalfooter = new ModalFooter({});
  return {
    c() {
      div2 = element("div");
      div0 = element("div");
      t0 = space();
      create_component(closebutton.$$.fragment);
      t1 = space();
      div1 = element("div");
      create_component(figureelement.$$.fragment);
      t2 = space();
      h2 = element("h2");
      h2.textContent = "Success!";
      t4 = space();
      p = element("p");
      p.innerHTML = `Your password has been reset. <br/>
      Please login with your new credentials.`;
      t7 = space();
      create_component(modalfooter.$$.fragment);
      attr(div0, "data-cy", "back-btn");
      attr(div0, "class", "ms-modal__back");
      attr(h2, "class", "ms-modal__title ms-modal__title--sub-text");
      attr(p, "class", "ms-modal__text");
      attr(div1, "class", "ms-modal__content");
      attr(div2, "class", "ms-modal");
      attr(div2, "id", "PasswordSuccessModal");
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      append(div2, div0);
      append(div2, t0);
      mount_component(closebutton, div2, null);
      append(div2, t1);
      append(div2, div1);
      mount_component(figureelement, div1, null);
      append(div1, t2);
      append(div1, h2);
      append(div1, t4);
      append(div1, p);
      append(div2, t7);
      mount_component(modalfooter, div2, null);
      current = true;
    },
    p(ctx2, [dirty]) {
      const closebutton_changes = {};
      if (dirty & /*closeModal*/
      1)
        closebutton_changes.closeModal = /*closeModal*/
        ctx2[0];
      closebutton.$set(closebutton_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(closebutton.$$.fragment, local);
      transition_in(figureelement.$$.fragment, local);
      transition_in(modalfooter.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(closebutton.$$.fragment, local);
      transition_out(figureelement.$$.fragment, local);
      transition_out(modalfooter.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div2);
      destroy_component(closebutton);
      destroy_component(figureelement);
      destroy_component(modalfooter);
    }
  };
}
function instance$y($$self, $$props, $$invalidate) {
  let { closeModal } = $$props;
  $$self.$$set = ($$props2) => {
    if ("closeModal" in $$props2)
      $$invalidate(0, closeModal = $$props2.closeModal);
  };
  return [closeModal];
}
var PassSuccessModal = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$y, create_fragment$12, safe_not_equal, { closeModal: 0 });
  }
};
function create_else_block_1$6(ctx) {
  let button;
  let backicon;
  let current;
  let mounted;
  let dispose;
  backicon = new BackIcon({});
  return {
    c() {
      button = element("button");
      create_component(backicon.$$.fragment);
    },
    m(target, anchor) {
      insert(target, button, anchor);
      mount_component(backicon, button, null);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler_1*/
          ctx[10]
        );
        mounted = true;
      }
    },
    p: noop,
    i(local) {
      if (current)
        return;
      transition_in(backicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(backicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(button);
      destroy_component(backicon);
      mounted = false;
      dispose();
    }
  };
}
function create_if_block_2$h(ctx) {
  let button;
  let backicon;
  let current;
  let mounted;
  let dispose;
  backicon = new BackIcon({});
  return {
    c() {
      button = element("button");
      create_component(backicon.$$.fragment);
    },
    m(target, anchor) {
      insert(target, button, anchor);
      mount_component(backicon, button, null);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler*/
          ctx[9]
        );
        mounted = true;
      }
    },
    p: noop,
    i(local) {
      if (current)
        return;
      transition_in(backicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(backicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(button);
      destroy_component(backicon);
      mounted = false;
      dispose();
    }
  };
}
function create_else_block$d(ctx) {
  let h2;
  return {
    c() {
      h2 = element("h2");
      h2.textContent = `${/*text*/
      ctx[5]["passwordless_token_heading"] || "Create an account"}`;
      attr(h2, "class", "ms-modal__title ms-modal__title--sub-text");
    },
    m(target, anchor) {
      insert(target, h2, anchor);
    },
    p: noop,
    d(detaching) {
      if (detaching)
        detach(h2);
    }
  };
}
function create_if_block_1$m(ctx) {
  let h2;
  return {
    c() {
      h2 = element("h2");
      h2.textContent = `${/*text*/
      ctx[5]["login_to_your_account"] || "Login to your account"}`;
      attr(h2, "class", "ms-modal__title ms-modal__title--sub-text");
    },
    m(target, anchor) {
      insert(target, h2, anchor);
    },
    p: noop,
    d(detaching) {
      if (detaching)
        detach(h2);
    }
  };
}
function create_if_block$s(ctx) {
  let div;
  let erroricon;
  let t;
  let current;
  erroricon = new ErrorIcon({});
  return {
    c() {
      div = element("div");
      create_component(erroricon.$$.fragment);
      t = text(" Please enter a valid code");
      attr(div, "class", "ms-form__error");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(erroricon, div, null);
      append(div, t);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(erroricon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(erroricon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      destroy_component(erroricon);
    }
  };
}
function create_fragment$11(ctx) {
  let div3;
  let div0;
  let current_block_type_index;
  let if_block0;
  let t0;
  let closebutton;
  let t1;
  let div2;
  let figureelement;
  let t2;
  let t3;
  let p;
  let t5;
  let form;
  let div1;
  let label;
  let t7;
  let fieldset;
  let t13;
  let t14;
  let submitbutton;
  let t15;
  let modalfooter;
  let current;
  let mounted;
  let dispose;
  const if_block_creators = [create_if_block_2$h, create_else_block_1$6];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*$PasswordlessStore*/
      ctx2[4].passwordlessModalType === "login"
    )
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  closebutton = new CloseButton({
    props: { closeModal: (
      /*closeModal*/
      ctx[1]
    ) }
  });
  figureelement = new FigureElement({});
  function select_block_type_1(ctx2, dirty) {
    if (
      /*$PasswordlessStore*/
      ctx2[4].passwordlessModalType === "login"
    )
      return create_if_block_1$m;
    return create_else_block$d;
  }
  let current_block_type = select_block_type_1(ctx);
  let if_block1 = current_block_type(ctx);
  let if_block2 = !/*tokenInputValid*/
  ctx[3] && create_if_block$s();
  submitbutton = new SubmitButton({
    props: {
      buttonText: (
        /*text*/
        ctx[5]["login_verify_email"] || "Verify Email"
      ),
      isLoading: (
        /*showLoader*/
        ctx[2]
      )
    }
  });
  modalfooter = new ModalFooter({});
  return {
    c() {
      div3 = element("div");
      div0 = element("div");
      if_block0.c();
      t0 = space();
      create_component(closebutton.$$.fragment);
      t1 = space();
      div2 = element("div");
      create_component(figureelement.$$.fragment);
      t2 = space();
      if_block1.c();
      t3 = space();
      p = element("p");
      p.textContent = `${/*text*/
      ctx[5]["login_passwordless_instructions"] || "Enter the verification code sent to your email address"}`;
      t5 = space();
      form = element("form");
      div1 = element("div");
      label = element("label");
      label.textContent = `${/*text*/
      ctx[5]["login_verification_code"] || "Verification Code"}`;
      t7 = space();
      fieldset = element("fieldset");
      fieldset.innerHTML = `<input name="token" class="ms-form__input ms-form__input--token" required="" type="tel"/> 
          <input name="token" class="ms-form__input ms-form__input--token" required="" type="tel"/> 
          <input name="token" class="ms-form__input ms-form__input--token" required="" type="tel"/> 
          <input name="token" class="ms-form__input ms-form__input--token" required="" type="tel"/> 
          <input name="token" class="ms-form__input ms-form__input--token" required="" type="tel"/> 
          <input name="token" class="ms-form__input ms-form__input--token" type="tel"/>`;
      t13 = space();
      if (if_block2)
        if_block2.c();
      t14 = space();
      create_component(submitbutton.$$.fragment);
      t15 = space();
      create_component(modalfooter.$$.fragment);
      attr(div0, "class", "ms-modal__back");
      attr(p, "class", "ms-modal__text");
      attr(label, "class", "ms-form__label");
      attr(label, "for", "token-fieldset");
      attr(fieldset, "class", "ms-form__fieldset");
      attr(fieldset, "name", "token-fieldset");
      attr(div1, "class", "ms-form__group");
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(form, "autocomplete", "off");
      attr(div2, "class", "ms-modal__content");
      attr(div3, "class", "ms-modal");
      attr(div3, "id", "PasswordlessTokenModal");
    },
    m(target, anchor) {
      insert(target, div3, anchor);
      append(div3, div0);
      if_blocks[current_block_type_index].m(div0, null);
      append(div3, t0);
      mount_component(closebutton, div3, null);
      append(div3, t1);
      append(div3, div2);
      mount_component(figureelement, div2, null);
      append(div2, t2);
      if_block1.m(div2, null);
      append(div2, t3);
      append(div2, p);
      append(div2, t5);
      append(div2, form);
      append(form, div1);
      append(div1, label);
      append(div1, t7);
      append(div1, fieldset);
      append(div1, t13);
      if (if_block2)
        if_block2.m(div1, null);
      append(form, t14);
      mount_component(submitbutton, form, null);
      append(div3, t15);
      mount_component(modalfooter, div3, null);
      current = true;
      if (!mounted) {
        dispose = listen(form, "submit", stop_propagation(prevent_default(
          /*submitPasswordlessToken*/
          ctx[6]
        )));
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block0 = if_blocks[current_block_type_index];
        if (!if_block0) {
          if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block0.c();
        } else {
          if_block0.p(ctx2, dirty);
        }
        transition_in(if_block0, 1);
        if_block0.m(div0, null);
      }
      const closebutton_changes = {};
      if (dirty & /*closeModal*/
      2)
        closebutton_changes.closeModal = /*closeModal*/
        ctx2[1];
      closebutton.$set(closebutton_changes);
      if (current_block_type === (current_block_type = select_block_type_1(ctx2)) && if_block1) {
        if_block1.p(ctx2, dirty);
      } else {
        if_block1.d(1);
        if_block1 = current_block_type(ctx2);
        if (if_block1) {
          if_block1.c();
          if_block1.m(div2, t3);
        }
      }
      if (!/*tokenInputValid*/
      ctx2[3]) {
        if (if_block2) {
          if (dirty & /*tokenInputValid*/
          8) {
            transition_in(if_block2, 1);
          }
        } else {
          if_block2 = create_if_block$s();
          if_block2.c();
          transition_in(if_block2, 1);
          if_block2.m(div1, null);
        }
      } else if (if_block2) {
        group_outros();
        transition_out(if_block2, 1, 1, () => {
          if_block2 = null;
        });
        check_outros();
      }
      const submitbutton_changes = {};
      if (dirty & /*showLoader*/
      4)
        submitbutton_changes.isLoading = /*showLoader*/
        ctx2[2];
      submitbutton.$set(submitbutton_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block0);
      transition_in(closebutton.$$.fragment, local);
      transition_in(figureelement.$$.fragment, local);
      transition_in(if_block2);
      transition_in(submitbutton.$$.fragment, local);
      transition_in(modalfooter.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(closebutton.$$.fragment, local);
      transition_out(figureelement.$$.fragment, local);
      transition_out(if_block2);
      transition_out(submitbutton.$$.fragment, local);
      transition_out(modalfooter.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div3);
      if_blocks[current_block_type_index].d();
      destroy_component(closebutton);
      destroy_component(figureelement);
      if_block1.d();
      if (if_block2)
        if_block2.d();
      destroy_component(submitbutton);
      destroy_component(modalfooter);
      mounted = false;
      dispose();
    }
  };
}
function instance$x($$self, $$props, $$invalidate) {
  let $PasswordlessStore;
  let $textStore;
  component_subscribe($$self, PasswordlessStore, ($$value) => $$invalidate(4, $PasswordlessStore = $$value));
  component_subscribe($$self, TextStore, ($$value) => $$invalidate(11, $textStore = $$value));
  let text2 = $textStore.text;
  let { closeModal } = $$props;
  let { display } = $$props;
  let { onSuccessPasswordlessToken } = $$props;
  let { onSuccess } = $$props;
  let showLoader2 = false;
  let tokenInputValid = true;
  onMount(() => {
    const tokenElements = [...document.querySelectorAll("input.ms-form__input--token")];
    tokenElements.forEach((ele, index) => {
      ele.addEventListener("keydown", (e) => {
        if (e.keyCode === 8 && e.target.value === "")
          tokenElements[Math.max(0, index - 1)].focus();
      });
      ele.addEventListener("input", (e) => {
        const [first, ...rest] = e.target.value;
        e.target.value = first != null ? first : "";
        const lastInputBox = index === tokenElements.length - 1;
        const insertedContent = first !== void 0;
        if (insertedContent && !lastInputBox) {
          tokenElements[index + 1].focus();
          tokenElements[index + 1].value = rest.join("");
          tokenElements[index + 1].dispatchEvent(new Event("input"));
        }
      });
    });
  });
  const validateFields = (e) => {
    const tokenElements = [...document.querySelectorAll("input.ms-form__input--token")];
    const hasEmpty = tokenElements.some((el) => {
      if (!el.value) {
        return true;
      }
      return false;
    });
    if (hasEmpty) {
      $$invalidate(3, tokenInputValid = false);
    } else {
      $$invalidate(3, tokenInputValid = true);
    }
    return !hasEmpty;
  };
  function submitPasswordlessToken(e) {
    return __async(this, null, function* () {
      e.target[7];
      const isValid = validateFields();
      if (!isValid)
        return;
      const token = [...document.getElementsByName("token")].filter(({ name }) => name).map(({ value }) => value).join("");
      try {
        $$invalidate(2, showLoader2 = true);
        if ($PasswordlessStore.passwordlessModalType === "login") {
          const { data } = yield window.$memberstackDom.loginMemberPasswordless(
            {
              passwordlessToken: token,
              email: $PasswordlessStore.passwordlessEmail
            },
            { includeContentGroups: true }
          );
          onSuccess({ type: "LOGIN", data });
          $$invalidate(2, showLoader2 = false);
        } else {
          const plans = ($PasswordlessStore.passwordlessPlans || []).map((plan) => {
            return { planId: plan };
          });
          const { data } = yield window.$memberstackDom.signupMemberPasswordless(
            {
              passwordlessToken: token,
              email: $PasswordlessStore.passwordlessEmail,
              plans,
              customFields: $PasswordlessStore.passwordlessCustomFields
            },
            { includeContentGroups: true }
          );
          onSuccess({ type: "SIGNUP", data });
          $$invalidate(2, showLoader2 = false);
        }
      } catch (err) {
        $$invalidate(2, showLoader2 = false);
        console.log(err);
        if (err.message) {
          window.$memberstackDom._showMessage(err.message, true);
        }
      }
    });
  }
  const click_handler = () => $$invalidate(0, display = "login");
  const click_handler_1 = () => $$invalidate(0, display = "signup");
  $$self.$$set = ($$props2) => {
    if ("closeModal" in $$props2)
      $$invalidate(1, closeModal = $$props2.closeModal);
    if ("display" in $$props2)
      $$invalidate(0, display = $$props2.display);
    if ("onSuccessPasswordlessToken" in $$props2)
      $$invalidate(7, onSuccessPasswordlessToken = $$props2.onSuccessPasswordlessToken);
    if ("onSuccess" in $$props2)
      $$invalidate(8, onSuccess = $$props2.onSuccess);
  };
  return [
    display,
    closeModal,
    showLoader2,
    tokenInputValid,
    $PasswordlessStore,
    text2,
    submitPasswordlessToken,
    onSuccessPasswordlessToken,
    onSuccess,
    click_handler,
    click_handler_1
  ];
}
var PasswordlessTokenModal = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$x, create_fragment$11, safe_not_equal, {
      closeModal: 1,
      display: 0,
      onSuccessPasswordlessToken: 7,
      onSuccess: 8
    });
  }
};
function create_fragment$10(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "d", "m8 8c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z");
      attr(path, "fill", "currentColor");
      attr(svg, "fill", "none");
      attr(svg, "viewBox", "0 0 16 16");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var ProfileIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$10, safe_not_equal, {});
  }
};
function create_fragment$$(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "d", "m9 0-9 4v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12v-6l-9-4zm0 10.99h7c-0.53 4.12-3.28 7.79-7 8.94v-8.93h-7v-5.7l7-3.11v8.8z");
      attr(path, "fill", "currentColor");
      attr(svg, "fill", "none");
      attr(svg, "viewBox", "0 0 18 22");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var SecurityIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$$, safe_not_equal, {});
  }
};
function create_fragment$_(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M16 16H2V2H9V0H2C0.89 0 0 0.9 0 2V16C0 17.1 0.89 18 2 18H16C17.1 18 18 17.1 18 16V9H16V16ZM11 0V2H14.59L4.76 11.83L6.17 13.24L16 3.41V7H18V0H11Z");
      attr(svg, "fill", "none");
      attr(svg, "viewBox", "0 0 18 18");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var LinkOutIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$_, safe_not_equal, {});
  }
};
function create_fragment$Z(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "d", "M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z");
      attr(path, "fill", "currentColor");
      attr(svg, "width", "16");
      attr(svg, "height", "16");
      attr(svg, "viewBox", "0 0 16 16");
      attr(svg, "fill", "none");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var LogoutIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$Z, safe_not_equal, {});
  }
};
function create_fragment$Y(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M12 2l-5.5 9h11L12 2zm0 3.84L13.93 9h-3.87L12 5.84zM17.5 13c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 7c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM3 21.5h8v-8H3v8zm2-6h4v4H5v-4z");
      attr(svg, "fill", "none");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "viewBox", "3 2 19 20");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var PlansIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$Y, safe_not_equal, {});
  }
};
function create_if_block_2$g(ctx) {
  let button;
  let profileicon;
  let t;
  let current;
  let mounted;
  let dispose;
  profileicon = new ProfileIcon({});
  return {
    c() {
      button = element("button");
      create_component(profileicon.$$.fragment);
      t = text(" Profile");
      attr(button, "data-cy", "profile-btn");
      attr(button, "class", "ms-modal__profile-option");
      toggle_class(
        button,
        "ms-modal__profile-option--active",
        /*displayProfile*/
        ctx[0] === "profile"
      );
    },
    m(target, anchor) {
      insert(target, button, anchor);
      mount_component(profileicon, button, null);
      append(button, t);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler*/
          ctx[8]
        );
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      if (!current || dirty & /*displayProfile*/
      1) {
        toggle_class(
          button,
          "ms-modal__profile-option--active",
          /*displayProfile*/
          ctx2[0] === "profile"
        );
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(profileicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(profileicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(button);
      destroy_component(profileicon);
      mounted = false;
      dispose();
    }
  };
}
function create_if_block_1$l(ctx) {
  let button;
  let plansicon;
  let t;
  let current;
  let mounted;
  let dispose;
  plansicon = new PlansIcon({});
  return {
    c() {
      button = element("button");
      create_component(plansicon.$$.fragment);
      t = text(" Plans");
      attr(button, "data-cy", "plans-btn");
      attr(button, "class", "ms-modal__profile-option");
      toggle_class(
        button,
        "ms-modal__profile-option--active",
        /*displayProfile*/
        ctx[0] === "plans"
      );
    },
    m(target, anchor) {
      insert(target, button, anchor);
      mount_component(plansicon, button, null);
      append(button, t);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler_2*/
          ctx[10]
        );
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      if (!current || dirty & /*displayProfile*/
      1) {
        toggle_class(
          button,
          "ms-modal__profile-option--active",
          /*displayProfile*/
          ctx2[0] === "plans"
        );
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(plansicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(plansicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(button);
      destroy_component(plansicon);
      mounted = false;
      dispose();
    }
  };
}
function create_if_block$r(ctx) {
  let button;
  let plansicon;
  let t;
  let current;
  let mounted;
  let dispose;
  plansicon = new PlansIcon({});
  return {
    c() {
      button = element("button");
      create_component(plansicon.$$.fragment);
      t = text(" Team");
      attr(button, "data-cy", "plans-btn");
      attr(button, "class", "ms-modal__profile-option");
      toggle_class(
        button,
        "ms-modal__profile-option--active",
        /*displayProfile*/
        ctx[0] === "team"
      );
    },
    m(target, anchor) {
      insert(target, button, anchor);
      mount_component(plansicon, button, null);
      append(button, t);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler_3*/
          ctx[11]
        );
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      if (!current || dirty & /*displayProfile*/
      1) {
        toggle_class(
          button,
          "ms-modal__profile-option--active",
          /*displayProfile*/
          ctx2[0] === "team"
        );
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(plansicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(plansicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(button);
      destroy_component(plansicon);
      mounted = false;
      dispose();
    }
  };
}
function create_fragment$X(ctx) {
  let t0;
  let button0;
  let securityicon;
  let t1;
  let t2;
  let show_if_1 = (
    /*showPlansNavButton*/
    ctx[3]()
  );
  let t3;
  let show_if = (
    /*showTeamNavButton*/
    ctx[4]()
  );
  let t4;
  let button1;
  let logouticon;
  let t5;
  let current;
  let mounted;
  let dispose;
  let if_block0 = !/*hideProfileSection*/
  ctx[1] && create_if_block_2$g(ctx);
  securityicon = new SecurityIcon({});
  let if_block1 = show_if_1 && create_if_block_1$l(ctx);
  let if_block2 = show_if && create_if_block$r(ctx);
  logouticon = new LogoutIcon({});
  return {
    c() {
      if (if_block0)
        if_block0.c();
      t0 = space();
      button0 = element("button");
      create_component(securityicon.$$.fragment);
      t1 = text(" Security");
      t2 = space();
      if (if_block1)
        if_block1.c();
      t3 = space();
      if (if_block2)
        if_block2.c();
      t4 = space();
      button1 = element("button");
      create_component(logouticon.$$.fragment);
      t5 = text(" Logout");
      attr(button0, "data-cy", "security-btn");
      attr(button0, "class", "ms-modal__profile-option");
      toggle_class(
        button0,
        "ms-modal__profile-option--active",
        /*displayProfile*/
        ctx[0] === "security" || /*displayProfile*/
        ctx[0] === "changePassword"
      );
      attr(button1, "data-cy", "logout-btn");
      attr(button1, "class", "ms-modal__profile-option");
    },
    m(target, anchor) {
      if (if_block0)
        if_block0.m(target, anchor);
      insert(target, t0, anchor);
      insert(target, button0, anchor);
      mount_component(securityicon, button0, null);
      append(button0, t1);
      insert(target, t2, anchor);
      if (if_block1)
        if_block1.m(target, anchor);
      insert(target, t3, anchor);
      if (if_block2)
        if_block2.m(target, anchor);
      insert(target, t4, anchor);
      insert(target, button1, anchor);
      mount_component(logouticon, button1, null);
      append(button1, t5);
      current = true;
      if (!mounted) {
        dispose = [
          listen(
            button0,
            "click",
            /*click_handler_1*/
            ctx[9]
          ),
          listen(
            button1,
            "click",
            /*logout*/
            ctx[2]
          )
        ];
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (!/*hideProfileSection*/
      ctx2[1]) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
          if (dirty & /*hideProfileSection*/
          2) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_2$g(ctx2);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(t0.parentNode, t0);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      if (!current || dirty & /*displayProfile*/
      1) {
        toggle_class(
          button0,
          "ms-modal__profile-option--active",
          /*displayProfile*/
          ctx2[0] === "security" || /*displayProfile*/
          ctx2[0] === "changePassword"
        );
      }
      if (show_if_1)
        if_block1.p(ctx2, dirty);
      if (show_if)
        if_block2.p(ctx2, dirty);
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block0);
      transition_in(securityicon.$$.fragment, local);
      transition_in(if_block1);
      transition_in(if_block2);
      transition_in(logouticon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(securityicon.$$.fragment, local);
      transition_out(if_block1);
      transition_out(if_block2);
      transition_out(logouticon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (if_block0)
        if_block0.d(detaching);
      if (detaching)
        detach(t0);
      if (detaching)
        detach(button0);
      destroy_component(securityicon);
      if (detaching)
        detach(t2);
      if (if_block1)
        if_block1.d(detaching);
      if (detaching)
        detach(t3);
      if (if_block2)
        if_block2.d(detaching);
      if (detaching)
        detach(t4);
      if (detaching)
        detach(button1);
      destroy_component(logouticon);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$w($$self, $$props, $$invalidate) {
  let { member } = $$props;
  let { onSuccessLogout } = $$props;
  let { displayProfile } = $$props;
  let { profileLoader } = $$props;
  let { hideProfileSection: hideProfileSection2 } = $$props;
  const unsubscribe = AppStore.subscribe((data) => {
    if (!data.initialValue) {
      const container = document.getElementById("msOverlay");
      const css = document.createElement("style");
      const color = data.branding.colors.lightMode.primaryButton;
      const fullCSS = `.ms-modal__profile-option:hover { color: ${color};} .ms-modal__profile-option--active { color: ${color};} .ms-modal__save-button { background: ${color};} .ms-modal__save-button:disabled { background: ${color};}`;
      css.appendChild(document.createTextNode(fullCSS));
      container.appendChild(css);
    }
  });
  onDestroy(() => {
    unsubscribe();
  });
  function logout(e) {
    return __async(this, null, function* () {
      try {
        const { data, _internalUseOnly: { message } } = yield window.$memberstackDom.logout();
        window.$memberstackDom._showMessage(message, false);
        onSuccessLogout({ type: "LOGOUT", data });
      } catch (err) {
        window.$memberstackDom._showMessage(err.message, true);
      }
    });
  }
  function showPlansNavButton() {
    return member.stripeCustomerId || member.planConnections.some((plan) => plan.type === "FREE") || member.teams.joinedTeams.length > 0;
  }
  function showTeamNavButton() {
    var _a;
    return ((_a = member.teams) == null ? void 0 : _a.ownedTeams.length) > 0;
  }
  const click_handler = () => $$invalidate(0, displayProfile = "profile");
  const click_handler_1 = () => $$invalidate(0, displayProfile = "security");
  const click_handler_2 = () => $$invalidate(0, displayProfile = "plans");
  const click_handler_3 = () => $$invalidate(0, displayProfile = "team");
  $$self.$$set = ($$props2) => {
    if ("member" in $$props2)
      $$invalidate(5, member = $$props2.member);
    if ("onSuccessLogout" in $$props2)
      $$invalidate(6, onSuccessLogout = $$props2.onSuccessLogout);
    if ("displayProfile" in $$props2)
      $$invalidate(0, displayProfile = $$props2.displayProfile);
    if ("profileLoader" in $$props2)
      $$invalidate(7, profileLoader = $$props2.profileLoader);
    if ("hideProfileSection" in $$props2)
      $$invalidate(1, hideProfileSection2 = $$props2.hideProfileSection);
  };
  return [
    displayProfile,
    hideProfileSection2,
    logout,
    showPlansNavButton,
    showTeamNavButton,
    member,
    onSuccessLogout,
    profileLoader,
    click_handler,
    click_handler_1,
    click_handler_2,
    click_handler_3
  ];
}
var ProfileModalNav = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$w, create_fragment$X, safe_not_equal, {
      member: 5,
      onSuccessLogout: 6,
      displayProfile: 0,
      profileLoader: 7,
      hideProfileSection: 1
    });
  }
};
function create_fragment$W(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "white");
      attr(path, "d", "M21 21C24.315 21 27 18.315 27 15C27 11.685 24.315 9 21 9C17.685 9 15 11.685 15 15C15 18.315 17.685 21 21 21ZM21 24C16.995 24 9 26.01 9 30V31.5C9 32.325 9.675 33 10.5 33H31.5C32.325 33 33 32.325 33 31.5V30C33 26.01 25.005 24 21 24Z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "width", "42");
      attr(svg, "height", "42");
      attr(svg, "viewBox", "0 0 42 42");
      attr(svg, "fill", "none");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var ProfileDefaultImage = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$W, safe_not_equal, {});
  }
};
function create_fragment$V(ctx) {
  let svg;
  let g;
  let path0;
  let defs;
  let clipPath;
  let path1;
  return {
    c() {
      svg = svg_element("svg");
      g = svg_element("g");
      path0 = svg_element("path");
      defs = svg_element("defs");
      clipPath = svg_element("clipPath");
      path1 = svg_element("path");
      attr(path0, "fill", "#494949");
      attr(path0, "d", "M6.667 10.667h2.666c.367 0 .667-.3.667-.667V6.667h1.06c.593 0 .893-.72.473-1.14l-3.06-3.06a.664.664 0 0 0-.94 0l-3.06 3.06c-.42.42-.126 1.14.467 1.14H6V10c0 .367.3.667.667.667zM4 12h8c.367 0 .667.3.667.667 0 .367-.3.667-.667.667H4a.669.669 0 0 1-.667-.667c0-.367.3-.667.667-.667z");
      attr(g, "clip-path", "url(#a)");
      attr(path1, "fill", "#fff");
      attr(path1, "d", "M0 0h16v16H0z");
      attr(clipPath, "id", "a");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "fill", "none");
      attr(svg, "viewBox", "0 0 16 16");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, g);
      append(g, path0);
      append(svg, defs);
      append(defs, clipPath);
      append(clipPath, path1);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var UploadIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$V, safe_not_equal, {});
  }
};
function get_each_context$b(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[10] = list[i];
  child_ctx[11] = list;
  child_ctx[12] = i;
  return child_ctx;
}
function create_else_block_1$5(ctx) {
  let profiledefaultimage;
  let current;
  profiledefaultimage = new ProfileDefaultImage({});
  return {
    c() {
      create_component(profiledefaultimage.$$.fragment);
    },
    m(target, anchor) {
      mount_component(profiledefaultimage, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current)
        return;
      transition_in(profiledefaultimage.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(profiledefaultimage.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(profiledefaultimage, detaching);
    }
  };
}
function create_if_block_2$f(ctx) {
  let img;
  let img_src_value;
  return {
    c() {
      img = element("img");
      if (!src_url_equal(img.src, img_src_value = /*member*/
      ctx[0].profileImage))
        attr(img, "src", img_src_value);
      attr(img, "alt", "profile image");
    },
    m(target, anchor) {
      insert(target, img, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*member*/
      1 && !src_url_equal(img.src, img_src_value = /*member*/
      ctx2[0].profileImage)) {
        attr(img, "src", img_src_value);
      }
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(img);
    }
  };
}
function create_else_block$c(ctx) {
  let t;
  return {
    c() {
      t = text("Replace Image");
    },
    m(target, anchor) {
      insert(target, t, anchor);
    },
    d(detaching) {
      if (detaching)
        detach(t);
    }
  };
}
function create_if_block_1$k(ctx) {
  let t;
  return {
    c() {
      t = text("Upload Profile Image");
    },
    m(target, anchor) {
      insert(target, t, anchor);
    },
    d(detaching) {
      if (detaching)
        detach(t);
    }
  };
}
function create_if_block$q(ctx) {
  let div1;
  let div0;
  let label;
  let t0_value = (
    /*customField*/
    ctx[10].label + ""
  );
  let t0;
  let label_for_value;
  let t1;
  let input;
  let input_placeholder_value;
  let input_name_value;
  let t2;
  let mounted;
  let dispose;
  function input_input_handler() {
    ctx[6].call(
      input,
      /*customField*/
      ctx[10]
    );
  }
  return {
    c() {
      div1 = element("div");
      div0 = element("div");
      label = element("label");
      t0 = text(t0_value);
      t1 = space();
      input = element("input");
      t2 = space();
      attr(label, "class", "ms-form__label");
      attr(label, "for", label_for_value = /*customField*/
      ctx[10].key);
      attr(input, "class", "ms-form__input");
      attr(input, "type", "text");
      attr(input, "placeholder", input_placeholder_value = /*customField*/
      ctx[10].label);
      attr(input, "name", input_name_value = /*customField*/
      ctx[10].key);
      attr(div0, "class", "ms-form__group");
      attr(div1, "class", "ms-modal__custom-field-container");
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);
      append(div0, label);
      append(label, t0);
      append(div0, t1);
      append(div0, input);
      set_input_value(
        input,
        /*member*/
        ctx[0].customFields[
          /*customField*/
          ctx[10].key
        ]
      );
      append(div1, t2);
      if (!mounted) {
        dispose = [
          listen(input, "input", input_input_handler),
          listen(
            input,
            "keyup",
            /*checkForChange*/
            ctx[4]
          ),
          listen(
            input,
            "paste",
            /*checkForChange*/
            ctx[4]
          )
        ];
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*customFields*/
      2 && t0_value !== (t0_value = /*customField*/
      ctx[10].label + ""))
        set_data(t0, t0_value);
      if (dirty & /*customFields*/
      2 && label_for_value !== (label_for_value = /*customField*/
      ctx[10].key)) {
        attr(label, "for", label_for_value);
      }
      if (dirty & /*customFields*/
      2 && input_placeholder_value !== (input_placeholder_value = /*customField*/
      ctx[10].label)) {
        attr(input, "placeholder", input_placeholder_value);
      }
      if (dirty & /*customFields*/
      2 && input_name_value !== (input_name_value = /*customField*/
      ctx[10].key)) {
        attr(input, "name", input_name_value);
      }
      if (dirty & /*member, customFields*/
      3 && input.value !== /*member*/
      ctx[0].customFields[
        /*customField*/
        ctx[10].key
      ]) {
        set_input_value(
          input,
          /*member*/
          ctx[0].customFields[
            /*customField*/
            ctx[10].key
          ]
        );
      }
    },
    d(detaching) {
      if (detaching)
        detach(div1);
      mounted = false;
      run_all(dispose);
    }
  };
}
function create_each_block$b(ctx) {
  let if_block_anchor;
  let if_block = (
    /*customField*/
    ctx[10].hidden !== true && create_if_block$q(ctx)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx2, dirty) {
      if (
        /*customField*/
        ctx2[10].hidden !== true
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
        } else {
          if_block = create_if_block$q(ctx2);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    d(detaching) {
      if (if_block)
        if_block.d(detaching);
      if (detaching)
        detach(if_block_anchor);
    }
  };
}
function create_fragment$U(ctx) {
  let div1;
  let h2;
  let t1;
  let div0;
  let button0;
  let t2;
  let t3;
  let div4;
  let div2;
  let current_block_type_index;
  let if_block0;
  let t4;
  let div3;
  let button1;
  let uploadicon;
  let t5;
  let form;
  let current;
  let mounted;
  let dispose;
  const if_block_creators = [create_if_block_2$f, create_else_block_1$5];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*member*/
      ctx2[0].profileImage
    )
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  uploadicon = new UploadIcon({});
  function select_block_type_1(ctx2, dirty) {
    if (!/*member*/
    ctx2[0].profileImage)
      return create_if_block_1$k;
    return create_else_block$c;
  }
  let current_block_type = select_block_type_1(ctx);
  let if_block1 = current_block_type(ctx);
  let each_value = (
    /*customFields*/
    ctx[1]
  );
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$b(get_each_context$b(ctx, each_value, i));
  }
  return {
    c() {
      div1 = element("div");
      h2 = element("h2");
      h2.textContent = "Profile Information";
      t1 = space();
      div0 = element("div");
      button0 = element("button");
      t2 = text("Save");
      t3 = space();
      div4 = element("div");
      div2 = element("div");
      if_block0.c();
      t4 = space();
      div3 = element("div");
      button1 = element("button");
      create_component(uploadicon.$$.fragment);
      if_block1.c();
      t5 = space();
      form = element("form");
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      attr(h2, "class", "ms-modal__title ms-modal__title--profile");
      attr(button0, "class", "ms-modal__save-button");
      button0.disabled = /*saveDisabled*/
      ctx[2];
      attr(div0, "class", "ms-modal__action-container");
      attr(div1, "class", "ms-modal__title-container");
      attr(div2, "class", "ms-modal__profile-image");
      attr(button1, "data-cy", "change-profile-image");
      attr(button1, "type", "submit");
      attr(button1, "class", "ms-modal__outline-button");
      attr(button1, "data-image-btn", "");
      attr(div3, "class", "ms-modal__profile-image-button-container");
      attr(div4, "class", "ms-modal__profile-image-container");
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(form, "autocomplete", "off");
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, h2);
      append(div1, t1);
      append(div1, div0);
      append(div0, button0);
      append(button0, t2);
      insert(target, t3, anchor);
      insert(target, div4, anchor);
      append(div4, div2);
      if_blocks[current_block_type_index].m(div2, null);
      append(div4, t4);
      append(div4, div3);
      append(div3, button1);
      mount_component(uploadicon, button1, null);
      if_block1.m(button1, null);
      insert(target, t5, anchor);
      insert(target, form, anchor);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(form, null);
        }
      }
      current = true;
      if (!mounted) {
        dispose = [
          listen(
            button0,
            "click",
            /*saveProfile*/
            ctx[3]
          ),
          listen(form, "submit", stop_propagation(prevent_default(
            /*saveProfile*/
            ctx[3]
          )))
        ];
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (!current || dirty & /*saveDisabled*/
      4) {
        button0.disabled = /*saveDisabled*/
        ctx2[2];
      }
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block0 = if_blocks[current_block_type_index];
        if (!if_block0) {
          if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block0.c();
        } else {
          if_block0.p(ctx2, dirty);
        }
        transition_in(if_block0, 1);
        if_block0.m(div2, null);
      }
      if (current_block_type !== (current_block_type = select_block_type_1(ctx2))) {
        if_block1.d(1);
        if_block1 = current_block_type(ctx2);
        if (if_block1) {
          if_block1.c();
          if_block1.m(button1, null);
        }
      }
      if (dirty & /*customFields, member, checkForChange*/
      19) {
        each_value = /*customFields*/
        ctx2[1];
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context$b(ctx2, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
          } else {
            each_blocks[i] = create_each_block$b(child_ctx);
            each_blocks[i].c();
            each_blocks[i].m(form, null);
          }
        }
        for (; i < each_blocks.length; i += 1) {
          each_blocks[i].d(1);
        }
        each_blocks.length = each_value.length;
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block0);
      transition_in(uploadicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(uploadicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div1);
      if (detaching)
        detach(t3);
      if (detaching)
        detach(div4);
      if_blocks[current_block_type_index].d();
      destroy_component(uploadicon);
      if_block1.d();
      if (detaching)
        detach(t5);
      if (detaching)
        detach(form);
      destroy_each(each_blocks, detaching);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$v($$self, $$props, $$invalidate) {
  let { customFields } = $$props;
  let { member } = $$props;
  let { profileLoader } = $$props;
  const createFileInputElement = () => {
    const fileInputField = document.createElement("input");
    fileInputField.setAttribute("required", "");
    fileInputField.setAttribute("type", "file");
    fileInputField.setAttribute("accept", "image/*");
    fileInputField.setAttribute("profile-image", "true");
    fileInputField.setAttribute("name", "profile-image");
    fileInputField.setAttribute("DATA-name", "File");
    fileInputField.setAttribute("hidden", "");
    fileInputField.setAttribute("tabindex", "-1");
    return fileInputField;
  };
  const initProfileImageButton = (uploadButton) => {
    const fileInputField = createFileInputElement();
    uploadButton.parentNode.insertBefore(fileInputField, uploadButton.nextSibling);
    uploadButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      fileInputField.click();
    });
    fileInputField.addEventListener("change", (e) => __async(this, null, function* () {
      e.preventDefault();
      e.stopPropagation();
      const file = e.target.files[0];
      const { size: fileSize, type: fileType } = file;
      if (fileType.includes("image") === false)
        return window.$memberstackDom._showMessage("File is not an image.", true);
      if (fileSize > 4e6)
        return window.$memberstackDom._showMessage("Image must be less than 2MB.", true);
      try {
        $$invalidate(5, profileLoader = true);
        const updateMemberProfileImageFunction = window.$memberstackDom.updateMemberProfileImage;
        const { data, _internalUseOnly: { message } } = yield updateMemberProfileImageFunction({ profileImage: file });
        $$invalidate(0, member.profileImage = data.profileImage, member);
        if (message) {
          window.$memberstackDom._showMessage(message, false);
        }
      } catch (err) {
        console.log(err);
        if (err.message) {
          window.$memberstackDom._showMessage(err.message, true);
        }
      }
      $$invalidate(5, profileLoader = false);
    }));
  };
  onMount(() => {
    const upload = document.querySelector("[data-image-btn]");
    initProfileImageButton(upload);
  });
  let initialCustomFields = JSON.parse(JSON.stringify(member.customFields));
  let saveDisabled = true;
  function saveProfile(e) {
    return __async(this, null, function* () {
      $$invalidate(5, profileLoader = true);
      try {
        const { _internalUseOnly: { message: msg } } = yield window.$memberstackDom.updateMember({ customFields: member.customFields });
        $$invalidate(5, profileLoader = false);
        $$invalidate(2, saveDisabled = true);
        initialCustomFields = JSON.parse(JSON.stringify(member.customFields));
        window.$memberstackDom._showMessage(msg, false);
      } catch (err) {
        $$invalidate(5, profileLoader = false);
        window.$memberstackDom._showMessage(err.message, true);
      }
    });
  }
  function checkForChange(e) {
    if (e.target.value !== initialCustomFields[e.target.name]) {
      $$invalidate(2, saveDisabled = false);
      return;
    }
    $$invalidate(2, saveDisabled = true);
  }
  function input_input_handler(customField) {
    member.customFields[customField.key] = this.value;
    $$invalidate(0, member);
  }
  $$self.$$set = ($$props2) => {
    if ("customFields" in $$props2)
      $$invalidate(1, customFields = $$props2.customFields);
    if ("member" in $$props2)
      $$invalidate(0, member = $$props2.member);
    if ("profileLoader" in $$props2)
      $$invalidate(5, profileLoader = $$props2.profileLoader);
  };
  return [
    member,
    customFields,
    saveDisabled,
    saveProfile,
    checkForChange,
    profileLoader,
    input_input_handler
  ];
}
var ProfileInfoContent = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$v, create_fragment$U, safe_not_equal, {
      customFields: 1,
      member: 0,
      profileLoader: 5
    });
  }
};
function create_fragment$T(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "m14 7h-1v-2c0-2.76-2.24-5-5-5s-5 2.24-5 5v2h-1c-1.1 0-2 0.9-2 2v10c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-10c0-1.1-0.9-2-2-2zm-9-2c0-1.66 1.34-3 3-3s3 1.34 3 3v2h-6v-2zm9 14h-12v-10h12v10zm-6-3c1.1 0 2-0.9 2-2s-0.9-2-2-2-2 0.9-2 2 0.9 2 2 2z");
      attr(svg, "fill", "none");
      attr(svg, "viewBox", "0 0 16 21");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var PasswordLockIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$T, safe_not_equal, {});
  }
};
function get_each_context$a(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[16] = list[i];
  return child_ctx;
}
function create_else_block_1$4(ctx) {
  let t;
  return {
    c() {
      t = text("Change Password");
    },
    m(target, anchor) {
      insert(target, t, anchor);
    },
    d(detaching) {
      if (detaching)
        detach(t);
    }
  };
}
function create_if_block_2$e(ctx) {
  let t;
  return {
    c() {
      t = text("Set Password");
    },
    m(target, anchor) {
      insert(target, t, anchor);
    },
    d(detaching) {
      if (detaching)
        detach(t);
    }
  };
}
function create_if_block$p(ctx) {
  let p;
  let t1;
  let div;
  let each_blocks = [];
  let each_1_lookup = /* @__PURE__ */ new Map();
  let each_value = (
    /*$app*/
    ctx[4].authProviders
  );
  const get_key = (ctx2) => (
    /*provider*/
    ctx2[16].provider
  );
  for (let i = 0; i < each_value.length; i += 1) {
    let child_ctx = get_each_context$a(ctx, each_value, i);
    let key = get_key(child_ctx);
    each_1_lookup.set(key, each_blocks[i] = create_each_block$a(key, child_ctx));
  }
  return {
    c() {
      p = element("p");
      p.textContent = "Connect Additional Accounts";
      t1 = space();
      div = element("div");
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      attr(p, "class", "ms-form__label");
      attr(div, "class", "ms-modal__social");
    },
    m(target, anchor) {
      insert(target, p, anchor);
      insert(target, t1, anchor);
      insert(target, div, anchor);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(div, null);
        }
      }
    },
    p(ctx2, dirty) {
      if (dirty & /*disconnectProvider, $app, member, connectAdditionalProvider*/
      210) {
        each_value = /*$app*/
        ctx2[4].authProviders;
        each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx2, each_value, each_1_lookup, div, destroy_block, create_each_block$a, null, get_each_context$a);
      }
    },
    d(detaching) {
      if (detaching)
        detach(p);
      if (detaching)
        detach(t1);
      if (detaching)
        detach(div);
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].d();
      }
    }
  };
}
function create_else_block$b(ctx) {
  let button;
  let img;
  let img_src_value;
  let img_alt_value;
  let t0;
  let span;
  let t1;
  let t2_value = (
    /*provider*/
    ctx[16].name + ""
  );
  let t2;
  let mounted;
  let dispose;
  function click_handler_2() {
    return (
      /*click_handler_2*/
      ctx[14](
        /*provider*/
        ctx[16]
      )
    );
  }
  return {
    c() {
      button = element("button");
      img = element("img");
      t0 = space();
      span = element("span");
      t1 = text("Connect with ");
      t2 = text(t2_value);
      if (!src_url_equal(img.src, img_src_value = /*provider*/
      ctx[16].icon))
        attr(img, "src", img_src_value);
      attr(img, "alt", img_alt_value = /*provider*/
      ctx[16].name);
      attr(button, "class", "ms-modal__social-button");
      attr(button, "type", "button");
    },
    m(target, anchor) {
      insert(target, button, anchor);
      append(button, img);
      append(button, t0);
      append(button, span);
      append(span, t1);
      append(span, t2);
      if (!mounted) {
        dispose = listen(button, "click", click_handler_2);
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*$app*/
      16 && !src_url_equal(img.src, img_src_value = /*provider*/
      ctx[16].icon)) {
        attr(img, "src", img_src_value);
      }
      if (dirty & /*$app*/
      16 && img_alt_value !== (img_alt_value = /*provider*/
      ctx[16].name)) {
        attr(img, "alt", img_alt_value);
      }
      if (dirty & /*$app*/
      16 && t2_value !== (t2_value = /*provider*/
      ctx[16].name + ""))
        set_data(t2, t2_value);
    },
    d(detaching) {
      if (detaching)
        detach(button);
      mounted = false;
      dispose();
    }
  };
}
function create_if_block_1$j(ctx) {
  let button;
  let img;
  let img_src_value;
  let img_alt_value;
  let t0;
  let span;
  let t1;
  let t2_value = (
    /*provider*/
    ctx[16].name + ""
  );
  let t2;
  let mounted;
  let dispose;
  function click_handler_1() {
    return (
      /*click_handler_1*/
      ctx[13](
        /*provider*/
        ctx[16]
      )
    );
  }
  return {
    c() {
      button = element("button");
      img = element("img");
      t0 = space();
      span = element("span");
      t1 = text("Disconnect ");
      t2 = text(t2_value);
      if (!src_url_equal(img.src, img_src_value = /*provider*/
      ctx[16].icon))
        attr(img, "src", img_src_value);
      attr(img, "alt", img_alt_value = /*provider*/
      ctx[16].name);
      attr(button, "class", "ms-modal__social-button");
      set_style(button, "background-color", "#F6F6F6");
      attr(button, "type", "button");
    },
    m(target, anchor) {
      insert(target, button, anchor);
      append(button, img);
      append(button, t0);
      append(button, span);
      append(span, t1);
      append(span, t2);
      if (!mounted) {
        dispose = listen(button, "click", click_handler_1);
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*$app*/
      16 && !src_url_equal(img.src, img_src_value = /*provider*/
      ctx[16].icon)) {
        attr(img, "src", img_src_value);
      }
      if (dirty & /*$app*/
      16 && img_alt_value !== (img_alt_value = /*provider*/
      ctx[16].name)) {
        attr(img, "alt", img_alt_value);
      }
      if (dirty & /*$app*/
      16 && t2_value !== (t2_value = /*provider*/
      ctx[16].name + ""))
        set_data(t2, t2_value);
    },
    d(detaching) {
      if (detaching)
        detach(button);
      mounted = false;
      dispose();
    }
  };
}
function create_each_block$a(key_1, ctx) {
  let div;
  let show_if;
  let t;
  function func2(...args) {
    return (
      /*func*/
      ctx[9](
        /*provider*/
        ctx[16],
        ...args
      )
    );
  }
  function select_block_type_1(ctx2, dirty) {
    if (dirty & /*member, $app*/
    18)
      show_if = null;
    if (show_if == null)
      show_if = !!/*member*/
      ctx2[1].auth.providers.some(func2);
    if (show_if)
      return create_if_block_1$j;
    return create_else_block$b;
  }
  let current_block_type = select_block_type_1(ctx, -1);
  let if_block = current_block_type(ctx);
  return {
    key: key_1,
    first: null,
    c() {
      div = element("div");
      if_block.c();
      t = space();
      attr(div, "class", "ms-modal__social-buttons");
      this.first = div;
    },
    m(target, anchor) {
      insert(target, div, anchor);
      if_block.m(div, null);
      append(div, t);
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block) {
        if_block.p(ctx, dirty);
      } else {
        if_block.d(1);
        if_block = current_block_type(ctx);
        if (if_block) {
          if_block.c();
          if_block.m(div, t);
        }
      }
    },
    d(detaching) {
      if (detaching)
        detach(div);
      if_block.d();
    }
  };
}
function create_fragment$S(ctx) {
  let div1;
  let h2;
  let t1;
  let div0;
  let button0;
  let t2;
  let button0_disabled_value;
  let t3;
  let form;
  let emailinput;
  let updating_emailInputValid;
  let updating_emailValue;
  let t4;
  let div2;
  let label;
  let t6;
  let button1;
  let passwordlockicon;
  let t7;
  let t8;
  let if_block1_anchor;
  let current;
  let mounted;
  let dispose;
  function emailinput_emailInputValid_binding(value) {
    ctx[10](value);
  }
  function emailinput_emailValue_binding(value) {
    ctx[11](value);
  }
  let emailinput_props = {};
  if (
    /*emailInputValid*/
    ctx[3] !== void 0
  ) {
    emailinput_props.emailInputValid = /*emailInputValid*/
    ctx[3];
  }
  if (
    /*emailValue*/
    ctx[2] !== void 0
  ) {
    emailinput_props.emailValue = /*emailValue*/
    ctx[2];
  }
  emailinput = new EmailInput({ props: emailinput_props });
  binding_callbacks.push(() => bind(emailinput, "emailInputValid", emailinput_emailInputValid_binding));
  binding_callbacks.push(() => bind(emailinput, "emailValue", emailinput_emailValue_binding));
  passwordlockicon = new PasswordLockIcon({});
  function select_block_type(ctx2, dirty) {
    if (!/*member*/
    ctx2[1].auth.hasPassword)
      return create_if_block_2$e;
    return create_else_block_1$4;
  }
  let current_block_type = select_block_type(ctx);
  let if_block0 = current_block_type(ctx);
  let if_block1 = (
    /*$app*/
    ctx[4].authProviders.length > 0 && create_if_block$p(ctx)
  );
  return {
    c() {
      div1 = element("div");
      h2 = element("h2");
      h2.textContent = "Security";
      t1 = space();
      div0 = element("div");
      button0 = element("button");
      t2 = text("Save");
      t3 = space();
      form = element("form");
      create_component(emailinput.$$.fragment);
      t4 = space();
      div2 = element("div");
      label = element("label");
      label.textContent = "Password";
      t6 = space();
      button1 = element("button");
      create_component(passwordlockicon.$$.fragment);
      t7 = space();
      if_block0.c();
      t8 = space();
      if (if_block1)
        if_block1.c();
      if_block1_anchor = empty();
      attr(h2, "class", "ms-modal__title ms-modal__title--profile");
      attr(button0, "class", "ms-modal__save-button");
      button0.disabled = button0_disabled_value = !/*emailInputValid*/
      ctx[3];
      attr(div0, "class", "ms-modal__action-container");
      attr(div1, "class", "ms-modal__title-container");
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(form, "autocomplete", "off");
      attr(label, "class", "ms-form__label");
      attr(label, "for", "setPassword");
      attr(button1, "data-cy", "change-password-btn");
      attr(button1, "class", "ms-modal__outline-button");
      attr(button1, "name", "setPassword");
      attr(div2, "class", "ms-form__group");
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, h2);
      append(div1, t1);
      append(div1, div0);
      append(div0, button0);
      append(button0, t2);
      insert(target, t3, anchor);
      insert(target, form, anchor);
      mount_component(emailinput, form, null);
      insert(target, t4, anchor);
      insert(target, div2, anchor);
      append(div2, label);
      append(div2, t6);
      append(div2, button1);
      mount_component(passwordlockicon, button1, null);
      append(button1, t7);
      if_block0.m(button1, null);
      insert(target, t8, anchor);
      if (if_block1)
        if_block1.m(target, anchor);
      insert(target, if_block1_anchor, anchor);
      current = true;
      if (!mounted) {
        dispose = [
          listen(
            button0,
            "click",
            /*submitEmailChange*/
            ctx[5]
          ),
          listen(form, "submit", stop_propagation(prevent_default(
            /*submitEmailChange*/
            ctx[5]
          ))),
          listen(
            button1,
            "click",
            /*click_handler*/
            ctx[12]
          )
        ];
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (!current || dirty & /*emailInputValid*/
      8 && button0_disabled_value !== (button0_disabled_value = !/*emailInputValid*/
      ctx2[3])) {
        button0.disabled = button0_disabled_value;
      }
      const emailinput_changes = {};
      if (!updating_emailInputValid && dirty & /*emailInputValid*/
      8) {
        updating_emailInputValid = true;
        emailinput_changes.emailInputValid = /*emailInputValid*/
        ctx2[3];
        add_flush_callback(() => updating_emailInputValid = false);
      }
      if (!updating_emailValue && dirty & /*emailValue*/
      4) {
        updating_emailValue = true;
        emailinput_changes.emailValue = /*emailValue*/
        ctx2[2];
        add_flush_callback(() => updating_emailValue = false);
      }
      emailinput.$set(emailinput_changes);
      if (current_block_type !== (current_block_type = select_block_type(ctx2))) {
        if_block0.d(1);
        if_block0 = current_block_type(ctx2);
        if (if_block0) {
          if_block0.c();
          if_block0.m(button1, null);
        }
      }
      if (
        /*$app*/
        ctx2[4].authProviders.length > 0
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
        } else {
          if_block1 = create_if_block$p(ctx2);
          if_block1.c();
          if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
        }
      } else if (if_block1) {
        if_block1.d(1);
        if_block1 = null;
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(emailinput.$$.fragment, local);
      transition_in(passwordlockicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(emailinput.$$.fragment, local);
      transition_out(passwordlockicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div1);
      if (detaching)
        detach(t3);
      if (detaching)
        detach(form);
      destroy_component(emailinput);
      if (detaching)
        detach(t4);
      if (detaching)
        detach(div2);
      destroy_component(passwordlockicon);
      if_block0.d();
      if (detaching)
        detach(t8);
      if (if_block1)
        if_block1.d(detaching);
      if (detaching)
        detach(if_block1_anchor);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$u($$self, $$props, $$invalidate) {
  let $app;
  component_subscribe($$self, AppStore, ($$value) => $$invalidate(4, $app = $$value));
  let { displayProfile } = $$props;
  let { member } = $$props;
  let { emailValue } = $$props;
  let { profileLoader } = $$props;
  $app.authProviders.sort((a, b) => {
    if (isConnected(a) === isConnected(b)) {
      return a.order - b.order;
    }
    return isConnected(a) ? -1 : 1;
  });
  let emailInputValid = false;
  function submitEmailChange(e) {
    return __async(this, null, function* () {
      if (!emailInputValid || !emailValue)
        return;
      $$invalidate(8, profileLoader = true);
      try {
        const { _internalUseOnly: { message } } = yield window.$memberstackDom.updateMemberAuth({ email: emailValue });
        window.$memberstackDom._showMessage(message, false);
        $$invalidate(8, profileLoader = false);
      } catch (err) {
        window.$memberstackDom._showMessage(err.message, true);
        $$invalidate(8, profileLoader = false);
      }
    });
  }
  function disconnectProvider(provider) {
    return __async(this, null, function* () {
      $$invalidate(8, profileLoader = true);
      try {
        const { data, _internalUseOnly: { message } } = yield window.$memberstackDom.disconnectProvider({ provider });
        $$invalidate(1, member = __spreadProps(__spreadValues({}, member), {
          auth: __spreadProps(__spreadValues({}, member.auth), {
            providers: data.providers
          })
        }));
        window.$memberstackDom._showMessage(message, false);
        $$invalidate(8, profileLoader = false);
      } catch (err) {
        window.$memberstackDom._showMessage(err.message, true);
        $$invalidate(8, profileLoader = false);
      }
    });
  }
  function connectAdditionalProvider(provider) {
    return __async(this, null, function* () {
      console.log("connect", provider);
      try {
        const { data } = yield window.$memberstackDom.connectProvider({ provider });
        $$invalidate(1, member = __spreadProps(__spreadValues({}, member), {
          auth: __spreadProps(__spreadValues({}, member.auth), {
            providers: data.providers
          })
        }));
        window.$memberstackDom._showMessage(data.message, false);
      } catch (err) {
        window.$memberstackDom._showMessage(err.message, true);
      }
    });
  }
  function isConnected(provider) {
    return member.auth.providers.some((prv) => prv.provider === provider.provider);
  }
  const func2 = (provider, prv) => prv.provider === provider.provider;
  function emailinput_emailInputValid_binding(value) {
    emailInputValid = value;
    $$invalidate(3, emailInputValid);
  }
  function emailinput_emailValue_binding(value) {
    emailValue = value;
    $$invalidate(2, emailValue);
  }
  const click_handler = () => $$invalidate(0, displayProfile = "changePassword");
  const click_handler_1 = (provider) => disconnectProvider(provider.provider);
  const click_handler_2 = (provider) => connectAdditionalProvider(provider.provider);
  $$self.$$set = ($$props2) => {
    if ("displayProfile" in $$props2)
      $$invalidate(0, displayProfile = $$props2.displayProfile);
    if ("member" in $$props2)
      $$invalidate(1, member = $$props2.member);
    if ("emailValue" in $$props2)
      $$invalidate(2, emailValue = $$props2.emailValue);
    if ("profileLoader" in $$props2)
      $$invalidate(8, profileLoader = $$props2.profileLoader);
  };
  return [
    displayProfile,
    member,
    emailValue,
    emailInputValid,
    $app,
    submitEmailChange,
    disconnectProvider,
    connectAdditionalProvider,
    profileLoader,
    func2,
    emailinput_emailInputValid_binding,
    emailinput_emailValue_binding,
    click_handler,
    click_handler_1,
    click_handler_2
  ];
}
var SecurityInfoContent = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$u, create_fragment$S, safe_not_equal, {
      displayProfile: 0,
      member: 1,
      emailValue: 2,
      profileLoader: 8
    });
  }
};
function create_else_block$a(ctx) {
  let t;
  return {
    c() {
      t = text("Change Password");
    },
    m(target, anchor) {
      insert(target, t, anchor);
    },
    d(detaching) {
      if (detaching)
        detach(t);
    }
  };
}
function create_if_block_1$i(ctx) {
  let t;
  return {
    c() {
      t = text("Set Password");
    },
    m(target, anchor) {
      insert(target, t, anchor);
    },
    d(detaching) {
      if (detaching)
        detach(t);
    }
  };
}
function create_if_block$o(ctx) {
  let passwordinput;
  let updating_passwordValue;
  let updating_passwordInputValid;
  let current;
  function passwordinput_passwordValue_binding(value) {
    ctx[11](value);
  }
  function passwordinput_passwordInputValid_binding(value) {
    ctx[12](value);
  }
  let passwordinput_props = {
    passwordLabel: "Current Password",
    passwordPlaceholder: "Enter current password"
  };
  if (
    /*currentPasswordValue*/
    ctx[2] !== void 0
  ) {
    passwordinput_props.passwordValue = /*currentPasswordValue*/
    ctx[2];
  }
  if (
    /*currentPasswordValid*/
    ctx[5] !== void 0
  ) {
    passwordinput_props.passwordInputValid = /*currentPasswordValid*/
    ctx[5];
  }
  passwordinput = new PasswordInput({ props: passwordinput_props });
  binding_callbacks.push(() => bind(passwordinput, "passwordValue", passwordinput_passwordValue_binding));
  binding_callbacks.push(() => bind(passwordinput, "passwordInputValid", passwordinput_passwordInputValid_binding));
  return {
    c() {
      create_component(passwordinput.$$.fragment);
    },
    m(target, anchor) {
      mount_component(passwordinput, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const passwordinput_changes = {};
      if (!updating_passwordValue && dirty & /*currentPasswordValue*/
      4) {
        updating_passwordValue = true;
        passwordinput_changes.passwordValue = /*currentPasswordValue*/
        ctx2[2];
        add_flush_callback(() => updating_passwordValue = false);
      }
      if (!updating_passwordInputValid && dirty & /*currentPasswordValid*/
      32) {
        updating_passwordInputValid = true;
        passwordinput_changes.passwordInputValid = /*currentPasswordValid*/
        ctx2[5];
        add_flush_callback(() => updating_passwordInputValid = false);
      }
      passwordinput.$set(passwordinput_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(passwordinput.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(passwordinput.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(passwordinput, detaching);
    }
  };
}
function create_fragment$R(ctx) {
  let div3;
  let div1;
  let div0;
  let button0;
  let backicon;
  let t0;
  let h2;
  let t1;
  let div2;
  let button1;
  let t2;
  let button1_disabled_value;
  let t3;
  let form;
  let t4;
  let passwordinput0;
  let updating_passwordValue;
  let updating_passwordInputValid;
  let t5;
  let passwordinput1;
  let updating_passwordValue_1;
  let updating_passwordInputValid_1;
  let current;
  let mounted;
  let dispose;
  backicon = new BackIcon({});
  function select_block_type(ctx2, dirty) {
    if (!/*member*/
    ctx2[1].auth.hasPassword)
      return create_if_block_1$i;
    return create_else_block$a;
  }
  let current_block_type = select_block_type(ctx);
  let if_block0 = current_block_type(ctx);
  let if_block1 = (
    /*member*/
    ctx[1].auth.hasPassword && create_if_block$o(ctx)
  );
  function passwordinput0_passwordValue_binding(value) {
    ctx[13](value);
  }
  function passwordinput0_passwordInputValid_binding(value) {
    ctx[14](value);
  }
  let passwordinput0_props = {
    passwordLabel: "New Password",
    passwordPlaceholder: "Enter a strong password"
  };
  if (
    /*newPasswordValue*/
    ctx[3] !== void 0
  ) {
    passwordinput0_props.passwordValue = /*newPasswordValue*/
    ctx[3];
  }
  if (
    /*newPasswordValid*/
    ctx[6] !== void 0
  ) {
    passwordinput0_props.passwordInputValid = /*newPasswordValid*/
    ctx[6];
  }
  passwordinput0 = new PasswordInput({ props: passwordinput0_props });
  binding_callbacks.push(() => bind(passwordinput0, "passwordValue", passwordinput0_passwordValue_binding));
  binding_callbacks.push(() => bind(passwordinput0, "passwordInputValid", passwordinput0_passwordInputValid_binding));
  function passwordinput1_passwordValue_binding(value) {
    ctx[15](value);
  }
  function passwordinput1_passwordInputValid_binding(value) {
    ctx[16](value);
  }
  let passwordinput1_props = {
    passwordLabel: "Confirm New Password",
    passwordPlaceholder: "Enter a strong password"
  };
  if (
    /*confirmPasswordValue*/
    ctx[4] !== void 0
  ) {
    passwordinput1_props.passwordValue = /*confirmPasswordValue*/
    ctx[4];
  }
  if (
    /*confirmPasswordValid*/
    ctx[7] !== void 0
  ) {
    passwordinput1_props.passwordInputValid = /*confirmPasswordValid*/
    ctx[7];
  }
  passwordinput1 = new PasswordInput({ props: passwordinput1_props });
  binding_callbacks.push(() => bind(passwordinput1, "passwordValue", passwordinput1_passwordValue_binding));
  binding_callbacks.push(() => bind(passwordinput1, "passwordInputValid", passwordinput1_passwordInputValid_binding));
  return {
    c() {
      div3 = element("div");
      div1 = element("div");
      div0 = element("div");
      button0 = element("button");
      create_component(backicon.$$.fragment);
      t0 = space();
      h2 = element("h2");
      if_block0.c();
      t1 = space();
      div2 = element("div");
      button1 = element("button");
      t2 = text("Save");
      t3 = space();
      form = element("form");
      if (if_block1)
        if_block1.c();
      t4 = space();
      create_component(passwordinput0.$$.fragment);
      t5 = space();
      create_component(passwordinput1.$$.fragment);
      attr(div0, "class", "ms-modal__profile-back");
      attr(h2, "class", "ms-modal__title ms-modal__title--profile");
      attr(div1, "class", "ms-modal__title-group");
      attr(button1, "class", "ms-modal__save-button");
      button1.disabled = button1_disabled_value = /*member*/
      ctx[1].auth.hasPassword && !/*currentPasswordValid*/
      ctx[5] || !/*newPasswordValid*/
      ctx[6] || !/*confirmPasswordValid*/
      ctx[7];
      attr(div2, "class", "ms-modal__action-container");
      attr(div3, "class", "ms-modal__title-container");
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(form, "autocomplete", "off");
    },
    m(target, anchor) {
      insert(target, div3, anchor);
      append(div3, div1);
      append(div1, div0);
      append(div0, button0);
      mount_component(backicon, button0, null);
      append(div1, t0);
      append(div1, h2);
      if_block0.m(h2, null);
      append(div3, t1);
      append(div3, div2);
      append(div2, button1);
      append(button1, t2);
      insert(target, t3, anchor);
      insert(target, form, anchor);
      if (if_block1)
        if_block1.m(form, null);
      append(form, t4);
      mount_component(passwordinput0, form, null);
      append(form, t5);
      mount_component(passwordinput1, form, null);
      current = true;
      if (!mounted) {
        dispose = [
          listen(
            button0,
            "click",
            /*click_handler*/
            ctx[10]
          ),
          listen(
            button1,
            "click",
            /*submitPasswordChange*/
            ctx[8]
          ),
          listen(form, "submit", stop_propagation(prevent_default(
            /*submitPasswordChange*/
            ctx[8]
          )))
        ];
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (current_block_type !== (current_block_type = select_block_type(ctx2))) {
        if_block0.d(1);
        if_block0 = current_block_type(ctx2);
        if (if_block0) {
          if_block0.c();
          if_block0.m(h2, null);
        }
      }
      if (!current || dirty & /*member, currentPasswordValid, newPasswordValid, confirmPasswordValid*/
      226 && button1_disabled_value !== (button1_disabled_value = /*member*/
      ctx2[1].auth.hasPassword && !/*currentPasswordValid*/
      ctx2[5] || !/*newPasswordValid*/
      ctx2[6] || !/*confirmPasswordValid*/
      ctx2[7])) {
        button1.disabled = button1_disabled_value;
      }
      if (
        /*member*/
        ctx2[1].auth.hasPassword
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty & /*member*/
          2) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block$o(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(form, t4);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
      const passwordinput0_changes = {};
      if (!updating_passwordValue && dirty & /*newPasswordValue*/
      8) {
        updating_passwordValue = true;
        passwordinput0_changes.passwordValue = /*newPasswordValue*/
        ctx2[3];
        add_flush_callback(() => updating_passwordValue = false);
      }
      if (!updating_passwordInputValid && dirty & /*newPasswordValid*/
      64) {
        updating_passwordInputValid = true;
        passwordinput0_changes.passwordInputValid = /*newPasswordValid*/
        ctx2[6];
        add_flush_callback(() => updating_passwordInputValid = false);
      }
      passwordinput0.$set(passwordinput0_changes);
      const passwordinput1_changes = {};
      if (!updating_passwordValue_1 && dirty & /*confirmPasswordValue*/
      16) {
        updating_passwordValue_1 = true;
        passwordinput1_changes.passwordValue = /*confirmPasswordValue*/
        ctx2[4];
        add_flush_callback(() => updating_passwordValue_1 = false);
      }
      if (!updating_passwordInputValid_1 && dirty & /*confirmPasswordValid*/
      128) {
        updating_passwordInputValid_1 = true;
        passwordinput1_changes.passwordInputValid = /*confirmPasswordValid*/
        ctx2[7];
        add_flush_callback(() => updating_passwordInputValid_1 = false);
      }
      passwordinput1.$set(passwordinput1_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(backicon.$$.fragment, local);
      transition_in(if_block1);
      transition_in(passwordinput0.$$.fragment, local);
      transition_in(passwordinput1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(backicon.$$.fragment, local);
      transition_out(if_block1);
      transition_out(passwordinput0.$$.fragment, local);
      transition_out(passwordinput1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div3);
      destroy_component(backicon);
      if_block0.d();
      if (detaching)
        detach(t3);
      if (detaching)
        detach(form);
      if (if_block1)
        if_block1.d();
      destroy_component(passwordinput0);
      destroy_component(passwordinput1);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$t($$self, $$props, $$invalidate) {
  let { displayProfile } = $$props;
  let { profileLoader } = $$props;
  let { member } = $$props;
  let currentPasswordValue = "";
  let newPasswordValue = "";
  let confirmPasswordValue = "";
  let currentPasswordValid = false;
  let newPasswordValid = false;
  let confirmPasswordValid = false;
  function submitPasswordChange(e) {
    return __async(this, null, function* () {
      if (member.auth.hasPassword && !currentPasswordValid && !newPasswordValid && !confirmPasswordValid)
        return;
      if (!member.auth.hasPassword && !newPasswordValid && !confirmPasswordValid)
        return;
      $$invalidate(9, profileLoader = true);
      try {
        let message;
        if (member.auth.hasPassword) {
          const { _internalUseOnly: { message: msg } } = yield window.$memberstackDom.updateMemberAuth({
            oldPassword: currentPasswordValue,
            newPassword: newPasswordValue
          });
          message = msg;
        } else {
          const { _internalUseOnly: { message: msg } } = yield window.$memberstackDom.setPassword({ password: newPasswordValue });
          $$invalidate(1, member.auth.hasPassword = true, member);
          message = msg;
        }
        window.$memberstackDom._showMessage(message, false);
        $$invalidate(2, currentPasswordValue = "");
        $$invalidate(3, newPasswordValue = "");
        $$invalidate(4, confirmPasswordValue = "");
        $$invalidate(9, profileLoader = false);
      } catch (err) {
        window.$memberstackDom._showMessage(err.message, true);
        $$invalidate(9, profileLoader = false);
      }
    });
  }
  const click_handler = () => $$invalidate(0, displayProfile = "security");
  function passwordinput_passwordValue_binding(value) {
    currentPasswordValue = value;
    $$invalidate(2, currentPasswordValue);
  }
  function passwordinput_passwordInputValid_binding(value) {
    currentPasswordValid = value;
    $$invalidate(5, currentPasswordValid);
  }
  function passwordinput0_passwordValue_binding(value) {
    newPasswordValue = value;
    $$invalidate(3, newPasswordValue);
  }
  function passwordinput0_passwordInputValid_binding(value) {
    newPasswordValid = value;
    $$invalidate(6, newPasswordValid);
  }
  function passwordinput1_passwordValue_binding(value) {
    confirmPasswordValue = value;
    $$invalidate(4, confirmPasswordValue);
  }
  function passwordinput1_passwordInputValid_binding(value) {
    confirmPasswordValid = value;
    $$invalidate(7, confirmPasswordValid);
  }
  $$self.$$set = ($$props2) => {
    if ("displayProfile" in $$props2)
      $$invalidate(0, displayProfile = $$props2.displayProfile);
    if ("profileLoader" in $$props2)
      $$invalidate(9, profileLoader = $$props2.profileLoader);
    if ("member" in $$props2)
      $$invalidate(1, member = $$props2.member);
  };
  return [
    displayProfile,
    member,
    currentPasswordValue,
    newPasswordValue,
    confirmPasswordValue,
    currentPasswordValid,
    newPasswordValid,
    confirmPasswordValid,
    submitPasswordChange,
    profileLoader,
    click_handler,
    passwordinput_passwordValue_binding,
    passwordinput_passwordInputValid_binding,
    passwordinput0_passwordValue_binding,
    passwordinput0_passwordInputValid_binding,
    passwordinput1_passwordValue_binding,
    passwordinput1_passwordInputValid_binding
  ];
}
var PasswordInfoContent = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$t, create_fragment$R, safe_not_equal, {
      displayProfile: 0,
      profileLoader: 9,
      member: 1
    });
  }
};
function cubicOut(t) {
  const f = t - 1;
  return f * f * f + 1;
}
function fade(node, { delay = 0, duration = 400, easing = identity } = {}) {
  const o = +getComputedStyle(node).opacity;
  return {
    delay,
    duration,
    easing,
    css: (t) => `opacity: ${t * o}`
  };
}
function slide(node, { delay = 0, duration = 400, easing = cubicOut, axis = "y" } = {}) {
  const style = getComputedStyle(node);
  const opacity = +style.opacity;
  const primary_property = axis === "y" ? "height" : "width";
  const primary_property_value = parseFloat(style[primary_property]);
  const secondary_properties = axis === "y" ? ["top", "bottom"] : ["left", "right"];
  const capitalized_secondary_properties = secondary_properties.map((e) => `${e[0].toUpperCase()}${e.slice(1)}`);
  const padding_start_value = parseFloat(style[`padding${capitalized_secondary_properties[0]}`]);
  const padding_end_value = parseFloat(style[`padding${capitalized_secondary_properties[1]}`]);
  const margin_start_value = parseFloat(style[`margin${capitalized_secondary_properties[0]}`]);
  const margin_end_value = parseFloat(style[`margin${capitalized_secondary_properties[1]}`]);
  const border_width_start_value = parseFloat(style[`border${capitalized_secondary_properties[0]}Width`]);
  const border_width_end_value = parseFloat(style[`border${capitalized_secondary_properties[1]}Width`]);
  return {
    delay,
    duration,
    easing,
    css: (t) => `overflow: hidden;opacity: ${Math.min(t * 20, 1) * opacity};${primary_property}: ${t * primary_property_value}px;padding-${secondary_properties[0]}: ${t * padding_start_value}px;padding-${secondary_properties[1]}: ${t * padding_end_value}px;margin-${secondary_properties[0]}: ${t * margin_start_value}px;margin-${secondary_properties[1]}: ${t * margin_end_value}px;border-${secondary_properties[0]}-width: ${t * border_width_start_value}px;border-${secondary_properties[1]}-width: ${t * border_width_end_value}px;`
  };
}
function create_fragment$Q(ctx) {
  let div;
  let loadingicon;
  let div_transition;
  let current;
  loadingicon = new LoadingIcon({});
  return {
    c() {
      div = element("div");
      create_component(loadingicon.$$.fragment);
      attr(div, "class", "ms__profile__loader");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(loadingicon, div, null);
      current = true;
    },
    p: noop,
    i(local) {
      if (current)
        return;
      transition_in(loadingicon.$$.fragment, local);
      add_render_callback(() => {
        if (!current)
          return;
        if (!div_transition)
          div_transition = create_bidirectional_transition(div, fade, {}, true);
        div_transition.run(1);
      });
      current = true;
    },
    o(local) {
      transition_out(loadingicon.$$.fragment, local);
      if (!div_transition)
        div_transition = create_bidirectional_transition(div, fade, {}, false);
      div_transition.run(0);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      destroy_component(loadingicon);
      if (detaching && div_transition)
        div_transition.end();
    }
  };
}
var ProfileLoader = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$Q, safe_not_equal, {});
  }
};
function create_fragment$P(ctx) {
  let button;
  let switch_instance0;
  let t0;
  let t1;
  let t2;
  let switch_instance1;
  let button_class_value;
  let current;
  let mounted;
  let dispose;
  var switch_value = (
    /*buttonLeftIcon*/
    ctx[2]
  );
  function switch_props(ctx2) {
    return {};
  }
  if (switch_value) {
    switch_instance0 = construct_svelte_component(switch_value, switch_props());
  }
  var switch_value_1 = (
    /*buttonRightIcon*/
    ctx[1]
  );
  function switch_props_1(ctx2) {
    return {};
  }
  if (switch_value_1) {
    switch_instance1 = construct_svelte_component(switch_value_1, switch_props_1());
  }
  return {
    c() {
      button = element("button");
      if (switch_instance0)
        create_component(switch_instance0.$$.fragment);
      t0 = space();
      t1 = text(
        /*buttonText*/
        ctx[0]
      );
      t2 = space();
      if (switch_instance1)
        create_component(switch_instance1.$$.fragment);
      attr(button, "class", button_class_value = "ms-modal__regular-button " + /*$$restProps*/
      (ctx[5].class || ""));
      set_style(
        button,
        "background",
        /*buttonColor*/
        ctx[4]
      );
    },
    m(target, anchor) {
      insert(target, button, anchor);
      if (switch_instance0)
        mount_component(switch_instance0, button, null);
      append(button, t0);
      append(button, t1);
      append(button, t2);
      if (switch_instance1)
        mount_component(switch_instance1, button, null);
      current = true;
      if (!mounted) {
        dispose = listen(button, "click", function() {
          if (is_function(
            /*onClick*/
            ctx[3]
          ))
            ctx[3].apply(this, arguments);
        });
        mounted = true;
      }
    },
    p(new_ctx, [dirty]) {
      ctx = new_ctx;
      if (dirty & /*buttonLeftIcon*/
      4 && switch_value !== (switch_value = /*buttonLeftIcon*/
      ctx[2])) {
        if (switch_instance0) {
          group_outros();
          const old_component = switch_instance0;
          transition_out(old_component.$$.fragment, 1, 0, () => {
            destroy_component(old_component, 1);
          });
          check_outros();
        }
        if (switch_value) {
          switch_instance0 = construct_svelte_component(switch_value, switch_props());
          create_component(switch_instance0.$$.fragment);
          transition_in(switch_instance0.$$.fragment, 1);
          mount_component(switch_instance0, button, t0);
        } else {
          switch_instance0 = null;
        }
      }
      if (!current || dirty & /*buttonText*/
      1)
        set_data(
          t1,
          /*buttonText*/
          ctx[0]
        );
      if (dirty & /*buttonRightIcon*/
      2 && switch_value_1 !== (switch_value_1 = /*buttonRightIcon*/
      ctx[1])) {
        if (switch_instance1) {
          group_outros();
          const old_component = switch_instance1;
          transition_out(old_component.$$.fragment, 1, 0, () => {
            destroy_component(old_component, 1);
          });
          check_outros();
        }
        if (switch_value_1) {
          switch_instance1 = construct_svelte_component(switch_value_1, switch_props_1());
          create_component(switch_instance1.$$.fragment);
          transition_in(switch_instance1.$$.fragment, 1);
          mount_component(switch_instance1, button, null);
        } else {
          switch_instance1 = null;
        }
      }
      if (!current || dirty & /*$$restProps*/
      32 && button_class_value !== (button_class_value = "ms-modal__regular-button " + /*$$restProps*/
      (ctx[5].class || ""))) {
        attr(button, "class", button_class_value);
      }
      if (!current || dirty & /*buttonColor*/
      16) {
        set_style(
          button,
          "background",
          /*buttonColor*/
          ctx[4]
        );
      }
    },
    i(local) {
      if (current)
        return;
      if (switch_instance0)
        transition_in(switch_instance0.$$.fragment, local);
      if (switch_instance1)
        transition_in(switch_instance1.$$.fragment, local);
      current = true;
    },
    o(local) {
      if (switch_instance0)
        transition_out(switch_instance0.$$.fragment, local);
      if (switch_instance1)
        transition_out(switch_instance1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(button);
      if (switch_instance0)
        destroy_component(switch_instance0);
      if (switch_instance1)
        destroy_component(switch_instance1);
      mounted = false;
      dispose();
    }
  };
}
function instance$s($$self, $$props, $$invalidate) {
  const omit_props_names = ["buttonText", "buttonRightIcon", "buttonLeftIcon", "onClick"];
  let $$restProps = compute_rest_props($$props, omit_props_names);
  let $app;
  component_subscribe($$self, AppStore, ($$value) => $$invalidate(6, $app = $$value));
  let { buttonText = "Submit" } = $$props;
  let { buttonRightIcon = null } = $$props;
  let { buttonLeftIcon = null } = $$props;
  let { onClick = () => {
  } } = $$props;
  let buttonColor = "rgb(41, 98, 255)";
  if ($app.branding.colors.lightMode.primaryButton) {
    buttonColor = $app.branding.colors.lightMode.primaryButton;
  }
  $$self.$$set = ($$new_props) => {
    $$props = assign(assign({}, $$props), exclude_internal_props($$new_props));
    $$invalidate(5, $$restProps = compute_rest_props($$props, omit_props_names));
    if ("buttonText" in $$new_props)
      $$invalidate(0, buttonText = $$new_props.buttonText);
    if ("buttonRightIcon" in $$new_props)
      $$invalidate(1, buttonRightIcon = $$new_props.buttonRightIcon);
    if ("buttonLeftIcon" in $$new_props)
      $$invalidate(2, buttonLeftIcon = $$new_props.buttonLeftIcon);
    if ("onClick" in $$new_props)
      $$invalidate(3, onClick = $$new_props.onClick);
  };
  return [buttonText, buttonRightIcon, buttonLeftIcon, onClick, buttonColor, $$restProps];
}
var RegularButton = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$s, create_fragment$P, safe_not_equal, {
      buttonText: 0,
      buttonRightIcon: 1,
      buttonLeftIcon: 2,
      onClick: 3
    });
  }
};
function create_fragment$O(ctx) {
  let button;
  let t;
  let button_class_value;
  let mounted;
  let dispose;
  return {
    c() {
      button = element("button");
      t = text(
        /*buttonText*/
        ctx[0]
      );
      attr(button, "class", button_class_value = "ms-modal__text-button " + /*$$restProps*/
      ctx[3].class);
      set_style(
        button,
        "color",
        /*buttonColor*/
        ctx[2]
      );
    },
    m(target, anchor) {
      insert(target, button, anchor);
      append(button, t);
      if (!mounted) {
        dispose = listen(button, "click", function() {
          if (is_function(
            /*onClick*/
            ctx[1]
          ))
            ctx[1].apply(this, arguments);
        });
        mounted = true;
      }
    },
    p(new_ctx, [dirty]) {
      ctx = new_ctx;
      if (dirty & /*buttonText*/
      1)
        set_data(
          t,
          /*buttonText*/
          ctx[0]
        );
      if (dirty & /*$$restProps*/
      8 && button_class_value !== (button_class_value = "ms-modal__text-button " + /*$$restProps*/
      ctx[3].class)) {
        attr(button, "class", button_class_value);
      }
      if (dirty & /*buttonColor*/
      4) {
        set_style(
          button,
          "color",
          /*buttonColor*/
          ctx[2]
        );
      }
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(button);
      mounted = false;
      dispose();
    }
  };
}
function instance$r($$self, $$props, $$invalidate) {
  const omit_props_names = ["buttonText", "onClick"];
  let $$restProps = compute_rest_props($$props, omit_props_names);
  let $app;
  component_subscribe($$self, AppStore, ($$value) => $$invalidate(4, $app = $$value));
  let { buttonText = "Submit" } = $$props;
  let { onClick = () => {
  } } = $$props;
  let buttonColor = "rgb(41, 98, 255)";
  if ($app.branding.colors.lightMode.primaryButton) {
    buttonColor = $app.branding.colors.lightMode.primaryButton;
  }
  $$self.$$set = ($$new_props) => {
    $$props = assign(assign({}, $$props), exclude_internal_props($$new_props));
    $$invalidate(3, $$restProps = compute_rest_props($$props, omit_props_names));
    if ("buttonText" in $$new_props)
      $$invalidate(0, buttonText = $$new_props.buttonText);
    if ("onClick" in $$new_props)
      $$invalidate(1, onClick = $$new_props.onClick);
  };
  return [buttonText, onClick, buttonColor, $$restProps];
}
var TextButton = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$r, create_fragment$O, safe_not_equal, { buttonText: 0, onClick: 1 });
  }
};
function get_each_context$9(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[11] = list[i];
  child_ctx[13] = i;
  return child_ctx;
}
function get_each_context_1$4(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[14] = list[i];
  return child_ctx;
}
function create_if_block_3$9(ctx) {
  let div;
  let regularbutton;
  let current;
  regularbutton = new RegularButton({
    props: {
      onClick: (
        /*launchPortal*/
        ctx[4]
      ),
      class: "ms-modal__regular-button--margin-right ms-modal__regular-button--left-icon",
      buttonText: "Manage Subscriptions",
      buttonLeftIcon: LinkOutIcon
    }
  });
  return {
    c() {
      div = element("div");
      create_component(regularbutton.$$.fragment);
      set_style(div, "display", "flex");
      set_style(div, "flex-wrap", "wrap");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(regularbutton, div, null);
      current = true;
    },
    p: noop,
    i(local) {
      if (current)
        return;
      transition_in(regularbutton.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(regularbutton.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      destroy_component(regularbutton);
    }
  };
}
function create_if_block_2$d(ctx) {
  let h3;
  let t1;
  let each_1_anchor;
  let current;
  let each_value_1 = (
    /*joinedTeams*/
    ctx[1]
  );
  let each_blocks = [];
  for (let i = 0; i < each_value_1.length; i += 1) {
    each_blocks[i] = create_each_block_1$4(get_each_context_1$4(ctx, each_value_1, i));
  }
  const out = (i) => transition_out(each_blocks[i], 1, 1, () => {
    each_blocks[i] = null;
  });
  return {
    c() {
      h3 = element("h3");
      h3.textContent = "Team Plans";
      t1 = space();
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      each_1_anchor = empty();
    },
    m(target, anchor) {
      insert(target, h3, anchor);
      insert(target, t1, anchor);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(target, anchor);
        }
      }
      insert(target, each_1_anchor, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      if (dirty & /*removeMemberFromTeam, joinedTeams, member*/
      67) {
        each_value_1 = /*joinedTeams*/
        ctx2[1];
        let i;
        for (i = 0; i < each_value_1.length; i += 1) {
          const child_ctx = get_each_context_1$4(ctx2, each_value_1, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
            transition_in(each_blocks[i], 1);
          } else {
            each_blocks[i] = create_each_block_1$4(child_ctx);
            each_blocks[i].c();
            transition_in(each_blocks[i], 1);
            each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
          }
        }
        group_outros();
        for (i = each_value_1.length; i < each_blocks.length; i += 1) {
          out(i);
        }
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      for (let i = 0; i < each_value_1.length; i += 1) {
        transition_in(each_blocks[i]);
      }
      current = true;
    },
    o(local) {
      each_blocks = each_blocks.filter(Boolean);
      for (let i = 0; i < each_blocks.length; i += 1) {
        transition_out(each_blocks[i]);
      }
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(h3);
      if (detaching)
        detach(t1);
      destroy_each(each_blocks, detaching);
      if (detaching)
        detach(each_1_anchor);
    }
  };
}
function create_each_block_1$4(ctx) {
  let div1;
  let div0;
  let b;
  let t0_value = (
    /*team*/
    ctx[14].planName + ""
  );
  let t0;
  let t1;
  let textbutton;
  let t2;
  let current;
  function func2() {
    return (
      /*func*/
      ctx[8](
        /*team*/
        ctx[14]
      )
    );
  }
  textbutton = new TextButton({
    props: { buttonText: "Leave Team", onClick: func2 }
  });
  return {
    c() {
      div1 = element("div");
      div0 = element("div");
      b = element("b");
      t0 = text(t0_value);
      t1 = space();
      create_component(textbutton.$$.fragment);
      t2 = space();
      attr(div1, "class", "ms-modal__card");
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);
      append(div0, b);
      append(b, t0);
      append(div1, t1);
      mount_component(textbutton, div1, null);
      append(div1, t2);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if ((!current || dirty & /*joinedTeams*/
      2) && t0_value !== (t0_value = /*team*/
      ctx[14].planName + ""))
        set_data(t0, t0_value);
      const textbutton_changes = {};
      if (dirty & /*joinedTeams, member*/
      3)
        textbutton_changes.onClick = func2;
      textbutton.$set(textbutton_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(textbutton.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(textbutton.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div1);
      destroy_component(textbutton);
    }
  };
}
function create_if_block_1$h(ctx) {
  let h3;
  let t1;
  let each_1_anchor;
  let current;
  let each_value = (
    /*freePlanConnections*/
    ctx[2]
  );
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$9(get_each_context$9(ctx, each_value, i));
  }
  const out = (i) => transition_out(each_blocks[i], 1, 1, () => {
    each_blocks[i] = null;
  });
  return {
    c() {
      h3 = element("h3");
      h3.textContent = "Free Plans";
      t1 = space();
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      each_1_anchor = empty();
    },
    m(target, anchor) {
      insert(target, h3, anchor);
      insert(target, t1, anchor);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(target, anchor);
        }
      }
      insert(target, each_1_anchor, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      if (dirty & /*removeFreePlan, freePlanConnections, $app*/
      44) {
        each_value = /*freePlanConnections*/
        ctx2[2];
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context$9(ctx2, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
            transition_in(each_blocks[i], 1);
          } else {
            each_blocks[i] = create_each_block$9(child_ctx);
            each_blocks[i].c();
            transition_in(each_blocks[i], 1);
            each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
          }
        }
        group_outros();
        for (i = each_value.length; i < each_blocks.length; i += 1) {
          out(i);
        }
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      for (let i = 0; i < each_value.length; i += 1) {
        transition_in(each_blocks[i]);
      }
      current = true;
    },
    o(local) {
      each_blocks = each_blocks.filter(Boolean);
      for (let i = 0; i < each_blocks.length; i += 1) {
        transition_out(each_blocks[i]);
      }
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(h3);
      if (detaching)
        detach(t1);
      destroy_each(each_blocks, detaching);
      if (detaching)
        detach(each_1_anchor);
    }
  };
}
function create_each_block$9(ctx) {
  let div1;
  let div0;
  let b;
  let t0_value = (
    /*$app*/
    ctx[3].plans.find(func_12).name + ""
  );
  let t0;
  let t1;
  let textbutton;
  let t2;
  let current;
  function func_12(...args) {
    return (
      /*func_1*/
      ctx[9](
        /*memberPlan*/
        ctx[11],
        ...args
      )
    );
  }
  function func_22() {
    return (
      /*func_2*/
      ctx[10](
        /*memberPlan*/
        ctx[11]
      )
    );
  }
  textbutton = new TextButton({
    props: { buttonText: "Remove", onClick: func_22 }
  });
  return {
    c() {
      div1 = element("div");
      div0 = element("div");
      b = element("b");
      t0 = text(t0_value);
      t1 = space();
      create_component(textbutton.$$.fragment);
      t2 = space();
      attr(div1, "class", "ms-modal__card");
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);
      append(div0, b);
      append(b, t0);
      append(div1, t1);
      mount_component(textbutton, div1, null);
      append(div1, t2);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if ((!current || dirty & /*$app, freePlanConnections*/
      12) && t0_value !== (t0_value = /*$app*/
      ctx[3].plans.find(func_12).name + ""))
        set_data(t0, t0_value);
      const textbutton_changes = {};
      if (dirty & /*freePlanConnections*/
      4)
        textbutton_changes.onClick = func_22;
      textbutton.$set(textbutton_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(textbutton.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(textbutton.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div1);
      destroy_component(textbutton);
    }
  };
}
function create_if_block$n(ctx) {
  let div;
  return {
    c() {
      div = element("div");
      div.textContent = "You currently have free no plans.";
    },
    m(target, anchor) {
      insert(target, div, anchor);
    },
    d(detaching) {
      if (detaching)
        detach(div);
    }
  };
}
function create_fragment$N(ctx) {
  let div;
  let t1;
  let t2;
  let t3;
  let t4;
  let if_block3_anchor;
  let current;
  let if_block0 = (
    /*member*/
    ctx[0].stripeCustomerId && create_if_block_3$9(ctx)
  );
  let if_block1 = (
    /*joinedTeams*/
    ctx[1].length > 0 && create_if_block_2$d(ctx)
  );
  let if_block2 = (
    /*freePlanConnections*/
    ctx[2].length > 0 && create_if_block_1$h(ctx)
  );
  let if_block3 = !/*member*/
  ctx[0].stripeCustomerId && /*freePlanConnections*/
  ctx[2].length === 0 && create_if_block$n();
  return {
    c() {
      div = element("div");
      div.innerHTML = `<h2 class="ms-modal__title ms-modal__title--profile">Plans</h2>`;
      t1 = space();
      if (if_block0)
        if_block0.c();
      t2 = space();
      if (if_block1)
        if_block1.c();
      t3 = space();
      if (if_block2)
        if_block2.c();
      t4 = space();
      if (if_block3)
        if_block3.c();
      if_block3_anchor = empty();
      attr(div, "class", "ms-modal__title-container");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      insert(target, t1, anchor);
      if (if_block0)
        if_block0.m(target, anchor);
      insert(target, t2, anchor);
      if (if_block1)
        if_block1.m(target, anchor);
      insert(target, t3, anchor);
      if (if_block2)
        if_block2.m(target, anchor);
      insert(target, t4, anchor);
      if (if_block3)
        if_block3.m(target, anchor);
      insert(target, if_block3_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (
        /*member*/
        ctx2[0].stripeCustomerId
      ) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
          if (dirty & /*member*/
          1) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_3$9(ctx2);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(t2.parentNode, t2);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      if (
        /*joinedTeams*/
        ctx2[1].length > 0
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty & /*joinedTeams*/
          2) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block_2$d(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(t3.parentNode, t3);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
      if (
        /*freePlanConnections*/
        ctx2[2].length > 0
      ) {
        if (if_block2) {
          if_block2.p(ctx2, dirty);
          if (dirty & /*freePlanConnections*/
          4) {
            transition_in(if_block2, 1);
          }
        } else {
          if_block2 = create_if_block_1$h(ctx2);
          if_block2.c();
          transition_in(if_block2, 1);
          if_block2.m(t4.parentNode, t4);
        }
      } else if (if_block2) {
        group_outros();
        transition_out(if_block2, 1, 1, () => {
          if_block2 = null;
        });
        check_outros();
      }
      if (!/*member*/
      ctx2[0].stripeCustomerId && /*freePlanConnections*/
      ctx2[2].length === 0) {
        if (if_block3)
          ;
        else {
          if_block3 = create_if_block$n();
          if_block3.c();
          if_block3.m(if_block3_anchor.parentNode, if_block3_anchor);
        }
      } else if (if_block3) {
        if_block3.d(1);
        if_block3 = null;
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block0);
      transition_in(if_block1);
      transition_in(if_block2);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(if_block1);
      transition_out(if_block2);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      if (detaching)
        detach(t1);
      if (if_block0)
        if_block0.d(detaching);
      if (detaching)
        detach(t2);
      if (if_block1)
        if_block1.d(detaching);
      if (detaching)
        detach(t3);
      if (if_block2)
        if_block2.d(detaching);
      if (detaching)
        detach(t4);
      if (if_block3)
        if_block3.d(detaching);
      if (detaching)
        detach(if_block3_anchor);
    }
  };
}
function instance$q($$self, $$props, $$invalidate) {
  let freePlanConnections;
  let joinedTeams;
  let $app;
  component_subscribe($$self, AppStore, ($$value) => $$invalidate(3, $app = $$value));
  let { profileLoader } = $$props;
  let { member } = $$props;
  function launchPortal(e) {
    return __async(this, null, function* () {
      $$invalidate(7, profileLoader = true);
      yield window.$memberstackDom.launchStripeCustomerPortal({ priceIds: [], autoRedirect: true });
    });
  }
  function removeFreePlan(planId) {
    return __async(this, null, function* () {
      $$invalidate(7, profileLoader = true);
      try {
        yield window.$memberstackDom.removePlan({ planId });
        $$invalidate(0, member.planConnections = member.planConnections.filter((plan) => plan.planId !== planId), member);
      } catch (err) {
        console.log(err);
        window.$memberstackDom._showMessage(err.message, true);
      } finally {
        $$invalidate(7, profileLoader = false);
      }
    });
  }
  function removeMemberFromTeam(teamId, memberId) {
    return __async(this, null, function* () {
      try {
        yield window.$memberstackDom.removeMemberFromTeam({ teamId, memberId });
        $$invalidate(0, member.teams.joinedTeams = member.teams.joinedTeams.filter((t) => t.teamId !== teamId), member);
      } catch (err) {
        window.$memberstackDom._showMessage(err.message, true);
      }
    });
  }
  const func2 = (team) => removeMemberFromTeam(team.teamId, member.id);
  const func_12 = (memberPlan, plan) => plan.id === memberPlan.planId;
  const func_22 = (memberPlan) => removeFreePlan(memberPlan.planId);
  $$self.$$set = ($$props2) => {
    if ("profileLoader" in $$props2)
      $$invalidate(7, profileLoader = $$props2.profileLoader);
    if ("member" in $$props2)
      $$invalidate(0, member = $$props2.member);
  };
  $$self.$$.update = () => {
    var _a;
    if ($$self.$$.dirty & /*member*/
    1) {
      $$invalidate(2, freePlanConnections = member.planConnections.filter((plan) => plan.type === "FREE"));
    }
    if ($$self.$$.dirty & /*member*/
    1) {
      $$invalidate(1, joinedTeams = (_a = member.teams) == null ? void 0 : _a.joinedTeams);
    }
  };
  return [
    member,
    joinedTeams,
    freePlanConnections,
    $app,
    launchPortal,
    removeFreePlan,
    removeMemberFromTeam,
    profileLoader,
    func2,
    func_12,
    func_22
  ];
}
var PlansInfoContent = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$q, create_fragment$N, safe_not_equal, { profileLoader: 7, member: 0 });
  }
};
function add_css$k(target) {
  append_styles(target, "svelte-c6ihgv", "svg.svelte-c6ihgv{fill:currentColor}");
}
function create_fragment$M(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "d", "M226.783-133.782q-38.363 0-65.682-27.319-27.319-27.319-27.319-65.682v-506.434q0-38.363 27.319-65.682 27.319-27.319 65.682-27.319h151.521q10.391-32.696 37.688-53.261 27.296-20.566 64.008-20.566 34.326 0 62.283 20.566 27.957 20.565 38.913 53.261h152.021q38.363 0 65.682 27.319 27.319 27.319 27.319 65.682v506.434q0 38.363-27.319 65.682-27.319 27.319-65.682 27.319H226.783Zm0-93.001h506.434v-506.434h-63.043v75.043q0 18.887-13.807 32.694-13.807 13.807-32.694 13.807H336.327q-18.887 0-32.694-13.807-13.807-13.807-13.807-32.694v-75.043h-63.043v506.434Zm253.006-518.913q13.711 0 23.711-9.789 10-9.79 10-23.5 0-13.711-9.789-23.711-9.79-10-23.5-10-13.711 0-23.711 9.79-10 9.789-10 23.5 0 13.71 9.789 23.71 9.79 10 23.5 10Z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "height", "20");
      attr(svg, "viewBox", "0 -960 960 960");
      attr(svg, "width", "20");
      attr(svg, "class", "svelte-c6ihgv");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var CopyIcon$1 = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$M, safe_not_equal, {}, add_css$k);
  }
};
function create_fragment$L(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M109-120q-11 0-20-5.5T75-140q-5-9-5.5-19.5T75-180l370-640q6-10 15.5-15t19.5-5q10 0 19.5 5t15.5 15l370 640q6 10 5.5 20.5T885-140q-5 9-14 14.5t-20 5.5H109Zm371-120q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm0-120q17 0 28.5-11.5T520-400v-120q0-17-11.5-28.5T480-560q-17 0-28.5 11.5T440-520v120q0 17 11.5 28.5T480-360Z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "height", "24");
      attr(svg, "viewBox", "0 -960 960 960");
      attr(svg, "width", "24");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var WarningIcon$1 = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$L, safe_not_equal, {});
  }
};
function add_css$j(target) {
  append_styles(target, "svelte-1haqb7b", ".ms-modal__title-container--teams.svelte-1haqb7b{display:flex;justify-content:flex-start;align-items:baseline;margin-bottom:24px;gap:12px}.ms-modal__title--teams.svelte-1haqb7b{margin-bottom:0px}.ms-modal__title--seats.svelte-1haqb7b{font-size:14px;line-height:1;font-weight:500;color:#5c5c5c}.ms-modal__invite-group.svelte-1haqb7b{margin-bottom:24px}.ms-modal__invite-input-group.svelte-1haqb7b{display:flex;gap:12px;border:1px solid #ddd;border-radius:6px;justify-content:space-between;align-items:center;padding:6px}.ms-modal__invite-input.svelte-1haqb7b{border:none;background:none;outline:none;width:100%;font-size:12px;padding:8px 0;text-overflow:ellipsis}.ms-modal__invite-copy-btn.svelte-1haqb7b{font-size:14px;font-weight:700;line-height:1;color:#fff;background-color:#2962ff;border-radius:4px;display:flex;align-items:center;padding:8px 12px;gap:6px}.ms-modal__invite-copy-btn svg{margin-right:4px;width:16px}.ms-modal__invite-regenerate-btn.svelte-1haqb7b{font-size:12px;font-weight:600;line-height:1;color:#2962ff;background-color:transparent;border:none;outline:none;padding:4px 0}.ms-modal__upgrade-warning.svelte-1haqb7b{display:flex;align-items:center;gap:12px;padding:12px;border-radius:8px;font-size:14px;font-weight:500;line-height:1;color:#e28c0a;background-color:#faf3e1;width:100%;text-align:left}.ms-modal__upgrade-warning-text.svelte-1haqb7b{width:100%}.ms-modal__team-member.svelte-1haqb7b{display:flex;justify-content:space-between;align-items:center;padding:12px 0;border-bottom:1px solid #ebebeb}.ms-modal__team-member.svelte-1haqb7b:last-child{border-bottom:none}.ms-modal__team-member-info.svelte-1haqb7b{display:flex;align-items:center}.ms-modal__team-member-image.svelte-1haqb7b{width:32px;height:32px;border-radius:50%;margin-right:10px}.ms-modal__team-member-image--initial.svelte-1haqb7b{width:32px;height:32px;border-radius:50%;border:1.33px solid #2962ff;margin-right:12px;display:flex;justify-content:center;align-items:center;background-color:#e7f1ff;color:#2962ff;font-size:18px;font-weight:500;line-height:1}.ms-modal__team-member-email.svelte-1haqb7b{font-size:14px;font-weight:500;line-height:1;color:#5c5c5c}.ms-modal__team-member-actions.svelte-1haqb7b{display:flex;align-items:center}.ms-modal__team-member-role.svelte-1haqb7b{font-size:12px;font-weight:500;line-height:1;color:#5c5c5c}.ms-modal__team-member-remove-btn.svelte-1haqb7b{font-size:12px;font-weight:600;line-height:1;color:#c8020d;background-color:transparent;border:none;outline:none;padding:4px 0;display:flex;align-items:center;margin-left:8px}.ms-modal__team-member-remove-text.svelte-1haqb7b{margin-right:8px}.ms-modal__team-member-remove-btn svg{width:10px !important}");
}
function get_each_context$8(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[15] = list[i];
  return child_ctx;
}
function create_if_block_5$5(ctx) {
  var _a, _b;
  let div;
  let t0_value = (
    /*teamData*/
    ((_a = ctx[0]) == null ? void 0 : _a.members.length) + ""
  );
  let t0;
  let t1;
  let t2_value = (
    /*teamData*/
    ((_b = ctx[0]) == null ? void 0 : _b.maxTeamMembers) + ""
  );
  let t2;
  let t3;
  return {
    c() {
      div = element("div");
      t0 = text(t0_value);
      t1 = text("/");
      t2 = text(t2_value);
      t3 = text(" Seats");
      attr(div, "class", "ms-modal__title--seats svelte-1haqb7b");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, t0);
      append(div, t1);
      append(div, t2);
      append(div, t3);
    },
    p(ctx2, dirty) {
      var _a2, _b2;
      if (dirty & /*teamData*/
      1 && t0_value !== (t0_value = /*teamData*/
      ((_a2 = ctx2[0]) == null ? void 0 : _a2.members.length) + ""))
        set_data(t0, t0_value);
      if (dirty & /*teamData*/
      1 && t2_value !== (t2_value = /*teamData*/
      ((_b2 = ctx2[0]) == null ? void 0 : _b2.maxTeamMembers) + ""))
        set_data(t2, t2_value);
    },
    d(detaching) {
      if (detaching)
        detach(div);
    }
  };
}
function create_catch_block(ctx) {
  return {
    c: noop,
    m: noop,
    p: noop,
    i: noop,
    o: noop,
    d: noop
  };
}
function create_then_block(ctx) {
  let current_block_type_index;
  let if_block0;
  let t;
  let if_block1_anchor;
  let current;
  const if_block_creators = [create_if_block_4$6, create_else_block_2$1];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    var _a, _b;
    if (
      /*teamData*/
      ((_a = ctx2[0]) == null ? void 0 : _a.members.length) < /*teamData*/
      ((_b = ctx2[0]) == null ? void 0 : _b.maxTeamMembers)
    )
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  let if_block1 = (
    /*teamData*/
    ctx[0] && /*teamData*/
    ctx[0].members.length > 0 && create_if_block$m(ctx)
  );
  return {
    c() {
      if_block0.c();
      t = space();
      if (if_block1)
        if_block1.c();
      if_block1_anchor = empty();
    },
    m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, t, anchor);
      if (if_block1)
        if_block1.m(target, anchor);
      insert(target, if_block1_anchor, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block0 = if_blocks[current_block_type_index];
        if (!if_block0) {
          if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block0.c();
        } else {
          if_block0.p(ctx2, dirty);
        }
        transition_in(if_block0, 1);
        if_block0.m(t.parentNode, t);
      }
      if (
        /*teamData*/
        ctx2[0] && /*teamData*/
        ctx2[0].members.length > 0
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty & /*teamData*/
          1) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block$m(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block0);
      transition_in(if_block1);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(if_block1);
      current = false;
    },
    d(detaching) {
      if_blocks[current_block_type_index].d(detaching);
      if (detaching)
        detach(t);
      if (if_block1)
        if_block1.d(detaching);
      if (detaching)
        detach(if_block1_anchor);
    }
  };
}
function create_else_block_2$1(ctx) {
  let div;
  let warningicon;
  let t0;
  let span;
  let current;
  warningicon = new WarningIcon$1({});
  return {
    c() {
      div = element("div");
      create_component(warningicon.$$.fragment);
      t0 = space();
      span = element("span");
      span.textContent = "Your team is growing! Upgrade your plan for more seats.";
      attr(span, "class", "ms-modal__upgrade-warning-text svelte-1haqb7b");
      attr(div, "class", "ms-modal__upgrade-warning svelte-1haqb7b");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(warningicon, div, null);
      append(div, t0);
      append(div, span);
      current = true;
    },
    p: noop,
    i(local) {
      if (current)
        return;
      transition_in(warningicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(warningicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      destroy_component(warningicon);
    }
  };
}
function create_if_block_4$6(ctx) {
  let div1;
  let div0;
  let input;
  let t0;
  let button0;
  let copyicon;
  let t1;
  let t2;
  let t3;
  let button1;
  let current;
  let mounted;
  let dispose;
  copyicon = new CopyIcon$1({});
  return {
    c() {
      div1 = element("div");
      div0 = element("div");
      input = element("input");
      t0 = space();
      button0 = element("button");
      create_component(copyicon.$$.fragment);
      t1 = space();
      t2 = text(
        /*copyInviteText*/
        ctx[2]
      );
      t3 = space();
      button1 = element("button");
      button1.textContent = "Regenerate Invite Link";
      attr(input, "type", "text");
      attr(input, "class", "ms-modal__invite-input svelte-1haqb7b");
      input.value = /*inviteLink*/
      ctx[3];
      input.readOnly = true;
      attr(button0, "class", "ms-modal__invite-copy-btn svelte-1haqb7b");
      attr(div0, "class", "ms-modal__invite-input-group svelte-1haqb7b");
      attr(button1, "class", "ms-modal__invite-regenerate-btn svelte-1haqb7b");
      attr(div1, "class", "ms-modal__invite-group svelte-1haqb7b");
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);
      append(div0, input);
      append(div0, t0);
      append(div0, button0);
      mount_component(copyicon, button0, null);
      append(button0, t1);
      append(button0, t2);
      append(div1, t3);
      append(div1, button1);
      current = true;
      if (!mounted) {
        dispose = [
          listen(
            button0,
            "click",
            /*click_handler*/
            ctx[10]
          ),
          listen(
            button1,
            "click",
            /*click_handler_1*/
            ctx[11]
          )
        ];
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      if (!current || dirty & /*inviteLink*/
      8 && input.value !== /*inviteLink*/
      ctx2[3]) {
        input.value = /*inviteLink*/
        ctx2[3];
      }
      if (!current || dirty & /*copyInviteText*/
      4)
        set_data(
          t2,
          /*copyInviteText*/
          ctx2[2]
        );
    },
    i(local) {
      if (current)
        return;
      transition_in(copyicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(copyicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div1);
      destroy_component(copyicon);
      mounted = false;
      run_all(dispose);
    }
  };
}
function create_if_block$m(ctx) {
  let div;
  let each_blocks = [];
  let each_1_lookup = /* @__PURE__ */ new Map();
  let current;
  let each_value = (
    /*teamData*/
    ctx[0].members
  );
  const get_key = (ctx2) => (
    /*m*/
    ctx2[15].member.id
  );
  for (let i = 0; i < each_value.length; i += 1) {
    let child_ctx = get_each_context$8(ctx, each_value, i);
    let key = get_key(child_ctx);
    each_1_lookup.set(key, each_blocks[i] = create_each_block$8(key, child_ctx));
  }
  return {
    c() {
      div = element("div");
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      attr(div, "class", "ms-modal__team-members");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(div, null);
        }
      }
      current = true;
    },
    p(ctx2, dirty) {
      if (dirty & /*showRemoveButton, teamData, removeMemberFromTeam*/
      81) {
        each_value = /*teamData*/
        ctx2[0].members;
        group_outros();
        each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx2, each_value, each_1_lookup, div, outro_and_destroy_block, create_each_block$8, null, get_each_context$8);
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      for (let i = 0; i < each_value.length; i += 1) {
        transition_in(each_blocks[i]);
      }
      current = true;
    },
    o(local) {
      for (let i = 0; i < each_blocks.length; i += 1) {
        transition_out(each_blocks[i]);
      }
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].d();
      }
    }
  };
}
function create_else_block_1$3(ctx) {
  let img;
  let img_src_value;
  return {
    c() {
      img = element("img");
      attr(img, "class", "ms-modal__team-member-image svelte-1haqb7b");
      if (!src_url_equal(img.src, img_src_value = /*m*/
      ctx[15].member.profileImage))
        attr(img, "src", img_src_value);
      attr(img, "alt", "Member Profile Avatar");
    },
    m(target, anchor) {
      insert(target, img, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*teamData*/
      1 && !src_url_equal(img.src, img_src_value = /*m*/
      ctx2[15].member.profileImage)) {
        attr(img, "src", img_src_value);
      }
    },
    d(detaching) {
      if (detaching)
        detach(img);
    }
  };
}
function create_if_block_3$8(ctx) {
  let div;
  let t_value = (
    /*m*/
    ctx[15].member.auth.email[0].toUpperCase() + ""
  );
  let t;
  return {
    c() {
      div = element("div");
      t = text(t_value);
      attr(div, "class", "ms-modal__team-member-image--initial svelte-1haqb7b");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, t);
    },
    p(ctx2, dirty) {
      if (dirty & /*teamData*/
      1 && t_value !== (t_value = /*m*/
      ctx2[15].member.auth.email[0].toUpperCase() + ""))
        set_data(t, t_value);
    },
    d(detaching) {
      if (detaching)
        detach(div);
    }
  };
}
function create_if_block_1$g(ctx) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block_2$c, create_else_block$9];
  const if_blocks = [];
  function select_block_type_2(ctx2, dirty) {
    if (!/*m*/
    ctx2[15].showRemoveButton)
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type_2(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type_2(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if_blocks[current_block_type_index].d(detaching);
      if (detaching)
        detach(if_block_anchor);
    }
  };
}
function create_else_block$9(ctx) {
  let button;
  let span;
  let t1;
  let closeicon;
  let current;
  let mounted;
  let dispose;
  closeicon = new CloseIcon({});
  function click_handler_3() {
    return (
      /*click_handler_3*/
      ctx[13](
        /*m*/
        ctx[15]
      )
    );
  }
  return {
    c() {
      button = element("button");
      span = element("span");
      span.textContent = "Are you sure?";
      t1 = space();
      create_component(closeicon.$$.fragment);
      attr(span, "class", "ms-modal__team-member-remove-text svelte-1haqb7b");
      attr(button, "class", "ms-modal__team-member-remove-btn svelte-1haqb7b");
    },
    m(target, anchor) {
      insert(target, button, anchor);
      append(button, span);
      append(button, t1);
      mount_component(closeicon, button, null);
      current = true;
      if (!mounted) {
        dispose = listen(button, "click", click_handler_3);
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
    },
    i(local) {
      if (current)
        return;
      transition_in(closeicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(closeicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(button);
      destroy_component(closeicon);
      mounted = false;
      dispose();
    }
  };
}
function create_if_block_2$c(ctx) {
  let button;
  let closeicon;
  let current;
  let mounted;
  let dispose;
  closeicon = new CloseIcon({});
  function click_handler_2() {
    return (
      /*click_handler_2*/
      ctx[12](
        /*m*/
        ctx[15]
      )
    );
  }
  return {
    c() {
      button = element("button");
      create_component(closeicon.$$.fragment);
      attr(button, "class", "ms-modal__team-member-remove-btn svelte-1haqb7b");
    },
    m(target, anchor) {
      insert(target, button, anchor);
      mount_component(closeicon, button, null);
      current = true;
      if (!mounted) {
        dispose = listen(button, "click", click_handler_2);
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
    },
    i(local) {
      if (current)
        return;
      transition_in(closeicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(closeicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(button);
      destroy_component(closeicon);
      mounted = false;
      dispose();
    }
  };
}
function create_each_block$8(key_1, ctx) {
  let div4;
  let div1;
  let t0;
  let div0;
  let t1_value = (
    /*m*/
    ctx[15].member.auth.email + ""
  );
  let t1;
  let t2;
  let div3;
  let div2;
  let t3_value = (
    /*m*/
    ctx[15].role + ""
  );
  let t3;
  let t4;
  let t5;
  let current;
  function select_block_type_1(ctx2, dirty) {
    if (
      /*m*/
      ctx2[15].member.profileImage === null
    )
      return create_if_block_3$8;
    return create_else_block_1$3;
  }
  let current_block_type = select_block_type_1(ctx);
  let if_block0 = current_block_type(ctx);
  let if_block1 = (
    /*m*/
    ctx[15].role !== "OWNER" && create_if_block_1$g(ctx)
  );
  return {
    key: key_1,
    first: null,
    c() {
      div4 = element("div");
      div1 = element("div");
      if_block0.c();
      t0 = space();
      div0 = element("div");
      t1 = text(t1_value);
      t2 = space();
      div3 = element("div");
      div2 = element("div");
      t3 = text(t3_value);
      t4 = space();
      if (if_block1)
        if_block1.c();
      t5 = space();
      attr(div0, "class", "ms-modal__team-member-email svelte-1haqb7b");
      attr(div1, "class", "ms-modal__team-member-info svelte-1haqb7b");
      attr(div2, "class", "ms-modal__team-member-role svelte-1haqb7b");
      attr(div3, "class", "ms-modal__team-member-actions svelte-1haqb7b");
      attr(div4, "class", "ms-modal__team-member svelte-1haqb7b");
      this.first = div4;
    },
    m(target, anchor) {
      insert(target, div4, anchor);
      append(div4, div1);
      if_block0.m(div1, null);
      append(div1, t0);
      append(div1, div0);
      append(div0, t1);
      append(div4, t2);
      append(div4, div3);
      append(div3, div2);
      append(div2, t3);
      append(div3, t4);
      if (if_block1)
        if_block1.m(div3, null);
      append(div4, t5);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (current_block_type === (current_block_type = select_block_type_1(ctx)) && if_block0) {
        if_block0.p(ctx, dirty);
      } else {
        if_block0.d(1);
        if_block0 = current_block_type(ctx);
        if (if_block0) {
          if_block0.c();
          if_block0.m(div1, t0);
        }
      }
      if ((!current || dirty & /*teamData*/
      1) && t1_value !== (t1_value = /*m*/
      ctx[15].member.auth.email + ""))
        set_data(t1, t1_value);
      if ((!current || dirty & /*teamData*/
      1) && t3_value !== (t3_value = /*m*/
      ctx[15].role + ""))
        set_data(t3, t3_value);
      if (
        /*m*/
        ctx[15].role !== "OWNER"
      ) {
        if (if_block1) {
          if_block1.p(ctx, dirty);
          if (dirty & /*teamData*/
          1) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block_1$g(ctx);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(div3, null);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block1);
      current = true;
    },
    o(local) {
      transition_out(if_block1);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div4);
      if_block0.d();
      if (if_block1)
        if_block1.d();
    }
  };
}
function create_pending_block(ctx) {
  let p;
  return {
    c() {
      p = element("p");
      p.textContent = "Loading...";
    },
    m(target, anchor) {
      insert(target, p, anchor);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(p);
    }
  };
}
function create_fragment$K(ctx) {
  var _a;
  let div;
  let h2;
  let t1;
  let t2;
  let await_block_anchor;
  let promise2;
  let current;
  let if_block = (
    /*teamData*/
    ((_a = ctx[0]) == null ? void 0 : _a.members.length) > 0 && create_if_block_5$5(ctx)
  );
  let info = {
    ctx,
    current: null,
    token: null,
    hasCatch: false,
    pending: create_pending_block,
    then: create_then_block,
    catch: create_catch_block,
    blocks: [, , ,]
  };
  handle_promise(promise2 = /*teamPromise*/
  ctx[1], info);
  return {
    c() {
      div = element("div");
      h2 = element("h2");
      h2.textContent = "Team";
      t1 = space();
      if (if_block)
        if_block.c();
      t2 = space();
      await_block_anchor = empty();
      info.block.c();
      attr(h2, "class", "ms-modal__title ms-modal__title--teams svelte-1haqb7b");
      attr(div, "class", "ms-modal__title-container ms-modal__title-container--teams svelte-1haqb7b");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, h2);
      append(div, t1);
      if (if_block)
        if_block.m(div, null);
      insert(target, t2, anchor);
      insert(target, await_block_anchor, anchor);
      info.block.m(target, info.anchor = anchor);
      info.mount = () => await_block_anchor.parentNode;
      info.anchor = await_block_anchor;
      current = true;
    },
    p(new_ctx, [dirty]) {
      var _a2;
      ctx = new_ctx;
      if (
        /*teamData*/
        ((_a2 = ctx[0]) == null ? void 0 : _a2.members.length) > 0
      ) {
        if (if_block) {
          if_block.p(ctx, dirty);
        } else {
          if_block = create_if_block_5$5(ctx);
          if_block.c();
          if_block.m(div, null);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
      info.ctx = ctx;
      if (dirty & /*teamPromise*/
      2 && promise2 !== (promise2 = /*teamPromise*/
      ctx[1]) && handle_promise(promise2, info))
        ;
      else {
        update_await_block_branch(info, ctx, dirty);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(info.block);
      current = true;
    },
    o(local) {
      for (let i = 0; i < 3; i += 1) {
        const block = info.blocks[i];
        transition_out(block);
      }
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      if (if_block)
        if_block.d();
      if (detaching)
        detach(t2);
      if (detaching)
        detach(await_block_anchor);
      info.block.d(detaching);
      info.token = null;
      info = null;
    }
  };
}
function instance$p($$self, $$props, $$invalidate) {
  var _a, _b, _c;
  let inviteLink;
  let { profileLoader } = $$props;
  let { member } = $$props;
  let teamPromise;
  let teamData;
  let copyInviteText = "Copy";
  function showRemoveButton(m) {
    m.showRemoveButton = true;
    $$invalidate(0, teamData.members = [...teamData.members.filter((member2) => member2.member.id !== m.member.id), m], teamData);
    setTimeout(
      () => {
        m.showRemoveButton = false;
      },
      3e3
    );
  }
  function copyInviteLink() {
    navigator.clipboard.writeText(inviteLink);
    $$invalidate(2, copyInviteText = "Copied!");
    setTimeout(
      () => {
        $$invalidate(2, copyInviteText = "Copy");
      },
      2e3
    );
  }
  function getTeam(teamId) {
    return __async(this, null, function* () {
      const { data } = yield window.$memberstackDom.getTeam({ teamId });
      $$invalidate(0, teamData = data);
      return data;
    });
  }
  function removeMemberFromTeam(memberId) {
    return __async(this, null, function* () {
      try {
        $$invalidate(8, profileLoader = true);
        yield window.$memberstackDom.removeMemberFromTeam({ teamId: teamData.id, memberId });
        $$invalidate(0, teamData.members = teamData.members.filter((m) => m.member.id !== memberId), teamData);
        window.$memberstackDom._showMessage("Member has been removed from team.", false);
      } catch (err) {
        window.$memberstackDom._showMessage(err.message, true);
      } finally {
        $$invalidate(8, profileLoader = false);
      }
    });
  }
  function generateInviteToken() {
    return __async(this, null, function* () {
      try {
        $$invalidate(8, profileLoader = true);
        const { data } = yield window.$memberstackDom.generateInviteToken({ teamId: teamData.id });
        $$invalidate(0, teamData.inviteToken = data.inviteToken, teamData);
        window.$memberstackDom._showMessage("Invite Link Regenerated", false);
      } catch (err) {
        window.$memberstackDom._showMessage(err.message, true);
      } finally {
        $$invalidate(8, profileLoader = false);
      }
    });
  }
  if (((_b = (_a = member == null ? void 0 : member.teams) == null ? void 0 : _a.ownedTeams) == null ? void 0 : _b.length) > 0) {
    const teamId = (_c = member.teams) == null ? void 0 : _c.ownedTeams[0].teamId;
    teamPromise = getTeam(teamId);
  } else {
    teamPromise = Promise.resolve(null);
  }
  const click_handler = () => copyInviteLink();
  const click_handler_1 = () => generateInviteToken();
  const click_handler_2 = (m) => showRemoveButton(m);
  const click_handler_3 = (m) => removeMemberFromTeam(m.member.id);
  $$self.$$set = ($$props2) => {
    if ("profileLoader" in $$props2)
      $$invalidate(8, profileLoader = $$props2.profileLoader);
    if ("member" in $$props2)
      $$invalidate(9, member = $$props2.member);
  };
  $$self.$$.update = () => {
    var _a2;
    if ($$self.$$.dirty & /*teamData*/
    1) {
      $$invalidate(3, inviteLink = `${window.location.origin}${(_a2 = teamData == null ? void 0 : teamData.plan) == null ? void 0 : _a2.teamAccountInviteSignupLink}?inviteToken=${teamData == null ? void 0 : teamData.inviteToken}`);
    }
  };
  return [
    teamData,
    teamPromise,
    copyInviteText,
    inviteLink,
    showRemoveButton,
    copyInviteLink,
    removeMemberFromTeam,
    generateInviteToken,
    profileLoader,
    member,
    click_handler,
    click_handler_1,
    click_handler_2,
    click_handler_3
  ];
}
var ProfileTeamContent = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$p, create_fragment$K, safe_not_equal, { profileLoader: 8, member: 9 }, add_css$j);
  }
};
function create_if_block_5$4(ctx) {
  let profileloader;
  let current;
  profileloader = new ProfileLoader({});
  return {
    c() {
      create_component(profileloader.$$.fragment);
    },
    m(target, anchor) {
      mount_component(profileloader, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(profileloader.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(profileloader.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(profileloader, detaching);
    }
  };
}
function create_if_block_4$5(ctx) {
  let profileteamcontent;
  let updating_member;
  let updating_profileLoader;
  let current;
  function profileteamcontent_member_binding(value) {
    ctx[19](value);
  }
  function profileteamcontent_profileLoader_binding(value) {
    ctx[20](value);
  }
  let profileteamcontent_props = {};
  if (
    /*member*/
    ctx[1] !== void 0
  ) {
    profileteamcontent_props.member = /*member*/
    ctx[1];
  }
  if (
    /*profileLoader*/
    ctx[4] !== void 0
  ) {
    profileteamcontent_props.profileLoader = /*profileLoader*/
    ctx[4];
  }
  profileteamcontent = new ProfileTeamContent({ props: profileteamcontent_props });
  binding_callbacks.push(() => bind(profileteamcontent, "member", profileteamcontent_member_binding));
  binding_callbacks.push(() => bind(profileteamcontent, "profileLoader", profileteamcontent_profileLoader_binding));
  return {
    c() {
      create_component(profileteamcontent.$$.fragment);
    },
    m(target, anchor) {
      mount_component(profileteamcontent, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const profileteamcontent_changes = {};
      if (!updating_member && dirty & /*member*/
      2) {
        updating_member = true;
        profileteamcontent_changes.member = /*member*/
        ctx2[1];
        add_flush_callback(() => updating_member = false);
      }
      if (!updating_profileLoader && dirty & /*profileLoader*/
      16) {
        updating_profileLoader = true;
        profileteamcontent_changes.profileLoader = /*profileLoader*/
        ctx2[4];
        add_flush_callback(() => updating_profileLoader = false);
      }
      profileteamcontent.$set(profileteamcontent_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(profileteamcontent.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(profileteamcontent.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(profileteamcontent, detaching);
    }
  };
}
function create_if_block_3$7(ctx) {
  let plansinfocontent;
  let updating_member;
  let updating_profileLoader;
  let current;
  function plansinfocontent_member_binding(value) {
    ctx[17](value);
  }
  function plansinfocontent_profileLoader_binding(value) {
    ctx[18](value);
  }
  let plansinfocontent_props = {};
  if (
    /*member*/
    ctx[1] !== void 0
  ) {
    plansinfocontent_props.member = /*member*/
    ctx[1];
  }
  if (
    /*profileLoader*/
    ctx[4] !== void 0
  ) {
    plansinfocontent_props.profileLoader = /*profileLoader*/
    ctx[4];
  }
  plansinfocontent = new PlansInfoContent({ props: plansinfocontent_props });
  binding_callbacks.push(() => bind(plansinfocontent, "member", plansinfocontent_member_binding));
  binding_callbacks.push(() => bind(plansinfocontent, "profileLoader", plansinfocontent_profileLoader_binding));
  return {
    c() {
      create_component(plansinfocontent.$$.fragment);
    },
    m(target, anchor) {
      mount_component(plansinfocontent, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const plansinfocontent_changes = {};
      if (!updating_member && dirty & /*member*/
      2) {
        updating_member = true;
        plansinfocontent_changes.member = /*member*/
        ctx2[1];
        add_flush_callback(() => updating_member = false);
      }
      if (!updating_profileLoader && dirty & /*profileLoader*/
      16) {
        updating_profileLoader = true;
        plansinfocontent_changes.profileLoader = /*profileLoader*/
        ctx2[4];
        add_flush_callback(() => updating_profileLoader = false);
      }
      plansinfocontent.$set(plansinfocontent_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(plansinfocontent.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(plansinfocontent.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(plansinfocontent, detaching);
    }
  };
}
function create_if_block_2$b(ctx) {
  let passwordinfocontent;
  let updating_displayProfile;
  let updating_profileLoader;
  let updating_member;
  let current;
  function passwordinfocontent_displayProfile_binding(value) {
    ctx[14](value);
  }
  function passwordinfocontent_profileLoader_binding(value) {
    ctx[15](value);
  }
  function passwordinfocontent_member_binding(value) {
    ctx[16](value);
  }
  let passwordinfocontent_props = {};
  if (
    /*displayProfile*/
    ctx[0] !== void 0
  ) {
    passwordinfocontent_props.displayProfile = /*displayProfile*/
    ctx[0];
  }
  if (
    /*profileLoader*/
    ctx[4] !== void 0
  ) {
    passwordinfocontent_props.profileLoader = /*profileLoader*/
    ctx[4];
  }
  if (
    /*member*/
    ctx[1] !== void 0
  ) {
    passwordinfocontent_props.member = /*member*/
    ctx[1];
  }
  passwordinfocontent = new PasswordInfoContent({ props: passwordinfocontent_props });
  binding_callbacks.push(() => bind(passwordinfocontent, "displayProfile", passwordinfocontent_displayProfile_binding));
  binding_callbacks.push(() => bind(passwordinfocontent, "profileLoader", passwordinfocontent_profileLoader_binding));
  binding_callbacks.push(() => bind(passwordinfocontent, "member", passwordinfocontent_member_binding));
  return {
    c() {
      create_component(passwordinfocontent.$$.fragment);
    },
    m(target, anchor) {
      mount_component(passwordinfocontent, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const passwordinfocontent_changes = {};
      if (!updating_displayProfile && dirty & /*displayProfile*/
      1) {
        updating_displayProfile = true;
        passwordinfocontent_changes.displayProfile = /*displayProfile*/
        ctx2[0];
        add_flush_callback(() => updating_displayProfile = false);
      }
      if (!updating_profileLoader && dirty & /*profileLoader*/
      16) {
        updating_profileLoader = true;
        passwordinfocontent_changes.profileLoader = /*profileLoader*/
        ctx2[4];
        add_flush_callback(() => updating_profileLoader = false);
      }
      if (!updating_member && dirty & /*member*/
      2) {
        updating_member = true;
        passwordinfocontent_changes.member = /*member*/
        ctx2[1];
        add_flush_callback(() => updating_member = false);
      }
      passwordinfocontent.$set(passwordinfocontent_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(passwordinfocontent.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(passwordinfocontent.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(passwordinfocontent, detaching);
    }
  };
}
function create_if_block_1$f(ctx) {
  let securityinfocontent;
  let updating_displayProfile;
  let updating_profileLoader;
  let updating_member;
  let current;
  function securityinfocontent_displayProfile_binding(value) {
    ctx[11](value);
  }
  function securityinfocontent_profileLoader_binding(value) {
    ctx[12](value);
  }
  function securityinfocontent_member_binding(value) {
    ctx[13](value);
  }
  let securityinfocontent_props = {};
  if (
    /*displayProfile*/
    ctx[0] !== void 0
  ) {
    securityinfocontent_props.displayProfile = /*displayProfile*/
    ctx[0];
  }
  if (
    /*profileLoader*/
    ctx[4] !== void 0
  ) {
    securityinfocontent_props.profileLoader = /*profileLoader*/
    ctx[4];
  }
  if (
    /*member*/
    ctx[1] !== void 0
  ) {
    securityinfocontent_props.member = /*member*/
    ctx[1];
  }
  securityinfocontent = new SecurityInfoContent({ props: securityinfocontent_props });
  binding_callbacks.push(() => bind(securityinfocontent, "displayProfile", securityinfocontent_displayProfile_binding));
  binding_callbacks.push(() => bind(securityinfocontent, "profileLoader", securityinfocontent_profileLoader_binding));
  binding_callbacks.push(() => bind(securityinfocontent, "member", securityinfocontent_member_binding));
  return {
    c() {
      create_component(securityinfocontent.$$.fragment);
    },
    m(target, anchor) {
      mount_component(securityinfocontent, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const securityinfocontent_changes = {};
      if (!updating_displayProfile && dirty & /*displayProfile*/
      1) {
        updating_displayProfile = true;
        securityinfocontent_changes.displayProfile = /*displayProfile*/
        ctx2[0];
        add_flush_callback(() => updating_displayProfile = false);
      }
      if (!updating_profileLoader && dirty & /*profileLoader*/
      16) {
        updating_profileLoader = true;
        securityinfocontent_changes.profileLoader = /*profileLoader*/
        ctx2[4];
        add_flush_callback(() => updating_profileLoader = false);
      }
      if (!updating_member && dirty & /*member*/
      2) {
        updating_member = true;
        securityinfocontent_changes.member = /*member*/
        ctx2[1];
        add_flush_callback(() => updating_member = false);
      }
      securityinfocontent.$set(securityinfocontent_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(securityinfocontent.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(securityinfocontent.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(securityinfocontent, detaching);
    }
  };
}
function create_if_block$l(ctx) {
  let profileinfocontent;
  let updating_member;
  let updating_profileLoader;
  let current;
  function profileinfocontent_member_binding(value) {
    ctx[9](value);
  }
  function profileinfocontent_profileLoader_binding(value) {
    ctx[10](value);
  }
  let profileinfocontent_props = {
    customFields: (
      /*$app*/
      ctx[5].customFields
    )
  };
  if (
    /*member*/
    ctx[1] !== void 0
  ) {
    profileinfocontent_props.member = /*member*/
    ctx[1];
  }
  if (
    /*profileLoader*/
    ctx[4] !== void 0
  ) {
    profileinfocontent_props.profileLoader = /*profileLoader*/
    ctx[4];
  }
  profileinfocontent = new ProfileInfoContent({ props: profileinfocontent_props });
  binding_callbacks.push(() => bind(profileinfocontent, "member", profileinfocontent_member_binding));
  binding_callbacks.push(() => bind(profileinfocontent, "profileLoader", profileinfocontent_profileLoader_binding));
  return {
    c() {
      create_component(profileinfocontent.$$.fragment);
    },
    m(target, anchor) {
      mount_component(profileinfocontent, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const profileinfocontent_changes = {};
      if (dirty & /*$app*/
      32)
        profileinfocontent_changes.customFields = /*$app*/
        ctx2[5].customFields;
      if (!updating_member && dirty & /*member*/
      2) {
        updating_member = true;
        profileinfocontent_changes.member = /*member*/
        ctx2[1];
        add_flush_callback(() => updating_member = false);
      }
      if (!updating_profileLoader && dirty & /*profileLoader*/
      16) {
        updating_profileLoader = true;
        profileinfocontent_changes.profileLoader = /*profileLoader*/
        ctx2[4];
        add_flush_callback(() => updating_profileLoader = false);
      }
      profileinfocontent.$set(profileinfocontent_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(profileinfocontent.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(profileinfocontent.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(profileinfocontent, detaching);
    }
  };
}
function create_fragment$J(ctx) {
  let div5;
  let div1;
  let div0;
  let t0_value = (
    /*member*/
    ctx[1].auth.email + ""
  );
  let t0;
  let t1;
  let closebutton;
  let t2;
  let div4;
  let div2;
  let profilemodalnav;
  let updating_member;
  let updating_displayProfile;
  let updating_profileLoader;
  let t3;
  let div3;
  let t4;
  let current_block_type_index;
  let if_block1;
  let t5;
  let modalfooter;
  let current;
  closebutton = new CloseButton({
    props: { closeModal: (
      /*closeModal*/
      ctx[3]
    ) }
  });
  function profilemodalnav_member_binding(value) {
    ctx[6](value);
  }
  function profilemodalnav_displayProfile_binding(value) {
    ctx[7](value);
  }
  function profilemodalnav_profileLoader_binding(value) {
    ctx[8](value);
  }
  let profilemodalnav_props = {
    onSuccessLogout: (
      /*onSuccessLogout*/
      ctx[2]
    ),
    hideProfileSection
  };
  if (
    /*member*/
    ctx[1] !== void 0
  ) {
    profilemodalnav_props.member = /*member*/
    ctx[1];
  }
  if (
    /*displayProfile*/
    ctx[0] !== void 0
  ) {
    profilemodalnav_props.displayProfile = /*displayProfile*/
    ctx[0];
  }
  if (
    /*profileLoader*/
    ctx[4] !== void 0
  ) {
    profilemodalnav_props.profileLoader = /*profileLoader*/
    ctx[4];
  }
  profilemodalnav = new ProfileModalNav({ props: profilemodalnav_props });
  binding_callbacks.push(() => bind(profilemodalnav, "member", profilemodalnav_member_binding));
  binding_callbacks.push(() => bind(profilemodalnav, "displayProfile", profilemodalnav_displayProfile_binding));
  binding_callbacks.push(() => bind(profilemodalnav, "profileLoader", profilemodalnav_profileLoader_binding));
  let if_block0 = (
    /*profileLoader*/
    ctx[4] && create_if_block_5$4()
  );
  const if_block_creators = [
    create_if_block$l,
    create_if_block_1$f,
    create_if_block_2$b,
    create_if_block_3$7,
    create_if_block_4$5
  ];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*displayProfile*/
      ctx2[0] === "profile"
    )
      return 0;
    if (
      /*displayProfile*/
      ctx2[0] === "security"
    )
      return 1;
    if (
      /*displayProfile*/
      ctx2[0] === "changePassword"
    )
      return 2;
    if (
      /*displayProfile*/
      ctx2[0] === "plans"
    )
      return 3;
    if (
      /*displayProfile*/
      ctx2[0] === "team"
    )
      return 4;
    return -1;
  }
  if (~(current_block_type_index = select_block_type(ctx))) {
    if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  }
  modalfooter = new ModalFooter({});
  return {
    c() {
      div5 = element("div");
      div1 = element("div");
      div0 = element("div");
      t0 = text(t0_value);
      t1 = space();
      create_component(closebutton.$$.fragment);
      t2 = space();
      div4 = element("div");
      div2 = element("div");
      create_component(profilemodalnav.$$.fragment);
      t3 = space();
      div3 = element("div");
      if (if_block0)
        if_block0.c();
      t4 = space();
      if (if_block1)
        if_block1.c();
      t5 = space();
      create_component(modalfooter.$$.fragment);
      attr(div1, "class", "ms-modal__header");
      attr(div2, "class", "ms-modal__content-left");
      attr(div3, "class", "ms-modal__content-right");
      attr(div4, "class", "ms-modal__content ms-modal__content--profile");
      attr(div5, "class", "ms-modal ms-modal--profile");
      attr(div5, "id", "ProfileModal");
    },
    m(target, anchor) {
      insert(target, div5, anchor);
      append(div5, div1);
      append(div1, div0);
      append(div0, t0);
      append(div1, t1);
      mount_component(closebutton, div1, null);
      append(div5, t2);
      append(div5, div4);
      append(div4, div2);
      mount_component(profilemodalnav, div2, null);
      append(div4, t3);
      append(div4, div3);
      if (if_block0)
        if_block0.m(div3, null);
      append(div3, t4);
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].m(div3, null);
      }
      append(div5, t5);
      mount_component(modalfooter, div5, null);
      current = true;
    },
    p(ctx2, [dirty]) {
      if ((!current || dirty & /*member*/
      2) && t0_value !== (t0_value = /*member*/
      ctx2[1].auth.email + ""))
        set_data(t0, t0_value);
      const closebutton_changes = {};
      if (dirty & /*closeModal*/
      8)
        closebutton_changes.closeModal = /*closeModal*/
        ctx2[3];
      closebutton.$set(closebutton_changes);
      const profilemodalnav_changes = {};
      if (dirty & /*onSuccessLogout*/
      4)
        profilemodalnav_changes.onSuccessLogout = /*onSuccessLogout*/
        ctx2[2];
      if (!updating_member && dirty & /*member*/
      2) {
        updating_member = true;
        profilemodalnav_changes.member = /*member*/
        ctx2[1];
        add_flush_callback(() => updating_member = false);
      }
      if (!updating_displayProfile && dirty & /*displayProfile*/
      1) {
        updating_displayProfile = true;
        profilemodalnav_changes.displayProfile = /*displayProfile*/
        ctx2[0];
        add_flush_callback(() => updating_displayProfile = false);
      }
      if (!updating_profileLoader && dirty & /*profileLoader*/
      16) {
        updating_profileLoader = true;
        profilemodalnav_changes.profileLoader = /*profileLoader*/
        ctx2[4];
        add_flush_callback(() => updating_profileLoader = false);
      }
      profilemodalnav.$set(profilemodalnav_changes);
      if (
        /*profileLoader*/
        ctx2[4]
      ) {
        if (if_block0) {
          if (dirty & /*profileLoader*/
          16) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_5$4();
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(div3, t4);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if (~current_block_type_index) {
          if_blocks[current_block_type_index].p(ctx2, dirty);
        }
      } else {
        if (if_block1) {
          group_outros();
          transition_out(if_blocks[previous_block_index], 1, 1, () => {
            if_blocks[previous_block_index] = null;
          });
          check_outros();
        }
        if (~current_block_type_index) {
          if_block1 = if_blocks[current_block_type_index];
          if (!if_block1) {
            if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
            if_block1.c();
          } else {
            if_block1.p(ctx2, dirty);
          }
          transition_in(if_block1, 1);
          if_block1.m(div3, null);
        } else {
          if_block1 = null;
        }
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(closebutton.$$.fragment, local);
      transition_in(profilemodalnav.$$.fragment, local);
      transition_in(if_block0);
      transition_in(if_block1);
      transition_in(modalfooter.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(closebutton.$$.fragment, local);
      transition_out(profilemodalnav.$$.fragment, local);
      transition_out(if_block0);
      transition_out(if_block1);
      transition_out(modalfooter.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div5);
      destroy_component(closebutton);
      destroy_component(profilemodalnav);
      if (if_block0)
        if_block0.d();
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].d();
      }
      destroy_component(modalfooter);
    }
  };
}
var hideProfileSection = false;
function instance$o($$self, $$props, $$invalidate) {
  let $app;
  component_subscribe($$self, AppStore, ($$value) => $$invalidate(5, $app = $$value));
  let { onSuccessLogout } = $$props;
  let { closeModal } = $$props;
  let { displayProfile = "profile" } = $$props;
  let { member } = $$props;
  let profileLoader = false;
  function profilemodalnav_member_binding(value) {
    member = value;
    $$invalidate(1, member);
  }
  function profilemodalnav_displayProfile_binding(value) {
    displayProfile = value;
    $$invalidate(0, displayProfile);
  }
  function profilemodalnav_profileLoader_binding(value) {
    profileLoader = value;
    $$invalidate(4, profileLoader);
  }
  function profileinfocontent_member_binding(value) {
    member = value;
    $$invalidate(1, member);
  }
  function profileinfocontent_profileLoader_binding(value) {
    profileLoader = value;
    $$invalidate(4, profileLoader);
  }
  function securityinfocontent_displayProfile_binding(value) {
    displayProfile = value;
    $$invalidate(0, displayProfile);
  }
  function securityinfocontent_profileLoader_binding(value) {
    profileLoader = value;
    $$invalidate(4, profileLoader);
  }
  function securityinfocontent_member_binding(value) {
    member = value;
    $$invalidate(1, member);
  }
  function passwordinfocontent_displayProfile_binding(value) {
    displayProfile = value;
    $$invalidate(0, displayProfile);
  }
  function passwordinfocontent_profileLoader_binding(value) {
    profileLoader = value;
    $$invalidate(4, profileLoader);
  }
  function passwordinfocontent_member_binding(value) {
    member = value;
    $$invalidate(1, member);
  }
  function plansinfocontent_member_binding(value) {
    member = value;
    $$invalidate(1, member);
  }
  function plansinfocontent_profileLoader_binding(value) {
    profileLoader = value;
    $$invalidate(4, profileLoader);
  }
  function profileteamcontent_member_binding(value) {
    member = value;
    $$invalidate(1, member);
  }
  function profileteamcontent_profileLoader_binding(value) {
    profileLoader = value;
    $$invalidate(4, profileLoader);
  }
  $$self.$$set = ($$props2) => {
    if ("onSuccessLogout" in $$props2)
      $$invalidate(2, onSuccessLogout = $$props2.onSuccessLogout);
    if ("closeModal" in $$props2)
      $$invalidate(3, closeModal = $$props2.closeModal);
    if ("displayProfile" in $$props2)
      $$invalidate(0, displayProfile = $$props2.displayProfile);
    if ("member" in $$props2)
      $$invalidate(1, member = $$props2.member);
  };
  return [
    displayProfile,
    member,
    onSuccessLogout,
    closeModal,
    profileLoader,
    $app,
    profilemodalnav_member_binding,
    profilemodalnav_displayProfile_binding,
    profilemodalnav_profileLoader_binding,
    profileinfocontent_member_binding,
    profileinfocontent_profileLoader_binding,
    securityinfocontent_displayProfile_binding,
    securityinfocontent_profileLoader_binding,
    securityinfocontent_member_binding,
    passwordinfocontent_displayProfile_binding,
    passwordinfocontent_profileLoader_binding,
    passwordinfocontent_member_binding,
    plansinfocontent_member_binding,
    plansinfocontent_profileLoader_binding,
    profileteamcontent_member_binding,
    profileteamcontent_profileLoader_binding
  ];
}
var ProfileModal = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$o, create_fragment$J, safe_not_equal, {
      onSuccessLogout: 2,
      closeModal: 3,
      displayProfile: 0,
      member: 1
    });
  }
};
function create_fragment$I(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M7.41 1.41L6 0L0 6L6 12L7.41 10.59L2.83 6L7.41 1.41Z");
      attr(svg, "fill", "none");
      attr(svg, "transform", "rotate(180)");
      attr(svg, "viewBox", "0 0 8 12");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var ForwardIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$I, safe_not_equal, {});
  }
};
function create_if_block_1$e(ctx) {
  let button;
  let div;
  let profileicon;
  let t0;
  let t1;
  let forwardicon;
  let current;
  let mounted;
  let dispose;
  profileicon = new ProfileIcon({});
  forwardicon = new ForwardIcon({});
  return {
    c() {
      button = element("button");
      div = element("div");
      create_component(profileicon.$$.fragment);
      t0 = text(" Profile");
      t1 = space();
      create_component(forwardicon.$$.fragment);
      attr(button, "class", "ms-modal__profile-option");
      toggle_class(
        button,
        "ms-modal__profile-option--active",
        /*displayProfile*/
        ctx[0] === "profile"
      );
    },
    m(target, anchor) {
      insert(target, button, anchor);
      append(button, div);
      mount_component(profileicon, div, null);
      append(div, t0);
      append(button, t1);
      mount_component(forwardicon, button, null);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler*/
          ctx[7]
        );
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      if (!current || dirty & /*displayProfile*/
      1) {
        toggle_class(
          button,
          "ms-modal__profile-option--active",
          /*displayProfile*/
          ctx2[0] === "profile"
        );
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(profileicon.$$.fragment, local);
      transition_in(forwardicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(profileicon.$$.fragment, local);
      transition_out(forwardicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(button);
      destroy_component(profileicon);
      destroy_component(forwardicon);
      mounted = false;
      dispose();
    }
  };
}
function create_if_block$k(ctx) {
  let button;
  let div;
  let linkouticon;
  let t0;
  let t1;
  let forwardicon;
  let current;
  let mounted;
  let dispose;
  linkouticon = new LinkOutIcon({});
  forwardicon = new ForwardIcon({});
  return {
    c() {
      button = element("button");
      div = element("div");
      create_component(linkouticon.$$.fragment);
      t0 = text(" Billing Portal");
      t1 = space();
      create_component(forwardicon.$$.fragment);
      attr(button, "class", "ms-modal__profile-option");
    },
    m(target, anchor) {
      insert(target, button, anchor);
      append(button, div);
      mount_component(linkouticon, div, null);
      append(div, t0);
      append(button, t1);
      mount_component(forwardicon, button, null);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*launchPortal*/
          ctx[4]
        );
        mounted = true;
      }
    },
    p: noop,
    i(local) {
      if (current)
        return;
      transition_in(linkouticon.$$.fragment, local);
      transition_in(forwardicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(linkouticon.$$.fragment, local);
      transition_out(forwardicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(button);
      destroy_component(linkouticon);
      destroy_component(forwardicon);
      mounted = false;
      dispose();
    }
  };
}
function create_fragment$H(ctx) {
  let div2;
  let t0;
  let button0;
  let div0;
  let securityicon;
  let t1;
  let t2;
  let forwardicon0;
  let t3;
  let t4;
  let button1;
  let div1;
  let logouticon;
  let t5;
  let t6;
  let forwardicon1;
  let current;
  let mounted;
  let dispose;
  let if_block0 = !/*hideProfileSection*/
  ctx[2] && create_if_block_1$e(ctx);
  securityicon = new SecurityIcon({});
  forwardicon0 = new ForwardIcon({});
  let if_block1 = (
    /*member*/
    ctx[1].stripeCustomerId && create_if_block$k(ctx)
  );
  logouticon = new LogoutIcon({});
  forwardicon1 = new ForwardIcon({});
  return {
    c() {
      div2 = element("div");
      if (if_block0)
        if_block0.c();
      t0 = space();
      button0 = element("button");
      div0 = element("div");
      create_component(securityicon.$$.fragment);
      t1 = text(" Security");
      t2 = space();
      create_component(forwardicon0.$$.fragment);
      t3 = space();
      if (if_block1)
        if_block1.c();
      t4 = space();
      button1 = element("button");
      div1 = element("div");
      create_component(logouticon.$$.fragment);
      t5 = text(" Logout");
      t6 = space();
      create_component(forwardicon1.$$.fragment);
      attr(button0, "class", "ms-modal__profile-option");
      toggle_class(
        button0,
        "ms-modal__profile-option--active",
        /*displayProfile*/
        ctx[0] === "security" || /*displayProfile*/
        ctx[0] === "changePassword"
      );
      attr(button1, "class", "ms-modal__profile-option");
      attr(div2, "class", "ms-modal__mobile-profile-nav");
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      if (if_block0)
        if_block0.m(div2, null);
      append(div2, t0);
      append(div2, button0);
      append(button0, div0);
      mount_component(securityicon, div0, null);
      append(div0, t1);
      append(button0, t2);
      mount_component(forwardicon0, button0, null);
      append(div2, t3);
      if (if_block1)
        if_block1.m(div2, null);
      append(div2, t4);
      append(div2, button1);
      append(button1, div1);
      mount_component(logouticon, div1, null);
      append(div1, t5);
      append(button1, t6);
      mount_component(forwardicon1, button1, null);
      current = true;
      if (!mounted) {
        dispose = [
          listen(
            button0,
            "click",
            /*click_handler_1*/
            ctx[8]
          ),
          listen(
            button1,
            "click",
            /*logout*/
            ctx[3]
          )
        ];
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (!/*hideProfileSection*/
      ctx2[2]) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
          if (dirty & /*hideProfileSection*/
          4) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_1$e(ctx2);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(div2, t0);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      if (!current || dirty & /*displayProfile*/
      1) {
        toggle_class(
          button0,
          "ms-modal__profile-option--active",
          /*displayProfile*/
          ctx2[0] === "security" || /*displayProfile*/
          ctx2[0] === "changePassword"
        );
      }
      if (
        /*member*/
        ctx2[1].stripeCustomerId
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty & /*member*/
          2) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block$k(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(div2, t4);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block0);
      transition_in(securityicon.$$.fragment, local);
      transition_in(forwardicon0.$$.fragment, local);
      transition_in(if_block1);
      transition_in(logouticon.$$.fragment, local);
      transition_in(forwardicon1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(securityicon.$$.fragment, local);
      transition_out(forwardicon0.$$.fragment, local);
      transition_out(if_block1);
      transition_out(logouticon.$$.fragment, local);
      transition_out(forwardicon1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div2);
      if (if_block0)
        if_block0.d();
      destroy_component(securityicon);
      destroy_component(forwardicon0);
      if (if_block1)
        if_block1.d();
      destroy_component(logouticon);
      destroy_component(forwardicon1);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$n($$self, $$props, $$invalidate) {
  let { member } = $$props;
  let { onSuccessLogout } = $$props;
  let { displayProfile } = $$props;
  let { profileLoader } = $$props;
  let { hideProfileSection: hideProfileSection2 } = $$props;
  const unsubscribe = AppStore.subscribe((data) => {
    if (!data.initialValue) {
      const container = document.getElementById("msOverlay");
      const css = document.createElement("style");
      const color = data.branding.colors.lightMode.primaryButton;
      const fullCSS = `.ms-modal__profile-option:hover { color: ${color};} .ms-modal__profile-option--active { color: ${color};} .ms-modal__save-button { background: ${color};} .ms-modal__save-button:disabled { background: ${color};}`;
      css.appendChild(document.createTextNode(fullCSS));
      container.appendChild(css);
    }
  });
  onDestroy(() => {
    unsubscribe();
  });
  function logout(e) {
    return __async(this, null, function* () {
      try {
        const { data, _internalUseOnly: { message } } = yield window.$memberstackDom.logout();
        window.$memberstackDom._showMessage(message, false);
        onSuccessLogout({ type: "LOGOUT", data });
      } catch (err) {
        window.$memberstackDom._showMessage(err.message, true);
      }
    });
  }
  function launchPortal(e) {
    return __async(this, null, function* () {
      $$invalidate(5, profileLoader = true);
      yield window.$memberstackDom.launchStripeCustomerPortal({ priceIds: [], autoRedirect: true });
    });
  }
  const click_handler = () => $$invalidate(0, displayProfile = "profile");
  const click_handler_1 = () => $$invalidate(0, displayProfile = "security");
  $$self.$$set = ($$props2) => {
    if ("member" in $$props2)
      $$invalidate(1, member = $$props2.member);
    if ("onSuccessLogout" in $$props2)
      $$invalidate(6, onSuccessLogout = $$props2.onSuccessLogout);
    if ("displayProfile" in $$props2)
      $$invalidate(0, displayProfile = $$props2.displayProfile);
    if ("profileLoader" in $$props2)
      $$invalidate(5, profileLoader = $$props2.profileLoader);
    if ("hideProfileSection" in $$props2)
      $$invalidate(2, hideProfileSection2 = $$props2.hideProfileSection);
  };
  return [
    displayProfile,
    member,
    hideProfileSection2,
    logout,
    launchPortal,
    profileLoader,
    onSuccessLogout,
    click_handler,
    click_handler_1
  ];
}
var MobileProfileModalNav = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$n, create_fragment$H, safe_not_equal, {
      member: 1,
      onSuccessLogout: 6,
      displayProfile: 0,
      profileLoader: 5,
      hideProfileSection: 2
    });
  }
};
function get_each_context$7(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[5] = list[i];
  child_ctx[6] = list;
  child_ctx[7] = i;
  return child_ctx;
}
function create_if_block$j(ctx) {
  let div1;
  let div0;
  let label;
  let t0_value = (
    /*customField*/
    ctx[5].label + ""
  );
  let t0;
  let label_for_value;
  let t1;
  let input;
  let input_placeholder_value;
  let input_name_value;
  let t2;
  let mounted;
  let dispose;
  function input_input_handler() {
    ctx[4].call(
      input,
      /*customField*/
      ctx[5]
    );
  }
  return {
    c() {
      div1 = element("div");
      div0 = element("div");
      label = element("label");
      t0 = text(t0_value);
      t1 = space();
      input = element("input");
      t2 = space();
      attr(label, "class", "ms-form__label");
      attr(label, "for", label_for_value = /*customField*/
      ctx[5].key);
      attr(input, "class", "ms-form__input");
      attr(input, "type", "text");
      attr(input, "placeholder", input_placeholder_value = /*customField*/
      ctx[5].label);
      attr(input, "name", input_name_value = /*customField*/
      ctx[5].key);
      attr(div0, "class", "ms-form__group");
      attr(div1, "class", "ms-modal__custom-field-container");
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);
      append(div0, label);
      append(label, t0);
      append(div0, t1);
      append(div0, input);
      set_input_value(
        input,
        /*member*/
        ctx[0].customFields[
          /*customField*/
          ctx[5].key
        ]
      );
      append(div1, t2);
      if (!mounted) {
        dispose = listen(input, "input", input_input_handler);
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*customFields*/
      2 && t0_value !== (t0_value = /*customField*/
      ctx[5].label + ""))
        set_data(t0, t0_value);
      if (dirty & /*customFields*/
      2 && label_for_value !== (label_for_value = /*customField*/
      ctx[5].key)) {
        attr(label, "for", label_for_value);
      }
      if (dirty & /*customFields*/
      2 && input_placeholder_value !== (input_placeholder_value = /*customField*/
      ctx[5].label)) {
        attr(input, "placeholder", input_placeholder_value);
      }
      if (dirty & /*customFields*/
      2 && input_name_value !== (input_name_value = /*customField*/
      ctx[5].key)) {
        attr(input, "name", input_name_value);
      }
      if (dirty & /*member, customFields*/
      3 && input.value !== /*member*/
      ctx[0].customFields[
        /*customField*/
        ctx[5].key
      ]) {
        set_input_value(
          input,
          /*member*/
          ctx[0].customFields[
            /*customField*/
            ctx[5].key
          ]
        );
      }
    },
    d(detaching) {
      if (detaching)
        detach(div1);
      mounted = false;
      dispose();
    }
  };
}
function create_each_block$7(ctx) {
  let if_block_anchor;
  let if_block = (
    /*customField*/
    ctx[5].hidden !== true && create_if_block$j(ctx)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx2, dirty) {
      if (
        /*customField*/
        ctx2[5].hidden !== true
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
        } else {
          if_block = create_if_block$j(ctx2);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    d(detaching) {
      if (if_block)
        if_block.d(detaching);
      if (detaching)
        detach(if_block_anchor);
    }
  };
}
function create_fragment$G(ctx) {
  let form;
  let t0;
  let div;
  let button;
  let mounted;
  let dispose;
  let each_value = (
    /*customFields*/
    ctx[1]
  );
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$7(get_each_context$7(ctx, each_value, i));
  }
  return {
    c() {
      form = element("form");
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      t0 = space();
      div = element("div");
      button = element("button");
      button.textContent = "Save";
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(form, "autocomplete", "off");
      attr(button, "class", "ms-modal__save-button ms-modal__save-button--large");
      attr(div, "class", "ms-modal__action-container");
    },
    m(target, anchor) {
      insert(target, form, anchor);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(form, null);
        }
      }
      insert(target, t0, anchor);
      insert(target, div, anchor);
      append(div, button);
      if (!mounted) {
        dispose = [
          listen(form, "submit", stop_propagation(prevent_default(
            /*saveProfile*/
            ctx[2]
          ))),
          listen(
            button,
            "click",
            /*saveProfile*/
            ctx[2]
          )
        ];
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (dirty & /*customFields, member*/
      3) {
        each_value = /*customFields*/
        ctx2[1];
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context$7(ctx2, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
          } else {
            each_blocks[i] = create_each_block$7(child_ctx);
            each_blocks[i].c();
            each_blocks[i].m(form, null);
          }
        }
        for (; i < each_blocks.length; i += 1) {
          each_blocks[i].d(1);
        }
        each_blocks.length = each_value.length;
      }
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(form);
      destroy_each(each_blocks, detaching);
      if (detaching)
        detach(t0);
      if (detaching)
        detach(div);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$m($$self, $$props, $$invalidate) {
  let { customFields } = $$props;
  let { member } = $$props;
  let { profileLoader } = $$props;
  function saveProfile(e) {
    return __async(this, null, function* () {
      $$invalidate(3, profileLoader = true);
      yield window.$memberstackDom.updateMember({ customFields: member.customFields });
      $$invalidate(3, profileLoader = false);
    });
  }
  function input_input_handler(customField) {
    member.customFields[customField.key] = this.value;
    $$invalidate(0, member);
  }
  $$self.$$set = ($$props2) => {
    if ("customFields" in $$props2)
      $$invalidate(1, customFields = $$props2.customFields);
    if ("member" in $$props2)
      $$invalidate(0, member = $$props2.member);
    if ("profileLoader" in $$props2)
      $$invalidate(3, profileLoader = $$props2.profileLoader);
  };
  return [member, customFields, saveProfile, profileLoader, input_input_handler];
}
var MobileProfileInfoContent = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$m, create_fragment$G, safe_not_equal, {
      customFields: 1,
      member: 0,
      profileLoader: 3
    });
  }
};
function get_each_context$6(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[16] = list[i];
  return child_ctx;
}
function create_else_block_1$2(ctx) {
  let t;
  return {
    c() {
      t = text("Change Password");
    },
    m(target, anchor) {
      insert(target, t, anchor);
    },
    d(detaching) {
      if (detaching)
        detach(t);
    }
  };
}
function create_if_block_2$a(ctx) {
  let t;
  return {
    c() {
      t = text("Set Password");
    },
    m(target, anchor) {
      insert(target, t, anchor);
    },
    d(detaching) {
      if (detaching)
        detach(t);
    }
  };
}
function create_if_block$i(ctx) {
  let p;
  let t1;
  let div;
  let each_blocks = [];
  let each_1_lookup = /* @__PURE__ */ new Map();
  let each_value = (
    /*$app*/
    ctx[4].authProviders
  );
  const get_key = (ctx2) => (
    /*provider*/
    ctx2[16].provider
  );
  for (let i = 0; i < each_value.length; i += 1) {
    let child_ctx = get_each_context$6(ctx, each_value, i);
    let key = get_key(child_ctx);
    each_1_lookup.set(key, each_blocks[i] = create_each_block$6(key, child_ctx));
  }
  return {
    c() {
      p = element("p");
      p.textContent = "Connect Additional Accounts";
      t1 = space();
      div = element("div");
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      attr(p, "class", "ms-form__label");
      attr(div, "class", "ms-modal__social");
    },
    m(target, anchor) {
      insert(target, p, anchor);
      insert(target, t1, anchor);
      insert(target, div, anchor);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(div, null);
        }
      }
    },
    p(ctx2, dirty) {
      if (dirty & /*disconnectProvider, $app, member, connectAdditionalProvider*/
      210) {
        each_value = /*$app*/
        ctx2[4].authProviders;
        each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx2, each_value, each_1_lookup, div, destroy_block, create_each_block$6, null, get_each_context$6);
      }
    },
    d(detaching) {
      if (detaching)
        detach(p);
      if (detaching)
        detach(t1);
      if (detaching)
        detach(div);
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].d();
      }
    }
  };
}
function create_else_block$8(ctx) {
  let button;
  let img;
  let img_src_value;
  let img_alt_value;
  let t0;
  let span;
  let t1;
  let t2_value = (
    /*provider*/
    ctx[16].name + ""
  );
  let t2;
  let mounted;
  let dispose;
  function click_handler_2() {
    return (
      /*click_handler_2*/
      ctx[14](
        /*provider*/
        ctx[16]
      )
    );
  }
  return {
    c() {
      button = element("button");
      img = element("img");
      t0 = space();
      span = element("span");
      t1 = text("Connect with ");
      t2 = text(t2_value);
      if (!src_url_equal(img.src, img_src_value = /*provider*/
      ctx[16].icon))
        attr(img, "src", img_src_value);
      attr(img, "alt", img_alt_value = /*provider*/
      ctx[16].name);
      attr(button, "class", "ms-modal__social-button");
      attr(button, "type", "button");
    },
    m(target, anchor) {
      insert(target, button, anchor);
      append(button, img);
      append(button, t0);
      append(button, span);
      append(span, t1);
      append(span, t2);
      if (!mounted) {
        dispose = listen(button, "click", click_handler_2);
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*$app*/
      16 && !src_url_equal(img.src, img_src_value = /*provider*/
      ctx[16].icon)) {
        attr(img, "src", img_src_value);
      }
      if (dirty & /*$app*/
      16 && img_alt_value !== (img_alt_value = /*provider*/
      ctx[16].name)) {
        attr(img, "alt", img_alt_value);
      }
      if (dirty & /*$app*/
      16 && t2_value !== (t2_value = /*provider*/
      ctx[16].name + ""))
        set_data(t2, t2_value);
    },
    d(detaching) {
      if (detaching)
        detach(button);
      mounted = false;
      dispose();
    }
  };
}
function create_if_block_1$d(ctx) {
  let button;
  let img;
  let img_src_value;
  let img_alt_value;
  let t0;
  let span;
  let t1;
  let t2_value = (
    /*provider*/
    ctx[16].name + ""
  );
  let t2;
  let mounted;
  let dispose;
  function click_handler_1() {
    return (
      /*click_handler_1*/
      ctx[13](
        /*provider*/
        ctx[16]
      )
    );
  }
  return {
    c() {
      button = element("button");
      img = element("img");
      t0 = space();
      span = element("span");
      t1 = text("Disconnect ");
      t2 = text(t2_value);
      if (!src_url_equal(img.src, img_src_value = /*provider*/
      ctx[16].icon))
        attr(img, "src", img_src_value);
      attr(img, "alt", img_alt_value = /*provider*/
      ctx[16].name);
      attr(button, "class", "ms-modal__social-button");
      set_style(button, "background-color", "#F6F6F6");
      attr(button, "type", "button");
    },
    m(target, anchor) {
      insert(target, button, anchor);
      append(button, img);
      append(button, t0);
      append(button, span);
      append(span, t1);
      append(span, t2);
      if (!mounted) {
        dispose = listen(button, "click", click_handler_1);
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*$app*/
      16 && !src_url_equal(img.src, img_src_value = /*provider*/
      ctx[16].icon)) {
        attr(img, "src", img_src_value);
      }
      if (dirty & /*$app*/
      16 && img_alt_value !== (img_alt_value = /*provider*/
      ctx[16].name)) {
        attr(img, "alt", img_alt_value);
      }
      if (dirty & /*$app*/
      16 && t2_value !== (t2_value = /*provider*/
      ctx[16].name + ""))
        set_data(t2, t2_value);
    },
    d(detaching) {
      if (detaching)
        detach(button);
      mounted = false;
      dispose();
    }
  };
}
function create_each_block$6(key_1, ctx) {
  let div;
  let show_if;
  let t;
  function func2(...args) {
    return (
      /*func*/
      ctx[9](
        /*provider*/
        ctx[16],
        ...args
      )
    );
  }
  function select_block_type_1(ctx2, dirty) {
    if (dirty & /*member, $app*/
    18)
      show_if = null;
    if (show_if == null)
      show_if = !!/*member*/
      ctx2[1].auth.providers.some(func2);
    if (show_if)
      return create_if_block_1$d;
    return create_else_block$8;
  }
  let current_block_type = select_block_type_1(ctx, -1);
  let if_block = current_block_type(ctx);
  return {
    key: key_1,
    first: null,
    c() {
      div = element("div");
      if_block.c();
      t = space();
      attr(div, "class", "ms-modal__social-buttons");
      this.first = div;
    },
    m(target, anchor) {
      insert(target, div, anchor);
      if_block.m(div, null);
      append(div, t);
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block) {
        if_block.p(ctx, dirty);
      } else {
        if_block.d(1);
        if_block = current_block_type(ctx);
        if (if_block) {
          if_block.c();
          if_block.m(div, t);
        }
      }
    },
    d(detaching) {
      if (detaching)
        detach(div);
      if_block.d();
    }
  };
}
function create_fragment$F(ctx) {
  let form;
  let emailinput;
  let updating_emailInputValid;
  let updating_emailValue;
  let t0;
  let div0;
  let label;
  let t2;
  let button0;
  let passwordlockicon;
  let t3;
  let t4;
  let t5;
  let div1;
  let button1;
  let t6;
  let button1_disabled_value;
  let current;
  let mounted;
  let dispose;
  function emailinput_emailInputValid_binding(value) {
    ctx[10](value);
  }
  function emailinput_emailValue_binding(value) {
    ctx[11](value);
  }
  let emailinput_props = {};
  if (
    /*emailInputValid*/
    ctx[3] !== void 0
  ) {
    emailinput_props.emailInputValid = /*emailInputValid*/
    ctx[3];
  }
  if (
    /*emailValue*/
    ctx[2] !== void 0
  ) {
    emailinput_props.emailValue = /*emailValue*/
    ctx[2];
  }
  emailinput = new EmailInput({ props: emailinput_props });
  binding_callbacks.push(() => bind(emailinput, "emailInputValid", emailinput_emailInputValid_binding));
  binding_callbacks.push(() => bind(emailinput, "emailValue", emailinput_emailValue_binding));
  passwordlockicon = new PasswordLockIcon({});
  function select_block_type(ctx2, dirty) {
    if (!/*member*/
    ctx2[1].auth.hasPassword)
      return create_if_block_2$a;
    return create_else_block_1$2;
  }
  let current_block_type = select_block_type(ctx);
  let if_block0 = current_block_type(ctx);
  let if_block1 = (
    /*$app*/
    ctx[4].authProviders.length > 0 && create_if_block$i(ctx)
  );
  return {
    c() {
      form = element("form");
      create_component(emailinput.$$.fragment);
      t0 = space();
      div0 = element("div");
      label = element("label");
      label.textContent = "Password";
      t2 = space();
      button0 = element("button");
      create_component(passwordlockicon.$$.fragment);
      t3 = space();
      if_block0.c();
      t4 = space();
      if (if_block1)
        if_block1.c();
      t5 = space();
      div1 = element("div");
      button1 = element("button");
      t6 = text("Save");
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(form, "autocomplete", "off");
      attr(label, "class", "ms-form__label");
      attr(label, "for", "setPassword");
      attr(button0, "class", "ms-modal__outline-button ms-modal__outline-button--mobile");
      attr(button0, "name", "setPassword");
      attr(div0, "class", "ms-form__group");
      attr(button1, "class", "ms-modal__save-button ms-modal__save-button--large");
      button1.disabled = button1_disabled_value = !/*emailInputValid*/
      ctx[3];
      attr(div1, "class", "ms-modal__action-container");
    },
    m(target, anchor) {
      insert(target, form, anchor);
      mount_component(emailinput, form, null);
      insert(target, t0, anchor);
      insert(target, div0, anchor);
      append(div0, label);
      append(div0, t2);
      append(div0, button0);
      mount_component(passwordlockicon, button0, null);
      append(button0, t3);
      if_block0.m(button0, null);
      insert(target, t4, anchor);
      if (if_block1)
        if_block1.m(target, anchor);
      insert(target, t5, anchor);
      insert(target, div1, anchor);
      append(div1, button1);
      append(button1, t6);
      current = true;
      if (!mounted) {
        dispose = [
          listen(form, "submit", stop_propagation(prevent_default(
            /*submitEmailChange*/
            ctx[5]
          ))),
          listen(
            button0,
            "click",
            /*click_handler*/
            ctx[12]
          ),
          listen(
            button1,
            "click",
            /*submitEmailChange*/
            ctx[5]
          )
        ];
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      const emailinput_changes = {};
      if (!updating_emailInputValid && dirty & /*emailInputValid*/
      8) {
        updating_emailInputValid = true;
        emailinput_changes.emailInputValid = /*emailInputValid*/
        ctx2[3];
        add_flush_callback(() => updating_emailInputValid = false);
      }
      if (!updating_emailValue && dirty & /*emailValue*/
      4) {
        updating_emailValue = true;
        emailinput_changes.emailValue = /*emailValue*/
        ctx2[2];
        add_flush_callback(() => updating_emailValue = false);
      }
      emailinput.$set(emailinput_changes);
      if (current_block_type !== (current_block_type = select_block_type(ctx2))) {
        if_block0.d(1);
        if_block0 = current_block_type(ctx2);
        if (if_block0) {
          if_block0.c();
          if_block0.m(button0, null);
        }
      }
      if (
        /*$app*/
        ctx2[4].authProviders.length > 0
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
        } else {
          if_block1 = create_if_block$i(ctx2);
          if_block1.c();
          if_block1.m(t5.parentNode, t5);
        }
      } else if (if_block1) {
        if_block1.d(1);
        if_block1 = null;
      }
      if (!current || dirty & /*emailInputValid*/
      8 && button1_disabled_value !== (button1_disabled_value = !/*emailInputValid*/
      ctx2[3])) {
        button1.disabled = button1_disabled_value;
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(emailinput.$$.fragment, local);
      transition_in(passwordlockicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(emailinput.$$.fragment, local);
      transition_out(passwordlockicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(form);
      destroy_component(emailinput);
      if (detaching)
        detach(t0);
      if (detaching)
        detach(div0);
      destroy_component(passwordlockicon);
      if_block0.d();
      if (detaching)
        detach(t4);
      if (if_block1)
        if_block1.d(detaching);
      if (detaching)
        detach(t5);
      if (detaching)
        detach(div1);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$l($$self, $$props, $$invalidate) {
  let $app;
  component_subscribe($$self, AppStore, ($$value) => $$invalidate(4, $app = $$value));
  let { displayProfile } = $$props;
  let { member } = $$props;
  let { emailValue } = $$props;
  let { profileLoader } = $$props;
  $app.authProviders.sort((a, b) => {
    if (isConnected(a) === isConnected(b)) {
      return a.order - b.order;
    }
    return isConnected(a) ? -1 : 1;
  });
  let emailInputValid = false;
  function submitEmailChange(e) {
    return __async(this, null, function* () {
      if (!emailInputValid || !emailValue)
        return;
      $$invalidate(8, profileLoader = true);
      try {
        const { _internalUseOnly: { message } } = yield window.$memberstackDom.updateMemberAuth({ email: emailValue });
        window.$memberstackDom._showMessage(message, false);
        $$invalidate(8, profileLoader = false);
      } catch (err) {
        window.$memberstackDom._showMessage(err.message, true);
        $$invalidate(8, profileLoader = false);
      }
    });
  }
  function disconnectProvider(provider) {
    return __async(this, null, function* () {
      $$invalidate(8, profileLoader = true);
      try {
        const { data, _internalUseOnly: { message } } = yield window.$memberstackDom.disconnectProvider({ provider });
        $$invalidate(1, member = __spreadProps(__spreadValues({}, member), {
          auth: __spreadProps(__spreadValues({}, member.auth), {
            providers: data.providers
          })
        }));
        window.$memberstackDom._showMessage(message, false);
        $$invalidate(8, profileLoader = false);
      } catch (err) {
        window.$memberstackDom._showMessage(err.message, true);
        $$invalidate(8, profileLoader = false);
      }
    });
  }
  function connectAdditionalProvider(provider) {
    return __async(this, null, function* () {
      console.log("connect", provider);
      try {
        const { data } = yield window.$memberstackDom.connectProvider({ provider });
        $$invalidate(1, member = __spreadProps(__spreadValues({}, member), {
          auth: __spreadProps(__spreadValues({}, member.auth), {
            providers: data.providers
          })
        }));
        window.$memberstackDom._showMessage(data.message, false);
      } catch (err) {
        window.$memberstackDom._showMessage(err.message, true);
      }
    });
  }
  function isConnected(provider) {
    return member.auth.providers.some((prv) => prv.provider === provider.provider);
  }
  const func2 = (provider, prv) => prv.provider === provider.provider;
  function emailinput_emailInputValid_binding(value) {
    emailInputValid = value;
    $$invalidate(3, emailInputValid);
  }
  function emailinput_emailValue_binding(value) {
    emailValue = value;
    $$invalidate(2, emailValue);
  }
  const click_handler = () => $$invalidate(0, displayProfile = "changePassword");
  const click_handler_1 = (provider) => disconnectProvider(provider.provider);
  const click_handler_2 = (provider) => connectAdditionalProvider(provider.provider);
  $$self.$$set = ($$props2) => {
    if ("displayProfile" in $$props2)
      $$invalidate(0, displayProfile = $$props2.displayProfile);
    if ("member" in $$props2)
      $$invalidate(1, member = $$props2.member);
    if ("emailValue" in $$props2)
      $$invalidate(2, emailValue = $$props2.emailValue);
    if ("profileLoader" in $$props2)
      $$invalidate(8, profileLoader = $$props2.profileLoader);
  };
  return [
    displayProfile,
    member,
    emailValue,
    emailInputValid,
    $app,
    submitEmailChange,
    disconnectProvider,
    connectAdditionalProvider,
    profileLoader,
    func2,
    emailinput_emailInputValid_binding,
    emailinput_emailValue_binding,
    click_handler,
    click_handler_1,
    click_handler_2
  ];
}
var MobileSecurityInfoContent = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$l, create_fragment$F, safe_not_equal, {
      displayProfile: 0,
      member: 1,
      emailValue: 2,
      profileLoader: 8
    });
  }
};
function create_if_block$h(ctx) {
  let passwordinput;
  let updating_passwordValue;
  let updating_passwordInputValid;
  let current;
  function passwordinput_passwordValue_binding(value) {
    ctx[9](value);
  }
  function passwordinput_passwordInputValid_binding(value) {
    ctx[10](value);
  }
  let passwordinput_props = {
    passwordLabel: "Current Password",
    passwordPlaceholder: "Enter a strong password"
  };
  if (
    /*currentPasswordValue*/
    ctx[1] !== void 0
  ) {
    passwordinput_props.passwordValue = /*currentPasswordValue*/
    ctx[1];
  }
  if (
    /*currentPasswordValid*/
    ctx[4] !== void 0
  ) {
    passwordinput_props.passwordInputValid = /*currentPasswordValid*/
    ctx[4];
  }
  passwordinput = new PasswordInput({ props: passwordinput_props });
  binding_callbacks.push(() => bind(passwordinput, "passwordValue", passwordinput_passwordValue_binding));
  binding_callbacks.push(() => bind(passwordinput, "passwordInputValid", passwordinput_passwordInputValid_binding));
  return {
    c() {
      create_component(passwordinput.$$.fragment);
    },
    m(target, anchor) {
      mount_component(passwordinput, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const passwordinput_changes = {};
      if (!updating_passwordValue && dirty & /*currentPasswordValue*/
      2) {
        updating_passwordValue = true;
        passwordinput_changes.passwordValue = /*currentPasswordValue*/
        ctx2[1];
        add_flush_callback(() => updating_passwordValue = false);
      }
      if (!updating_passwordInputValid && dirty & /*currentPasswordValid*/
      16) {
        updating_passwordInputValid = true;
        passwordinput_changes.passwordInputValid = /*currentPasswordValid*/
        ctx2[4];
        add_flush_callback(() => updating_passwordInputValid = false);
      }
      passwordinput.$set(passwordinput_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(passwordinput.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(passwordinput.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(passwordinput, detaching);
    }
  };
}
function create_fragment$E(ctx) {
  let form;
  let t0;
  let passwordinput0;
  let updating_passwordValue;
  let updating_passwordInputValid;
  let t1;
  let passwordinput1;
  let updating_passwordValue_1;
  let updating_passwordInputValid_1;
  let t2;
  let div;
  let button;
  let t3;
  let button_disabled_value;
  let current;
  let mounted;
  let dispose;
  let if_block = (
    /*member*/
    ctx[0].auth.hasPassword && create_if_block$h(ctx)
  );
  function passwordinput0_passwordValue_binding(value) {
    ctx[11](value);
  }
  function passwordinput0_passwordInputValid_binding(value) {
    ctx[12](value);
  }
  let passwordinput0_props = {
    passwordLabel: "New Password",
    passwordPlaceholder: "Enter a strong password"
  };
  if (
    /*newPasswordValue*/
    ctx[2] !== void 0
  ) {
    passwordinput0_props.passwordValue = /*newPasswordValue*/
    ctx[2];
  }
  if (
    /*newPasswordValid*/
    ctx[5] !== void 0
  ) {
    passwordinput0_props.passwordInputValid = /*newPasswordValid*/
    ctx[5];
  }
  passwordinput0 = new PasswordInput({ props: passwordinput0_props });
  binding_callbacks.push(() => bind(passwordinput0, "passwordValue", passwordinput0_passwordValue_binding));
  binding_callbacks.push(() => bind(passwordinput0, "passwordInputValid", passwordinput0_passwordInputValid_binding));
  function passwordinput1_passwordValue_binding(value) {
    ctx[13](value);
  }
  function passwordinput1_passwordInputValid_binding(value) {
    ctx[14](value);
  }
  let passwordinput1_props = {
    passwordLabel: "Confirm New Password",
    passwordPlaceholder: "Enter a strong password"
  };
  if (
    /*confirmPasswordValue*/
    ctx[3] !== void 0
  ) {
    passwordinput1_props.passwordValue = /*confirmPasswordValue*/
    ctx[3];
  }
  if (
    /*confirmPasswordValid*/
    ctx[6] !== void 0
  ) {
    passwordinput1_props.passwordInputValid = /*confirmPasswordValid*/
    ctx[6];
  }
  passwordinput1 = new PasswordInput({ props: passwordinput1_props });
  binding_callbacks.push(() => bind(passwordinput1, "passwordValue", passwordinput1_passwordValue_binding));
  binding_callbacks.push(() => bind(passwordinput1, "passwordInputValid", passwordinput1_passwordInputValid_binding));
  return {
    c() {
      form = element("form");
      if (if_block)
        if_block.c();
      t0 = space();
      create_component(passwordinput0.$$.fragment);
      t1 = space();
      create_component(passwordinput1.$$.fragment);
      t2 = space();
      div = element("div");
      button = element("button");
      t3 = text("Save");
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(form, "autocomplete", "off");
      attr(button, "class", "ms-modal__save-button ms-modal__save-button--large");
      button.disabled = button_disabled_value = /*member*/
      ctx[0].auth.hasPassword && !/*currentPasswordValid*/
      ctx[4] || !/*newPasswordValid*/
      ctx[5] || !/*confirmPasswordValid*/
      ctx[6];
      attr(div, "class", "ms-modal__action-container");
    },
    m(target, anchor) {
      insert(target, form, anchor);
      if (if_block)
        if_block.m(form, null);
      append(form, t0);
      mount_component(passwordinput0, form, null);
      append(form, t1);
      mount_component(passwordinput1, form, null);
      insert(target, t2, anchor);
      insert(target, div, anchor);
      append(div, button);
      append(button, t3);
      current = true;
      if (!mounted) {
        dispose = [
          listen(form, "submit", stop_propagation(prevent_default(
            /*submitPasswordChange*/
            ctx[7]
          ))),
          listen(
            button,
            "click",
            /*submitPasswordChange*/
            ctx[7]
          )
        ];
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (
        /*member*/
        ctx2[0].auth.hasPassword
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
          if (dirty & /*member*/
          1) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$h(ctx2);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(form, t0);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
      const passwordinput0_changes = {};
      if (!updating_passwordValue && dirty & /*newPasswordValue*/
      4) {
        updating_passwordValue = true;
        passwordinput0_changes.passwordValue = /*newPasswordValue*/
        ctx2[2];
        add_flush_callback(() => updating_passwordValue = false);
      }
      if (!updating_passwordInputValid && dirty & /*newPasswordValid*/
      32) {
        updating_passwordInputValid = true;
        passwordinput0_changes.passwordInputValid = /*newPasswordValid*/
        ctx2[5];
        add_flush_callback(() => updating_passwordInputValid = false);
      }
      passwordinput0.$set(passwordinput0_changes);
      const passwordinput1_changes = {};
      if (!updating_passwordValue_1 && dirty & /*confirmPasswordValue*/
      8) {
        updating_passwordValue_1 = true;
        passwordinput1_changes.passwordValue = /*confirmPasswordValue*/
        ctx2[3];
        add_flush_callback(() => updating_passwordValue_1 = false);
      }
      if (!updating_passwordInputValid_1 && dirty & /*confirmPasswordValid*/
      64) {
        updating_passwordInputValid_1 = true;
        passwordinput1_changes.passwordInputValid = /*confirmPasswordValid*/
        ctx2[6];
        add_flush_callback(() => updating_passwordInputValid_1 = false);
      }
      passwordinput1.$set(passwordinput1_changes);
      if (!current || dirty & /*member, currentPasswordValid, newPasswordValid, confirmPasswordValid*/
      113 && button_disabled_value !== (button_disabled_value = /*member*/
      ctx2[0].auth.hasPassword && !/*currentPasswordValid*/
      ctx2[4] || !/*newPasswordValid*/
      ctx2[5] || !/*confirmPasswordValid*/
      ctx2[6])) {
        button.disabled = button_disabled_value;
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      transition_in(passwordinput0.$$.fragment, local);
      transition_in(passwordinput1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      transition_out(passwordinput0.$$.fragment, local);
      transition_out(passwordinput1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(form);
      if (if_block)
        if_block.d();
      destroy_component(passwordinput0);
      destroy_component(passwordinput1);
      if (detaching)
        detach(t2);
      if (detaching)
        detach(div);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$k($$self, $$props, $$invalidate) {
  let { profileLoader } = $$props;
  let { member } = $$props;
  let currentPasswordValue = "";
  let newPasswordValue = "";
  let confirmPasswordValue = "";
  let currentPasswordValid = false;
  let newPasswordValid = false;
  let confirmPasswordValid = false;
  function submitPasswordChange(e) {
    return __async(this, null, function* () {
      if (member.auth.hasPassword && !currentPasswordValid && !newPasswordValid && !confirmPasswordValid)
        return;
      if (!member.auth.hasPassword && !newPasswordValid && !confirmPasswordValid)
        return;
      $$invalidate(8, profileLoader = true);
      try {
        let message;
        if (member.auth.hasPassword) {
          const { _internalUseOnly: { message: msg } } = yield window.$memberstackDom.updateMemberAuth({
            oldPassword: currentPasswordValue,
            newPassword: newPasswordValue
          });
          message = msg;
        } else {
          const { _internalUseOnly: { message: msg } } = yield window.$memberstackDom.setPassword({ password: newPasswordValue });
          $$invalidate(0, member.auth.hasPassword = true, member);
          message = msg;
        }
        window.$memberstackDom._showMessage(message, false);
        $$invalidate(1, currentPasswordValue = "");
        $$invalidate(2, newPasswordValue = "");
        $$invalidate(3, confirmPasswordValue = "");
        $$invalidate(8, profileLoader = false);
      } catch (err) {
        window.$memberstackDom._showMessage(err.message, true);
        $$invalidate(8, profileLoader = false);
      }
    });
  }
  function passwordinput_passwordValue_binding(value) {
    currentPasswordValue = value;
    $$invalidate(1, currentPasswordValue);
  }
  function passwordinput_passwordInputValid_binding(value) {
    currentPasswordValid = value;
    $$invalidate(4, currentPasswordValid);
  }
  function passwordinput0_passwordValue_binding(value) {
    newPasswordValue = value;
    $$invalidate(2, newPasswordValue);
  }
  function passwordinput0_passwordInputValid_binding(value) {
    newPasswordValid = value;
    $$invalidate(5, newPasswordValid);
  }
  function passwordinput1_passwordValue_binding(value) {
    confirmPasswordValue = value;
    $$invalidate(3, confirmPasswordValue);
  }
  function passwordinput1_passwordInputValid_binding(value) {
    confirmPasswordValid = value;
    $$invalidate(6, confirmPasswordValid);
  }
  $$self.$$set = ($$props2) => {
    if ("profileLoader" in $$props2)
      $$invalidate(8, profileLoader = $$props2.profileLoader);
    if ("member" in $$props2)
      $$invalidate(0, member = $$props2.member);
  };
  return [
    member,
    currentPasswordValue,
    newPasswordValue,
    confirmPasswordValue,
    currentPasswordValid,
    newPasswordValid,
    confirmPasswordValid,
    submitPasswordChange,
    profileLoader,
    passwordinput_passwordValue_binding,
    passwordinput_passwordInputValid_binding,
    passwordinput0_passwordValue_binding,
    passwordinput0_passwordInputValid_binding,
    passwordinput1_passwordValue_binding,
    passwordinput1_passwordInputValid_binding
  ];
}
var MobilePasswordInfoContent = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$k, create_fragment$E, safe_not_equal, { profileLoader: 8, member: 0 });
  }
};
function create_if_block_6$3(ctx) {
  let div;
  let button;
  let backicon;
  let current;
  let mounted;
  let dispose;
  backicon = new BackIcon({});
  return {
    c() {
      div = element("div");
      button = element("button");
      create_component(backicon.$$.fragment);
      attr(div, "class", "ms-modal__profile-back--mobile");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, button);
      mount_component(backicon, button, null);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler*/
          ctx[8]
        );
        mounted = true;
      }
    },
    p: noop,
    i(local) {
      if (current)
        return;
      transition_in(backicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(backicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      destroy_component(backicon);
      mounted = false;
      dispose();
    }
  };
}
function create_else_block$7(ctx) {
  let memberstackicon;
  let current;
  memberstackicon = new MemberstackIcon({});
  return {
    c() {
      create_component(memberstackicon.$$.fragment);
    },
    m(target, anchor) {
      mount_component(memberstackicon, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current)
        return;
      transition_in(memberstackicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(memberstackicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(memberstackicon, detaching);
    }
  };
}
function create_if_block_5$3(ctx) {
  let img;
  let img_src_value;
  let img_alt_value;
  return {
    c() {
      img = element("img");
      if (!src_url_equal(img.src, img_src_value = /*$app*/
      ctx[7].branding.logo))
        attr(img, "src", img_src_value);
      attr(img, "alt", img_alt_value = /*$app*/
      ctx[7].name);
    },
    m(target, anchor) {
      insert(target, img, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*$app*/
      128 && !src_url_equal(img.src, img_src_value = /*$app*/
      ctx2[7].branding.logo)) {
        attr(img, "src", img_src_value);
      }
      if (dirty & /*$app*/
      128 && img_alt_value !== (img_alt_value = /*$app*/
      ctx2[7].name)) {
        attr(img, "alt", img_alt_value);
      }
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(img);
    }
  };
}
function create_if_block_4$4(ctx) {
  let profileloader;
  let current;
  profileloader = new ProfileLoader({});
  return {
    c() {
      create_component(profileloader.$$.fragment);
    },
    m(target, anchor) {
      mount_component(profileloader, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(profileloader.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(profileloader.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(profileloader, detaching);
    }
  };
}
function create_if_block_3$6(ctx) {
  let mobilepasswordinfocontent;
  let updating_displayProfile;
  let updating_profileLoader;
  let updating_member;
  let current;
  function mobilepasswordinfocontent_displayProfile_binding(value) {
    ctx[17](value);
  }
  function mobilepasswordinfocontent_profileLoader_binding(value) {
    ctx[18](value);
  }
  function mobilepasswordinfocontent_member_binding(value) {
    ctx[19](value);
  }
  let mobilepasswordinfocontent_props = {};
  if (
    /*displayProfile*/
    ctx[0] !== void 0
  ) {
    mobilepasswordinfocontent_props.displayProfile = /*displayProfile*/
    ctx[0];
  }
  if (
    /*profileLoader*/
    ctx[6] !== void 0
  ) {
    mobilepasswordinfocontent_props.profileLoader = /*profileLoader*/
    ctx[6];
  }
  if (
    /*member*/
    ctx[1] !== void 0
  ) {
    mobilepasswordinfocontent_props.member = /*member*/
    ctx[1];
  }
  mobilepasswordinfocontent = new MobilePasswordInfoContent({ props: mobilepasswordinfocontent_props });
  binding_callbacks.push(() => bind(mobilepasswordinfocontent, "displayProfile", mobilepasswordinfocontent_displayProfile_binding));
  binding_callbacks.push(() => bind(mobilepasswordinfocontent, "profileLoader", mobilepasswordinfocontent_profileLoader_binding));
  binding_callbacks.push(() => bind(mobilepasswordinfocontent, "member", mobilepasswordinfocontent_member_binding));
  return {
    c() {
      create_component(mobilepasswordinfocontent.$$.fragment);
    },
    m(target, anchor) {
      mount_component(mobilepasswordinfocontent, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const mobilepasswordinfocontent_changes = {};
      if (!updating_displayProfile && dirty & /*displayProfile*/
      1) {
        updating_displayProfile = true;
        mobilepasswordinfocontent_changes.displayProfile = /*displayProfile*/
        ctx2[0];
        add_flush_callback(() => updating_displayProfile = false);
      }
      if (!updating_profileLoader && dirty & /*profileLoader*/
      64) {
        updating_profileLoader = true;
        mobilepasswordinfocontent_changes.profileLoader = /*profileLoader*/
        ctx2[6];
        add_flush_callback(() => updating_profileLoader = false);
      }
      if (!updating_member && dirty & /*member*/
      2) {
        updating_member = true;
        mobilepasswordinfocontent_changes.member = /*member*/
        ctx2[1];
        add_flush_callback(() => updating_member = false);
      }
      mobilepasswordinfocontent.$set(mobilepasswordinfocontent_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(mobilepasswordinfocontent.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(mobilepasswordinfocontent.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(mobilepasswordinfocontent, detaching);
    }
  };
}
function create_if_block_2$9(ctx) {
  let mobilesecurityinfocontent;
  let updating_displayProfile;
  let updating_profileLoader;
  let updating_member;
  let current;
  function mobilesecurityinfocontent_displayProfile_binding(value) {
    ctx[14](value);
  }
  function mobilesecurityinfocontent_profileLoader_binding(value) {
    ctx[15](value);
  }
  function mobilesecurityinfocontent_member_binding(value) {
    ctx[16](value);
  }
  let mobilesecurityinfocontent_props = {};
  if (
    /*displayProfile*/
    ctx[0] !== void 0
  ) {
    mobilesecurityinfocontent_props.displayProfile = /*displayProfile*/
    ctx[0];
  }
  if (
    /*profileLoader*/
    ctx[6] !== void 0
  ) {
    mobilesecurityinfocontent_props.profileLoader = /*profileLoader*/
    ctx[6];
  }
  if (
    /*member*/
    ctx[1] !== void 0
  ) {
    mobilesecurityinfocontent_props.member = /*member*/
    ctx[1];
  }
  mobilesecurityinfocontent = new MobileSecurityInfoContent({ props: mobilesecurityinfocontent_props });
  binding_callbacks.push(() => bind(mobilesecurityinfocontent, "displayProfile", mobilesecurityinfocontent_displayProfile_binding));
  binding_callbacks.push(() => bind(mobilesecurityinfocontent, "profileLoader", mobilesecurityinfocontent_profileLoader_binding));
  binding_callbacks.push(() => bind(mobilesecurityinfocontent, "member", mobilesecurityinfocontent_member_binding));
  return {
    c() {
      create_component(mobilesecurityinfocontent.$$.fragment);
    },
    m(target, anchor) {
      mount_component(mobilesecurityinfocontent, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const mobilesecurityinfocontent_changes = {};
      if (!updating_displayProfile && dirty & /*displayProfile*/
      1) {
        updating_displayProfile = true;
        mobilesecurityinfocontent_changes.displayProfile = /*displayProfile*/
        ctx2[0];
        add_flush_callback(() => updating_displayProfile = false);
      }
      if (!updating_profileLoader && dirty & /*profileLoader*/
      64) {
        updating_profileLoader = true;
        mobilesecurityinfocontent_changes.profileLoader = /*profileLoader*/
        ctx2[6];
        add_flush_callback(() => updating_profileLoader = false);
      }
      if (!updating_member && dirty & /*member*/
      2) {
        updating_member = true;
        mobilesecurityinfocontent_changes.member = /*member*/
        ctx2[1];
        add_flush_callback(() => updating_member = false);
      }
      mobilesecurityinfocontent.$set(mobilesecurityinfocontent_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(mobilesecurityinfocontent.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(mobilesecurityinfocontent.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(mobilesecurityinfocontent, detaching);
    }
  };
}
function create_if_block_1$c(ctx) {
  let mobileprofileinfocontent;
  let updating_member;
  let updating_profileLoader;
  let current;
  function mobileprofileinfocontent_member_binding(value) {
    ctx[12](value);
  }
  function mobileprofileinfocontent_profileLoader_binding(value) {
    ctx[13](value);
  }
  let mobileprofileinfocontent_props = {
    customFields: (
      /*$app*/
      ctx[7].customFields
    )
  };
  if (
    /*member*/
    ctx[1] !== void 0
  ) {
    mobileprofileinfocontent_props.member = /*member*/
    ctx[1];
  }
  if (
    /*profileLoader*/
    ctx[6] !== void 0
  ) {
    mobileprofileinfocontent_props.profileLoader = /*profileLoader*/
    ctx[6];
  }
  mobileprofileinfocontent = new MobileProfileInfoContent({ props: mobileprofileinfocontent_props });
  binding_callbacks.push(() => bind(mobileprofileinfocontent, "member", mobileprofileinfocontent_member_binding));
  binding_callbacks.push(() => bind(mobileprofileinfocontent, "profileLoader", mobileprofileinfocontent_profileLoader_binding));
  return {
    c() {
      create_component(mobileprofileinfocontent.$$.fragment);
    },
    m(target, anchor) {
      mount_component(mobileprofileinfocontent, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const mobileprofileinfocontent_changes = {};
      if (dirty & /*$app*/
      128)
        mobileprofileinfocontent_changes.customFields = /*$app*/
        ctx2[7].customFields;
      if (!updating_member && dirty & /*member*/
      2) {
        updating_member = true;
        mobileprofileinfocontent_changes.member = /*member*/
        ctx2[1];
        add_flush_callback(() => updating_member = false);
      }
      if (!updating_profileLoader && dirty & /*profileLoader*/
      64) {
        updating_profileLoader = true;
        mobileprofileinfocontent_changes.profileLoader = /*profileLoader*/
        ctx2[6];
        add_flush_callback(() => updating_profileLoader = false);
      }
      mobileprofileinfocontent.$set(mobileprofileinfocontent_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(mobileprofileinfocontent.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(mobileprofileinfocontent.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(mobileprofileinfocontent, detaching);
    }
  };
}
function create_if_block$g(ctx) {
  let mobileprofilemodalnav;
  let updating_member;
  let updating_displayProfile;
  let updating_profileLoader;
  let current;
  function mobileprofilemodalnav_member_binding(value) {
    ctx[9](value);
  }
  function mobileprofilemodalnav_displayProfile_binding(value) {
    ctx[10](value);
  }
  function mobileprofilemodalnav_profileLoader_binding(value) {
    ctx[11](value);
  }
  let mobileprofilemodalnav_props = {
    onSuccessLogout: (
      /*onSuccessLogout*/
      ctx[3]
    ),
    hideProfileSection: (
      /*hideProfileSection*/
      ctx[5]
    )
  };
  if (
    /*member*/
    ctx[1] !== void 0
  ) {
    mobileprofilemodalnav_props.member = /*member*/
    ctx[1];
  }
  if (
    /*displayProfile*/
    ctx[0] !== void 0
  ) {
    mobileprofilemodalnav_props.displayProfile = /*displayProfile*/
    ctx[0];
  }
  if (
    /*profileLoader*/
    ctx[6] !== void 0
  ) {
    mobileprofilemodalnav_props.profileLoader = /*profileLoader*/
    ctx[6];
  }
  mobileprofilemodalnav = new MobileProfileModalNav({ props: mobileprofilemodalnav_props });
  binding_callbacks.push(() => bind(mobileprofilemodalnav, "member", mobileprofilemodalnav_member_binding));
  binding_callbacks.push(() => bind(mobileprofilemodalnav, "displayProfile", mobileprofilemodalnav_displayProfile_binding));
  binding_callbacks.push(() => bind(mobileprofilemodalnav, "profileLoader", mobileprofilemodalnav_profileLoader_binding));
  return {
    c() {
      create_component(mobileprofilemodalnav.$$.fragment);
    },
    m(target, anchor) {
      mount_component(mobileprofilemodalnav, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const mobileprofilemodalnav_changes = {};
      if (dirty & /*onSuccessLogout*/
      8)
        mobileprofilemodalnav_changes.onSuccessLogout = /*onSuccessLogout*/
        ctx2[3];
      if (dirty & /*hideProfileSection*/
      32)
        mobileprofilemodalnav_changes.hideProfileSection = /*hideProfileSection*/
        ctx2[5];
      if (!updating_member && dirty & /*member*/
      2) {
        updating_member = true;
        mobileprofilemodalnav_changes.member = /*member*/
        ctx2[1];
        add_flush_callback(() => updating_member = false);
      }
      if (!updating_displayProfile && dirty & /*displayProfile*/
      1) {
        updating_displayProfile = true;
        mobileprofilemodalnav_changes.displayProfile = /*displayProfile*/
        ctx2[0];
        add_flush_callback(() => updating_displayProfile = false);
      }
      if (!updating_profileLoader && dirty & /*profileLoader*/
      64) {
        updating_profileLoader = true;
        mobileprofilemodalnav_changes.profileLoader = /*profileLoader*/
        ctx2[6];
        add_flush_callback(() => updating_profileLoader = false);
      }
      mobileprofilemodalnav.$set(mobileprofilemodalnav_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(mobileprofilemodalnav.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(mobileprofilemodalnav.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(mobileprofilemodalnav, detaching);
    }
  };
}
function create_fragment$D(ctx) {
  let div5;
  let div2;
  let t0;
  let div1;
  let figure;
  let current_block_type_index;
  let if_block1;
  let t1;
  let div0;
  let b;
  let t2;
  let t3;
  let closebutton;
  let t4;
  let div4;
  let div3;
  let t5;
  let current_block_type_index_1;
  let if_block3;
  let t6;
  let modalfooter;
  let current;
  let if_block0 = (
    /*displayProfile*/
    (ctx[0] === "profile" || /*displayProfile*/
    ctx[0] === "changePassword" || /*displayProfile*/
    ctx[0] === "security") && create_if_block_6$3(ctx)
  );
  const if_block_creators = [create_if_block_5$3, create_else_block$7];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*$app*/
      ctx2[7].branding.logo
    )
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  closebutton = new CloseButton({
    props: { closeModal: (
      /*closeModal*/
      ctx[4]
    ) }
  });
  let if_block2 = (
    /*profileLoader*/
    ctx[6] && create_if_block_4$4()
  );
  const if_block_creators_1 = [create_if_block$g, create_if_block_1$c, create_if_block_2$9, create_if_block_3$6];
  const if_blocks_1 = [];
  function select_block_type_1(ctx2, dirty) {
    if (
      /*displayProfile*/
      ctx2[0] === "profile-nav"
    )
      return 0;
    if (
      /*displayProfile*/
      ctx2[0] === "profile"
    )
      return 1;
    if (
      /*displayProfile*/
      ctx2[0] === "security"
    )
      return 2;
    if (
      /*displayProfile*/
      ctx2[0] === "changePassword"
    )
      return 3;
    return -1;
  }
  if (~(current_block_type_index_1 = select_block_type_1(ctx))) {
    if_block3 = if_blocks_1[current_block_type_index_1] = if_block_creators_1[current_block_type_index_1](ctx);
  }
  modalfooter = new ModalFooter({});
  return {
    c() {
      div5 = element("div");
      div2 = element("div");
      if (if_block0)
        if_block0.c();
      t0 = space();
      div1 = element("div");
      figure = element("figure");
      if_block1.c();
      t1 = space();
      div0 = element("div");
      b = element("b");
      t2 = text(
        /*profileTitle*/
        ctx[2]
      );
      t3 = space();
      create_component(closebutton.$$.fragment);
      t4 = space();
      div4 = element("div");
      div3 = element("div");
      if (if_block2)
        if_block2.c();
      t5 = space();
      if (if_block3)
        if_block3.c();
      t6 = space();
      create_component(modalfooter.$$.fragment);
      attr(figure, "class", "ms-modal__figure ms-modal__figure--mobile");
      attr(div1, "class", "ms-modal__header--center");
      attr(div2, "class", "ms-modal__header--mobile");
      attr(div3, "class", "ms-modal__content--mobile");
      attr(div4, "class", "ms-modal__content ms-modal__content--profile");
      attr(div5, "class", "ms-modal ms-modal--profile");
      attr(div5, "id", "MobileProfileModal");
    },
    m(target, anchor) {
      insert(target, div5, anchor);
      append(div5, div2);
      if (if_block0)
        if_block0.m(div2, null);
      append(div2, t0);
      append(div2, div1);
      append(div1, figure);
      if_blocks[current_block_type_index].m(figure, null);
      append(div1, t1);
      append(div1, div0);
      append(div0, b);
      append(b, t2);
      append(div2, t3);
      mount_component(closebutton, div2, null);
      append(div5, t4);
      append(div5, div4);
      append(div4, div3);
      if (if_block2)
        if_block2.m(div3, null);
      append(div3, t5);
      if (~current_block_type_index_1) {
        if_blocks_1[current_block_type_index_1].m(div3, null);
      }
      append(div5, t6);
      mount_component(modalfooter, div5, null);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (
        /*displayProfile*/
        ctx2[0] === "profile" || /*displayProfile*/
        ctx2[0] === "changePassword" || /*displayProfile*/
        ctx2[0] === "security"
      ) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
          if (dirty & /*displayProfile*/
          1) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_6$3(ctx2);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(div2, t0);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block1 = if_blocks[current_block_type_index];
        if (!if_block1) {
          if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block1.c();
        } else {
          if_block1.p(ctx2, dirty);
        }
        transition_in(if_block1, 1);
        if_block1.m(figure, null);
      }
      if (!current || dirty & /*profileTitle*/
      4)
        set_data(
          t2,
          /*profileTitle*/
          ctx2[2]
        );
      const closebutton_changes = {};
      if (dirty & /*closeModal*/
      16)
        closebutton_changes.closeModal = /*closeModal*/
        ctx2[4];
      closebutton.$set(closebutton_changes);
      if (
        /*profileLoader*/
        ctx2[6]
      ) {
        if (if_block2) {
          if (dirty & /*profileLoader*/
          64) {
            transition_in(if_block2, 1);
          }
        } else {
          if_block2 = create_if_block_4$4();
          if_block2.c();
          transition_in(if_block2, 1);
          if_block2.m(div3, t5);
        }
      } else if (if_block2) {
        group_outros();
        transition_out(if_block2, 1, 1, () => {
          if_block2 = null;
        });
        check_outros();
      }
      let previous_block_index_1 = current_block_type_index_1;
      current_block_type_index_1 = select_block_type_1(ctx2);
      if (current_block_type_index_1 === previous_block_index_1) {
        if (~current_block_type_index_1) {
          if_blocks_1[current_block_type_index_1].p(ctx2, dirty);
        }
      } else {
        if (if_block3) {
          group_outros();
          transition_out(if_blocks_1[previous_block_index_1], 1, 1, () => {
            if_blocks_1[previous_block_index_1] = null;
          });
          check_outros();
        }
        if (~current_block_type_index_1) {
          if_block3 = if_blocks_1[current_block_type_index_1];
          if (!if_block3) {
            if_block3 = if_blocks_1[current_block_type_index_1] = if_block_creators_1[current_block_type_index_1](ctx2);
            if_block3.c();
          } else {
            if_block3.p(ctx2, dirty);
          }
          transition_in(if_block3, 1);
          if_block3.m(div3, null);
        } else {
          if_block3 = null;
        }
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block0);
      transition_in(if_block1);
      transition_in(closebutton.$$.fragment, local);
      transition_in(if_block2);
      transition_in(if_block3);
      transition_in(modalfooter.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(if_block1);
      transition_out(closebutton.$$.fragment, local);
      transition_out(if_block2);
      transition_out(if_block3);
      transition_out(modalfooter.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div5);
      if (if_block0)
        if_block0.d();
      if_blocks[current_block_type_index].d();
      destroy_component(closebutton);
      if (if_block2)
        if_block2.d();
      if (~current_block_type_index_1) {
        if_blocks_1[current_block_type_index_1].d();
      }
      destroy_component(modalfooter);
    }
  };
}
function instance$j($$self, $$props, $$invalidate) {
  let $app;
  component_subscribe($$self, AppStore, ($$value) => $$invalidate(7, $app = $$value));
  let { onSuccessLogout } = $$props;
  let { closeModal } = $$props;
  let { displayProfile = "profile-nav" } = $$props;
  let { member } = $$props;
  let { profileTitle = member.auth.email } = $$props;
  let hideProfileSection2 = false;
  let profileLoader = false;
  if (!$app.customFields.filter((field) => !field.hidden).length) {
    displayProfile = "security";
    hideProfileSection2 = true;
  }
  const click_handler = () => $$invalidate(0, displayProfile = "profile-nav");
  function mobileprofilemodalnav_member_binding(value) {
    member = value;
    $$invalidate(1, member);
  }
  function mobileprofilemodalnav_displayProfile_binding(value) {
    displayProfile = value;
    $$invalidate(0, displayProfile);
  }
  function mobileprofilemodalnav_profileLoader_binding(value) {
    profileLoader = value;
    $$invalidate(6, profileLoader);
  }
  function mobileprofileinfocontent_member_binding(value) {
    member = value;
    $$invalidate(1, member);
  }
  function mobileprofileinfocontent_profileLoader_binding(value) {
    profileLoader = value;
    $$invalidate(6, profileLoader);
  }
  function mobilesecurityinfocontent_displayProfile_binding(value) {
    displayProfile = value;
    $$invalidate(0, displayProfile);
  }
  function mobilesecurityinfocontent_profileLoader_binding(value) {
    profileLoader = value;
    $$invalidate(6, profileLoader);
  }
  function mobilesecurityinfocontent_member_binding(value) {
    member = value;
    $$invalidate(1, member);
  }
  function mobilepasswordinfocontent_displayProfile_binding(value) {
    displayProfile = value;
    $$invalidate(0, displayProfile);
  }
  function mobilepasswordinfocontent_profileLoader_binding(value) {
    profileLoader = value;
    $$invalidate(6, profileLoader);
  }
  function mobilepasswordinfocontent_member_binding(value) {
    member = value;
    $$invalidate(1, member);
  }
  $$self.$$set = ($$props2) => {
    if ("onSuccessLogout" in $$props2)
      $$invalidate(3, onSuccessLogout = $$props2.onSuccessLogout);
    if ("closeModal" in $$props2)
      $$invalidate(4, closeModal = $$props2.closeModal);
    if ("displayProfile" in $$props2)
      $$invalidate(0, displayProfile = $$props2.displayProfile);
    if ("member" in $$props2)
      $$invalidate(1, member = $$props2.member);
    if ("profileTitle" in $$props2)
      $$invalidate(2, profileTitle = $$props2.profileTitle);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*displayProfile, member*/
    3) {
      if (displayProfile === "profile-nav") {
        $$invalidate(2, profileTitle = member.auth.email);
      } else if (displayProfile === "profile") {
        $$invalidate(2, profileTitle = "My Profile");
      } else if (displayProfile === "security") {
        $$invalidate(2, profileTitle = "Security");
      } else if (displayProfile === "changePassword") {
        if (!member.auth.hasPassword) {
          $$invalidate(2, profileTitle = "Set Password");
        } else {
          $$invalidate(2, profileTitle = "Change Password");
        }
      }
    }
  };
  return [
    displayProfile,
    member,
    profileTitle,
    onSuccessLogout,
    closeModal,
    hideProfileSection2,
    profileLoader,
    $app,
    click_handler,
    mobileprofilemodalnav_member_binding,
    mobileprofilemodalnav_displayProfile_binding,
    mobileprofilemodalnav_profileLoader_binding,
    mobileprofileinfocontent_member_binding,
    mobileprofileinfocontent_profileLoader_binding,
    mobilesecurityinfocontent_displayProfile_binding,
    mobilesecurityinfocontent_profileLoader_binding,
    mobilesecurityinfocontent_member_binding,
    mobilepasswordinfocontent_displayProfile_binding,
    mobilepasswordinfocontent_profileLoader_binding,
    mobilepasswordinfocontent_member_binding
  ];
}
var MobileProfileModal = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$j, create_fragment$D, safe_not_equal, {
      onSuccessLogout: 3,
      closeModal: 4,
      displayProfile: 0,
      member: 1,
      profileTitle: 2
    });
  }
};
function add_css$i(target) {
  append_styles(target, "svelte-50knw2", "svg.svelte-50knw2{fill:currentColor;width:9px;height:auto}");
}
function create_fragment$C(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M459-381 314-526q-3-3-4.5-6.5T308-540q0-8 5.5-14t14.5-6h304q9 0 14.5 6t5.5 14q0 2-6 14L501-381q-5 5-10 7t-11 2q-6 0-11-2t-10-7Z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "viewBox", "308 -560 344 188");
      attr(svg, "class", "svelte-50knw2");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var ArrowIcon$1 = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$C, safe_not_equal, {}, add_css$i);
  }
};
function add_css$h(target) {
  append_styles(target, "svelte-w4kmg0", "#TestCardModal .copied{background-color:#3eb862 !important;color:#fff !important}#TestCardModal .copied svg{opacity:1 !important}#TestCardModal.svelte-w4kmg0 .ms-modal__title.svelte-w4kmg0{text-align:left;margin-bottom:5px;font-size:20px;line-height:24px}#TestCardModal.svelte-w4kmg0 .ms-video.svelte-w4kmg0{width:100%;margin-top:20px;margin-bottom:20px;border-radius:10px;overflow:hidden}#TestCardModal.svelte-w4kmg0 p.svelte-w4kmg0{color:#443;font-size:11px;line-height:16.5px;margin-bottom:10px}#TestCardModal.svelte-w4kmg0 p.no-margin.svelte-w4kmg0{margin:0}#TestCardModal.svelte-w4kmg0 p a.svelte-w4kmg0{color:#443;font-weight:bold;text-decoration:underline}#TestCardModal.svelte-w4kmg0 .ms-split-button.svelte-w4kmg0{display:flex;position:relative;margin-bottom:10px;width:100%;color:#292929;font-size:13px;line-height:1}#TestCardModal.svelte-w4kmg0 .ms-split-button__main.svelte-w4kmg0{background-color:#f5f5f5;border:0.5px solid #dddfee;border-radius:6px 0 0 6px;padding:10px 15px;width:100%;display:flex;text-overflow:ellipsis;gap:6px;align-items:center;transition:background-color 0.2s}#TestCardModal.svelte-w4kmg0 .ms-split-button__main span.svelte-w4kmg0{font-weight:bold}#TestCardModal.svelte-w4kmg0 .ms-split-button__main.svelte-w4kmg0:hover{background:#dddfee}#TestCardModal.svelte-w4kmg0 .ms-split-button__secondary.svelte-w4kmg0{background-color:#f5f5f5;border:0.5px solid #dddfee;border-radius:0 6px 6px 0;padding:10px 15px;display:flex;align-items:center;justify-content:center;transition:background-color 0.2s}#TestCardModal.svelte-w4kmg0 .ms-split-button__secondary.svelte-w4kmg0:hover{background:#dddfee}#TestCardModal.svelte-w4kmg0 .ms-split-button__secondary.active.svelte-w4kmg0{background:#dddfee}#TestCardModal.svelte-w4kmg0 .ms-split-button__dropdown.svelte-w4kmg0{background-color:#f5f5f5;border:0.5px solid #dddfee;border-radius:6px;color:#443;display:none;font-size:12px;line-height:1;position:absolute;right:0;top:100%;z-index:2147483649 !important;width:auto}#TestCardModal.svelte-w4kmg0 .ms-split-button__dropdown.show.svelte-w4kmg0{display:block}#TestCardModal.svelte-w4kmg0 .ms-split-button__dropdown section.svelte-w4kmg0{display:flex;flex-direction:column}#TestCardModal.svelte-w4kmg0 .ms-split-button__dropdown-title.svelte-w4kmg0{background-color:#f5f5f5;color:#000;font-size:11px;font-weight:bold;line-height:1;padding:10px;border-bottom:0.5px solid #dddfee;text-align:right}#TestCardModal.svelte-w4kmg0 .ms-split-button__dropdown button.svelte-w4kmg0{background-color:#fff;color:#443;font-size:11px;line-height:1;padding:10px;width:100%;text-align:right;transition:background-color 0.2s;display:flex;justify-content:space-between;align-items:center}#TestCardModal.svelte-w4kmg0 .ms-split-button__dropdown button .ms-split-button__copy-icon.svelte-w4kmg0{position:relative;width:20px;height:5px;display:flex;justify-content:center;align-items:center}#TestCardModal.svelte-w4kmg0 .ms-split-button__dropdown button.svelte-w4kmg0:hover{background-color:#dddfee}\n      #TestCardModal\n        .ms-split-button__dropdown\n        button\n        .ms-split-button__copy-icon\n        svg\n    {position:absolute}\n      #TestCardModal\n        .ms-split-button__dropdown\n        button:hover\n        .ms-split-button__copy-icon\n        svg\n    {opacity:1}\n      #TestCardModal\n        .ms-split-button__dropdown\n        button\n        .ms-split-button__copy-icon\n        svg\n    {opacity:0}#TestCardModal.svelte-w4kmg0 .ms-split-button__dropdown button span.svelte-w4kmg0{font-weight:bold}#TestCardModal.svelte-w4kmg0 .ms-split-button__dropdown-footer.svelte-w4kmg0{background-color:#f5f5f5;color:#000;font-size:11px;line-height:1;font-weight:bold;padding:10px;text-align:center}#TestCardModal.svelte-w4kmg0 .ms-split-button__dropdown-footer a.svelte-w4kmg0{color:#2962ff;text-decoration:none}#TestCardModal.svelte-w4kmg0 .ms-submit-button.svelte-w4kmg0{background-color:#434de7;border-radius:6px;color:#fff;font-size:14px;font-weight:bold;line-height:1;padding:16px;width:100%}");
}
function create_if_block$f(ctx) {
  let closebutton;
  let current;
  closebutton = new CloseButton({
    props: { closeModal: (
      /*closeModal*/
      ctx[0]
    ) }
  });
  return {
    c() {
      create_component(closebutton.$$.fragment);
    },
    m(target, anchor) {
      mount_component(closebutton, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const closebutton_changes = {};
      if (dirty & /*closeModal*/
      1)
        closebutton_changes.closeModal = /*closeModal*/
        ctx2[0];
      closebutton.$set(closebutton_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(closebutton.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(closebutton.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(closebutton, detaching);
    }
  };
}
function create_fragment$B(ctx) {
  let div5;
  let t0;
  let div4;
  let h2;
  let t2;
  let p0;
  let t4;
  let video;
  let source0;
  let source0_src_value;
  let source1;
  let source1_src_value;
  let t5;
  let div3;
  let button0;
  let copyicon0;
  let t6;
  let t7;
  let span0;
  let t9;
  let button1;
  let arrowicon;
  let t10;
  let nav;
  let section0;
  let div0;
  let t12;
  let button2;
  let span1;
  let copyicon1;
  let span2;
  let t15;
  let button3;
  let span3;
  let copyicon2;
  let span4;
  let t18;
  let button4;
  let span5;
  let copyicon3;
  let span6;
  let t21;
  let section1;
  let div1;
  let t23;
  let button5;
  let span7;
  let copyicon4;
  let span8;
  let t26;
  let button6;
  let span9;
  let copyicon5;
  let span10;
  let t29;
  let div2;
  let t33;
  let p1;
  let t35;
  let button7;
  let current;
  let mounted;
  let dispose;
  let if_block = (!/*params*/
  ctx[2] || !/*params*/
  ctx[2].hideCloseButton) && create_if_block$f(ctx);
  copyicon0 = new CopyIcon$1({});
  arrowicon = new ArrowIcon$1({});
  copyicon1 = new CopyIcon$1({});
  copyicon2 = new CopyIcon$1({});
  copyicon3 = new CopyIcon$1({});
  copyicon4 = new CopyIcon$1({});
  copyicon5 = new CopyIcon$1({});
  return {
    c() {
      div5 = element("div");
      if (if_block)
        if_block.c();
      t0 = space();
      div4 = element("div");
      h2 = element("h2");
      h2.textContent = "Copy Stripe Test Card";
      t2 = space();
      p0 = element("p");
      p0.textContent = "Test mode only. Live members will never see this modal.";
      t4 = space();
      video = element("video");
      source0 = element("source");
      source1 = element("source");
      t5 = space();
      div3 = element("div");
      button0 = element("button");
      create_component(copyicon0.$$.fragment);
      t6 = space();
      t7 = text(
        /*buttonText*/
        ctx[3]
      );
      span0 = element("span");
      span0.textContent = "...4242";
      t9 = space();
      button1 = element("button");
      create_component(arrowicon.$$.fragment);
      t10 = space();
      nav = element("nav");
      section0 = element("section");
      div0 = element("div");
      div0.textContent = "Test Successful Payments";
      t12 = space();
      button2 = element("button");
      span1 = element("span");
      create_component(copyicon1.$$.fragment);
      span2 = element("span");
      span2.innerHTML = `Visa Debit <b>...5556</b>`;
      t15 = space();
      button3 = element("button");
      span3 = element("span");
      create_component(copyicon2.$$.fragment);
      span4 = element("span");
      span4.innerHTML = `Mastercard <b>...4444</b>`;
      t18 = space();
      button4 = element("button");
      span5 = element("span");
      create_component(copyicon3.$$.fragment);
      span6 = element("span");
      span6.innerHTML = `American Express <b>...10005</b>`;
      t21 = space();
      section1 = element("section");
      div1 = element("div");
      div1.textContent = "Test Declined Payments";
      t23 = space();
      button5 = element("button");
      span7 = element("span");
      create_component(copyicon4.$$.fragment);
      span8 = element("span");
      span8.innerHTML = `Generic decline <b>...0002</b>`;
      t26 = space();
      button6 = element("button");
      span9 = element("span");
      create_component(copyicon5.$$.fragment);
      span10 = element("span");
      span10.innerHTML = `Insufficient funds <b>...9995</b>`;
      t29 = space();
      div2 = element("div");
      div2.innerHTML = `Complete list of <a href="https://stripe.com/docs/testing" target="_blank" class="svelte-w4kmg0">alternative test cards</a>.`;
      t33 = space();
      p1 = element("p");
      p1.textContent = "Paste the card number on the next screen, with any CVC,\n      expiration date, and ZIP code.";
      t35 = space();
      button7 = element("button");
      button7.textContent = "Continue to Test Checkout";
      attr(h2, "class", "ms-modal__title svelte-w4kmg0");
      attr(h2, "data-copy-btn", "");
      attr(p0, "class", "no-margin svelte-w4kmg0");
      if (!src_url_equal(source0.src, source0_src_value = videoMP4Path))
        attr(source0, "src", source0_src_value);
      attr(source0, "type", "video/mp4");
      if (!src_url_equal(source1.src, source1_src_value = videoWebMPath))
        attr(source1, "src", source1_src_value);
      attr(source1, "type", "video/webm");
      video.autoplay = true;
      video.loop = true;
      video.muted = true;
      video.playsInline = true;
      attr(video, "class", "ms-video svelte-w4kmg0");
      attr(video, "poster", videoImagePath);
      attr(span0, "class", "svelte-w4kmg0");
      attr(button0, "class", "ms-split-button__main svelte-w4kmg0");
      attr(button1, "class", "ms-split-button__secondary svelte-w4kmg0");
      toggle_class(
        button1,
        "active",
        /*showDropdown*/
        ctx[4]
      );
      attr(div0, "class", "ms-split-button__dropdown-title svelte-w4kmg0");
      attr(span1, "class", "ms-split-button__copy-icon svelte-w4kmg0");
      attr(span2, "class", "svelte-w4kmg0");
      attr(button2, "class", "svelte-w4kmg0");
      attr(span3, "class", "ms-split-button__copy-icon svelte-w4kmg0");
      attr(span4, "class", "svelte-w4kmg0");
      attr(button3, "class", "svelte-w4kmg0");
      attr(span5, "class", "ms-split-button__copy-icon svelte-w4kmg0");
      attr(span6, "class", "svelte-w4kmg0");
      attr(button4, "class", "svelte-w4kmg0");
      attr(section0, "class", "svelte-w4kmg0");
      attr(div1, "class", "ms-split-button__dropdown-title svelte-w4kmg0");
      attr(span7, "class", "ms-split-button__copy-icon svelte-w4kmg0");
      attr(span8, "class", "svelte-w4kmg0");
      attr(button5, "class", "svelte-w4kmg0");
      attr(span9, "class", "ms-split-button__copy-icon svelte-w4kmg0");
      attr(span10, "class", "svelte-w4kmg0");
      attr(button6, "class", "svelte-w4kmg0");
      attr(section1, "class", "svelte-w4kmg0");
      attr(div2, "class", "ms-split-button__dropdown-footer svelte-w4kmg0");
      attr(nav, "class", "ms-split-button__dropdown svelte-w4kmg0");
      toggle_class(
        nav,
        "show",
        /*showDropdown*/
        ctx[4]
      );
      attr(div3, "class", "ms-split-button svelte-w4kmg0");
      attr(p1, "class", "svelte-w4kmg0");
      attr(button7, "class", "ms-submit-button svelte-w4kmg0");
      attr(div4, "class", "ms-modal__content");
      attr(div5, "class", "ms-modal svelte-w4kmg0");
      attr(div5, "id", "TestCardModal");
    },
    m(target, anchor) {
      insert(target, div5, anchor);
      if (if_block)
        if_block.m(div5, null);
      append(div5, t0);
      append(div5, div4);
      append(div4, h2);
      append(div4, t2);
      append(div4, p0);
      append(div4, t4);
      append(div4, video);
      append(video, source0);
      append(video, source1);
      append(div4, t5);
      append(div4, div3);
      append(div3, button0);
      mount_component(copyicon0, button0, null);
      append(button0, t6);
      append(button0, t7);
      append(button0, span0);
      append(div3, t9);
      append(div3, button1);
      mount_component(arrowicon, button1, null);
      append(div3, t10);
      append(div3, nav);
      append(nav, section0);
      append(section0, div0);
      append(section0, t12);
      append(section0, button2);
      append(button2, span1);
      mount_component(copyicon1, span1, null);
      append(button2, span2);
      append(section0, t15);
      append(section0, button3);
      append(button3, span3);
      mount_component(copyicon2, span3, null);
      append(button3, span4);
      append(section0, t18);
      append(section0, button4);
      append(button4, span5);
      mount_component(copyicon3, span5, null);
      append(button4, span6);
      append(nav, t21);
      append(nav, section1);
      append(section1, div1);
      append(section1, t23);
      append(section1, button5);
      append(button5, span7);
      mount_component(copyicon4, span7, null);
      append(button5, span8);
      append(section1, t26);
      append(section1, button6);
      append(button6, span9);
      mount_component(copyicon5, span9, null);
      append(button6, span10);
      append(nav, t29);
      append(nav, div2);
      append(div4, t33);
      append(div4, p1);
      append(div4, t35);
      append(div4, button7);
      current = true;
      if (!mounted) {
        dispose = [
          listen(
            button0,
            "click",
            /*click_handler*/
            ctx[7]
          ),
          listen(
            button1,
            "click",
            /*click_handler_1*/
            ctx[8]
          ),
          listen(
            button2,
            "click",
            /*click_handler_2*/
            ctx[9]
          ),
          listen(
            button3,
            "click",
            /*click_handler_3*/
            ctx[10]
          ),
          listen(
            button4,
            "click",
            /*click_handler_4*/
            ctx[11]
          ),
          listen(
            button5,
            "click",
            /*click_handler_5*/
            ctx[12]
          ),
          listen(
            button6,
            "click",
            /*click_handler_6*/
            ctx[13]
          ),
          listen(
            button7,
            "click",
            /*click_handler_7*/
            ctx[14]
          )
        ];
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (!/*params*/
      ctx2[2] || !/*params*/
      ctx2[2].hideCloseButton) {
        if (if_block) {
          if_block.p(ctx2, dirty);
          if (dirty & /*params*/
          4) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$f(ctx2);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(div5, t0);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
      if (!current || dirty & /*buttonText*/
      8)
        set_data(
          t7,
          /*buttonText*/
          ctx2[3]
        );
      if (!current || dirty & /*showDropdown*/
      16) {
        toggle_class(
          button1,
          "active",
          /*showDropdown*/
          ctx2[4]
        );
      }
      if (!current || dirty & /*showDropdown*/
      16) {
        toggle_class(
          nav,
          "show",
          /*showDropdown*/
          ctx2[4]
        );
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      transition_in(copyicon0.$$.fragment, local);
      transition_in(arrowicon.$$.fragment, local);
      transition_in(copyicon1.$$.fragment, local);
      transition_in(copyicon2.$$.fragment, local);
      transition_in(copyicon3.$$.fragment, local);
      transition_in(copyicon4.$$.fragment, local);
      transition_in(copyicon5.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      transition_out(copyicon0.$$.fragment, local);
      transition_out(arrowicon.$$.fragment, local);
      transition_out(copyicon1.$$.fragment, local);
      transition_out(copyicon2.$$.fragment, local);
      transition_out(copyicon3.$$.fragment, local);
      transition_out(copyicon4.$$.fragment, local);
      transition_out(copyicon5.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div5);
      if (if_block)
        if_block.d();
      destroy_component(copyicon0);
      destroy_component(arrowicon);
      destroy_component(copyicon1);
      destroy_component(copyicon2);
      destroy_component(copyicon3);
      destroy_component(copyicon4);
      destroy_component(copyicon5);
      mounted = false;
      run_all(dispose);
    }
  };
}
var videoImagePath = "https://assets-global.website-files.com/65a6d87f7ae30844cde0911b/65efa0d9dc3019b69fe6a9cb_4242%20full-poster-00001.jpg";
var videoMP4Path = "https://assets-global.website-files.com/65a6d87f7ae30844cde0911b/65efa0d9dc3019b69fe6a9cb_4242%20full-transcode.mp4";
var videoWebMPath = "https://assets-global.website-files.com/65a6d87f7ae30844cde0911b/65efa0d9dc3019b69fe6a9cb_4242%20full-transcode.webm";
function instance$i($$self, $$props, $$invalidate) {
  let { closeModal } = $$props;
  let { display } = $$props;
  let { onSuccessSubmit } = $$props;
  let { params } = $$props;
  let buttonText = "Copy Stripe Test Card";
  let showDropdown = false;
  function copyToClipboard(event, copyText, changeText) {
    navigator.clipboard.writeText(copyText);
    const button = event.currentTarget;
    if (changeText)
      $$invalidate(3, buttonText = "Copied Stripe Test Card");
    button.classList.add("copied");
    setTimeout(
      () => {
        button.classList.remove("copied");
        $$invalidate(3, buttonText = "Copy Stripe Test Card");
        $$invalidate(4, showDropdown = false);
      },
      1e3
    );
  }
  const click_handler = (event) => copyToClipboard(event, "4242 4242 4242 4242", true);
  const click_handler_1 = () => $$invalidate(4, showDropdown = !showDropdown);
  const click_handler_2 = (event) => copyToClipboard(event, "4000 0566 5566 5556");
  const click_handler_3 = (event) => copyToClipboard(event, "5555 5555 5555 4444");
  const click_handler_4 = (event) => copyToClipboard(event, "3782 822463 10005");
  const click_handler_5 = (event) => copyToClipboard(event, "4000 0000 0000 0002");
  const click_handler_6 = (event) => copyToClipboard(event, "4000 0000 0000 9995");
  const click_handler_7 = () => {
    onSuccessSubmit();
  };
  $$self.$$set = ($$props2) => {
    if ("closeModal" in $$props2)
      $$invalidate(0, closeModal = $$props2.closeModal);
    if ("display" in $$props2)
      $$invalidate(6, display = $$props2.display);
    if ("onSuccessSubmit" in $$props2)
      $$invalidate(1, onSuccessSubmit = $$props2.onSuccessSubmit);
    if ("params" in $$props2)
      $$invalidate(2, params = $$props2.params);
  };
  return [
    closeModal,
    onSuccessSubmit,
    params,
    buttonText,
    showDropdown,
    copyToClipboard,
    display,
    click_handler,
    click_handler_1,
    click_handler_2,
    click_handler_3,
    click_handler_4,
    click_handler_5,
    click_handler_6,
    click_handler_7
  ];
}
var TestCardModal = class extends SvelteComponent {
  constructor(options) {
    super();
    init(
      this,
      options,
      instance$i,
      create_fragment$B,
      safe_not_equal,
      {
        closeModal: 0,
        display: 6,
        onSuccessSubmit: 1,
        params: 2
      },
      add_css$h
    );
  }
};
AppStore.subscribe((data) => {
  if (!data.initialValue) {
    InspectorStore.update((store) => {
      store.appData = data;
      return store;
    });
  }
});
var InspectorStore = writable({
  showSidebar: false,
  showSide: "right",
  // "left" or "right
  showTab: "inspector",
  // inspector, member, app
  xRayMode: localStorage.getItem("MSXRayMode") ? JSON.parse(localStorage.getItem("MSXRayMode")) : true,
  xRayErrorElements: [],
  xRayWarningElements: [],
  cartData: [],
  // data from the session storage
  inspectorData: [],
  // id's of items that have been found on the page
  // member data from the memberstack local storage _ms-mem
  memberData: localStorage.getItem("_ms-mem") ? JSON.parse(localStorage.getItem("_ms-mem")) : {},
  appData: {}
  // data from the app store
});
var SetCartData = (data) => {
  InspectorStore.update((store) => {
    store.cartData = data;
    return store;
  });
};
var AddInspectorData = (data) => {
  InspectorStore.update((store) => {
    store.inspectorData.push(data);
    return store;
  });
};
var SetShowSidebar = (toggle) => {
  InspectorStore.update((store) => {
    store.showSidebar = toggle;
    return store;
  });
};
var SetShowSide = (side) => {
  InspectorStore.update((store) => {
    store.showSide = side;
    return store;
  });
};
var SetShowTab = (tab) => {
  InspectorStore.update((store) => {
    store.showTab = tab;
    return store;
  });
};
var ToggleXRayMode = () => {
  InspectorStore.update((store) => {
    store.xRayMode = !store.xRayMode;
    localStorage.setItem("MSXRayMode", store.xRayMode);
    return store;
  });
};
var AddXRayErrorElement = (data) => {
  InspectorStore.update((store) => {
    store.xRayErrorElements.push(data);
    return store;
  });
};
var AddXRayWarningElement = (data) => {
  InspectorStore.update((store) => {
    store.xRayWarningElements.push(data);
    return store;
  });
};
function UpdateMemberData() {
  InspectorStore.update((store) => {
    store.memberData = localStorage.getItem("_ms-mem") ? JSON.parse(localStorage.getItem("_ms-mem")) : {};
    return store;
  });
}
if (typeof window !== "undefined") {
  window.addEventListener("storage", function(event) {
    if (event.key === "_ms-mem") {
      UpdateMemberData();
    }
  });
}
var inspectorItems = [
  {
    "id": "ready-for-checkout",
    "type": "cart",
    "title": "Ready for Checkout",
    "description": "<p>You previously selected a paid plan attribute.</p>",
    "helpItems": [
      {
        "title": "Checkout with multiple plans.",
        "description": '<p>It is not possible to purchase multiple plans/products at same time. </p><p>Please see our <a href="https://docs.memberstack.com/hc/en-us/community/posts/11223550134043--Wishlist-Enable-quantities-during-checkout" target="_blank" class="link">roadmap</a> for updates. </p>'
      },
      {
        "title": "Launch the checkout process.",
        "description": "<p>This attribute will only launch the checkout process for logged-in members. </p><p> The checkout will launch automatically after you create an account or log in. </p>"
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7403200877211-Paid-Plans"
  },
  {
    "id": "ready-for-signup",
    "type": "cart",
    "title": "Ready for Signup",
    "description": "<p>You previously selected a free plan. </p>",
    "helpItems": [
      {
        "title": "Launch a signup modal.",
        "description": `<p>You're almost there! You need to add the <strong>data-ms-modal="signup" </strong>attribute to your button. </p>`
      },
      {
        "title": "Redirect to my signup page.",
        "description": `<p>You need to manually set the link to your signup page (just like any other link on your site).</p><img loading="lazy" src="https://assets-global.website-files.com/65a6d87f7ae30844cde0911b/65a943f5672ffd06c81856ee_Screenshot%202024-01-18%20at%2010.29.49%E2%80%AFAM.png" alt="" class="image"><p>If you don't have a signup page yet, please create one and then add a <a href="https://www.memberstack.com/webflow-components/signup" target="_blank" class="link">sign up component</a>. </p>`
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/12511667983899"
  },
  {
    "id": "price-add",
    "type": "found",
    "dataAttribute": "data-ms-price:add",
    "title": "Price Add",
    "description": "<p>The <strong>data-ms-price:add</strong> data attribute will add a paid plan, and will not effect existing subscriptions or purchases. </p>",
    "helpItems": [
      {
        "title": "Launch a signup modal.",
        "description": `<p>You're almost there! You need to add the <strong>data-ms-modal="signup" </strong>attribute to your button. </p>`
      },
      {
        "title": "Redirect to my signup page.",
        "description": `<p>You need to manually set the link to your signup page (just like any other link on your site).</p><img loading="lazy" src="https://assets-global.website-files.com/65a6d87f7ae30844cde0911b/65a943f5672ffd06c81856ee_Screenshot%202024-01-18%20at%2010.29.49%E2%80%AFAM.png" alt="" class="image"><p>If you don't have a signup page yet, please create one and then add a <a href="https://www.memberstack.com/webflow-components/signup" target="_blank" class="link">sign up component</a>. </p>`
      },
      {
        "title": "Launch the checkout process.",
        "description": "<p>This attribute will only launch the checkout process for logged-in members. </p><p> The checkout will launch automatically after you create an account or log in. </p>"
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7403200877211-Paid-Plans"
  },
  {
    "id": "price-update",
    "type": "found",
    "dataAttribute": "data-ms-price:update",
    "title": "Price Update",
    "description": "<p>The <span><strong>data-ms-price:update</strong></span> data attribute will add a paid plan for new members and replace paid plans for existing members. </p>",
    "helpItems": [
      {
        "title": "Launch the checkout process.",
        "description": "<p>This attribute will only launch the checkout process for logged-in members. </p><p> The checkout will launch automatically after you create an account or log in. </p>"
      },
      {
        "title": "Redirect to my signup page.",
        "description": `<p>You need to manually set the link to your signup page (just like any other link on your site).</p><img loading="lazy" src="https://assets-global.website-files.com/65a6d87f7ae30844cde0911b/65a943f5672ffd06c81856ee_Screenshot%202024-01-18%20at%2010.29.49%E2%80%AFAM.png" alt="" class="image"><p>If you don't have a signup page yet, please create one and then add a <a href="https://www.memberstack.com/webflow-components/signup" target="_blank" class="link">sign up component</a>. </p>`
      },
      {
        "title": "Launch a signup modal.",
        "description": `<p>You're almost there! You need to add the <strong>data-ms-modal="signup" </strong>attribute to your button. </p>`
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7403200877211-Paid-Plans"
  },
  {
    "id": "price-remove-all",
    "type": "found",
    "dataAttribute": "data-ms-price:remove='all'",
    "title": "Price Remove All",
    "description": `<p>The <strong>data-ms-price:remove="all"</strong> is used to clear out the session storage. When a user goes back and forth looking at prices they get added to the browser's session storage. <br></p><p>This enables a very basic cart feature. Using this data attribute would \u201Cclear the cart\u201D.</p>`,
    "helpItems": [
      {
        "title": "Remove past free plans.",
        "description": `<p>This attribute can only remove paid plans. </p><p>You'll need to use <strong>data-ms-plan:remove="plan-id" </strong>to remove individual free plans. And <a href="https://docs.memberstack.com/hc/en-us/articles/14084137149339-Plan-Logic" target="_blank" class="link">Plan Logic</a> to remove multiple.</p>`
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7403200877211-Sites-with-Paid-Plans#h_01HBBXT8J8559GAW67SK72JAM1"
  },
  {
    "id": "plan-add",
    "type": "found",
    "dataAttribute": "data-ms-plan:add",
    "title": "Plan Add",
    "description": "<p>The <strong>data-ms-plan:add</strong> data attribute will add a free plan.</p>",
    "helpItems": [
      {
        "title": "Launch a signup modal.",
        "description": `<p>You're almost there! You need to add the <strong>data-ms-modal="signup" </strong>attribute to your button. </p>`
      },
      {
        "title": "Redirect to my signup page.",
        "description": `<p>You need to manually set the link to your signup page (just like any other link on your site).</p><img loading="lazy" src="https://assets-global.website-files.com/65a6d87f7ae30844cde0911b/65a943f5672ffd06c81856ee_Screenshot%202024-01-18%20at%2010.29.49%E2%80%AFAM.png" alt="" class="image"><p>If you don't have a signup page yet, please create one and then add a <a href="https://www.memberstack.com/webflow-components/signup" target="_blank" class="link">sign up component</a>. </p>`
      },
      {
        "title": "Remove past free plans.",
        "description": `<p>This attribute can only remove paid plans. </p><p>You'll need to use <strong>data-ms-plan:remove="plan-id" </strong>to remove individual free plans. And <a href="https://docs.memberstack.com/hc/en-us/articles/14084137149339-Plan-Logic" target="_blank" class="link">Plan Logic</a> to remove multiple.</p>`
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/12511667983899"
  },
  {
    "id": "plan-update",
    "type": "found",
    "dataAttribute": "data-ms-plan:update",
    "title": "Plan Update",
    "description": "<p>The <strong>data-ms-plan:update</strong> data attribute will add a free plan for new members and replace free plans for existing members. </p>",
    "helpItems": [
      {
        "title": "Launch a signup modal.",
        "description": `<p>You're almost there! You need to add the <strong>data-ms-modal="signup" </strong>attribute to your button. </p>`
      },
      {
        "title": "Redirect to my signup page.",
        "description": `<p>You need to manually set the link to your signup page (just like any other link on your site).</p><img loading="lazy" src="https://assets-global.website-files.com/65a6d87f7ae30844cde0911b/65a943f5672ffd06c81856ee_Screenshot%202024-01-18%20at%2010.29.49%E2%80%AFAM.png" alt="" class="image"><p>If you don't have a signup page yet, please create one and then add a <a href="https://www.memberstack.com/webflow-components/signup" target="_blank" class="link">sign up component</a>. </p>`
      },
      {
        "title": "Remove past free plans.",
        "description": `<p>This attribute can only remove paid plans. </p><p>You'll need to use <strong>data-ms-plan:remove="plan-id" </strong>to remove individual free plans. And <a href="https://docs.memberstack.com/hc/en-us/articles/14084137149339-Plan-Logic" target="_blank" class="link">Plan Logic</a> to remove multiple.</p>`
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/12511667983899"
  },
  {
    "id": "plan-remove",
    "type": "found",
    "dataAttribute": "data-ms-plan:remove",
    "title": "Plan Remove",
    "description": "<p>The <strong>data-ms-plan:remove</strong> data attribute will remove a free plan.</p>",
    "helpItems": [
      {
        "title": "Remove paid plans.",
        "description": `<p>This attribute can only remove free plans. </p><p>You'll need to use <strong>data-ms-price:remove="all" </strong>to remove previously selected paid plans.</p><p>You can automatically remove past one-time purchases using a feature called <a href="https://docs.memberstack.com/hc/en-us/articles/7785629397659-Create-a-Login-Form-in-Webflow" target="_blank" class="link">Plan Logic</a>.</p>`
      },
      {
        "title": "Remove multiple free plans.",
        "description": '<p>This attribute can only remove one free plan at a time.</p><p>However, you can automatically remove multiple free plans using a feature called <a href="https://docs.memberstack.com/hc/en-us/articles/7785629397659-Create-a-Login-Form-in-Webflow" target="_blank" class="link">Plan Logic</a>.</p>'
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/19394955714459-Managing-Member-Plans-with-Data-Attributes"
  },
  {
    "id": "signup-form",
    "type": "found",
    "dataAttribute": "data-ms-form='signup'",
    "title": "Signup Form",
    "description": "<p>We found a signup form!<br></p><p>New visitors can use this form to create an account. &nbsp;</p>",
    "helpItems": [
      {
        "title": "Change redirect.",
        "description": '<p>You can set redirects in a few different ways.</p><p>We recommend setting your global <a href="https://docs.memberstack.com/hc/en-us/articles/7384608370715-Default-Redirects-Plan-Redirects-Signup-Login-Logout" target="_blank" class="link">Default Redirects</a> first, and then setting your <a href="https://docs.memberstack.com/hc/en-us/articles/7384608370715-Default-Redirects-Plan-Redirects-Signup-Login-Logout#plans" target="_blank" class="link">Plan Level Redirects</a> after that.</p><p>You can also set the redirect directly on a form. However this is the least flexible option. </p>'
      },
      {
        "title": "Social auth doesn't work.",
        "description": `<p>You'll need to create your own developer account with each social auth provider. <br></p><p>Please see the <a href="https://docs.memberstack.com/hc/en-us/sections/9188390078491-Social-Authentication-SSO" target="_blank" class="link">help center for more.</a></p>`
      },
      {
        "title": "Launch checkout after signup.",
        "description": '<p>You can launch the checkout after signup by adding a <a href="https://docs.memberstack.com/hc/en-us/articles/7384849448091-Getting-Started-with-Plans-Prices" target="_blank" class="link">price attribute</a> to the signup &lt;form&gt;, to a button on this page, or &nbsp;to a button on a previous page. </p>'
      },
      {
        "title": "Form doesn't submit to Webflow.",
        "description": '<p>Memberstack does not send member-info to Webflow. </p><p>However, you can create your own form notifications using the "New Member" event in &nbsp;<a href="https://docs.memberstack.com/hc/en-us/articles/7252991415323-Make-com-Integration" target="_blank" class="link">Make</a> or <a href="https://docs.memberstack.com/hc/en-us/articles/7252886662299-Zapier-Integration" target="_blank" class="link">Zapier.</a></p>'
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7424129003547-Create-a-Signup-Form-in-Webflow"
  },
  {
    "id": "login-form",
    "type": "found",
    "dataAttribute": "data-ms-form='login'",
    "title": "Login Form",
    "description": "<p>We found a login form.</p><p>Returning members can use this form to log into access their account.</p>",
    "helpItems": [
      {
        "title": "Change redirect.",
        "description": '<p>You can set redirects in a few different ways.</p><p>We recommend setting your global <a href="https://docs.memberstack.com/hc/en-us/articles/7384608370715-Default-Redirects-Plan-Redirects-Signup-Login-Logout" target="_blank" class="link">Default Redirects</a> first, and then setting your <a href="https://docs.memberstack.com/hc/en-us/articles/7384608370715-Default-Redirects-Plan-Redirects-Signup-Login-Logout#plans" target="_blank" class="link">Plan Level Redirects</a> after that.</p><p>You can also set the redirect directly on a form. However this is the least flexible option. </p>'
      },
      {
        "title": "Social auth doesn't work.",
        "description": `<p>You'll need to create your own developer account with each social auth provider. <br></p><p>Please see the <a href="https://docs.memberstack.com/hc/en-us/sections/9188390078491-Social-Authentication-SSO" target="_blank" class="link">help center for more.</a></p>`
      },
      {
        "title": "Member-specific redirects.",
        "description": '<p>Please see this article to create member-specific pages and redirects. </p><p><a href="https://docs.memberstack.com/hc/en-us/articles/7385311945499" target="_blank" class="link break">https://docs.memberstack.com/hc/en-us/articles/7385311945499</a></p>'
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7785629397659-Create-a-Login-Form-in-Webflow"
  },
  {
    "id": "passwordless-signup",
    "type": "found",
    "dataAttribute": "data-ms-form='passwordless-signup'",
    "title": "Passwordless Signup ",
    "description": '<p>We found a passwordless signup form! </p><p>This is different than a <a href="https://docs.memberstack.com/hc/en-us/articles/7424129003547-Create-a-Signup-Form-in-Webflow" target="_blank" class="link">generic sign up</a> form. Passwordless signup forms have two parts. Part 1 collects the email address. And part 2 asks for a unique code which was emailed to the member. </p>',
    "helpItems": [
      {
        "title": "Change redirect.",
        "description": '<p>You can set redirects in a few different ways.</p><p>We recommend setting your global <a href="https://docs.memberstack.com/hc/en-us/articles/7384608370715-Default-Redirects-Plan-Redirects-Signup-Login-Logout" target="_blank" class="link">Default Redirects</a> first, and then setting your <a href="https://docs.memberstack.com/hc/en-us/articles/7384608370715-Default-Redirects-Plan-Redirects-Signup-Login-Logout#plans" target="_blank" class="link">Plan Level Redirects</a> after that.</p><p>You can also set the redirect directly on a form. However this is the least flexible option. </p>'
      },
      {
        "title": "Social auth doesn't work.",
        "description": `<p>You'll need to create your own developer account with each social auth provider. <br></p><p>Please see the <a href="https://docs.memberstack.com/hc/en-us/sections/9188390078491-Social-Authentication-SSO" target="_blank" class="link">help center for more.</a></p>`
      },
      {
        "title": "Customize/send emails.",
        "description": '<p>You can brand, modify, and translate your emails in the dashboard. </p><p><a href="https://app.memberstack.com/settings/emails" class="link break">https://app.memberstack.com/settings/emails</a></p>'
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us"
  },
  {
    "id": "passwordless-login",
    "type": "found",
    "dataAttribute": "data-ms-form='passwordless-login'",
    "title": "Passwordless Login ",
    "description": '<p>We found a passwordless signup form! </p><p>This is different than a <a href="https://docs.memberstack.com/hc/en-us/articles/7785629397659-Create-a-Login-Form-in-Webflow" target="_blank" class="link">generic login</a> form. Passwordless signup forms have two parts. Part 1 collects the email address. And part 2 asks for a unique code which was emailed to the member. </p>',
    "helpItems": [
      {
        "title": "Change redirect.",
        "description": '<p>You can set redirects in a few different ways.</p><p>We recommend setting your global <a href="https://docs.memberstack.com/hc/en-us/articles/7384608370715-Default-Redirects-Plan-Redirects-Signup-Login-Logout" target="_blank" class="link">Default Redirects</a> first, and then setting your <a href="https://docs.memberstack.com/hc/en-us/articles/7384608370715-Default-Redirects-Plan-Redirects-Signup-Login-Logout#plans" target="_blank" class="link">Plan Level Redirects</a> after that.</p><p>You can also set the redirect directly on a form. However this is the least flexible option. </p>'
      },
      {
        "title": "Social auth doesn't work.",
        "description": `<p>You'll need to create your own developer account with each social auth provider. <br></p><p>Please see the <a href="https://docs.memberstack.com/hc/en-us/sections/9188390078491-Social-Authentication-SSO" target="_blank" class="link">help center for more.</a></p>`
      },
      {
        "title": "Customize/send emails.",
        "description": '<p>You can brand, modify, and translate your emails in the dashboard. </p><p><a href="https://app.memberstack.com/settings/emails" class="link break">https://app.memberstack.com/settings/emails</a></p>'
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us"
  },
  {
    "id": "forgot-password-form",
    "type": "found",
    "dataAttribute": "data-ms-form='forgot-password'",
    "title": "Forgot Password Form",
    "description": "<p>We found a forgot password form!</p><p>This type of form is for logged out members to regain access to their account. It is the first of three forms. </p>",
    "helpItems": [
      {
        "title": "Change redirect",
        "description": `<p>You'll need to manually set the redirect for each password form in Webflow.</p><p>Select the &lt;form&gt; element and add the URL or slug for the reset password page. </p><img src="https://assets-global.website-files.com/65a6d87f7ae30844cde0911b/65b8471ba385a8f671a0d4c2_Screenshot%202024-01-30%20at%209.47.17%E2%80%AFAM.png" loading="lazy" alt="" class="image">`
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7787009388315-Create-a-Forgot-Password-Form-for-logged-out-users-"
  },
  {
    "id": "reset-password-form",
    "type": "found",
    "dataAttribute": "data-ms-form='reset-password'",
    "title": "Reset Password Form",
    "description": '<p>We found a reset password form!</p><p>This form comes after a <a href="https://docs.memberstack.com/hc/en-us/articles/7787009388315-Create-a-Forgot-Password-Form-for-logged-out-users-" target="_blank" class="link">forgot password form</a>. It allows members with a confirmation code to change their password without logging in. </p>',
    "helpItems": [
      {
        "title": "Change redirect",
        "description": `<p>You'll need to manually set the redirect for each password form in Webflow.</p><p>Select the &lt;form&gt; element and add the URL or slug for the reset password page. </p><img src="https://assets-global.website-files.com/65a6d87f7ae30844cde0911b/65b8471ba385a8f671a0d4c2_Screenshot%202024-01-30%20at%209.47.17%E2%80%AFAM.png" loading="lazy" alt="" class="image">`
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7787009388315-Create-a-Forgot-Password-Form-for-logged-out-users-"
  },
  {
    "id": "profile-form",
    "type": "found",
    "dataAttribute": "data-ms-form='profile'",
    "title": "Profile Form",
    "description": "<p>We found a profile form!</p><p>Members can use this form to update their &nbsp;custom fields, email, and password. </p>",
    "helpItems": [
      {
        "title": "Redirect on submission.",
        "description": '<p>You can turn any profile form into an onboarding form by adding a redirect url/slug under form settings. </p><img loading="lazy" src="https://assets-global.website-files.com/65a6d87f7ae30844cde0911b/65b847dea88067f906491a12_Screenshot%202024-01-30%20at%209.50.35%E2%80%AFAM.png" alt="" class="image"><p>You can learn more in our help center article on <a href="https://docs.memberstack.com/hc/en-us/articles/7789449570587-Create-a-Multi-step-Onboarding-Form-in-Webflow" target="_blank" class="link">onboarding forms.</a></p>'
      },
      {
        "title": "Display plan info.",
        "description": '<p>Memberstack relies on Stripe\u2019s hosted Billing Portal to allow members to securely manage paid plans, subscriptions, purchases, payment information, etc.</p><p>Create a button and add the <strong>data-ms-action="customer-portal"</strong> attribute.</p><p>Learn more in the <a href="https://docs.memberstack.com/hc/en-us/articles/7782712032539-Stripe-Customer-Portal" target="_blank" class="link">help center. </a></p>'
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7785751124379-Create-Profile-Forms-in-Webflow"
  },
  {
    "id": "password-form",
    "type": "found",
    "dataAttribute": "data-ms-form='password'",
    "title": "Password Form",
    "description": '<p>We found a password form! </p><p>This is a dedicated "change password" UI for logged in members. </p>',
    "helpItems": [],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7785751124379-Create-Profile-Forms-in-Webflow"
  },
  {
    "id": "email-form",
    "type": "found",
    "dataAttribute": "data-ms-form='email'",
    "title": "Email Form",
    "description": '<p>We found an update email form! </p><p>This is a dedicated "change password" UI for logged in members. &nbsp;</p>',
    "helpItems": [],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7785751124379-Create-Profile-Forms-in-Webflow"
  },
  {
    "id": "commenting-channel",
    "type": "found",
    "dataAttribute": "data-ms-channel",
    "title": "Commenting Channel",
    "description": "<p>We found a commenting channel! <br></p><p>A: This channel does not have an ID&nbsp;set, and is therefor using the page slug for a unique identifier.</p><p>B: This channel has an ID&nbsp;of <strong>Homepage</strong>. </p>",
    "helpItems": [
      {
        "title": "Comments from other pages.",
        "description": '<p>Comments are displayed based on the channel ID. Extra comments could be present because you have a duplicate <a href="https://docs.memberstack.com/hc/en-us/articles/18966275380123-Webflow-Commenting#h_01HBE08ZHZ7ZXG70K00KFC77EH" target="_blank" class="link">channel ID</a> set. </p><p>You can remove the channel ID to associate comments with the current URL. </p>'
      },
      {
        "title": "All comments are missing.",
        "description": `<p>Comments are displayed based on the channel ID. Your comments could be missing because you have the wrong <a href="https://docs.memberstack.com/hc/en-us/articles/18966275380123-Webflow-Commenting#h_01HBE08ZHZ7ZXG70K00KFC77EH" target="_blank" class="link">channel ID</a> set. <br></p><p>If you recently changed from <a href="https://docs.memberstack.com/hc/en-us/articles/7595262385819-Managing-Test-Mode-and-Live-Mode" target="_blank" class="link">test mode to live mode</a>, all of your test mode comments are only &nbsp;visible in test mode. You'll need to recreate them in live mode if you need them. </p>`
      },
      {
        "title": "Some comments are missing.",
        "description": `<p>There are a few reasons why this could be happening. <br></p><p>If you recently changed from <a href="https://docs.memberstack.com/hc/en-us/articles/7595262385819-Managing-Test-Mode-and-Live-Mode" target="_blank" class="link">test mode to live mode</a>, all of your test mode comments are only &nbsp;visible in test mode. You'll need to recreate them in live mode if you need them. </p><p>It's also possible that your comments are being hidden for moderation. <a href="https://docs.memberstack.com/hc/en-us/articles/18966275380123-Webflow-Commenting#01HBE4T840HB90WPQEPTJA8RS0" target="_blank" class="link">Learn more here</a>. </p>`
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/18966275380123"
  },
  {
    "id": "logout-link",
    "type": "found",
    "dataAttribute": "data-ms-action='logout'",
    "title": "Logout Link",
    "description": "<p>We found a logout link!</p>",
    "helpItems": [
      {
        "title": "How do I set a page redirect?",
        "description": "<p>There are a few different ways to set &nbsp;redirects in Memberstack.</p><p>Click the documentation button below for the full picture.</p>"
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7389990064283-Create-a-Logout-Link-or-Button-in-Webflow"
  },
  {
    "id": "signup-modal",
    "type": "found",
    "dataAttribute": "data-ms-modal='signup'",
    "title": "Signup Modal",
    "description": "<p>We found an attribute to launch the pre-build signup modal.</p>",
    "helpItems": [
      {
        "title": "Redirect to my signup page.",
        "description": `<p>You need to remove the <strong>data-ms-modal</strong> attribute manually set the link to your signup page (just like any other link on your site).</p><img loading="lazy" src="https://assets-global.website-files.com/65a6d87f7ae30844cde0911b/65a943f5672ffd06c81856ee_Screenshot%202024-01-18%20at%2010.29.49%E2%80%AFAM.png" alt="" class="image"><p>If you don't have a signup page yet, please create one and then add a <a href="https://www.memberstack.com/webflow-components/signup" target="_blank" class="link">sign up component</a>. </p>`
      },
      {
        "title": "How do I set a page redirect?",
        "description": "<p>There are a few different ways to set &nbsp;redirects in Memberstack.</p><p>Click the documentation button below for the full picture.</p>"
      },
      {
        "title": "Change the logo and button color.",
        "description": `<p>You can modify your app's logo and brand color in the dashboard under <a href="https://app.memberstack.com/settings/design" target="_blank" class="link">Design</a>. </p><a href="https://app.memberstack.com/settings/design" target="_blank" class="w-inline-block"><img loading="lazy" src="https://assets-global.website-files.com/65a6d87f7ae30844cde0911b/65c2f096af2b47e160d15a5e_Screenshot%202024-02-07%20at%2011.52.58%E2%80%AFAM.jpg" alt="" class="image"></a><p>If you need more design control you can start &nbsp;from one of our <a href="https://www.memberstack.com/webflow-components" target="_blank" class="link">hundreds of free Webflow UI</a>.</p>`
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/12971481752091"
  },
  {
    "id": "login-modal",
    "type": "found",
    "dataAttribute": "data-ms-modal='login'",
    "title": "Login Modal",
    "description": "<p>We found an attribute to launch the pre-build login modal.</p>",
    "helpItems": [
      {
        "title": "Redirect to my login page.",
        "description": `<p>You need to remove the <strong>data-ms-modal</strong> attribute manually set the link to your login page (just like any other link on your site).</p><img loading="lazy" src="https://assets-global.website-files.com/65a6d87f7ae30844cde0911b/65c2ee6faf2b47e160cffef1_Screenshot%202024-02-07%20at%2011.43.38%E2%80%AFAM.jpg" alt="" class="image"><p>If you don't have a login page yet, please create one and then add a <a href="https://www.memberstack.com/webflow-components/login" target="_blank" class="link">sign up component</a>. </p>`
      },
      {
        "title": "Change the logo and button color.",
        "description": `<p>You can modify your app's logo and brand color in the dashboard under <a href="https://app.memberstack.com/settings/design" target="_blank" class="link">Design</a>. </p><a href="https://app.memberstack.com/settings/design" target="_blank" class="w-inline-block"><img loading="lazy" src="https://assets-global.website-files.com/65a6d87f7ae30844cde0911b/65c2f096af2b47e160d15a5e_Screenshot%202024-02-07%20at%2011.52.58%E2%80%AFAM.jpg" alt="" class="image"></a><p>If you need more design control you can start &nbsp;from one of our <a href="https://www.memberstack.com/webflow-components" target="_blank" class="link">hundreds of free Webflow UI</a>.</p>`
      },
      {
        "title": "How do I set a page redirect?",
        "description": "<p>There are a few different ways to set &nbsp;redirects in Memberstack.</p><p>Click the documentation button below for the full picture.</p>"
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/12971481752091"
  },
  {
    "id": "profile-modal",
    "type": "found",
    "dataAttribute": "data-ms-modal='profile'",
    "title": "Profile Modal",
    "description": "<p>We found an attribute to launch the pre-build profile modal.</p>",
    "helpItems": [
      {
        "title": "Change the logo and button color.",
        "description": `<p>You can modify your app's logo and brand color in the dashboard under <a href="https://app.memberstack.com/settings/design" target="_blank" class="link">Design</a>. </p><a href="https://app.memberstack.com/settings/design" target="_blank" class="w-inline-block"><img loading="lazy" src="https://assets-global.website-files.com/65a6d87f7ae30844cde0911b/65c2f096af2b47e160d15a5e_Screenshot%202024-02-07%20at%2011.52.58%E2%80%AFAM.jpg" alt="" class="image"></a><p>If you need more design control you can start &nbsp;from one of our <a href="https://www.memberstack.com/webflow-components" target="_blank" class="link">hundreds of free Webflow UI</a>.</p>`
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/12971481752091"
  },
  {
    "id": "forgot-password-modal",
    "type": "found",
    "dataAttribute": "data-ms-modal='forgot-password'",
    "title": "Forgot Password Modal",
    "description": "<p>We found an attribute to launch the pre-build forgot password modal. This UI gives logged-out members an opportunity to reset their password via email.</p>",
    "helpItems": [
      {
        "title": "Change the logo and button color.",
        "description": `<p>You can modify your app's logo and brand color in the dashboard under <a href="https://app.memberstack.com/settings/design" target="_blank" class="link">Design</a>. </p><a href="https://app.memberstack.com/settings/design" target="_blank" class="w-inline-block"><img loading="lazy" src="https://assets-global.website-files.com/65a6d87f7ae30844cde0911b/65c2f096af2b47e160d15a5e_Screenshot%202024-02-07%20at%2011.52.58%E2%80%AFAM.jpg" alt="" class="image"></a><p>If you need more design control you can start &nbsp;from one of our <a href="https://www.memberstack.com/webflow-components" target="_blank" class="link">hundreds of free Webflow UI</a>.</p>`
      },
      {
        "title": "Customize/send emails.",
        "description": '<p>You can brand, modify, and translate your emails in the dashboard. </p><p><a href="https://app.memberstack.com/settings/emails" class="link break">https://app.memberstack.com/settings/emails</a></p>'
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/12971481752091"
  },
  {
    "id": "stripe-customer-portal",
    "type": "found",
    "dataAttribute": "data-ms-action='customer-portal'",
    "title": "Stripe Customer Portal",
    "description": "<p>We found an attribute to launch the Stripe Customer Portal.<br></p><p>Memberstack relies on Stripe\u2019s hosted Billing Portal to enable members to securely manage paid plans, subscriptions, purchases, payment information, etc.</p>",
    "helpItems": [
      {
        "title": "Change branding/design.",
        "description": '<p>Stripe gives you an opportunity to add a splash of branding to its already beautiful UI. </p><p><a href="https://docs.memberstack.com/hc/en-us/articles/13074541430427-Stripe-Checkout-Branding-Design" target="_blank" class="link">Visit the help center &nbsp;for next steps. </a></p>'
      },
      {
        "title": "Show/hide a feature in Stripe.",
        "description": '<p>Memberstack decides what features are enabled by default, but you can change this in your Stripe settings. </p><p><a href="https://docs.memberstack.com/hc/en-us/articles/19863375803163-How-to-Customize-Your-Stripe-Hosted-Portal" target="_blank" class="link">Visit the help center &nbsp;for next steps. </a></p>'
      },
      {
        "title": "White-label the \xA0Stripe domain.",
        "description": `<p>You can change this in your Stripe settings. <br></p><p><a href="https://stripe.com/docs/payments/checkout/custom-domains" target="_blank" class="link">Visit Stripe's help center &nbsp;for next steps. </a></p>`
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7782712032539-Stripe-Customer-Portal"
  },
  {
    "id": "resend-verification-email",
    "type": "found",
    "dataAttribute": "data-ms-action='resend-verification-email'",
    "title": "Resend Verification Email",
    "description": "<p>We found an attribute to resend verification emails. <br></p><p>Memberstack automatically sends a verification message, but members can request a new email just incase. </p>",
    "helpItems": [
      {
        "title": "Customize/send emails.",
        "description": '<p>You can brand, modify, and translate your emails in the dashboard. </p><p><a href="https://app.memberstack.com/settings/emails" class="link break">https://app.memberstack.com/settings/emails</a></p>'
      },
      {
        "title": 'Change Email "From" Address.',
        "description": `<p>Memberstack's password reset emails and email verification emails come from a generic <strong>no-reply@memberstack.io</strong> email address.</p><p>We can &nbsp;change the "from" email for you.<a href="https://docs.memberstack.com/hc/en-us/articles/11193994555547-Change-the-From-Email-Address" target="_blank" class="link"> Learn more here</a>.</p>`
      },
      {
        "title": "Not getting emails.",
        "description": '<p>Emails usually arrive in a few seconds. Slow delivery times could be caused by slow internet, increased demand, or the emails are going to spam. <br></p><p>Please <a href="https://docs.memberstack.com/hc/en-us/requests/new" target="_blank" class="link">contact support</a> if emails are taking longer than 30 seconds to arrive. &nbsp;</p>'
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/8437630733083-Email-Verification"
  },
  {
    "id": "login-redirect",
    "type": "found",
    "dataAttribute": "data-ms-action='login-redirect'",
    "title": "Login Redirect",
    "description": '<p>We found a button that will dynamically redirect the user based on their <a href="https://docs.memberstack.com/hc/en-us/articles/7384608370715" target="_blank" class="link">login redirect</a>.</p><p>The button is only visible if a member is logged in.</p>',
    "helpItems": [],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/9780287236507-Login-Redirect-Buttons"
  },
  {
    "id": "upload-profile-image",
    "type": "found",
    "dataAttribute": "data-ms-action='profile-image'",
    "title": "Profile Image",
    "description": '<p>We found an attribute for uploading profile images. </p><p>The image is saved automatically on upload. Use <strong>data-ms-member= "profile-image"</strong> to display image. </p>',
    "helpItems": [
      {
        "title": "My form is breaking.",
        "description": "<p>Profile image update buttons are not allowed inside forms. &nbsp;Please remove the attribute or place it outside of the form.</p>"
      },
      {
        "title": "Images are not being displayed.",
        "description": '<p>This feature only works with the <strong><code>&lt;image&gt;</code></strong> element. It does not support CSS background images. <br></p><p>Make sure your image element has the attribute of <strong>data-ms-member= "profile-image"</strong>.</p>'
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/15973891080731-Profile-Images"
  },
  {
    "id": "member-data",
    "type": "found",
    "dataAttribute": "data-ms-member",
    "title": "Member Data",
    "description": "<p>This element will display a member's data or fallback to the placeholder text. </p><p>This data is only visible to the member. </p>",
    "helpItems": [
      {
        "title": "Change placeholder value.",
        "description": "<p>Memberstack will fallback to whatever value is set in Webflow.</p>"
      },
      {
        "title": "Display data publically.",
        "description": `<p>It is only possible to display a member's data publicly if it is... <br>A) Stored in a separate database like the Webflow CMS (<a href="https://www.memberstack.com/webflow-templates/public-member-profiles" target="_blank" class="link">view example</a>). <br>B)&nbsp;Is associated with a comment created by that member (<a href="https://youtu.be/4uvRtQ2d2UM" target="_blank" class="link">view example</a>).</p>`
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7389966150939-Member-Data-Attributes-in-Webflow"
  },
  {
    "id": "facebook-login",
    "type": "found",
    "dataAttribute": "data-ms-auth-provider='facebook'",
    "title": "Facebook Login",
    "description": "<p>Members can use this button to login with Facebook. </p>",
    "helpItems": [
      {
        "title": "Blank page / error message",
        "description": "<p>You'll need to create your own developer account with each social auth provider.<br><br>Click the documentation link below.</p>"
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/9116286679195-Facebook-Authentication"
  },
  {
    "id": "google-login",
    "type": "found",
    "dataAttribute": "data-ms-auth-provider='google'",
    "title": "Google Login",
    "description": "<p>Members can use this button to login with Google. </p>",
    "helpItems": [
      {
        "title": "Blank page / error message",
        "description": "<p>You'll need to create your own developer account with each social auth provider.<br><br>Click the documentation link below.</p>"
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/8327236548379-Google-Authentication"
  },
  {
    "id": "linkedin-login",
    "type": "found",
    "dataAttribute": "data-ms-auth-provider='linkedin'",
    "title": "LinkedIn Login",
    "description": "<p>Members can use this button to login with LinkedIn. </p>",
    "helpItems": [
      {
        "title": "Blank page / error message",
        "description": "<p>You'll need to create your own developer account with each social auth provider.<br><br>Click the documentation link below.</p>"
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/9128407335835-LinkedIn-Authentication"
  },
  {
    "id": "spotify-login",
    "type": "found",
    "dataAttribute": "data-ms-auth-provider='spotify'",
    "title": "Spotify Login",
    "description": "<p>Members can use this button to login with Spotify. </p>",
    "helpItems": [
      {
        "title": "Blank page / error message",
        "description": "<p>You'll need to create your own developer account with each social auth provider.<br><br>Click the documentation link below.</p>"
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/9151679451803-Spotify-Authentication"
  },
  {
    "id": "dribbble-login",
    "type": "found",
    "dataAttribute": "data-ms-auth-provider='dribbble'",
    "title": "Dribbble Login",
    "description": "<p>Members can use this button to login with Dribbble. </p>",
    "helpItems": [
      {
        "title": "Blank page / error message",
        "description": "<p>You'll need to create your own developer account with each social auth provider.<br><br>Click the documentation link below.</p>"
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/9151726845339-Dribbble-Authentication"
  },
  {
    "id": "github-login",
    "type": "found",
    "dataAttribute": "data-ms-auth-provider='github'",
    "title": "Github Login",
    "description": "<p>Members can use this button to login with Github. </p>",
    "helpItems": [
      {
        "title": "Blank page / error message",
        "description": "<p>You'll need to create your own developer account with each social auth provider.<br><br>Click the documentation link below.</p>"
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/9151629563291-GitHub-Authentication"
  },
  {
    "id": "gated-content",
    "type": "found",
    "dataAttribute": "data-ms-content",
    "title": "Gated Content",
    "description": "<p>These attributes will change the display state of &nbsp;an element based on the users permissions.</p><p><strong>Needs permission \u2192</strong> Element is hidden and removed. </p><p><strong>Has permission \u2192 </strong>the element is left as-is. &nbsp;</p>",
    "helpItems": [
      {
        "title": "Hide element in Webflow.",
        "description": '<p>First hide the element in Webflow. </p><p>Then, add &nbsp;the attribute <strong>data-ms-bind:style="YOUR_VALUE"</strong> to change the styling of an element. Use the value <strong>display:block</strong> to set it to display block when visible. </p><p><a href="https://docs.memberstack.com/hc/en-us/articles/16015762458011" target="_blank" class="link">Visit the help center &nbsp;for more info. </a></p>'
      },
      {
        "title": "Set to display:block to page load.",
        "description": '<p>First hide the element in Webflow. </p><p>Then, add &nbsp;the attribute <strong>data-ms-bind:style="YOUR_VALUE"</strong> to change the styling of an element. Use the value <strong>display:block</strong> to set it to display block when visible. </p><p><a href="https://docs.memberstack.com/hc/en-us/articles/16015762458011" target="_blank" class="link">Visit the help center &nbsp;for more info. </a></p>'
      },
      {
        "title": "Extra security.",
        "description": '<p>You can host HTML content and links inside of Memberstack for extra security.</p><p><a href="https://docs.memberstack.com/hc/en-us/articles/15074205669403-Hosted-Content" target="_blank" class="link">Visit the help center &nbsp;for more info. </a></p>'
      },
      {
        "title": "Invert functionality.",
        "description": '<p>You can invert the display state of an element by adding an exclamation mark. </p><p>For example data-ms-member="<strong>members</strong>" is content that is only accessible to members. &nbsp;If we change it to data-ms-member="<strong>!members</strong>" now that content &nbsp;is NOT available to members. </p>'
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7403036765339-Show-and-Hide-Individual-Elements-data-ms-content"
  },
  {
    "id": "post-creator-data",
    "type": "found",
    "dataAttribute": "data-ms-post-creator",
    "title": "Post Creator Data",
    "description": "<p>This element will display the commenter's information. </p><p>This information will update automatically if the member updates their profile. </p>",
    "helpItems": [
      {
        "title": "Change placeholder value.",
        "description": "<p>Memberstack will fallback to whatever value is set in Webflow.</p>"
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/18966275380123"
  },
  {
    "id": "thread-creator-data",
    "type": "found",
    "dataAttribute": "data-ms-thread-creator",
    "title": "Thread Creator Data",
    "description": "<p>This element will display the commenter's information. </p><p>This information will update automatically if the member updates their profile. </p>",
    "helpItems": [
      {
        "title": "Change placeholder value.",
        "description": "<p>Memberstack will fallback to whatever value is set in Webflow.</p>"
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/18966275380123"
  },
  {
    "id": "broken-plan-suffix",
    "type": "error",
    "title": "Broken Plan Suffix",
    "description": "<p>We found a <strong>data-ms-plan</strong> data attribute without a ':add', ':update' or ':remove' suffix</p>",
    "helpItems": [],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7406222866459"
  },
  {
    "id": "broken-price-suffix",
    "type": "error",
    "title": "Broken Price Suffix",
    "description": "<p>We found a <strong>data-ms-price</strong> data attribute without a ':add', ':update' or ':remove' suffix</p>",
    "helpItems": [],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7406222866459"
  },
  {
    "id": "broken-plan-button",
    "type": "error",
    "title": "Broken Plan Button",
    "description": "<p>We found a <strong>data-ms-plan</strong> data attribute without a free plan ID.</p>",
    "helpItems": [
      {
        "title": "Create a paid plan button.",
        "description": "<p>You'll need to swap your <span>data-ms-<strong>plan</strong></span> attribute with a <span>data-ms-<strong>price</strong></span> attribute. </p>"
      },
      {
        "title": "Create a free plan button.",
        "description": `<p>You'll need to locate your plan id and add it to the data-ms-plan attribute. </p><p>Please refer to <a href="https://docs.memberstack.com/hc/en-us/articles/17265502821275" target="_blank" class="link">this doc</a> for more info.</p>`
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/17265502821275"
  },
  {
    "id": "broken-price-button",
    "type": "error",
    "title": "Broken Price Button",
    "description": "<p>We found a <strong>data-ms-price</strong> data attribute that is not using the right value.</p>",
    "helpItems": [
      {
        "title": "Create a paid plan button.",
        "description": `<p>You'll need to swap your <strong>Plan ID</strong> for a more specific <strong>Price ID</strong>. </p><p>Please refer to <a href="https://docs.memberstack.com/hc/en-us/articles/7403200877211-Paid-Plans" target="_blank" class="link">this doc</a> for more info.</p>`
      },
      {
        "title": "Create a free plan button.",
        "description": `<p>You'll need to replace your <strong>data-ms-price</strong> attribute with a <strong>data-ms-plan</strong> attribute.</p><p>Please refer to <a href="https://docs.memberstack.com/hc/en-us/articles/17265502821275" target="_blank" class="link">this doc</a> for more info. </p>`
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/17265502821275"
  },
  {
    "id": "missing-attribute-value",
    "type": "error",
    "title": "Missing Attribute Value",
    "description": "<p>We found a <strong>data-ms-plan</strong> or <strong>data-ms-price</strong> data attribute without a value.</p>",
    "helpItems": [],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7252466484635"
  },
  {
    "id": "image-inside-profile-form",
    "type": "error",
    "title": "Image inside Profile Form",
    "description": "<p>Despite the name, Profile Image upload buttons cannot go inside of a profile form. </p><p>They can go anywhere on the page, except inside of a profile form. </p>",
    "helpItems": [],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/15973891080731-Profile-Images"
  },
  {
    "id": "image-inside-signup-form",
    "type": "error",
    "title": "Image inside Signup Form",
    "description": "<p> It is not possible to collect a profile image during sign up, but you can create an onboarding form that prompt the user to add a profile image <em>after</em> sign up. </p>",
    "helpItems": [],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7789449570587-Create-a-Multi-step-Onboarding-Form-in-Webflow"
  },
  {
    "id": "image-inside-comment-form",
    "type": "error",
    "title": "Image inside Comment Form",
    "description": "<p>Profile image update buttons are not allowed inside forms. &nbsp;Please remove the attribute or place it outside of the form.</p>",
    "helpItems": [],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/15973891080731-Profile-Images"
  },
  {
    "id": "extra-login-elements",
    "type": "error",
    "title": "Extra Login Elements",
    "description": '<p>We found not-allowed custom field attributes inside your login form.</p><p>You probably have <strong>data-ms-form="login"</strong> attribute on your <strong>signup form</strong>. </p>',
    "helpItems": [],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7785629397659-Create-a-Login-Form-in-Webflow"
  },
  {
    "id": "orphan-commenting-ui",
    "type": "error",
    "title": "Orphan Commenting Attributes",
    "description": "<p>We found a <strong>data-ms-thread</strong> or <strong>data-ms-post</strong> attribute outside of a<strong> data-ms-channel</strong> section. </p><p>Please make sure all commenting UI is placed inside of a parent <strong>data-ms-channel </strong>element. &nbsp;</p>",
    "helpItems": [],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/18966275380123"
  },
  {
    "id": "post-in-thread",
    "type": "error",
    "title": "Post Attribute inside a Thread",
    "description": "<p>We found a <strong>data-ms-post</strong> attribute inside of the <strong>thread</strong> section.</p><p>This usually happens if you start to duplicate elements in your design. </p>",
    "helpItems": [],
    "documentationLink": "https://www.loom.com/share/218c58a3babd4c4686184dc12bdbd875"
  },
  {
    "id": "plan-on-social-auth",
    "type": "error",
    "title": "Plan attribute on a social button",
    "description": "<p>We found a <strong>data-ms-plan</strong> or <strong>data-ms-price</strong> attribute on a <strong>data-ms-auth-provider </strong>button. These attributes do not work well together. &nbsp;</p>",
    "helpItems": [],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/sections/9188390078491-Social-Authentication-SSO"
  },
  {
    "id": "private-custom-field",
    "type": "error",
    "title": "Private Custom Fields",
    "description": `<p>We found a <strong>data-ms-post-creator</strong> or a <strong>data-ms-thread-creator</strong> attribute that is private. </p><p>You'll need to update the <strong>custom field settings</strong> to make this data public.<br> <a href="https://docs.memberstack.com/hc/en-us/articles/18966275380123-Webflow-Commenting#public-custom-fields" target="_blank" class="link">Learn how \u2192</a></p>`,
    "helpItems": [],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/18966275380123-Webflow-Commenting#public-custom-fields"
  },
  {
    "id": "misplaced-form-attribute",
    "type": "error",
    "title": "Misplaced Form Attribute",
    "description": '<p>We found a <strong>data-ms-form</strong> data attribute but it is not on a <strong>&lt;form&gt; </strong>element. Please click "documentation" to see how to debug.</p>',
    "helpItems": [],
    "documentationLink": "https://www.loom.com/share/486e0b760845447290c4d7bfd5b100ea"
  },
  {
    "id": "duplicate-install-code",
    "type": "error",
    "title": "Duplicate install code",
    "description": '<p>We found two instances your install code. Please click "documentation" below see how to debug.</p>',
    "helpItems": [],
    "documentationLink": "https://www.loom.com/share/3f3e542458444296841ab9101064693c?sid=cbe21222-4e76-4648-b95d-1574b61c88c2"
  },
  {
    "id": "missing-login-elements",
    "type": "error",
    "title": "Missing Login elements",
    "description": '<p>Your login form is missing one of the following attributes:</p><ul role="list" class="list"><li>data-ms-member="<a href="#">password</a>"</li><li>data-ms-member="<a href="#">email</a>"</li></ul>',
    "helpItems": [
      {
        "title": "Add Social Authentication",
        "description": '<div>You can leave out required data attributes if your form contains social login buttons. &nbsp;<br><br>You can copy <a href="https://www.memberstack.com/webflow-components/auth-button" target="_blank" class="link">components</a> here, and find additional <a href="https://docs.memberstack.com/hc/en-us/sections/9188390078491-Social-Authentication-SSOhttps://docs.memberstack.com/hc/en-us/sections/9188390078491-Social-Authentication-SSO" target="_blank" class="link">documentation</a> here. </div>'
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7785629397659-Create-a-Login-Form-in-Webflow"
  },
  {
    "id": "missing-signup-elements",
    "type": "error",
    "title": "Missing Signup elements",
    "description": '<p>Your signup form is missing one of the following attributes:</p><ul role="list" class="list"><li>data-ms-member="<a href="#">password</a>"</li><li>data-ms-member="<a href="#">email</a>"</li></ul>',
    "helpItems": [
      {
        "title": "Add Social Authentication",
        "description": '<div>You can leave out required data attributes if your form contains social login buttons. &nbsp;<br><br>You can copy <a href="https://www.memberstack.com/webflow-components/auth-button" target="_blank" class="link">components</a> here, and find additional <a href="https://docs.memberstack.com/hc/en-us/sections/9188390078491-Social-Authentication-SSOhttps://docs.memberstack.com/hc/en-us/sections/9188390078491-Social-Authentication-SSO" target="_blank" class="link">documentation</a> here. </div>'
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7424129003547-Create-a-Signup-Form-in-Webflow"
  },
  {
    "id": "missing-redirect",
    "type": "warning",
    "title": "Missing Redirect",
    "description": '<p>Your forgot password form does not have a redirect set. </p><div><a data-documentation="" href="https://docs.memberstack.com/hc/en-us/articles/7787009388315-Create-a-Forgot-Password-Form-for-logged-out-users#h_01HQ9DESYG2B53882YJ20ZQJ6K" target="_blank" class="help-option w-inline-block"><div>Documentation</div><div class="svg w-embed"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path fill="currentColor" d="M280-280q-83 0-141.5-58.5T80-480q0-83 58.5-141.5T280-680h120q17 0 28.5 11.5T440-640q0 17-11.5 28.5T400-600H280q-50 0-85 35t-35 85q0 50 35 85t85 35h120q17 0 28.5 11.5T440-320q0 17-11.5 28.5T400-280H280Zm80-160q-17 0-28.5-11.5T320-480q0-17 11.5-28.5T360-520h240q17 0 28.5 11.5T640-480q0 17-11.5 28.5T600-440H360Zm200 160q-17 0-28.5-11.5T520-320q0-17 11.5-28.5T560-360h120q50 0 85-35t35-85q0-50-35-85t-85-35H560q-17 0-28.5-11.5T520-640q0-17 11.5-28.5T560-680h120q83 0 141.5 58.5T880-480q0 83-58.5 141.5T680-280H560Z"></path></svg></div></a></div>',
    "helpItems": [],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7787009388315-Create-a-Forgot-Password-Form-for-logged-out-users#h_01HQ9DESYG2B53882YJ20ZQJ6K"
  },
  {
    "id": "misplaced-install-code",
    "type": "warning",
    "title": "Misplaced install code",
    "description": '<p>The Memberstack Install script is outside of the &nbsp;<strong>&lt;header&gt;</strong> code section.</p><p>We recommend moving this script to the very top of the <strong>&lt;header&gt;</strong> code section.</p><div><a data-documentation="" href="https://docs.memberstack.com/hc/en-us/articles/7253090768539-Installing-Memberstack-in-Webflow" target="_blank" class="help-option w-inline-block"><div>Documentation</div><div class="svg w-embed"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path fill="currentColor" d="M280-280q-83 0-141.5-58.5T80-480q0-83 58.5-141.5T280-680h120q17 0 28.5 11.5T440-640q0 17-11.5 28.5T400-600H280q-50 0-85 35t-35 85q0 50 35 85t85 35h120q17 0 28.5 11.5T440-320q0 17-11.5 28.5T400-280H280Zm80-160q-17 0-28.5-11.5T320-480q0-17 11.5-28.5T360-520h240q17 0 28.5 11.5T640-480q0 17-11.5 28.5T600-440H360Zm200 160q-17 0-28.5-11.5T520-320q0-17 11.5-28.5T560-360h120q50 0 85-35t35-85q0-50-35-85t-85-35H560q-17 0-28.5-11.5T520-640q0-17 11.5-28.5T560-680h120q83 0 141.5 58.5T880-480q0 83-58.5 141.5T680-280H560Z"></path></svg></div></a></div>',
    "helpItems": [],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/7253090768539-Installing-Memberstack-in-Webflow"
  },
  {
    "id": "plan-without-action",
    "type": "warning",
    "title": "Plan Button without an Action",
    "description": "<p>We found a <strong>data-ms-plan</strong> attribute without a <strong>page link</strong> or <strong>data-ms-modal</strong>.</p><p>You can disregard this warning if that was intentional.</p>",
    "helpItems": [
      {
        "title": "Redirect to my signup page.",
        "description": "<p>You need to manually set the link to your signup page (just like any other link on your site).</p><img loading='lazy' src='https://assets-global.website-files.com/65a6d87f7ae30844cde0911b/65a943f5672ffd06c81856ee_Screenshot%202024-01-18%20at%2010.29.49%E2%80%AFAM.png' alt=''><p>If you don't have a signup page yet, please create one and then add a <a href='https://www.memberstack.com/webflow-components/signup' target='_blank'>sign up component</a>.</p>"
      },
      {
        "title": "Launch a signup modal.",
        "description": "<p>You're almost there! You need to add the <strong>data-ms-modal='signup' </strong>attribute to your button.</p>"
      }
    ],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/19394955714459"
  },
  {
    "id": "price-without-action",
    "type": "warning",
    "title": "Price Button without an Action",
    "description": "<p>We found a <strong>data-ms-price</strong> attribute without a <strong>page link</strong> or <strong>data-ms-modal</strong>.</p><p>You can disregard this warning if that was intentional.</p>",
    "helpItems": [
      {
        "title": "launch the checkout process.",
        "description": "<p>This attribute will only launch the checkout process for logged-in members. </p><p> The checkout will launch automatically after you create an account or log in. </p>"
      },
      {
        "title": "Redirect to my signup page.",
        "description": "<p>You need to manually set the link to your signup page (just like any other link on your site).</p><img loading='lazy' src='https://assets-global.website-files.com/65a6d87f7ae30844cde0911b/65a943f5672ffd06c81856ee_Screenshot%202024-01-18%20at%2010.29.49%E2%80%AFAM.png' alt=''><p>If you don't have a signup page yet, please create one and then add a <a href='https://www.memberstack.com/webflow-components/signup' target='_blank'>sign up component</a>.</p>"
      },
      {
        "title": "Launch a signup modal.",
        "description": "<p>You're almost there! You need to add the <strong>data-ms-modal='signup' </strong>attribute to your button.</p>"
      }
    ]
  },
  {
    "id": "incorrect-plan-id",
    "type": "error",
    "title": "Incorrect Plan ID",
    "description": "<p>This page contains a <b>data-ms-plan='PLAN_ID'</b> that is incorrect or from another project. Replace it with an attribute from your plans page.</p>",
    "helpItems": [],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/23346885800219"
  },
  {
    "id": "incorrect-price-id",
    "type": "error",
    "title": "Incorrect Price ID",
    "description": "<p>This page contains a <b>data-ms-price='PRICE_ID'</b> that is incorrect or from another project. Replace it with an attribute from your prices page.</p>",
    "helpItems": [],
    "documentationLink": "https://docs.memberstack.com/hc/en-us/articles/23346885800219"
  },
  {
    "id": "price-update",
    "type": "found",
    "dataAttribute": "data-ms-price:update",
    "title": "Price Update",
    "description": "<p>You previously selected a paid plan attribute.</p>",
    "helpItems": [],
    "documentationLink": "#"
  }
];
function getAndLogSessionStorageItem(key, inspectorData) {
  const item = sessionStorage.getItem(key);
  if (item) {
    console.log(`%c${key} cart found: ${item}`, "color: green");
    SetCartData(item);
    AddInspectorData(inspectorData);
  }
}
function checkCartSessionStorage() {
  getAndLogSessionStorageItem("ms_plan", "ready-for-signup");
  getAndLogSessionStorageItem("ms_price", "ready-for-checkout");
}
function checkFoundDataAttributes$1() {
  const foundItems = inspectorItems.filter(
    (item) => item.type === "found"
  );
  const checkedAttributes = /* @__PURE__ */ new Set();
  for (const item of foundItems) {
    const attributeKey = item.dataAttribute.includes(":") ? item.dataAttribute.replace(/:/g, "\\:") : item.dataAttribute;
    if (checkedAttributes.has(attributeKey))
      continue;
    checkedAttributes.add(attributeKey);
    const dataAttribute = document.querySelector(`[${attributeKey}]`);
    if (dataAttribute) {
      console.log(`%c${item.id} found`, "color: green");
      AddInspectorData(item.id);
    }
  }
}
function logError(message, inspectorDataKey) {
  console.log(`%c${message}`, "color: red");
  AddInspectorData(inspectorDataKey);
}
function logWarning(message, inspectorDataKey) {
  console.log(`%c${message}`, "color: yellow");
  AddInspectorData(inspectorDataKey);
}
function checkElements(selector, checkFn) {
  const elements = document.querySelectorAll(selector);
  elements.forEach((element2) => checkFn(element2));
}
function checkAttributeForAddOrUpdate(element2, attributeName, inspectorDataKey) {
  const attributeNames = element2.getAttributeNames();
  const validAttribute = attributeNames.find(
    (attrName) => attrName.startsWith(attributeName + ":") && (element2.getAttribute(attrName).startsWith("pln_") || element2.getAttribute(attrName).startsWith("prc_"))
  );
  if (!validAttribute) {
    const errorMessage = `The ${attributeName} attribute's suffix is incorrect (e.g. ${attributeName}:add, ${attributeName}:update, ${attributeName}:remove).`;
    logError(errorMessage, inspectorDataKey);
    addXRayErrorElement(element2, errorMessage);
  }
}
function addXRayErrorElement(element2, message) {
  return __async(this, null, function* () {
    AddXRayErrorElement({ element: element2, message });
  });
}
function checkFormElements(formType) {
  return __async(this, null, function* () {
    const forms = document.querySelectorAll(
      `[data-ms-form='${formType}']`
    );
    forms.forEach((form) => {
      const emailInput = form.querySelector("[data-ms-member='email']");
      const passwordInput = form.querySelector(
        "[data-ms-member='password']"
      );
      const socialAuth = form.querySelector("[data-ms-auth-provider]");
      if (!emailInput || !passwordInput && !socialAuth) {
        logError(
          `Missing ${formType.charAt(0).toUpperCase() + formType.slice(1)} Elements`,
          `missing-${formType}-elements`
        );
        addXRayErrorElement(
          form,
          `Missing ${formType.charAt(0).toUpperCase() + formType.slice(1)} Elements`
        );
      }
    });
  });
}
var checkedForErrors = false;
function checkErrors() {
  return __async(this, null, function* () {
    let appData;
    AppStore.subscribe((data) => {
      if (!data.initialValue && checkedForErrors === false) {
        appData = data;
        checkedForErrors = true;
        runChecks();
      }
    });
    function runChecks() {
      return __async(this, null, function* () {
        checkElements("[data-ms-plan], [data-ms-price]", (element2) => {
          if (element2.hasAttribute("data-ms-plan")) {
            checkAttributeForAddOrUpdate(
              element2,
              "data-ms-plan",
              "broken-plan-suffix"
            );
          }
          if (element2.hasAttribute("data-ms-price")) {
            checkAttributeForAddOrUpdate(
              element2,
              "data-ms-price",
              "broken-price-suffix"
            );
          }
        });
        checkElements(
          "[data-ms-plan\\:update], [data-ms-plan\\:add], [data-ms-plan\\:remove]",
          (element2) => {
            const attributeValue = element2.getAttribute("data-ms-plan:update") || element2.getAttribute("data-ms-plan:add") || element2.getAttribute("data-ms-plan:remove");
            if (!attributeValue) {
              logError("Broken Plan Button Found", "broken-plan-button");
              addXRayErrorElement(element2, "Broken Plan Button Found");
              return;
            }
            if (!attributeValue.startsWith("pln_")) {
              logError("Broken Plan Button Found", "broken-plan-button");
              addXRayErrorElement(element2, "Broken Plan Button Found");
            }
          }
        );
        checkElements(
          "[data-ms-price\\:update], [data-ms-price\\:add], [data-ms-price\\:remove]",
          (element2) => {
            const attributeNames = element2.getAttributeNames();
            attributeNames.forEach((attrName) => {
              if (attrName.startsWith("data-ms-price")) {
                if (attrName.includes(":")) {
                  const suffix = attrName.split(":")[1];
                  if (suffix === "add" || suffix === "update") {
                    if (!element2.getAttribute(attrName).startsWith("prc_")) {
                      logError(
                        "Broken Price Button Found",
                        "broken-price-button"
                      );
                      addXRayErrorElement(
                        element2,
                        "Broken Price Button Found"
                      );
                    }
                  } else if (suffix === "remove") {
                    if (element2.getAttribute(attrName) !== "all") {
                      logError(
                        "Broken Price Button Found",
                        "broken-price-button"
                      );
                      addXRayErrorElement(
                        element2,
                        "Broken Price Button Found"
                      );
                    }
                  }
                } else {
                  logError(
                    "Broken Price Button Found",
                    "broken-price-button"
                  );
                  addXRayErrorElement(
                    element2,
                    "Broken Price Button Found"
                  );
                }
              }
            });
          }
        );
        ["profile", "signup", "comment"].forEach((type) => {
          checkElements(`[data-ms-form='${type}']`, (form) => {
            const profileImageUploadButton = form.querySelector(
              "[data-ms-action='profile-image']"
            );
            if (profileImageUploadButton) {
              logError(
                `Profile Image Upload Button Found Inside ${type} Form`,
                `image-inside-${type}-form`
              );
              addXRayErrorElement(
                profileImageUploadButton,
                `Profile Image Upload Button Found Inside ${type.charAt(0).toUpperCase() + type.slice(1)} Form`
              );
            }
          });
        });
        checkElements("[data-ms-form='login']", (form) => {
          const invalidLoginElements = form.querySelectorAll(
            "[data-ms-member]:not([data-ms-member='email']):not([data-ms-member='password'])"
          );
          if (invalidLoginElements.length > 0) {
            logError(
              "Extra Login Elements Found Inside Login Form",
              "extra-login-elements"
            );
            invalidLoginElements.forEach(
              (element2) => addXRayErrorElement(
                element2,
                "Extra Login Elements Found Inside Login Form"
              )
            );
          }
        });
        checkElements(
          "[data-ms-price], [data-ms-plan], [data-ms-plan\\:add], [data-ms-plan\\:update], [data-ms-plan\\:remove], [data-ms-price\\:add], [data-ms-price\\:update]",
          (element2) => {
            const attributeValue = element2.getAttribute("data-ms-price") || element2.getAttribute("data-ms-plan") || element2.getAttribute("data-ms-plan:add") || element2.getAttribute("data-ms-plan:update") || element2.getAttribute("data-ms-plan:remove") || element2.getAttribute("data-ms-price:add") || element2.getAttribute("data-ms-price:update");
            if (attributeValue) {
              const freePlans = appData.plans.filter(
                (plan) => plan.prices.length === 0
              );
              const paidPlans = appData.plans.filter(
                (plan) => plan.prices.length > 0
              );
              const freePlanIds = freePlans.map((plan) => plan.id);
              const paidPlanIds = paidPlans.map((plan) => plan.prices.map((price) => price.id)).flat();
              if (attributeValue.startsWith("pln_") && !freePlanIds.includes(attributeValue)) {
                logError("Incorrect Plan ID", "incorrect-plan-id");
                addXRayErrorElement(element2, "Incorrect Plan ID");
              }
              if (attributeValue.startsWith("prc_") && !paidPlanIds.includes(attributeValue)) {
                logError("Incorrect Price ID", "incorrect-price-id");
                addXRayErrorElement(element2, "Incorrect Price ID");
              }
            }
          }
        );
        ["[data-ms-thread]", "[data-ms-post]"].forEach((selector) => {
          checkElements(selector, (element2) => {
            if (!element2.closest("[data-ms-channel]")) {
              logError(
                "Orphan Commenting UI Found",
                "orphan-commenting-ui"
              );
              addXRayErrorElement(element2, "Orphan Commenting UI Found");
            }
          });
        });
        checkElements("[data-ms-thread] [data-ms-post]", (element2) => {
          if (element2.getAttribute("data-ms-post") === "showThreads")
            return;
          logError("Post Inside Thread Found", "post-in-thread");
          addXRayErrorElement(element2, "Post Inside Thread Found");
        });
        checkElements("[data-ms-auth-provider]", (button) => {
          if (button.getAttribute("data-ms-plan\\:add") || button.getAttribute("data-ms-plan\\:update") || button.getAttribute("data-ms-plan\\:remove") || button.getAttribute("data-ms-price\\:add") || button.getAttribute("data-ms-price\\:update") || button.getAttribute("data-ms-price\\:remove")) {
            logError(
              "Plan or Price Attribute Found on Social Button",
              "plan-on-social-auth"
            );
            addXRayErrorElement(
              button,
              "Plan or Price Attribute Found on Social Button"
            );
          }
        });
        const checkCustomFieldVisibility = (element2, attribute, messageKey) => {
          const customFieldKey = element2.getAttribute(attribute);
          const customField = appData.customFields.find(
            (field) => field.key === customFieldKey
          );
          if (customField && customField.visibility === "PRIVATE") {
            logError(
              `Private Custom Field Found on ${attribute}`,
              messageKey
            );
            addXRayErrorElement(
              element2,
              `Private Custom Field Found on ${attribute}`
            );
          }
        };
        setTimeout(() => {
          ["[data-ms-post-creator]", "[data-ms-thread-creator]"].forEach(
            (selector) => {
              checkElements(selector, (element2) => {
                checkCustomFieldVisibility(
                  element2,
                  selector.substring(1, selector.length - 1),
                  "private-custom-field"
                );
              });
            }
          );
        }, 1e3);
        checkElements("[data-ms-form]:not(form)", (element2) => {
          logError(
            "Misplaced Form Attribute Found",
            "misplaced-form-attribute"
          );
          addXRayErrorElement(element2, "Misplaced Form Attribute Found");
        });
        const installScripts = document.querySelectorAll(
          "script[src='https://api.memberstack.com/static/memberstack.js']"
        );
        if (installScripts.length > 1) {
          logError(
            "Duplicate Install Code Found",
            "duplicate-install-code"
          );
        }
        yield checkFormElements("signup");
        yield checkFormElements("login");
      });
    }
  });
}
function addXRayWarningElement(element2, message) {
  return __async(this, null, function* () {
    AddXRayWarningElement({ element: element2, message });
  });
}
function checkWarnings() {
  const forgotPasswordForm = document.querySelector(
    "[data-ms-form='forgot-password']"
  );
  if (forgotPasswordForm && !forgotPasswordForm.getAttribute("redirect")) {
    logWarning(
      "Forgot Password Form Missing Redirect",
      "missing-redirect"
    );
    addXRayWarningElement(
      forgotPasswordForm,
      "Forgot Password Form Missing Redirect"
    );
  }
  const installScript = document.querySelector(
    "script[src='https://api.memberstack.com/static/memberstack.js']"
  );
  if (installScript && installScript.parentElement.tagName !== "HEAD") {
    logWarning("Misplaced Install Code", "misplaced-install-code");
  }
  const planButtonsRaw = document.querySelectorAll(
    "[data-ms-plan\\:update], [data-ms-plan\\:add]"
  );
  const planButtons = Array.from(planButtonsRaw).filter((button) => {
    return button.tagName === "BUTTON" || button.tagName === "A";
  });
  planButtons.forEach((button) => {
    if (button.getAttribute("href") === "#" || !button.getAttribute("href") || !button.getAttribute("href") && !button.getAttribute("data-ms-modal")) {
      logWarning("Plan Without Action", "plan-without-action");
      addXRayWarningElement(button, "Plan Button Without Action");
    }
  });
  const priceButtons = document.querySelectorAll(
    "[data-ms-price\\:add], [data-ms-price\\:update]"
  );
  priceButtons.forEach((button) => {
    if (button.getAttribute("href") === "#" || !button.getAttribute("href") || !button.getAttribute("href") && !button.getAttribute("data-ms-modal")) {
      logWarning("Price Without Action", "price-without-action");
      addXRayWarningElement(button, "Price Button Without Action");
    }
  });
}
function checker() {
  checkCartSessionStorage();
  checkFoundDataAttributes$1();
  checkErrors();
  checkWarnings();
}
function add_css$g(target) {
  append_styles(target, "svelte-1d715s6", "svg.svelte-1d715s6{width:34px;max-height:26px;height:100%}");
}
function create_fragment$A(ctx) {
  let svg;
  let path0;
  let path1;
  let path2;
  let path3;
  let path4;
  let path5;
  let path6;
  let path7;
  return {
    c() {
      svg = svg_element("svg");
      path0 = svg_element("path");
      path1 = svg_element("path");
      path2 = svg_element("path");
      path3 = svg_element("path");
      path4 = svg_element("path");
      path5 = svg_element("path");
      path6 = svg_element("path");
      path7 = svg_element("path");
      attr(path0, "fill-rule", "evenodd");
      attr(path0, "clip-rule", "evenodd");
      attr(path0, "d", "M256.999 409.66C277.268 409.66 295.976 402.974 311.037 391.688C335.832 408.578 368.54 412.623 397.96 399.524C443.145 379.406 463.467 326.468 443.349 281.283L391.207 164.171C371.09 118.986 318.151 98.6654 272.966 118.783C266.609 121.614 260.743 125.094 255.413 129.112C250.314 125.364 244.737 122.103 238.719 119.423C193.534 99.3055 140.596 119.627 120.478 164.812L68.337 281.923C48.2193 327.108 68.5404 380.047 113.725 400.164C143.801 413.555 177.312 409.03 202.292 391.181C217.467 402.774 236.429 409.66 256.999 409.66Z");
      attr(path0, "fill", "black");
      attr(path1, "fill-rule", "evenodd");
      attr(path1, "clip-rule", "evenodd");
      attr(path1, "d", "M255.027 156.049C261.668 148.019 270.217 141.36 280.383 136.834C315.574 121.166 356.804 136.993 372.472 172.184L425.017 290.201C440.685 325.393 424.859 366.623 389.667 382.291C361.5 394.832 329.464 387.196 309.763 365.603C296.799 380.639 277.611 390.158 256.199 390.158C234.402 390.158 214.909 380.293 201.941 364.785C182.36 387.408 149.582 395.627 120.834 382.827C85.6421 367.159 69.8154 325.929 85.4836 290.737L138.028 172.72C153.697 137.528 194.927 121.702 230.118 137.37C240.056 141.795 248.45 148.258 255.027 156.049Z");
      attr(path1, "fill", "white");
      attr(path2, "d", "M355.762 235.16L388.364 307.456C394.961 322.086 388.296 339.226 373.478 345.739C358.663 352.254 341.303 345.673 334.705 331.044L308.352 272.601L296.738 299.617V235.16H355.762Z");
      attr(path2, "fill", "#2AA8FF");
      attr(path3, "d", "M359.295 242.995L366.042 257.953C361.966 256.556 357.591 255.796 353.034 255.796C334.211 255.796 318.458 268.752 314.445 286.114L308.352 272.601L301.894 287.622V242.995H359.295Z");
      attr(path3, "fill", "#393939");
      attr(path3, "fill-opacity", "0.2");
      attr(path4, "d", "M261.186 233.89V285.086H206.876L201.246 272.601L195.879 285.086H135.805V276.399L173.457 188.819C178.219 177.743 189.137 171.106 200.605 171.145C211.887 171.106 222.668 177.525 227.551 188.355L254.792 248.764L261.186 233.89Z");
      attr(path4, "fill", "#017ACE");
      attr(path5, "d", "M254.752 248.677L254.792 248.764L280.563 188.819C285.325 177.743 296.243 171.106 307.711 171.145C318.993 171.106 329.774 177.525 334.656 188.355L366.012 257.892C359.689 252.501 351.453 249.24 342.442 249.24C326.786 249.24 313.46 259.084 308.463 272.846L308.352 272.601L283.037 331.487C276.699 346.228 259.459 353.106 244.529 346.849C243.068 346.236 241.683 345.521 240.38 344.715C234.905 341.776 230.33 337.099 227.6 331.044L201.348 272.827C205.3 273.945 209.474 274.543 213.789 274.543C231.947 274.543 247.599 263.948 254.752 248.677Z");
      attr(path5, "fill", "#AEDEFF");
      attr(path6, "d", "M201.083 272.98L182.179 316.954C177.568 319.043 172.431 320.207 167.015 320.207C148.016 320.207 132.446 305.887 131.026 287.517L144 257.339C150.247 252.231 158.267 249.161 167.015 249.161C182.76 249.161 196.15 259.108 201.083 272.98Z");
      attr(path6, "fill", "black");
      attr(path7, "d", "M195.535 285.886L175.93 331.487C169.593 346.228 152.353 353.106 137.423 346.849C122.492 340.591 115.527 323.569 121.864 308.827L143.633 258.192C148.241 256.178 153.337 255.059 158.697 255.059C177.203 255.059 192.565 268.39 195.535 285.886Z");
      attr(path7, "fill", "#393939");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "fill", "none");
      attr(svg, "viewBox", "60.57 111.02 390.54 298.64");
      attr(svg, "class", "svelte-1d715s6");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path0);
      append(svg, path1);
      append(svg, path2);
      append(svg, path3);
      append(svg, path4);
      append(svg, path5);
      append(svg, path6);
      append(svg, path7);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var MemberstackLogo = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$A, safe_not_equal, {}, add_css$g);
  }
};
function create_fragment$z(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "d", "M480-424 284-228q-11 11-28 11t-28-11q-11-11-11-28t11-28l196-196-196-196q-11-11-11-28t11-28q11-11 28-11t28 11l196 196 196-196q11-11 28-11t28 11q11 11 11 28t-11 28L536-480l196 196q11 11 11 28t-11 28q-11 11-28 11t-28-11L480-424Z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "height", "24");
      attr(svg, "viewBox", "0 -960 960 960");
      attr(svg, "width", "24");
      attr(svg, "fill", "currentColor");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var InspectorBadgeOpen = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$z, safe_not_equal, {});
  }
};
function add_css$f(target) {
  append_styles(target, "svelte-rhveiw", ".ms-inspector-badge.svelte-rhveiw{position:fixed;bottom:10px;left:50%;transform:translateX(-50%);z-index:2147483648 !important;background:#fff;padding:0 7px;margin:0;box-shadow:0 0 10px rgba(0, 0, 0, 0.1);cursor:pointer;display:flex;align-items:stretch;color:#000;background-color:#faf3e1;border:1px solid #d78e2c;border-radius:4px;font-size:12px;font-weight:700;font-family:Plus Jakarta Sans, sans-serif;gap:7px;height:42px}.ms-inspector-badge--error.svelte-rhveiw{background-color:#f6cfca;border-color:#e06657}.ms-inspector-badge__text-wrapper.svelte-rhveiw{display:flex;justify-content:center;align-items:center;gap:7px}.ms-inspector-badge__logo.svelte-rhveiw{display:flex;align-items:center;align-self:center}.ms-inspector-badge__text.svelte-rhveiw{align-self:center}.ms-inspector-badge__divider.svelte-rhveiw{border-left:1px solid #d88e2b}.ms-inspector-badge__count.svelte-rhveiw{border:1px solid #c1c1c1;border-radius:4px;background-color:#fff;color:#000;padding:0 7px;margin:7px 0;display:flex;align-items:center;position:relative}.ms-inspector-badge__count--open.svelte-rhveiw{background-color:#fff;color:#000;padding:0}.ms-inspector-badge__error-indicator.svelte-rhveiw{width:10px;height:10px;background-color:#e06657;border-radius:50%;position:absolute;top:0;right:0;transform:translate(50%, -50%)}");
}
function create_else_block_1$1(ctx) {
  let span;
  return {
    c() {
      span = element("span");
      span.textContent = "Hide Inspector";
      attr(span, "class", "ms-inspector-badge__text svelte-rhveiw");
    },
    m(target, anchor) {
      insert(target, span, anchor);
    },
    d(detaching) {
      if (detaching)
        detach(span);
    }
  };
}
function create_if_block_2$8(ctx) {
  let span;
  return {
    c() {
      span = element("span");
      span.textContent = "Test Mode";
      attr(span, "class", "ms-inspector-badge__text svelte-rhveiw");
    },
    m(target, anchor) {
      insert(target, span, anchor);
    },
    d(detaching) {
      if (detaching)
        detach(span);
    }
  };
}
function create_if_block_1$b(ctx) {
  let span;
  let span_transition;
  let current;
  return {
    c() {
      span = element("span");
      attr(span, "class", "ms-inspector-badge__error-indicator svelte-rhveiw");
    },
    m(target, anchor) {
      insert(target, span, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      add_render_callback(() => {
        if (!current)
          return;
        if (!span_transition)
          span_transition = create_bidirectional_transition(span, fade, { duration: 300 }, true);
        span_transition.run(1);
      });
      current = true;
    },
    o(local) {
      if (!span_transition)
        span_transition = create_bidirectional_transition(span, fade, { duration: 300 }, false);
      span_transition.run(0);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(span);
      if (detaching && span_transition)
        span_transition.end();
    }
  };
}
function create_else_block$6(ctx) {
  let inspectorbadgeopen;
  let current;
  inspectorbadgeopen = new InspectorBadgeOpen({});
  return {
    c() {
      create_component(inspectorbadgeopen.$$.fragment);
    },
    m(target, anchor) {
      mount_component(inspectorbadgeopen, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current)
        return;
      transition_in(inspectorbadgeopen.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(inspectorbadgeopen.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(inspectorbadgeopen, detaching);
    }
  };
}
function create_if_block$e(ctx) {
  let t_value = (
    /*$InspectorStore*/
    (ctx[0].inspectorData.length || 0) + ""
  );
  let t;
  return {
    c() {
      t = text(t_value);
    },
    m(target, anchor) {
      insert(target, t, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*$InspectorStore*/
      1 && t_value !== (t_value = /*$InspectorStore*/
      (ctx2[0].inspectorData.length || 0) + ""))
        set_data(t, t_value);
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(t);
    }
  };
}
function create_fragment$y(ctx) {
  let button;
  let span1;
  let span0;
  let memberstacklogo;
  let t0;
  let t1;
  let span2;
  let t2;
  let span3;
  let t3;
  let current_block_type_index;
  let if_block2;
  let current;
  let mounted;
  let dispose;
  memberstacklogo = new MemberstackLogo({});
  function select_block_type(ctx2, dirty) {
    if (!/*$InspectorStore*/
    ctx2[0].showSidebar)
      return create_if_block_2$8;
    return create_else_block_1$1;
  }
  let current_block_type = select_block_type(ctx);
  let if_block0 = current_block_type(ctx);
  let if_block1 = (
    /*$InspectorStore*/
    ctx[0].xRayErrorElements.length > 0 && create_if_block_1$b()
  );
  const if_block_creators = [create_if_block$e, create_else_block$6];
  const if_blocks = [];
  function select_block_type_1(ctx2, dirty) {
    if (!/*$InspectorStore*/
    ctx2[0].showSidebar)
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type_1(ctx);
  if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      button = element("button");
      span1 = element("span");
      span0 = element("span");
      create_component(memberstacklogo.$$.fragment);
      t0 = space();
      if_block0.c();
      t1 = space();
      span2 = element("span");
      t2 = space();
      span3 = element("span");
      if (if_block1)
        if_block1.c();
      t3 = space();
      if_block2.c();
      attr(span0, "class", "ms-inspector-badge__logo svelte-rhveiw");
      attr(span1, "class", "ms-inspector-badge__text-wrapper svelte-rhveiw");
      attr(span2, "class", "ms-inspector-badge__divider svelte-rhveiw");
      attr(span3, "class", "ms-inspector-badge__count svelte-rhveiw");
      toggle_class(
        span3,
        "ms-inspector-badge__count--open",
        /*$InspectorStore*/
        ctx[0].showSidebar
      );
      attr(button, "class", "ms-inspector-badge svelte-rhveiw");
      attr(button, "data-cy", "inspector-button");
      toggle_class(
        button,
        "ms-inspector-badge--error",
        /*$InspectorStore*/
        ctx[0].xRayErrorElements.length > 0
      );
      set_style(
        button,
        "z-index",
        /*$InspectorStore*/
        ctx[0].showSidebar ? 2147483647 : 2147483648
      );
    },
    m(target, anchor) {
      insert(target, button, anchor);
      append(button, span1);
      append(span1, span0);
      mount_component(memberstacklogo, span0, null);
      append(span1, t0);
      if_block0.m(span1, null);
      append(button, t1);
      append(button, span2);
      append(button, t2);
      append(button, span3);
      if (if_block1)
        if_block1.m(span3, null);
      append(span3, t3);
      if_blocks[current_block_type_index].m(span3, null);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler*/
          ctx[2]
        );
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (current_block_type !== (current_block_type = select_block_type(ctx2))) {
        if_block0.d(1);
        if_block0 = current_block_type(ctx2);
        if (if_block0) {
          if_block0.c();
          if_block0.m(span1, null);
        }
      }
      if (
        /*$InspectorStore*/
        ctx2[0].xRayErrorElements.length > 0
      ) {
        if (if_block1) {
          if (dirty & /*$InspectorStore*/
          1) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block_1$b();
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(span3, t3);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type_1(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block2 = if_blocks[current_block_type_index];
        if (!if_block2) {
          if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block2.c();
        } else {
          if_block2.p(ctx2, dirty);
        }
        transition_in(if_block2, 1);
        if_block2.m(span3, null);
      }
      if (!current || dirty & /*$InspectorStore*/
      1) {
        toggle_class(
          span3,
          "ms-inspector-badge__count--open",
          /*$InspectorStore*/
          ctx2[0].showSidebar
        );
      }
      if (!current || dirty & /*$InspectorStore*/
      1) {
        toggle_class(
          button,
          "ms-inspector-badge--error",
          /*$InspectorStore*/
          ctx2[0].xRayErrorElements.length > 0
        );
      }
      if (dirty & /*$InspectorStore*/
      1) {
        set_style(
          button,
          "z-index",
          /*$InspectorStore*/
          ctx2[0].showSidebar ? 2147483647 : 2147483648
        );
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(memberstacklogo.$$.fragment, local);
      transition_in(if_block1);
      transition_in(if_block2);
      current = true;
    },
    o(local) {
      transition_out(memberstacklogo.$$.fragment, local);
      transition_out(if_block1);
      transition_out(if_block2);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(button);
      destroy_component(memberstacklogo);
      if_block0.d();
      if (if_block1)
        if_block1.d();
      if_blocks[current_block_type_index].d();
      mounted = false;
      dispose();
    }
  };
}
function instance$h($$self, $$props, $$invalidate) {
  let $InspectorStore;
  component_subscribe($$self, InspectorStore, ($$value) => $$invalidate(0, $InspectorStore = $$value));
  function toggleSidebar() {
    SetShowSidebar(!$InspectorStore.showSidebar);
  }
  const click_handler = () => toggleSidebar();
  return [$InspectorStore, toggleSidebar, click_handler];
}
var InspectorBadge = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$h, create_fragment$y, safe_not_equal, {}, add_css$f);
  }
};
var eventListeners = [];
function addEventListenerWithTracking(type, listener) {
  window.addEventListener(type, listener);
  eventListeners.push({ type, listener });
}
function removeAllEventListeners() {
  eventListeners.forEach(({ type, listener }) => {
    window.removeEventListener(type, listener);
  });
  eventListeners.length = 0;
}
function updatePosition(element2, highlightBox, label) {
  const rect = element2.getBoundingClientRect();
  highlightBox.style.top = `${rect.top + window.scrollY - 6}px`;
  highlightBox.style.left = `${rect.left + window.scrollX - 6}px`;
  label.style.top = `${rect.top + window.scrollY - label.offsetHeight - 6}px`;
  label.style.left = `${rect.left + window.scrollX - 6}px`;
}
function escapeCSSSelector(selector) {
  return selector.replace(/([:])/g, "\\$1");
}
function calculateZIndex(originalZIndex, type) {
  let newZIndex = originalZIndex;
  if (isNaN(newZIndex) || newZIndex < 0) {
    newZIndex = 50;
  }
  if (type === "error") {
    newZIndex += 3;
  } else if (type === "warning") {
    newZIndex += 2;
  } else {
    newZIndex += 1;
  }
  return newZIndex;
}
function createHighlightBox(rect, color, zindex, type) {
  const box = document.createElement("div");
  box.classList.add("ms-xray-outline");
  Object.assign(box.style, {
    position: "absolute",
    top: `${rect.top + window.scrollY - 6}px`,
    left: `${rect.left + window.scrollX - 6}px`,
    width: `${rect.width + 12}px`,
    height: `${rect.height + 12}px`,
    border: "2px solid",
    borderColor: color,
    pointerEvents: "none",
    zIndex: calculateZIndex(zindex, type)
  });
  document.body.appendChild(box);
  return box;
}
function getSvgForType(type) {
  const svgs = {
    found: `
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="13"
        viewBox="0 -960 960 960"
        width="13"
        ><path
          fill="currentColor"
          d="M120-200q-17 0-28.5-11.5T80-240q0-17 11.5-28.5T120-280h320q17 0 28.5 11.5T480-240q0 17-11.5 28.5T440-200H120Zm0-200q-17 0-28.5-11.5T80-440q0-17 11.5-28.5T120-480h120q17 0 28.5 11.5T280-440q0 17-11.5 28.5T240-400H120Zm0-200q-17 0-28.5-11.5T80-640q0-17 11.5-28.5T120-680h120q17 0 28.5 11.5T280-640q0 17-11.5 28.5T240-600H120Zm440 280q-83 0-141.5-58.5T360-520q0-83 58.5-141.5T560-720q83 0 141.5 58.5T760-520q0 29-8.5 57.5T726-410l126 126q11 11 11 28t-11 28q-11 11-28 11t-28-11L670-354q-24 17-52.5 25.5T560-320Zm0-80q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Z"
        />
    </svg>
    `,
    // SVG for 'found' items
    error: `
    <svg xmlns="http://www.w3.org/2000/svg" height="13" viewBox="0 -960 960 960" width="13"><path fill="currentColor" d="m480-424 116 116q11 11 28 11t28-11q11-11 11-28t-11-28L536-480l116-116q11-11 11-28t-11-28q-11-11-28-11t-28 11L480-536 364-652q-11-11-28-11t-28 11q-11 11-11 28t11 28l116 116-116 116q-11 11-11 28t11 28q11 11 28 11t28-11l116-116Zm0 344q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z"></path></svg>
    `,
    // SVG for 'error' items
    warning: `
    <svg xmlns="http://www.w3.org/2000/svg" height="13" viewBox="0 -960 960 960" width="13"><path fill="currentColor" d="M109-120q-11 0-20-5.5T75-140q-5-9-5.5-19.5T75-180l370-640q6-10 15.5-15t19.5-5q10 0 19.5 5t15.5 15l370 640q6 10 5.5 20.5T885-140q-5 9-14 14.5t-20 5.5H109Zm371-120q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm0-120q17 0 28.5-11.5T520-400v-120q0-17-11.5-28.5T480-560q-17 0-28.5 11.5T440-520v120q0 17 11.5 28.5T480-360Z"></path></svg>
    `
    // SVG for 'warning' items
  };
  return svgs[type] || "";
}
function createLabel(rect, text2, color, type, zindex, elementDataAttribute) {
  const label = document.createElement("div");
  label.classList.add("ms-xray-tooltip");
  const svg = getSvgForType(type);
  if (type === "found" && elementDataAttribute !== void 0 && text2 === "data-ms-member") {
    label.innerHTML = `${svg} ${text2}='${elementDataAttribute}'`;
  } else {
    label.innerHTML = `${svg} ${text2}`;
  }
  Object.assign(label.style, {
    position: "absolute",
    top: `${rect.top + window.scrollY}px`,
    left: `${rect.left + window.scrollX - 6}px`,
    backgroundColor: color,
    color: color === "#efd350" ? "#000" : "#fff",
    padding: "2px 3px",
    fontSize: "9px",
    lineHeight: "1",
    fontFamily: "Plus Jakarta Sans, sans-serif",
    zIndex: calculateZIndex(zindex, type),
    whiteSpace: "nowrap",
    borderRadius: "3px 3px 0 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "3px",
    pointerEvents: "none"
  });
  document.body.appendChild(label);
  return label;
}
function removeXrays() {
  return __async(this, null, function* () {
    document.querySelectorAll(".ms-xray-outline, .ms-xray-tooltip").forEach((el) => el.remove());
    removeAllEventListeners();
  });
}
function checkAttributes(type) {
  return __async(this, null, function* () {
    const store = get_store_value(InspectorStore);
    let items;
    switch (type) {
      case "error":
        items = store.xRayErrorElements;
        break;
      case "warning":
        items = store.xRayWarningElements;
        break;
      case "found":
        items = inspectorItems.filter((item) => item.type === "found");
        break;
      default:
        items = [];
    }
    const color = type === "error" ? "#e06657" : type === "warning" ? "#efd350" : "#5c9d6f";
    items.forEach((item) => {
      let elements;
      if (type === "found") {
        const attribute = escapeCSSSelector(item.dataAttribute);
        elements = document.querySelectorAll(`[${attribute}]`);
      } else {
        elements = [item.element];
      }
      elements.forEach((el) => {
        if (!el || el.offsetParent === null)
          return;
        const rect = el.getBoundingClientRect();
        const zindex = window.getComputedStyle(el).zIndex;
        const highlightBox = createHighlightBox(rect, color, zindex, type);
        const label = createLabel(rect, type === "found" ? item.dataAttribute : item.message, color, type, zindex, el.getAttribute(item.dataAttribute));
        const update2 = () => updatePosition(el, highlightBox, label);
        update2();
        addEventListenerWithTracking("scroll", update2);
        addEventListenerWithTracking("resize", update2);
      });
    });
  });
}
function checkFoundDataAttributes() {
  return __async(this, null, function* () {
    checkAttributes("found");
  });
}
function checkErrorDataAttributes() {
  return __async(this, null, function* () {
    checkAttributes("error");
  });
}
function checkWarningDataAttributes() {
  return __async(this, null, function* () {
    checkAttributes("warning");
  });
}
function create_fragment$x(ctx) {
  let span;
  return {
    c() {
      span = element("span");
      span.textContent = "AI";
    },
    m(target, anchor) {
      insert(target, span, anchor);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(span);
    }
  };
}
var AIIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$x, safe_not_equal, {});
  }
};
function create_fragment$w(ctx) {
  let svg;
  let path0;
  let path1;
  return {
    c() {
      svg = svg_element("svg");
      path0 = svg_element("path");
      path1 = svg_element("path");
      attr(path0, "d", "M0 0h24v24H0V0z");
      attr(path0, "fill", "none");
      attr(path1, "d", "M4 13h6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1zm0 8h6c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm10 0h6c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1zM13 4v4c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "height", "24px");
      attr(svg, "viewBox", "0 0 24 24");
      attr(svg, "width", "24px");
      attr(svg, "fill", "currentColor");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path0);
      append(svg, path1);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var ComponentsIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$w, safe_not_equal, {});
  }
};
function create_fragment$v(ctx) {
  let svg;
  let path0;
  let path1;
  return {
    c() {
      svg = svg_element("svg");
      path0 = svg_element("path");
      path1 = svg_element("path");
      attr(path0, "d", "M0 0h24v24H0V0z");
      attr(path0, "fill", "none");
      attr(path1, "d", "M20 6h-1v8c0 .55-.45 1-1 1H6v1c0 1.1.9 2 2 2h10l4 4V8c0-1.1-.9-2-2-2zm-3 5V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v13l4-4h9c1.1 0 2-.9 2-2z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "height", "100%");
      attr(svg, "viewBox", "0 0 24 24");
      attr(svg, "width", "1000px");
      attr(svg, "fill", "currentColor");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path0);
      append(svg, path1);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var ForumsIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$v, safe_not_equal, {});
  }
};
function create_fragment$u(ctx) {
  let svg;
  let g0;
  let rect0;
  let rect1;
  let g1;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      g0 = svg_element("g");
      rect0 = svg_element("rect");
      rect1 = svg_element("rect");
      g1 = svg_element("g");
      path = svg_element("path");
      attr(rect0, "fill", "none");
      attr(rect0, "height", "24");
      attr(rect0, "width", "24");
      attr(rect1, "fill", "none");
      attr(rect1, "height", "24");
      attr(rect1, "width", "24");
      attr(path, "d", "M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M19.46,9.12l-2.78,1.15 c-0.51-1.36-1.58-2.44-2.95-2.94l1.15-2.78C16.98,5.35,18.65,7.02,19.46,9.12z M12,15c-1.66,0-3-1.34-3-3s1.34-3,3-3s3,1.34,3,3 S13.66,15,12,15z M9.13,4.54l1.17,2.78c-1.38,0.5-2.47,1.59-2.98,2.97L4.54,9.13C5.35,7.02,7.02,5.35,9.13,4.54z M4.54,14.87 l2.78-1.15c0.51,1.38,1.59,2.46,2.97,2.96l-1.17,2.78C7.02,18.65,5.35,16.98,4.54,14.87z M14.88,19.46l-1.15-2.78 c1.37-0.51,2.45-1.59,2.95-2.97l2.78,1.17C18.65,16.98,16.98,18.65,14.88,19.46z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "height", "100%");
      attr(svg, "viewBox", "0 0 24 24");
      attr(svg, "width", "1000px");
      attr(svg, "fill", "currentColor");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, g0);
      append(g0, rect0);
      append(g0, rect1);
      append(svg, g1);
      append(g1, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var HelpIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$u, safe_not_equal, {});
  }
};
function create_fragment$t(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill-rule", "evenodd");
      attr(path, "clip-rule", "evenodd");
      attr(path, "d", "M13 10C13 11.1046 13.8954 12 15 12C16.1046 12 17 11.1046 17 10V5C17 3.89543 16.1046 3 15 3C13.8954 3 13 3.89543 13 5V10ZM5 8C3.89543 8 3 8.89543 3 10C3 11.1046 3.89543 12 5 12H10C11.1046 12 12 11.1046 12 10C12 8.89543 11.1046 8 10 8H5ZM15 13C13.8954 13 13 13.8954 13 15C13 16.1046 13.8954 17 15 17H20C21.1046 17 22 16.1046 22 15C22 13.8954 21.1046 13 20 13H15ZM10 22C8.89543 22 8 21.1046 8 20L8 15C8 13.8954 8.89543 13 10 13C11.1046 13 12 13.8954 12 15V20C12 21.1046 11.1046 22 10 22ZM8 5C8 3.89543 8.89543 3 10 3C11.1046 3 12 3.89543 12 5V7H10C8.89543 7 8 6.10457 8 5ZM3 15C3 16.1046 3.89543 17 5 17C6.10457 17 7 16.1046 7 15V13H5C3.89543 13 3 13.8954 3 15ZM17 20C17 21.1046 16.1046 22 15 22C13.8954 22 13 21.1046 13 20V18H15C16.1046 18 17 18.8954 17 20ZM22 10C22 8.89543 21.1046 8 20 8C18.8954 8 18 8.89543 18 10V12H20C21.1046 12 22 11.1046 22 10Z");
      attr(path, "fill", "currentColor");
      attr(svg, "width", "24");
      attr(svg, "height", "24");
      attr(svg, "viewBox", "0 0 24 24");
      attr(svg, "fill", "none");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var SlackIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$t, safe_not_equal, {});
  }
};
function create_fragment$s(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M280-80q-33 0-56.5-23.5T200-160q0-33 23.5-56.5T280-240q33 0 56.5 23.5T360-160q0 33-23.5 56.5T280-80Zm400 0q-33 0-56.5-23.5T600-160q0-33 23.5-56.5T680-240q33 0 56.5 23.5T760-160q0 33-23.5 56.5T680-80ZM208-800h590q23 0 35 20.5t1 41.5L692-482q-11 20-29.5 31T622-440H324l-44 80h440q17 0 28.5 11.5T760-320q0 17-11.5 28.5T720-280H280q-45 0-68-39.5t-2-78.5l54-98-144-304H80q-17 0-28.5-11.5T40-840q0-17 11.5-28.5T80-880h65q11 0 21 6t15 17l27 57Z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "height", "24");
      attr(svg, "viewBox", "0 -960 960 960");
      attr(svg, "width", "24");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var CartIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$s, safe_not_equal, {});
  }
};
function create_fragment$r(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M120-200q-17 0-28.5-11.5T80-240q0-17 11.5-28.5T120-280h320q17 0 28.5 11.5T480-240q0 17-11.5 28.5T440-200H120Zm0-200q-17 0-28.5-11.5T80-440q0-17 11.5-28.5T120-480h120q17 0 28.5 11.5T280-440q0 17-11.5 28.5T240-400H120Zm0-200q-17 0-28.5-11.5T80-640q0-17 11.5-28.5T120-680h120q17 0 28.5 11.5T280-640q0 17-11.5 28.5T240-600H120Zm440 280q-83 0-141.5-58.5T360-520q0-83 58.5-141.5T560-720q83 0 141.5 58.5T760-520q0 29-8.5 57.5T726-410l126 126q11 11 11 28t-11 28q-11 11-28 11t-28-11L670-354q-24 17-52.5 25.5T560-320Zm0-80q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "height", "24");
      attr(svg, "viewBox", "0 -960 960 960");
      attr(svg, "width", "24");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var MagIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$r, safe_not_equal, {});
  }
};
function create_fragment$q(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M606-105q-23 11-46 2.5T526-134L406-392l-93 130q-17 24-45 15t-28-38v-513q0-25 22.5-36t42.5 5l404 318q23 17 13.5 44T684-440H516l119 255q11 23 2.5 46T606-105Z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "height", "24");
      attr(svg, "viewBox", "0 -960 960 960");
      attr(svg, "width", "24");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var PointerIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$q, safe_not_equal, {});
  }
};
function create_fragment$p(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M792-56 624-222q-35 11-71 16.5t-73 5.5q-134 0-245-72T61-462q-5-9-7.5-18.5T51-500q0-10 2.5-19.5T61-538q22-39 47-76t58-66L56-792l56-56 736 736-56 56ZM480-320q11 0 21-1t20-4L305-541q-3 10-4 20t-1 21q0 75 52.5 127.5T480-320Zm292 18L645-428q7-17 11-35t4-37q0-75-52.5-127.5T480-680q-19 0-37 4t-35 12L306-766q42-17 85.5-25.5T480-800q134 0 245.5 72.5T900-537q5 8 7.5 17.5T910-500q0 10-2 19.5t-7 17.5q-24 47-55.5 88T772-302ZM587-486 467-606q26-5 50.5 4t41.5 28q17 18 24.5 41t3.5 47Z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "height", "24");
      attr(svg, "viewBox", "0 -960 960 960");
      attr(svg, "width", "24");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var EyeClosedIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$p, safe_not_equal, {});
  }
};
function create_fragment$o(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "m480-424 116 116q11 11 28 11t28-11q11-11 11-28t-11-28L536-480l116-116q11-11 11-28t-11-28q-11-11-28-11t-28 11L480-536 364-652q-11-11-28-11t-28 11q-11 11-11 28t11 28l116 116-116 116q-11 11-11 28t11 28q11 11 28 11t28-11l116-116Zm0 344q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "height", "24");
      attr(svg, "viewBox", "0 -960 960 960");
      attr(svg, "width", "24");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var XIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$o, safe_not_equal, {});
  }
};
function create_fragment$n(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M109-120q-11 0-20-5.5T75-140q-5-9-5.5-19.5T75-180l370-640q6-10 15.5-15t19.5-5q10 0 19.5 5t15.5 15l370 640q6 10 5.5 20.5T885-140q-5 9-14 14.5t-20 5.5H109Zm371-120q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm0-120q17 0 28.5-11.5T520-400v-120q0-17-11.5-28.5T480-560q-17 0-28.5 11.5T440-520v120q0 17 11.5 28.5T480-360Z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "height", "24");
      attr(svg, "viewBox", "0 -960 960 960");
      attr(svg, "width", "24");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var WarningIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$n, safe_not_equal, {});
  }
};
function add_css$e(target) {
  append_styles(target, "svelte-1lrintl", ".svg.svelte-1lrintl{width:1.5em;height:1.5em;justify-content:center;align-items:center;display:flex;margin:0}");
}
function create_fragment$m(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M280-280q-83 0-141.5-58.5T80-480q0-83 58.5-141.5T280-680h120q17 0 28.5 11.5T440-640q0 17-11.5 28.5T400-600H280q-50 0-85 35t-35 85q0 50 35 85t85 35h120q17 0 28.5 11.5T440-320q0 17-11.5 28.5T400-280H280Zm80-160q-17 0-28.5-11.5T320-480q0-17 11.5-28.5T360-520h240q17 0 28.5 11.5T640-480q0 17-11.5 28.5T600-440H360Zm200 160q-17 0-28.5-11.5T520-320q0-17 11.5-28.5T560-360h120q50 0 85-35t35-85q0-50-35-85t-85-35H560q-17 0-28.5-11.5T520-640q0-17 11.5-28.5T560-680h120q83 0 141.5 58.5T880-480q0 83-58.5 141.5T680-280H560Z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "height", "24");
      attr(svg, "viewBox", "0 -960 960 960");
      attr(svg, "width", "24");
      attr(svg, "class", "svg svelte-1lrintl");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var LinkIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$m, safe_not_equal, {}, add_css$e);
  }
};
function add_css$d(target) {
  append_styles(target, "svelte-e5yv66", ".ms-inspector-item__content-item__help.svelte-e5yv66{margin-bottom:7px}.ms-inspector-item__content-item__help a{text-decoration:underline;color:#fff;word-break:break-word}.ms-inspector-item__content-item__help a:hover{color:#fff}.ms-inspector-item__content-item__help__title.svelte-e5yv66{width:100%;grid-column-gap:4px;grid-row-gap:4px;border:1px solid #373737;background-color:#535353;border-radius:4px;justify-content:space-between;align-items:center;margin-top:0.6em;margin-bottom:-3px;padding-left:1em;padding-right:1em;line-height:2.7em;display:flex;color:#fff}.ms-inspector-item__content-item__help__title.svelte-e5yv66:hover{border-color:#292929;background-color:#444}.ms-inspector-item__content-item__help__description.svelte-e5yv66{border:1px solid #373737;background-color:#535353;border-bottom-right-radius:4px;border-bottom-left-radius:4px;padding:8px 8px 10px}.ms-inspector-item__content-item__help__description p:last-child{margin-bottom:0}.ms-inspector-item__content-item__help__description img{margin-bottom:7px}");
}
function create_if_block$d(ctx) {
  let div;
  let raw_value = (
    /*helpItem*/
    ctx[0].description + ""
  );
  let div_transition;
  let current;
  return {
    c() {
      div = element("div");
      attr(div, "class", "ms-inspector-item__content-item__help__description svelte-e5yv66");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      div.innerHTML = raw_value;
      current = true;
    },
    p(ctx2, dirty) {
      if ((!current || dirty & /*helpItem*/
      1) && raw_value !== (raw_value = /*helpItem*/
      ctx2[0].description + ""))
        div.innerHTML = raw_value;
    },
    i(local) {
      if (current)
        return;
      if (local) {
        add_render_callback(() => {
          if (!current)
            return;
          if (!div_transition)
            div_transition = create_bidirectional_transition(div, slide, { duration: 300 }, true);
          div_transition.run(1);
        });
      }
      current = true;
    },
    o(local) {
      if (local) {
        if (!div_transition)
          div_transition = create_bidirectional_transition(div, slide, { duration: 300 }, false);
        div_transition.run(0);
      }
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      if (detaching && div_transition)
        div_transition.end();
    }
  };
}
function create_fragment$l(ctx) {
  let div;
  let button;
  let t0_value = (
    /*helpItem*/
    ctx[0].title + ""
  );
  let t0;
  let t1;
  let mounted;
  let dispose;
  let if_block = (
    /*openHelpItem*/
    ctx[1] && create_if_block$d(ctx)
  );
  return {
    c() {
      div = element("div");
      button = element("button");
      t0 = text(t0_value);
      t1 = space();
      if (if_block)
        if_block.c();
      attr(button, "class", "ms-inspector-item__content-item__help__title svelte-e5yv66");
      attr(div, "class", "ms-inspector-item__content-item__help svelte-e5yv66");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, button);
      append(button, t0);
      append(div, t1);
      if (if_block)
        if_block.m(div, null);
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*handleClick*/
          ctx[2]
        );
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (dirty & /*helpItem*/
      1 && t0_value !== (t0_value = /*helpItem*/
      ctx2[0].title + ""))
        set_data(t0, t0_value);
      if (
        /*openHelpItem*/
        ctx2[1]
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
          if (dirty & /*openHelpItem*/
          2) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$d(ctx2);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(div, null);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      transition_in(if_block);
    },
    o(local) {
      transition_out(if_block);
    },
    d(detaching) {
      if (detaching)
        detach(div);
      if (if_block)
        if_block.d();
      mounted = false;
      dispose();
    }
  };
}
function instance$g($$self, $$props, $$invalidate) {
  let { helpItem } = $$props;
  let openHelpItem = false;
  function handleClick() {
    $$invalidate(1, openHelpItem = !openHelpItem);
  }
  $$self.$$set = ($$props2) => {
    if ("helpItem" in $$props2)
      $$invalidate(0, helpItem = $$props2.helpItem);
  };
  return [helpItem, openHelpItem, handleClick];
}
var InspectorHelpItem = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$g, create_fragment$l, safe_not_equal, { helpItem: 0 }, add_css$d);
  }
};
function add_css$c(target) {
  append_styles(target, "svelte-1pe9tmx", "svg.svelte-1pe9tmx{width:8px;height:auto}");
}
function create_fragment$k(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M459-381 314-526q-3-3-4.5-6.5T308-540q0-8 5.5-14t14.5-6h304q9 0 14.5 6t5.5 14q0 2-6 14L501-381q-5 5-10 7t-11 2q-6 0-11-2t-10-7Z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "viewBox", "308 -560 344 188");
      attr(
        svg,
        "style",
        /*style*/
        ctx[0]
      );
      attr(svg, "class", "svelte-1pe9tmx");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p(ctx2, [dirty]) {
      if (dirty & /*style*/
      1) {
        attr(
          svg,
          "style",
          /*style*/
          ctx2[0]
        );
      }
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
function instance$f($$self, $$props, $$invalidate) {
  let { style = "" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("style" in $$props2)
      $$invalidate(0, style = $$props2.style);
  };
  return [style];
}
var ArrowIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$f, create_fragment$k, safe_not_equal, { style: 0 }, add_css$c);
  }
};
function get_each_context$5(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[5] = list[i];
  return child_ctx;
}
function create_if_block_8$1(ctx) {
  let warningicon;
  let current;
  warningicon = new WarningIcon({});
  return {
    c() {
      create_component(warningicon.$$.fragment);
    },
    m(target, anchor) {
      mount_component(warningicon, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(warningicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(warningicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(warningicon, detaching);
    }
  };
}
function create_if_block_7$1(ctx) {
  let xicon;
  let current;
  xicon = new XIcon({});
  return {
    c() {
      create_component(xicon.$$.fragment);
    },
    m(target, anchor) {
      mount_component(xicon, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(xicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(xicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(xicon, detaching);
    }
  };
}
function create_if_block_6$2(ctx) {
  let eyeclosedicon;
  let current;
  eyeclosedicon = new EyeClosedIcon({});
  return {
    c() {
      create_component(eyeclosedicon.$$.fragment);
    },
    m(target, anchor) {
      mount_component(eyeclosedicon, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(eyeclosedicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(eyeclosedicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(eyeclosedicon, detaching);
    }
  };
}
function create_if_block_5$2(ctx) {
  let pointericon;
  let current;
  pointericon = new PointerIcon({});
  return {
    c() {
      create_component(pointericon.$$.fragment);
    },
    m(target, anchor) {
      mount_component(pointericon, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(pointericon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(pointericon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(pointericon, detaching);
    }
  };
}
function create_if_block_4$3(ctx) {
  let magicon;
  let current;
  magicon = new MagIcon({});
  return {
    c() {
      create_component(magicon.$$.fragment);
    },
    m(target, anchor) {
      mount_component(magicon, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(magicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(magicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(magicon, detaching);
    }
  };
}
function create_if_block_3$5(ctx) {
  let carticon;
  let current;
  carticon = new CartIcon({});
  return {
    c() {
      create_component(carticon.$$.fragment);
    },
    m(target, anchor) {
      mount_component(carticon, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(carticon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(carticon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(carticon, detaching);
    }
  };
}
function create_if_block$c(ctx) {
  let div4;
  let div0;
  let html_tag;
  let raw_value = (
    /*inspectorItem*/
    ctx[0].description + ""
  );
  let t0;
  let t1;
  let div3;
  let div1;
  let t3;
  let div2;
  let t4;
  let div4_transition;
  let current;
  let if_block0 = (
    /*inspectorItem*/
    ctx[0].type === "cart" && /*$InspectorStore*/
    ctx[2].cartData && create_if_block_2$7(ctx)
  );
  let each_value = (
    /*inspectorItem*/
    ctx[0].helpItems
  );
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$5(get_each_context$5(ctx, each_value, i));
  }
  const out = (i) => transition_out(each_blocks[i], 1, 1, () => {
    each_blocks[i] = null;
  });
  let if_block1 = (
    /*inspectorItem*/
    ctx[0].documentationLink && create_if_block_1$a(ctx)
  );
  return {
    c() {
      div4 = element("div");
      div0 = element("div");
      html_tag = new HtmlTag(false);
      t0 = space();
      if (if_block0)
        if_block0.c();
      t1 = space();
      div3 = element("div");
      div1 = element("div");
      div1.textContent = "Need help?";
      t3 = space();
      div2 = element("div");
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      t4 = space();
      if (if_block1)
        if_block1.c();
      html_tag.a = t0;
      attr(div0, "class", "ms-inspector-item__content-item");
      attr(div1, "class", "ms-inspector-item__content-item__title");
      attr(div2, "class", "ms-inspector-item__help-items");
      attr(div3, "class", "ms-inspector-item__content-item");
      attr(div4, "class", "ms-inspector-item__wrapper");
    },
    m(target, anchor) {
      insert(target, div4, anchor);
      append(div4, div0);
      html_tag.m(raw_value, div0);
      append(div0, t0);
      if (if_block0)
        if_block0.m(div0, null);
      append(div4, t1);
      append(div4, div3);
      append(div3, div1);
      append(div3, t3);
      append(div3, div2);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(div2, null);
        }
      }
      append(div2, t4);
      if (if_block1)
        if_block1.m(div2, null);
      current = true;
    },
    p(ctx2, dirty) {
      if ((!current || dirty & /*inspectorItem*/
      1) && raw_value !== (raw_value = /*inspectorItem*/
      ctx2[0].description + ""))
        html_tag.p(raw_value);
      if (
        /*inspectorItem*/
        ctx2[0].type === "cart" && /*$InspectorStore*/
        ctx2[2].cartData
      ) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
        } else {
          if_block0 = create_if_block_2$7(ctx2);
          if_block0.c();
          if_block0.m(div0, null);
        }
      } else if (if_block0) {
        if_block0.d(1);
        if_block0 = null;
      }
      if (dirty & /*inspectorItem*/
      1) {
        each_value = /*inspectorItem*/
        ctx2[0].helpItems;
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context$5(ctx2, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
            transition_in(each_blocks[i], 1);
          } else {
            each_blocks[i] = create_each_block$5(child_ctx);
            each_blocks[i].c();
            transition_in(each_blocks[i], 1);
            each_blocks[i].m(div2, t4);
          }
        }
        group_outros();
        for (i = each_value.length; i < each_blocks.length; i += 1) {
          out(i);
        }
        check_outros();
      }
      if (
        /*inspectorItem*/
        ctx2[0].documentationLink
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty & /*inspectorItem*/
          1) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block_1$a(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(div2, null);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      for (let i = 0; i < each_value.length; i += 1) {
        transition_in(each_blocks[i]);
      }
      transition_in(if_block1);
      if (local) {
        add_render_callback(() => {
          if (!current)
            return;
          if (!div4_transition)
            div4_transition = create_bidirectional_transition(div4, slide, { duration: 300 }, true);
          div4_transition.run(1);
        });
      }
      current = true;
    },
    o(local) {
      each_blocks = each_blocks.filter(Boolean);
      for (let i = 0; i < each_blocks.length; i += 1) {
        transition_out(each_blocks[i]);
      }
      transition_out(if_block1);
      if (local) {
        if (!div4_transition)
          div4_transition = create_bidirectional_transition(div4, slide, { duration: 300 }, false);
        div4_transition.run(0);
      }
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div4);
      if (if_block0)
        if_block0.d();
      destroy_each(each_blocks, detaching);
      if (if_block1)
        if_block1.d();
      if (detaching && div4_transition)
        div4_transition.end();
    }
  };
}
function create_if_block_2$7(ctx) {
  let span;
  let t_value = (
    /*$InspectorStore*/
    ctx[2].cartData + ""
  );
  let t;
  return {
    c() {
      span = element("span");
      t = text(t_value);
    },
    m(target, anchor) {
      insert(target, span, anchor);
      append(span, t);
    },
    p(ctx2, dirty) {
      if (dirty & /*$InspectorStore*/
      4 && t_value !== (t_value = /*$InspectorStore*/
      ctx2[2].cartData + ""))
        set_data(t, t_value);
    },
    d(detaching) {
      if (detaching)
        detach(span);
    }
  };
}
function create_each_block$5(ctx) {
  let inspectorhelpitem;
  let current;
  inspectorhelpitem = new InspectorHelpItem({ props: { helpItem: (
    /*helpItem*/
    ctx[5]
  ) } });
  return {
    c() {
      create_component(inspectorhelpitem.$$.fragment);
    },
    m(target, anchor) {
      mount_component(inspectorhelpitem, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const inspectorhelpitem_changes = {};
      if (dirty & /*inspectorItem*/
      1)
        inspectorhelpitem_changes.helpItem = /*helpItem*/
        ctx2[5];
      inspectorhelpitem.$set(inspectorhelpitem_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(inspectorhelpitem.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(inspectorhelpitem.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(inspectorhelpitem, detaching);
    }
  };
}
function create_if_block_1$a(ctx) {
  let div;
  let a;
  let t;
  let linkicon;
  let a_href_value;
  let current;
  linkicon = new LinkIcon({});
  return {
    c() {
      div = element("div");
      a = element("a");
      t = text("Documentation ");
      create_component(linkicon.$$.fragment);
      attr(a, "class", "ms-inspector-item__content-item__help__title ms-inspector-item__content-item__help__title--link");
      attr(a, "href", a_href_value = /*inspectorItem*/
      ctx[0].documentationLink);
      attr(a, "target", "_blank");
      attr(div, "class", "ms-inspector-item__content-item__help");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, a);
      append(a, t);
      mount_component(linkicon, a, null);
      current = true;
    },
    p(ctx2, dirty) {
      if (!current || dirty & /*inspectorItem*/
      1 && a_href_value !== (a_href_value = /*inspectorItem*/
      ctx2[0].documentationLink)) {
        attr(a, "href", a_href_value);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(linkicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(linkicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      destroy_component(linkicon);
    }
  };
}
function create_fragment$j(ctx) {
  let div2;
  let div0;
  let button;
  let span0;
  let current_block_type_index;
  let if_block0;
  let t0;
  let t1_value = (
    /*inspectorItem*/
    ctx[0].title + ""
  );
  let t1;
  let t2;
  let span1;
  let arrowicon;
  let t3;
  let div1;
  let div2_class_value;
  let div2_id_value;
  let current;
  let mounted;
  let dispose;
  const if_block_creators = [
    create_if_block_3$5,
    create_if_block_4$3,
    create_if_block_5$2,
    create_if_block_6$2,
    create_if_block_7$1,
    create_if_block_8$1
  ];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*inspectorItem*/
      ctx2[0].type === "cart"
    )
      return 0;
    if (
      /*inspectorItem*/
      ctx2[0].type === "found"
    )
      return 1;
    if (
      /*inspectorItem*/
      ctx2[0].type === "plan-price-clicked"
    )
      return 2;
    if (
      /*inspectorItem*/
      ctx2[0].type === "content-removed"
    )
      return 3;
    if (
      /*inspectorItem*/
      ctx2[0].type === "error"
    )
      return 4;
    if (
      /*inspectorItem*/
      ctx2[0].type === "warning"
    )
      return 5;
    return -1;
  }
  if (~(current_block_type_index = select_block_type(ctx))) {
    if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  }
  arrowicon = new ArrowIcon({
    props: {
      style: "transform: rotate(" + /*openInspectorItem*/
      (ctx[1] ? "180deg" : "0deg") + ")"
    }
  });
  let if_block1 = (
    /*openInspectorItem*/
    ctx[1] && create_if_block$c(ctx)
  );
  return {
    c() {
      div2 = element("div");
      div0 = element("div");
      button = element("button");
      span0 = element("span");
      if (if_block0)
        if_block0.c();
      t0 = space();
      t1 = text(t1_value);
      t2 = space();
      span1 = element("span");
      create_component(arrowicon.$$.fragment);
      t3 = space();
      div1 = element("div");
      if (if_block1)
        if_block1.c();
      attr(span0, "class", "ms-inspector-item__icon");
      attr(span1, "class", "ms-inspector-item__arrow");
      attr(button, "class", "ms-inspector-item__tab");
      attr(button, "data-cy", "inspector-item-button");
      attr(div0, "class", "ms-inspector-item__tabs");
      attr(div1, "class", "ms-inspector-item__content");
      attr(div2, "class", div2_class_value = "ms-inspector-item " + addTypeClass$1(
        /*inspectorItem*/
        ctx[0].type
      ));
      attr(div2, "id", div2_id_value = /*inspectorItem*/
      ctx[0].id);
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      append(div2, div0);
      append(div0, button);
      append(button, span0);
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].m(span0, null);
      }
      append(button, t0);
      append(button, t1);
      append(button, t2);
      append(button, span1);
      mount_component(arrowicon, span1, null);
      append(div2, t3);
      append(div2, div1);
      if (if_block1)
        if_block1.m(div1, null);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler*/
          ctx[4]
        );
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index !== previous_block_index) {
        if (if_block0) {
          group_outros();
          transition_out(if_blocks[previous_block_index], 1, 1, () => {
            if_blocks[previous_block_index] = null;
          });
          check_outros();
        }
        if (~current_block_type_index) {
          if_block0 = if_blocks[current_block_type_index];
          if (!if_block0) {
            if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
            if_block0.c();
          }
          transition_in(if_block0, 1);
          if_block0.m(span0, null);
        } else {
          if_block0 = null;
        }
      }
      if ((!current || dirty & /*inspectorItem*/
      1) && t1_value !== (t1_value = /*inspectorItem*/
      ctx2[0].title + ""))
        set_data(t1, t1_value);
      const arrowicon_changes = {};
      if (dirty & /*openInspectorItem*/
      2)
        arrowicon_changes.style = "transform: rotate(" + /*openInspectorItem*/
        (ctx2[1] ? "180deg" : "0deg") + ")";
      arrowicon.$set(arrowicon_changes);
      if (
        /*openInspectorItem*/
        ctx2[1]
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty & /*openInspectorItem*/
          2) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block$c(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(div1, null);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
      if (!current || dirty & /*inspectorItem*/
      1 && div2_class_value !== (div2_class_value = "ms-inspector-item " + addTypeClass$1(
        /*inspectorItem*/
        ctx2[0].type
      ))) {
        attr(div2, "class", div2_class_value);
      }
      if (!current || dirty & /*inspectorItem*/
      1 && div2_id_value !== (div2_id_value = /*inspectorItem*/
      ctx2[0].id)) {
        attr(div2, "id", div2_id_value);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block0);
      transition_in(arrowicon.$$.fragment, local);
      transition_in(if_block1);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(arrowicon.$$.fragment, local);
      transition_out(if_block1);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div2);
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].d();
      }
      destroy_component(arrowicon);
      if (if_block1)
        if_block1.d();
      mounted = false;
      dispose();
    }
  };
}
function addTypeClass$1(type) {
  return `ms-inspector-item--${type}`;
}
function instance$e($$self, $$props, $$invalidate) {
  let $InspectorStore;
  component_subscribe($$self, InspectorStore, ($$value) => $$invalidate(2, $InspectorStore = $$value));
  let { inspectorItem } = $$props;
  let openInspectorItem = false;
  onDestroy(() => {
    $$invalidate(1, openInspectorItem = false);
  });
  function showInspectorItemContent() {
    $$invalidate(1, openInspectorItem = !openInspectorItem);
  }
  const click_handler = () => showInspectorItemContent();
  $$self.$$set = ($$props2) => {
    if ("inspectorItem" in $$props2)
      $$invalidate(0, inspectorItem = $$props2.inspectorItem);
  };
  return [
    inspectorItem,
    openInspectorItem,
    $InspectorStore,
    showInspectorItemContent,
    click_handler
  ];
}
var InspectorItem = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$e, create_fragment$j, safe_not_equal, { inspectorItem: 0 });
  }
};
function add_css$b(target) {
  append_styles(target, "svelte-1vlgs5i", '.ms-inspector-items__header.svelte-1vlgs5i.svelte-1vlgs5i{display:flex;align-items:center;justify-content:space-between;margin-bottom:7px;font-size:11px;color:#fff;flex-shrink:0;flex-grow:1}.ms-inspector-items__title.svelte-1vlgs5i.svelte-1vlgs5i{font-weight:700}.ms-inspector-items__toggle.svelte-1vlgs5i.svelte-1vlgs5i{display:flex;align-items:center;gap:5px}.ms-inspector-items__switch.svelte-1vlgs5i.svelte-1vlgs5i{position:relative;display:inline-block;width:40px;height:20px;margin:0;padding:0}.ms-inspector-items__switch.svelte-1vlgs5i input.svelte-1vlgs5i{opacity:0;width:0;height:0}.ms-inspector-items__slider.svelte-1vlgs5i.svelte-1vlgs5i{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#444;border:1px solid #4b4b4b;-webkit-transition:0.4s;transition:0.4s;border-radius:100px}.ms-inspector-items__slider.svelte-1vlgs5i.svelte-1vlgs5i:before{position:absolute;content:"";height:16px;width:16px;left:1px;bottom:1px;background-color:#c1c1c1;-webkit-transition:0.4s;transition:0.4s;border-radius:50%}input.svelte-1vlgs5i:checked+.ms-inspector-items__slider.svelte-1vlgs5i{background-color:#2962ff;border-color:#2962ff}input.svelte-1vlgs5i:focus+.ms-inspector-items__slider.svelte-1vlgs5i{box-shadow:0 0 1px #2962ff}input.svelte-1vlgs5i:checked+.ms-inspector-items__slider.svelte-1vlgs5i:before{-webkit-transform:translateX(20px);-ms-transform:translateX(20px);transform:translateX(20px)}.ms-inspector-item{width:100%;background-color:#444;border:1px solid #5c5c5c;border-radius:4px;flex-wrap:wrap;margin-bottom:0.5em;display:flex;transition:height 0.2s ease-in-out;overflow:hidden}.ms-inspector-item__tabs{display:flex;align-items:stretch;justify-content:space-between;width:100%}.ms-inspector-item__tab{gap:6px;padding:4px;display:flex;align-items:center;background-color:transparent;transition:background-color 0.2s ease-in-out}.ms-inspector-item__tab:first-child{flex-grow:1}.ms-inspector-item__tab:hover{background-color:#535353}.ms-inspector-item--error{border-color:#e06657}.ms-inspector-item--warning{border-color:#e4d179}.ms-inspector-item__icon{width:22px;height:22px;display:flex;align-items:center;justify-content:center;background-color:#292929;border-radius:3px;color:#fff}.ms-inspector-item__icon svg{padding:2px}.ms-inspector-item--cart .ms-inspector-item__icon{background-color:#292929}.ms-inspector-item--found .ms-inspector-item__icon{background-color:#5b9c6f}\n      .ms-inspector-item--plan-price-clicked .ms-inspector-item__icon\n    {background-color:#2962ff}\n      .ms-inspector-item--content-removed .ms-inspector-item__icon\n    {background-color:#bb5bce}.ms-inspector-item--error .ms-inspector-item__icon{background-color:#e06657}.ms-inspector-item--warning .ms-inspector-item__icon{background-color:#535353;color:#efd350}.ms-inspector-item__content{width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center}.ms-inspector-item__wrapper{width:100%}.ms-inspector-item__content-item{padding:7px;border-top:1px solid rgba(41, 41, 41, 0.5);width:100%}.ms-inspector-item__content-item > *{font-family:Plus Jakarta Sans, sans-serif !important;line-height:1.5em;font-size:11px !important;margin:0;padding:0}.ms-inspector-item__content-item p{line-height:1.5 !important;margin-bottom:7px;color:#c1c1c1;font-size:11px !important}.ms-inspector-item__content-item p:last-child{margin-bottom:0}.ms-inspector-item__content-item a{text-decoration:underline;color:#fff;word-wrap:break-all}.ms-inspector-item__content-item__title{font-weight:700;font-size:12px;margin-bottom:7px;color:#c1c1c1}.ms-inspector-item__content-item__help__title{width:100%;grid-column-gap:4px;grid-row-gap:4px;border:1px solid #373737;background-color:#535353;border-radius:4px;justify-content:space-between;align-items:center;margin-top:0.6em;margin-bottom:-3px;padding-left:1em;padding-right:1em;line-height:2.7em;display:flex;color:#fff}.ms-inspector-item__content-item__help__title:hover{border-color:#292929;background-color:#444}.ms-inspector-item__content-item__help__title--link{text-decoration:none}.ms-inspector-item__content-item__help__description{overflow:hidden}.ms-inspector-item__count{border-radius:3px;background-color:#000;color:#e8e8e8;font-weight:700;font-size:9.9px;line-height:1;padding:3px;margin:0}.ms-inspector-item__arrow{margin-left:auto;margin-right:8px;width:8px;transition:transform 0.2s ease-in-out}');
}
function get_each_context$4(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[6] = list[i];
  return child_ctx;
}
function get_each_context_1$3(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[6] = list[i];
  return child_ctx;
}
function get_each_context_2$1(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[6] = list[i];
  return child_ctx;
}
function get_each_context_3(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[6] = list[i];
  return child_ctx;
}
function create_each_block_3(key_1, ctx) {
  let first;
  let inspectoritem;
  let current;
  inspectoritem = new InspectorItem({
    props: { inspectorItem: (
      /*inspectorItem*/
      ctx[6]
    ) }
  });
  return {
    key: key_1,
    first: null,
    c() {
      first = empty();
      create_component(inspectoritem.$$.fragment);
      this.first = first;
    },
    m(target, anchor) {
      insert(target, first, anchor);
      mount_component(inspectoritem, target, anchor);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      const inspectoritem_changes = {};
      if (dirty & /*inspectorItemsData*/
      2)
        inspectoritem_changes.inspectorItem = /*inspectorItem*/
        ctx[6];
      inspectoritem.$set(inspectoritem_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(inspectoritem.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(inspectoritem.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(first);
      destroy_component(inspectoritem, detaching);
    }
  };
}
function create_if_block$b(ctx) {
  let div1;
  let div0;
  let button;
  let span0;
  let magicon;
  let t0;
  let span1;
  let t2;
  let span2;
  let t3;
  let t4_value = (
    /*inspectorItemsData*/
    ctx[1].filter(func_2$1).length + ""
  );
  let t4;
  let t5;
  let span3;
  let arrowicon;
  let t6;
  let if_block_anchor;
  let current;
  let mounted;
  let dispose;
  magicon = new MagIcon({});
  arrowicon = new ArrowIcon({
    props: {
      style: "transform: rotate(" + /*showFoundItems*/
      (ctx[2] ? "180deg" : "0deg") + ")"
    }
  });
  let if_block = (
    /*showFoundItems*/
    ctx[2] && create_if_block_1$9(ctx)
  );
  return {
    c() {
      div1 = element("div");
      div0 = element("div");
      button = element("button");
      span0 = element("span");
      create_component(magicon.$$.fragment);
      t0 = space();
      span1 = element("span");
      span1.textContent = "Attributes Found";
      t2 = space();
      span2 = element("span");
      t3 = text("x");
      t4 = text(t4_value);
      t5 = space();
      span3 = element("span");
      create_component(arrowicon.$$.fragment);
      t6 = space();
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
      attr(span0, "class", "ms-inspector-item__icon");
      attr(span1, "class", "ms-inspector-item__text");
      attr(span2, "class", "ms-inspector-item__count");
      attr(span3, "class", "ms-inspector-item__arrow");
      attr(button, "class", "ms-inspector-item__tab");
      attr(button, "data-cy", "inspector-item--group-button");
      attr(div0, "class", "ms-inspector-item__tabs");
      attr(div1, "class", "ms-inspector-item ms-inspector-item--found");
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);
      append(div0, button);
      append(button, span0);
      mount_component(magicon, span0, null);
      append(button, t0);
      append(button, span1);
      append(button, t2);
      append(button, span2);
      append(span2, t3);
      append(span2, t4);
      append(button, t5);
      append(button, span3);
      mount_component(arrowicon, span3, null);
      insert(target, t6, anchor);
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*toggleShowFoundItems*/
          ctx[3]
        );
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      if ((!current || dirty & /*inspectorItemsData*/
      2) && t4_value !== (t4_value = /*inspectorItemsData*/
      ctx2[1].filter(func_2$1).length + ""))
        set_data(t4, t4_value);
      const arrowicon_changes = {};
      if (dirty & /*showFoundItems*/
      4)
        arrowicon_changes.style = "transform: rotate(" + /*showFoundItems*/
        (ctx2[2] ? "180deg" : "0deg") + ")";
      arrowicon.$set(arrowicon_changes);
      if (
        /*showFoundItems*/
        ctx2[2]
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
          if (dirty & /*showFoundItems*/
          4) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block_1$9(ctx2);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(magicon.$$.fragment, local);
      transition_in(arrowicon.$$.fragment, local);
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(magicon.$$.fragment, local);
      transition_out(arrowicon.$$.fragment, local);
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div1);
      destroy_component(magicon);
      destroy_component(arrowicon);
      if (detaching)
        detach(t6);
      if (if_block)
        if_block.d(detaching);
      if (detaching)
        detach(if_block_anchor);
      mounted = false;
      dispose();
    }
  };
}
function create_if_block_1$9(ctx) {
  let each_blocks = [];
  let each_1_lookup = /* @__PURE__ */ new Map();
  let each_1_anchor;
  let current;
  let each_value_2 = (
    /*inspectorItemsData*/
    ctx[1].filter(func_3$1)
  );
  const get_key = (ctx2) => (
    /*inspectorItem*/
    ctx2[6].id
  );
  for (let i = 0; i < each_value_2.length; i += 1) {
    let child_ctx = get_each_context_2$1(ctx, each_value_2, i);
    let key = get_key(child_ctx);
    each_1_lookup.set(key, each_blocks[i] = create_each_block_2$1(key, child_ctx));
  }
  return {
    c() {
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      each_1_anchor = empty();
    },
    m(target, anchor) {
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(target, anchor);
        }
      }
      insert(target, each_1_anchor, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      if (dirty & /*inspectorItemsData*/
      2) {
        each_value_2 = /*inspectorItemsData*/
        ctx2[1].filter(func_3$1);
        group_outros();
        each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx2, each_value_2, each_1_lookup, each_1_anchor.parentNode, outro_and_destroy_block, create_each_block_2$1, each_1_anchor, get_each_context_2$1);
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      for (let i = 0; i < each_value_2.length; i += 1) {
        transition_in(each_blocks[i]);
      }
      current = true;
    },
    o(local) {
      for (let i = 0; i < each_blocks.length; i += 1) {
        transition_out(each_blocks[i]);
      }
      current = false;
    },
    d(detaching) {
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].d(detaching);
      }
      if (detaching)
        detach(each_1_anchor);
    }
  };
}
function create_each_block_2$1(key_1, ctx) {
  let first;
  let inspectoritem;
  let current;
  inspectoritem = new InspectorItem({
    props: { inspectorItem: (
      /*inspectorItem*/
      ctx[6]
    ) }
  });
  return {
    key: key_1,
    first: null,
    c() {
      first = empty();
      create_component(inspectoritem.$$.fragment);
      this.first = first;
    },
    m(target, anchor) {
      insert(target, first, anchor);
      mount_component(inspectoritem, target, anchor);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      const inspectoritem_changes = {};
      if (dirty & /*inspectorItemsData*/
      2)
        inspectoritem_changes.inspectorItem = /*inspectorItem*/
        ctx[6];
      inspectoritem.$set(inspectoritem_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(inspectoritem.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(inspectoritem.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(first);
      destroy_component(inspectoritem, detaching);
    }
  };
}
function create_each_block_1$3(key_1, ctx) {
  let first;
  let inspectoritem;
  let current;
  inspectoritem = new InspectorItem({
    props: { inspectorItem: (
      /*inspectorItem*/
      ctx[6]
    ) }
  });
  return {
    key: key_1,
    first: null,
    c() {
      first = empty();
      create_component(inspectoritem.$$.fragment);
      this.first = first;
    },
    m(target, anchor) {
      insert(target, first, anchor);
      mount_component(inspectoritem, target, anchor);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      const inspectoritem_changes = {};
      if (dirty & /*inspectorItemsData*/
      2)
        inspectoritem_changes.inspectorItem = /*inspectorItem*/
        ctx[6];
      inspectoritem.$set(inspectoritem_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(inspectoritem.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(inspectoritem.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(first);
      destroy_component(inspectoritem, detaching);
    }
  };
}
function create_each_block$4(key_1, ctx) {
  let first;
  let inspectoritem;
  let current;
  inspectoritem = new InspectorItem({
    props: { inspectorItem: (
      /*inspectorItem*/
      ctx[6]
    ) }
  });
  return {
    key: key_1,
    first: null,
    c() {
      first = empty();
      create_component(inspectoritem.$$.fragment);
      this.first = first;
    },
    m(target, anchor) {
      insert(target, first, anchor);
      mount_component(inspectoritem, target, anchor);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      const inspectoritem_changes = {};
      if (dirty & /*inspectorItemsData*/
      2)
        inspectoritem_changes.inspectorItem = /*inspectorItem*/
        ctx[6];
      inspectoritem.$set(inspectoritem_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(inspectoritem.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(inspectoritem.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(first);
      destroy_component(inspectoritem, detaching);
    }
  };
}
function create_fragment$i(ctx) {
  let div2;
  let div0;
  let t1;
  let div1;
  let t2;
  let label;
  let input;
  let t3;
  let span;
  let t4;
  let each_blocks_2 = [];
  let each0_lookup = /* @__PURE__ */ new Map();
  let t5;
  let show_if = (
    /*inspectorItemsData*/
    ctx[1].filter(func$1).length > 0
  );
  let t6;
  let each_blocks_1 = [];
  let each1_lookup = /* @__PURE__ */ new Map();
  let t7;
  let each_blocks = [];
  let each2_lookup = /* @__PURE__ */ new Map();
  let each2_anchor;
  let current;
  let mounted;
  let dispose;
  let each_value_3 = (
    /*inspectorItemsData*/
    ctx[1].filter(func_1$1)
  );
  const get_key = (ctx2) => (
    /*inspectorItem*/
    ctx2[6].id
  );
  for (let i = 0; i < each_value_3.length; i += 1) {
    let child_ctx = get_each_context_3(ctx, each_value_3, i);
    let key = get_key(child_ctx);
    each0_lookup.set(key, each_blocks_2[i] = create_each_block_3(key, child_ctx));
  }
  let if_block = show_if && create_if_block$b(ctx);
  let each_value_1 = (
    /*inspectorItemsData*/
    ctx[1].filter(func_4$1)
  );
  const get_key_1 = (ctx2) => (
    /*inspectorItem*/
    ctx2[6].id
  );
  for (let i = 0; i < each_value_1.length; i += 1) {
    let child_ctx = get_each_context_1$3(ctx, each_value_1, i);
    let key = get_key_1(child_ctx);
    each1_lookup.set(key, each_blocks_1[i] = create_each_block_1$3(key, child_ctx));
  }
  let each_value = (
    /*inspectorItemsData*/
    ctx[1].filter(func_5$1)
  );
  const get_key_2 = (ctx2) => (
    /*inspectorItem*/
    ctx2[6].id
  );
  for (let i = 0; i < each_value.length; i += 1) {
    let child_ctx = get_each_context$4(ctx, each_value, i);
    let key = get_key_2(child_ctx);
    each2_lookup.set(key, each_blocks[i] = create_each_block$4(key, child_ctx));
  }
  return {
    c() {
      div2 = element("div");
      div0 = element("div");
      div0.textContent = "Events & Errors";
      t1 = space();
      div1 = element("div");
      t2 = text("X-ray\n    ");
      label = element("label");
      input = element("input");
      t3 = space();
      span = element("span");
      t4 = space();
      for (let i = 0; i < each_blocks_2.length; i += 1) {
        each_blocks_2[i].c();
      }
      t5 = space();
      if (if_block)
        if_block.c();
      t6 = space();
      for (let i = 0; i < each_blocks_1.length; i += 1) {
        each_blocks_1[i].c();
      }
      t7 = space();
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      each2_anchor = empty();
      attr(div0, "class", "ms-inspector-items__title svelte-1vlgs5i");
      attr(input, "type", "checkbox");
      attr(input, "data-cy", "x-ray-switch");
      attr(input, "class", "svelte-1vlgs5i");
      attr(span, "class", "ms-inspector-items__slider svelte-1vlgs5i");
      attr(label, "class", "ms-inspector-items__switch svelte-1vlgs5i");
      attr(div1, "class", "ms-inspector-items__toggle svelte-1vlgs5i");
      attr(div2, "class", "ms-inspector-items__header svelte-1vlgs5i");
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      append(div2, div0);
      append(div2, t1);
      append(div2, div1);
      append(div1, t2);
      append(div1, label);
      append(label, input);
      input.checked = /*$InspectorStore*/
      ctx[0].xRayMode;
      append(label, t3);
      append(label, span);
      insert(target, t4, anchor);
      for (let i = 0; i < each_blocks_2.length; i += 1) {
        if (each_blocks_2[i]) {
          each_blocks_2[i].m(target, anchor);
        }
      }
      insert(target, t5, anchor);
      if (if_block)
        if_block.m(target, anchor);
      insert(target, t6, anchor);
      for (let i = 0; i < each_blocks_1.length; i += 1) {
        if (each_blocks_1[i]) {
          each_blocks_1[i].m(target, anchor);
        }
      }
      insert(target, t7, anchor);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(target, anchor);
        }
      }
      insert(target, each2_anchor, anchor);
      current = true;
      if (!mounted) {
        dispose = [
          listen(
            input,
            "change",
            /*handleChange*/
            ctx[4]
          ),
          listen(
            input,
            "change",
            /*input_change_handler*/
            ctx[5]
          )
        ];
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (dirty & /*$InspectorStore*/
      1) {
        input.checked = /*$InspectorStore*/
        ctx2[0].xRayMode;
      }
      if (dirty & /*inspectorItemsData*/
      2) {
        each_value_3 = /*inspectorItemsData*/
        ctx2[1].filter(func_1$1);
        group_outros();
        each_blocks_2 = update_keyed_each(each_blocks_2, dirty, get_key, 1, ctx2, each_value_3, each0_lookup, t5.parentNode, outro_and_destroy_block, create_each_block_3, t5, get_each_context_3);
        check_outros();
      }
      if (dirty & /*inspectorItemsData*/
      2)
        show_if = /*inspectorItemsData*/
        ctx2[1].filter(func$1).length > 0;
      if (show_if) {
        if (if_block) {
          if_block.p(ctx2, dirty);
          if (dirty & /*inspectorItemsData*/
          2) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$b(ctx2);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(t6.parentNode, t6);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
      if (dirty & /*inspectorItemsData*/
      2) {
        each_value_1 = /*inspectorItemsData*/
        ctx2[1].filter(func_4$1);
        group_outros();
        each_blocks_1 = update_keyed_each(each_blocks_1, dirty, get_key_1, 1, ctx2, each_value_1, each1_lookup, t7.parentNode, outro_and_destroy_block, create_each_block_1$3, t7, get_each_context_1$3);
        check_outros();
      }
      if (dirty & /*inspectorItemsData*/
      2) {
        each_value = /*inspectorItemsData*/
        ctx2[1].filter(func_5$1);
        group_outros();
        each_blocks = update_keyed_each(each_blocks, dirty, get_key_2, 1, ctx2, each_value, each2_lookup, each2_anchor.parentNode, outro_and_destroy_block, create_each_block$4, each2_anchor, get_each_context$4);
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      for (let i = 0; i < each_value_3.length; i += 1) {
        transition_in(each_blocks_2[i]);
      }
      transition_in(if_block);
      for (let i = 0; i < each_value_1.length; i += 1) {
        transition_in(each_blocks_1[i]);
      }
      for (let i = 0; i < each_value.length; i += 1) {
        transition_in(each_blocks[i]);
      }
      current = true;
    },
    o(local) {
      for (let i = 0; i < each_blocks_2.length; i += 1) {
        transition_out(each_blocks_2[i]);
      }
      transition_out(if_block);
      for (let i = 0; i < each_blocks_1.length; i += 1) {
        transition_out(each_blocks_1[i]);
      }
      for (let i = 0; i < each_blocks.length; i += 1) {
        transition_out(each_blocks[i]);
      }
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div2);
      if (detaching)
        detach(t4);
      for (let i = 0; i < each_blocks_2.length; i += 1) {
        each_blocks_2[i].d(detaching);
      }
      if (detaching)
        detach(t5);
      if (if_block)
        if_block.d(detaching);
      if (detaching)
        detach(t6);
      for (let i = 0; i < each_blocks_1.length; i += 1) {
        each_blocks_1[i].d(detaching);
      }
      if (detaching)
        detach(t7);
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].d(detaching);
      }
      if (detaching)
        detach(each2_anchor);
      mounted = false;
      run_all(dispose);
    }
  };
}
var func$1 = (item) => item.type === "found";
var func_1$1 = (item) => item.type === "cart";
var func_2$1 = (item) => item.type === "found";
var func_3$1 = (item) => item.type === "found";
var func_4$1 = (item) => item.type === "error";
var func_5$1 = (item) => item.type === "warning";
function instance$d($$self, $$props, $$invalidate) {
  let $InspectorStore;
  component_subscribe($$self, InspectorStore, ($$value) => $$invalidate(0, $InspectorStore = $$value));
  let inspectorItemsData = [];
  let showFoundItems = false;
  onDestroy(() => {
    $$invalidate(2, showFoundItems = false);
  });
  function toggleShowFoundItems() {
    $$invalidate(2, showFoundItems = !showFoundItems);
  }
  function handleChange() {
    ToggleXRayMode();
  }
  function input_change_handler() {
    $InspectorStore.xRayMode = this.checked;
    InspectorStore.set($InspectorStore);
  }
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$InspectorStore*/
    1) {
      if ($InspectorStore.inspectorData.length > 0) {
        $$invalidate(1, inspectorItemsData = $InspectorStore.inspectorData.map((id) => {
          return inspectorItems.find((item) => item.id === id);
        }));
      }
    }
    if ($$self.$$.dirty & /*$InspectorStore*/
    1) {
      if ($InspectorStore.xRayMode === true) {
        checkFoundDataAttributes();
        checkErrorDataAttributes();
        checkWarningDataAttributes();
      } else {
        removeXrays();
      }
    }
  };
  return [
    $InspectorStore,
    inspectorItemsData,
    showFoundItems,
    toggleShowFoundItems,
    handleChange,
    input_change_handler
  ];
}
var InspectorTab = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$d, create_fragment$i, safe_not_equal, {}, add_css$b);
  }
};
function add_css$a(target) {
  append_styles(target, "svelte-1ave6sr", "button.svelte-1ave6sr{background:none;border:none;cursor:pointer;padding:0;display:flex;align-items:center}");
}
function create_fragment$h(ctx) {
  let button;
  let svg;
  let path;
  let button_class_value;
  let mounted;
  let dispose;
  return {
    c() {
      button = element("button");
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-520q0-17 11.5-28.5T160-720q17 0 28.5 11.5T200-680v520h400q17 0 28.5 11.5T640-120q0 17-11.5 28.5T600-80H200Zm160-240v-480 480Z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "viewBox", "120 -880 680 800");
      attr(
        button,
        "style",
        /*style*/
        ctx[0]
      );
      attr(button, "class", button_class_value = null_to_empty(
        /*clazz*/
        ctx[1]
      ) + " svelte-1ave6sr");
    },
    m(target, anchor) {
      insert(target, button, anchor);
      append(button, svg);
      append(svg, path);
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*copyToClipboard*/
          ctx[2]
        );
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (dirty & /*style*/
      1) {
        attr(
          button,
          "style",
          /*style*/
          ctx2[0]
        );
      }
      if (dirty & /*clazz*/
      2 && button_class_value !== (button_class_value = null_to_empty(
        /*clazz*/
        ctx2[1]
      ) + " svelte-1ave6sr")) {
        attr(button, "class", button_class_value);
      }
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(button);
      mounted = false;
      dispose();
    }
  };
}
function instance$c($$self, $$props, $$invalidate) {
  let { style = "" } = $$props;
  let { class: clazz } = $$props;
  let { copyText } = $$props;
  function copyToClipboard() {
    if (copyText) {
      navigator.clipboard.writeText(copyText);
    }
  }
  $$self.$$set = ($$props2) => {
    if ("style" in $$props2)
      $$invalidate(0, style = $$props2.style);
    if ("class" in $$props2)
      $$invalidate(1, clazz = $$props2.class);
    if ("copyText" in $$props2)
      $$invalidate(3, copyText = $$props2.copyText);
  };
  return [style, clazz, copyToClipboard, copyText];
}
var CopyIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$c, create_fragment$h, safe_not_equal, { style: 0, class: 1, copyText: 3 }, add_css$a);
  }
};
function add_css$9(target) {
  append_styles(target, "svelte-pivqfu", ".ms-member-tab__data-group.svelte-pivqfu{display:flex;align-items:center;gap:3px;margin-bottom:6px}.ms-member-tab__data-group.svelte-pivqfu:last-child{margin-bottom:0}.ms-member-tab__data-group.ms-member-tab__data-group--flex-top.svelte-pivqfu{align-items:flex-start}.ms-member-tab__data-group__label.svelte-pivqfu{width:150px;color:#e8e8e8;border:1px solid #4b4b4b;border-radius:4px;background:#444;font-size:9px;line-height:1;padding:6px;flex-shrink:0;width:auto}.ms-member-tab__data-group__copy-box.svelte-pivqfu{flex-grow:0;position:relative;display:flex;align-items:center;overflow:hidden;gap:6px}.ms-member-tab__data-group__copy-box__button.svelte-pivqfu{border:1px solid #4b4b4b;border-radius:4px;background:#000;color:#e8e8e8;font-size:10px;font-weight:700;line-height:1;padding:6px;flex-grow:1;text-align:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ms-member-tab__data-group__copy-box__icon{width:11px;height:auto;flex-shrink:0;fill:#e8e8e8;opacity:0;transition:opacity 0.2s ease-in-out}\n      .ms-member-tab__data-group__copy-box__button:hover\n        + .ms-member-tab__data-group__copy-box__icon\n    {opacity:1}.ms-member-tab__data-group__copy-box__icon:hover{opacity:1;cursor:pointer}");
}
function create_else_block$5(ctx) {
  let button;
  let t;
  let mounted;
  let dispose;
  return {
    c() {
      button = element("button");
      t = text(
        /*buttonText*/
        ctx[0]
      );
      attr(button, "class", "ms-member-tab__data-group__copy-box__button svelte-pivqfu");
    },
    m(target, anchor) {
      insert(target, button, anchor);
      append(button, t);
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*copyToClipboard*/
          ctx[3]
        );
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      if (dirty & /*buttonText*/
      1)
        set_data(
          t,
          /*buttonText*/
          ctx2[0]
        );
    },
    d(detaching) {
      if (detaching)
        detach(button);
      mounted = false;
      dispose();
    }
  };
}
function create_if_block_1$8(ctx) {
  let button;
  return {
    c() {
      button = element("button");
      attr(button, "class", "ms-member-tab__data-group__copy-box__button ms-member-tab__data-group__copy-box__button--image svelte-pivqfu");
      set_style(button, "background-image", "url(" + /*buttonText*/
      ctx[0] + ")");
      set_style(button, "min-width", "42px");
      set_style(button, "min-height", "42px");
      set_style(button, "background-size", "cover");
      set_style(button, "background-position", "center");
    },
    m(target, anchor) {
      insert(target, button, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*buttonText*/
      1) {
        set_style(button, "background-image", "url(" + /*buttonText*/
        ctx2[0] + ")");
      }
    },
    d(detaching) {
      if (detaching)
        detach(button);
    }
  };
}
function create_if_block$a(ctx) {
  let button;
  return {
    c() {
      button = element("button");
      attr(button, "class", "ms-member-tab__data-group__copy-box__button ms-member-tab__data-group__copy-box__button--color svelte-pivqfu");
      set_style(
        button,
        "background-color",
        /*buttonText*/
        ctx[0]
      );
      set_style(button, "min-width", "42px");
      set_style(button, "min-height", "23px");
    },
    m(target, anchor) {
      insert(target, button, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*buttonText*/
      1) {
        set_style(
          button,
          "background-color",
          /*buttonText*/
          ctx2[0]
        );
      }
    },
    d(detaching) {
      if (detaching)
        detach(button);
    }
  };
}
function create_fragment$g(ctx) {
  let div2;
  let div0;
  let t0;
  let t1;
  let div1;
  let show_if;
  let show_if_1;
  let t2;
  let copyicon;
  let div2_class_value;
  let current;
  function select_block_type(ctx2, dirty) {
    if (dirty & /*buttonText*/
    1)
      show_if = null;
    if (dirty & /*buttonText*/
    1)
      show_if_1 = null;
    if (show_if == null)
      show_if = !!/*buttonText*/
      (ctx2[0] && /*buttonText*/
      (ctx2[0].startsWith("#") || /*buttonText*/
      ctx2[0] && /*buttonText*/
      ctx2[0].startsWith("rgb")));
    if (show_if)
      return create_if_block$a;
    if (show_if_1 == null)
      show_if_1 = !!/*endsWith*/
      (ctx2[4](
        /*buttonText*/
        ctx2[0],
        ".png"
      ) || /*endsWith*/
      ctx2[4](
        /*buttonText*/
        ctx2[0],
        ".jpg"
      ) || /*endsWith*/
      ctx2[4](
        /*buttonText*/
        ctx2[0],
        ".jpeg"
      ) || /*endsWith*/
      ctx2[4](
        /*buttonText*/
        ctx2[0],
        ".gif"
      ));
    if (show_if_1)
      return create_if_block_1$8;
    return create_else_block$5;
  }
  let current_block_type = select_block_type(ctx, -1);
  let if_block = current_block_type(ctx);
  copyicon = new CopyIcon({
    props: {
      class: "ms-member-tab__data-group__copy-box__icon",
      copyText: (
        /*buttonText*/
        ctx[0]
      )
    }
  });
  return {
    c() {
      div2 = element("div");
      div0 = element("div");
      t0 = text(
        /*labelText*/
        ctx[1]
      );
      t1 = space();
      div1 = element("div");
      if_block.c();
      t2 = space();
      create_component(copyicon.$$.fragment);
      attr(div0, "class", "ms-member-tab__data-group__label svelte-pivqfu");
      attr(div1, "class", "ms-member-tab__data-group__copy-box svelte-pivqfu");
      attr(
        div2,
        "data-cy",
        /*cypress*/
        ctx[2]
      );
      attr(div2, "class", div2_class_value = "ms-member-tab__data-group " + /*endsWith*/
      (ctx[4](
        /*buttonText*/
        ctx[0],
        ".png"
      ) || /*endsWith*/
      ctx[4](
        /*buttonText*/
        ctx[0],
        ".jpg"
      ) || /*endsWith*/
      ctx[4](
        /*buttonText*/
        ctx[0],
        ".jpeg"
      ) || /*endsWith*/
      ctx[4](
        /*buttonText*/
        ctx[0],
        ".gif"
      ) ? "ms-member-tab__data-group--flex-top" : "") + " svelte-pivqfu");
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      append(div2, div0);
      append(div0, t0);
      append(div2, t1);
      append(div2, div1);
      if_block.m(div1, null);
      append(div1, t2);
      mount_component(copyicon, div1, null);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (!current || dirty & /*labelText*/
      2)
        set_data(
          t0,
          /*labelText*/
          ctx2[1]
        );
      if (current_block_type === (current_block_type = select_block_type(ctx2, dirty)) && if_block) {
        if_block.p(ctx2, dirty);
      } else {
        if_block.d(1);
        if_block = current_block_type(ctx2);
        if (if_block) {
          if_block.c();
          if_block.m(div1, t2);
        }
      }
      const copyicon_changes = {};
      if (dirty & /*buttonText*/
      1)
        copyicon_changes.copyText = /*buttonText*/
        ctx2[0];
      copyicon.$set(copyicon_changes);
      if (!current || dirty & /*cypress*/
      4) {
        attr(
          div2,
          "data-cy",
          /*cypress*/
          ctx2[2]
        );
      }
      if (!current || dirty & /*buttonText*/
      1 && div2_class_value !== (div2_class_value = "ms-member-tab__data-group " + /*endsWith*/
      (ctx2[4](
        /*buttonText*/
        ctx2[0],
        ".png"
      ) || /*endsWith*/
      ctx2[4](
        /*buttonText*/
        ctx2[0],
        ".jpg"
      ) || /*endsWith*/
      ctx2[4](
        /*buttonText*/
        ctx2[0],
        ".jpeg"
      ) || /*endsWith*/
      ctx2[4](
        /*buttonText*/
        ctx2[0],
        ".gif"
      ) ? "ms-member-tab__data-group--flex-top" : "") + " svelte-pivqfu")) {
        attr(div2, "class", div2_class_value);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(copyicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(copyicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div2);
      if_block.d();
      destroy_component(copyicon);
    }
  };
}
function instance$b($$self, $$props, $$invalidate) {
  let { labelText } = $$props;
  let { buttonText } = $$props;
  let { cypress } = $$props;
  function copyToClipboard() {
    navigator.clipboard.writeText(buttonText);
  }
  const endsWith = (text2, suffix) => typeof text2 === "string" && text2.endsWith(suffix);
  if (buttonText !== null && buttonText !== void 0 && typeof buttonText !== "string") {
    buttonText = buttonText.toString();
  }
  $$self.$$set = ($$props2) => {
    if ("labelText" in $$props2)
      $$invalidate(1, labelText = $$props2.labelText);
    if ("buttonText" in $$props2)
      $$invalidate(0, buttonText = $$props2.buttonText);
    if ("cypress" in $$props2)
      $$invalidate(2, cypress = $$props2.cypress);
  };
  return [buttonText, labelText, cypress, copyToClipboard, endsWith];
}
var CopyButtonGroup = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$b, create_fragment$g, safe_not_equal, { labelText: 1, buttonText: 0, cypress: 2 }, add_css$9);
  }
};
function create_fragment$f(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h357l-80 80H200v560h560v-278l80-80v358q0 33-23.5 56.5T760-120H200Zm280-360Zm-120 80v-97q0-16 6-30.5t17-25.5l344-344q12-12 27-18t30-6q16 0 30.5 6t26.5 18l56 57q11 12 17 26.5t6 29.5q0 15-5.5 29.5T897-728L553-384q-11 11-25.5 17.5T497-360h-97q-17 0-28.5-11.5T360-400Zm481-384-56-56 56 56ZM440-440h56l232-232-28-28-29-28-231 231v57Zm260-260-29-28 29 28 28 28-28-28Z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "viewBox", "120 -921 800 801");
      attr(
        svg,
        "class",
        /*clazz*/
        ctx[0]
      );
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p(ctx2, [dirty]) {
      if (dirty & /*clazz*/
      1) {
        attr(
          svg,
          "class",
          /*clazz*/
          ctx2[0]
        );
      }
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
function instance$a($$self, $$props, $$invalidate) {
  let { class: clazz } = $$props;
  $$self.$$set = ($$props2) => {
    if ("class" in $$props2)
      $$invalidate(0, clazz = $$props2.class);
  };
  return [clazz];
}
var EditIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$a, create_fragment$f, safe_not_equal, { class: 0 });
  }
};
function add_css$8(target) {
  append_styles(target, "svelte-1l53fni", ".ms-section-header.svelte-1l53fni{display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;width:100%}.ms-section-header__title.svelte-1l53fni{font-size:11px;line-height:1;font-weight:700;color:#e8e8e8}.ms-section-header__link.svelte-1l53fni{text-decoration:none;display:flex;align-items:center;gap:4px;color:#c1c1c1;font-size:10px;font-weight:400;transition:all 0.2s ease-in-out;border:1px solid #535353;border-radius:4px;background:#444;padding:1px 3px}.ms-section-header__link.svelte-1l53fni:hover{color:#fff}.ms-section-header__link__svg{width:13px;height:auto;fill:#c1c1c1}");
}
function create_if_block$9(ctx) {
  let a;
  let editicon;
  let span;
  let current;
  editicon = new EditIcon({
    props: { class: "ms-section-header__link__svg" }
  });
  return {
    c() {
      a = element("a");
      create_component(editicon.$$.fragment);
      span = element("span");
      span.textContent = "Edit";
      attr(a, "class", "ms-section-header__link svelte-1l53fni");
      attr(
        a,
        "href",
        /*editURL*/
        ctx[1]
      );
      attr(a, "target", "_blank");
    },
    m(target, anchor) {
      insert(target, a, anchor);
      mount_component(editicon, a, null);
      append(a, span);
      current = true;
    },
    p(ctx2, dirty) {
      if (!current || dirty & /*editURL*/
      2) {
        attr(
          a,
          "href",
          /*editURL*/
          ctx2[1]
        );
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(editicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(editicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(a);
      destroy_component(editicon);
    }
  };
}
function create_fragment$e(ctx) {
  let div1;
  let div0;
  let t0;
  let t1;
  let current;
  let if_block = (
    /*editURL*/
    ctx[1] && create_if_block$9(ctx)
  );
  return {
    c() {
      div1 = element("div");
      div0 = element("div");
      t0 = text(
        /*titleText*/
        ctx[0]
      );
      t1 = space();
      if (if_block)
        if_block.c();
      attr(div0, "class", "ms-section-header__title svelte-1l53fni");
      attr(div1, "class", "ms-section-header svelte-1l53fni");
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);
      append(div0, t0);
      append(div1, t1);
      if (if_block)
        if_block.m(div1, null);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (!current || dirty & /*titleText*/
      1)
        set_data(
          t0,
          /*titleText*/
          ctx2[0]
        );
      if (
        /*editURL*/
        ctx2[1]
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
          if (dirty & /*editURL*/
          2) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$9(ctx2);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(div1, null);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div1);
      if (if_block)
        if_block.d();
    }
  };
}
function instance$9($$self, $$props, $$invalidate) {
  let { titleText } = $$props;
  let { editURL } = $$props;
  $$self.$$set = ($$props2) => {
    if ("titleText" in $$props2)
      $$invalidate(0, titleText = $$props2.titleText);
    if ("editURL" in $$props2)
      $$invalidate(1, editURL = $$props2.editURL);
  };
  return [titleText, editURL];
}
var SectionHeader = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$9, create_fragment$e, safe_not_equal, { titleText: 0, editURL: 1 }, add_css$8);
  }
};
function create_fragment$d(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q48 0 93.5 11t87.5 32q15 8 19.5 24t-5.5 30q-10 14-26.5 18t-32.5-4q-32-15-66.5-23t-69.5-8q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-8-.5-15.5T798-511q-2-17 6.5-32.5T830-564q16-5 30 3t16 24q2 14 3 28t1 29q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-56-328 372-373q11-11 27.5-11.5T852-781q11 11 11 28t-11 28L452-324q-12 12-28 12t-28-12L282-438q-11-11-11-28t11-28q11-11 28-11t28 11l86 86Z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "height", "100%");
      attr(svg, "viewBox", "0 -960 960 960");
      attr(svg, "width", "100%");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var CheckIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$d, safe_not_equal, {});
  }
};
function add_css$7(target) {
  append_styles(target, "svelte-lh6dn1", ".ms-button-link.svelte-lh6dn1{display:flex;align-items:center;justify-content:space-between;gap:4px;color:#e8e8e8;font-size:11px;line-height:1;text-decoration:none;border:1px solid #373737;border-radius:4px;background:#535353;padding:5px 10px;transition:all 0.2s ease-in-out;margin-top:12px}.ms-app-tab__section__content--auth .ms-button-link{margin-top:0;margin-bottom:0.5em}.ms-button-link.svelte-lh6dn1:last-child{margin-bottom:0}.ms-button-link.svelte-lh6dn1:hover{color:#fff}.ms-button-link__svg{width:13px;height:auto;fill:#c1c1c1}.help-option__left-icon.svelte-lh6dn1{display:flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:3px;padding:2px;margin-left:-6px}.help-option__left-icon--enabled.svelte-lh6dn1{background:#5b9c6f\n  }.help-option__left-icon--disabled.svelte-lh6dn1{background:#292929\n  }.help-option__left-icon svg{width:100%;height:auto}.help-option__text.svelte-lh6dn1{flex:1}");
}
function create_if_block_1$7(ctx) {
  let span;
  let current_block_type_index;
  let if_block;
  let span_class_value;
  let current;
  const if_block_creators = [create_if_block_2$6, create_else_block$4];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*status*/
      ctx2[1] === true
    )
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      span = element("span");
      if_block.c();
      attr(span, "class", span_class_value = null_to_empty(`help-option__left-icon help-option__left-icon--${/*status*/
      ctx[1] ? "enabled" : "disabled"}`) + " svelte-lh6dn1");
    },
    m(target, anchor) {
      insert(target, span, anchor);
      if_blocks[current_block_type_index].m(span, null);
      current = true;
    },
    p(ctx2, dirty) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index !== previous_block_index) {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        }
        transition_in(if_block, 1);
        if_block.m(span, null);
      }
      if (!current || dirty & /*status*/
      2 && span_class_value !== (span_class_value = null_to_empty(`help-option__left-icon help-option__left-icon--${/*status*/
      ctx2[1] ? "enabled" : "disabled"}`) + " svelte-lh6dn1")) {
        attr(span, "class", span_class_value);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(span);
      if_blocks[current_block_type_index].d();
    }
  };
}
function create_else_block$4(ctx) {
  let xicon;
  let current;
  xicon = new XIcon({});
  return {
    c() {
      create_component(xicon.$$.fragment);
    },
    m(target, anchor) {
      mount_component(xicon, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(xicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(xicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(xicon, detaching);
    }
  };
}
function create_if_block_2$6(ctx) {
  let checkicon;
  let current;
  checkicon = new CheckIcon({});
  return {
    c() {
      create_component(checkicon.$$.fragment);
    },
    m(target, anchor) {
      mount_component(checkicon, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(checkicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(checkicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(checkicon, detaching);
    }
  };
}
function create_if_block$8(ctx) {
  let linkicon;
  let current;
  linkicon = new LinkIcon({});
  return {
    c() {
      create_component(linkicon.$$.fragment);
    },
    m(target, anchor) {
      mount_component(linkicon, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(linkicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(linkicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(linkicon, detaching);
    }
  };
}
function create_fragment$c(ctx) {
  let a;
  let t0;
  let span;
  let t1;
  let t2;
  let current;
  let if_block0 = (
    /*status*/
    ctx[1] !== void 0 && create_if_block_1$7(ctx)
  );
  let if_block1 = (
    /*showIcon*/
    ctx[3] && create_if_block$8()
  );
  return {
    c() {
      a = element("a");
      if (if_block0)
        if_block0.c();
      t0 = space();
      span = element("span");
      t1 = text(
        /*text*/
        ctx[2]
      );
      t2 = space();
      if (if_block1)
        if_block1.c();
      attr(span, "class", "help-option__text svelte-lh6dn1");
      attr(
        a,
        "href",
        /*link*/
        ctx[0]
      );
      attr(a, "target", "_blank");
      attr(a, "class", "ms-button-link svelte-lh6dn1");
      toggle_class(
        a,
        "ms-button-link--status",
        /*status*/
        ctx[1] === true
      );
    },
    m(target, anchor) {
      insert(target, a, anchor);
      if (if_block0)
        if_block0.m(a, null);
      append(a, t0);
      append(a, span);
      append(span, t1);
      append(a, t2);
      if (if_block1)
        if_block1.m(a, null);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (
        /*status*/
        ctx2[1] !== void 0
      ) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
          if (dirty & /*status*/
          2) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_1$7(ctx2);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(a, t0);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      if (!current || dirty & /*text*/
      4)
        set_data(
          t1,
          /*text*/
          ctx2[2]
        );
      if (
        /*showIcon*/
        ctx2[3]
      ) {
        if (if_block1) {
          if (dirty & /*showIcon*/
          8) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block$8();
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(a, null);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
      if (!current || dirty & /*link*/
      1) {
        attr(
          a,
          "href",
          /*link*/
          ctx2[0]
        );
      }
      if (!current || dirty & /*status*/
      2) {
        toggle_class(
          a,
          "ms-button-link--status",
          /*status*/
          ctx2[1] === true
        );
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block0);
      transition_in(if_block1);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(if_block1);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(a);
      if (if_block0)
        if_block0.d();
      if (if_block1)
        if_block1.d();
    }
  };
}
function instance$8($$self, $$props, $$invalidate) {
  let { link } = $$props;
  let { status } = $$props;
  let { text: text2 } = $$props;
  let { showIcon = true } = $$props;
  $$self.$$set = ($$props2) => {
    if ("link" in $$props2)
      $$invalidate(0, link = $$props2.link);
    if ("status" in $$props2)
      $$invalidate(1, status = $$props2.status);
    if ("text" in $$props2)
      $$invalidate(2, text2 = $$props2.text);
    if ("showIcon" in $$props2)
      $$invalidate(3, showIcon = $$props2.showIcon);
  };
  return [link, status, text2, showIcon];
}
var ButtonLink = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$8, create_fragment$c, safe_not_equal, { link: 0, status: 1, text: 2, showIcon: 3 }, add_css$7);
  }
};
function create_fragment$b(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "m440-380-237-30q-25-3-32.5-27t10.5-41l409-392q5-5 12-7.5t19-2.5q20 0 30.5 17t.5 35L520-580l237 30q25 3 32.5 27T779-482L370-90q-5 5-12 7.5T339-80q-20 0-30.5-17t-.5-35l132-248Z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "viewBox", "168.29 -880 623.41 800");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var LightningBoltIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$b, safe_not_equal, {});
  }
};
function create_fragment$a(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-1-120q14 0 24.5-10.5T514-235v-15q50-9 86-39t36-89q0-42-24-77t-96-61q-60-20-83-35t-23-41q0-26 18.5-41t53.5-15q20 0 35 7t25 19q10 12 22.5 16.5t23.5-.5q15-6 20.5-20.5T606-653q-16-23-39.5-39T516-710v-15q0-14-10.5-24.5T481-760q-14 0-24.5 10.5T446-725v15q-50 11-78 44t-28 74q0 47 27.5 76t86.5 50q63 23 87.5 41t24.5 47q0 33-23.5 48.5T486-314q-26 0-47-12.5T404-364q-8-14-21-19t-26 0q-14 5-20.5 19t-.5 27q16 34 43 55.5t65 29.5v17q0 14 10.5 24.5T479-200Z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "height", "24");
      attr(svg, "viewBox", "0 -960 960 960");
      attr(svg, "width", "24");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var MoneyIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$a, safe_not_equal, {});
  }
};
function add_css$6(target) {
  append_styles(target, "svelte-1dd5p02", ".ms-member-plan-item.svelte-1dd5p02.svelte-1dd5p02{width:100%;background-color:#444;border:1px solid #5c5c5c;border-radius:4px;flex-wrap:wrap;margin-bottom:0.5em;display:flex;transition:height 0.2s ease-in-out;overflow:hidden}.ms-member-plan-item__tabs.svelte-1dd5p02.svelte-1dd5p02{display:flex;align-items:stretch;justify-content:space-between;width:100%}.ms-member-plan-item__tab.svelte-1dd5p02.svelte-1dd5p02{gap:6px;padding:4px;display:flex;align-items:center;background-color:transparent;transition:background-color 0.2s ease-in-out;width:100%}.ms-member-plan-item--free.svelte-1dd5p02 .ms-member-plan-item__icon.svelte-1dd5p02{background-color:#2962ff}.ms-member-plan-item--paid.svelte-1dd5p02 .ms-member-plan-item__icon.svelte-1dd5p02{background-color:#5b9c6f}.ms-member-plan-item__icon.svelte-1dd5p02.svelte-1dd5p02{width:22px;height:22px;display:flex;align-items:center;justify-content:center;background-color:#292929;border-radius:3px;color:#fff;padding:2px}.ms-member-plan-item__icon svg{width:100%;height:100%}.ms-member-plan-item__arrow.svelte-1dd5p02.svelte-1dd5p02{margin-left:auto;margin-right:8px;width:8px;transition:transform 0.2s ease-in-out}.ms-member-plan-item__content.svelte-1dd5p02.svelte-1dd5p02{width:100%}.ms-member-plan-item__wrapper.svelte-1dd5p02.svelte-1dd5p02{background-color:#292929;width:100%;padding:8px}.ms-member-plan-item__content-item.svelte-1dd5p02.svelte-1dd5p02{margin-bottom:10px}.ms-member-plan-item__content-item__title.svelte-1dd5p02.svelte-1dd5p02{font-weight:bold;margin-bottom:5px}.ms-member-plan-item__content-item__help.svelte-1dd5p02.svelte-1dd5p02{margin-top:10px}.ms-member-plan-item__content-item__help__title.svelte-1dd5p02.svelte-1dd5p02{display:flex;align-items:center;text-decoration:none;color:#007bff}.ms-member-plan-item__content-item__help__title--link.svelte-1dd5p02.svelte-1dd5p02{color:#28a745}");
}
function create_else_block_2(ctx) {
  let lightningbolticon;
  let current;
  lightningbolticon = new LightningBoltIcon({});
  return {
    c() {
      create_component(lightningbolticon.$$.fragment);
    },
    m(target, anchor) {
      mount_component(lightningbolticon, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(lightningbolticon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(lightningbolticon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(lightningbolticon, detaching);
    }
  };
}
function create_if_block_3$4(ctx) {
  let moneyicon;
  let current;
  moneyicon = new MoneyIcon({});
  return {
    c() {
      create_component(moneyicon.$$.fragment);
    },
    m(target, anchor) {
      mount_component(moneyicon, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(moneyicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(moneyicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(moneyicon, detaching);
    }
  };
}
function create_else_block_1(ctx) {
  let t_value = (
    /*memberPlanItem*/
    ctx[0].planName + ""
  );
  let t;
  return {
    c() {
      t = text(t_value);
    },
    m(target, anchor) {
      insert(target, t, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*memberPlanItem*/
      1 && t_value !== (t_value = /*memberPlanItem*/
      ctx2[0].planName + ""))
        set_data(t, t_value);
    },
    d(detaching) {
      if (detaching)
        detach(t);
    }
  };
}
function create_if_block_2$5(ctx) {
  let t_value = (
    /*memberPlanItem*/
    ctx[0].priceDetails.priceName + ""
  );
  let t;
  return {
    c() {
      t = text(t_value);
    },
    m(target, anchor) {
      insert(target, t, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*memberPlanItem*/
      1 && t_value !== (t_value = /*memberPlanItem*/
      ctx2[0].priceDetails.priceName + ""))
        set_data(t, t_value);
    },
    d(detaching) {
      if (detaching)
        detach(t);
    }
  };
}
function create_if_block$7(ctx) {
  let div;
  let current_block_type_index;
  let if_block;
  let div_transition;
  let current;
  const if_block_creators = [create_if_block_1$6, create_else_block$3];
  const if_blocks = [];
  function select_block_type_2(ctx2, dirty) {
    if (
      /*memberPlanItem*/
      ctx2[0] && /*memberPlanItem*/
      ctx2[0].priceDetails
    )
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type_2(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      div = element("div");
      if_block.c();
      attr(div, "class", "ms-member-plan-item__wrapper svelte-1dd5p02");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      if_blocks[current_block_type_index].m(div, null);
      current = true;
    },
    p(ctx2, dirty) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type_2(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(div, null);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      if (local) {
        add_render_callback(() => {
          if (!current)
            return;
          if (!div_transition)
            div_transition = create_bidirectional_transition(div, slide, { duration: 300 }, true);
          div_transition.run(1);
        });
      }
      current = true;
    },
    o(local) {
      transition_out(if_block);
      if (local) {
        if (!div_transition)
          div_transition = create_bidirectional_transition(div, slide, { duration: 300 }, false);
        div_transition.run(0);
      }
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      if_blocks[current_block_type_index].d();
      if (detaching && div_transition)
        div_transition.end();
    }
  };
}
function create_else_block$3(ctx) {
  let copybuttongroup0;
  let t;
  let copybuttongroup1;
  let current;
  copybuttongroup0 = new CopyButtonGroup({
    props: {
      labelText: "ID",
      buttonText: (
        /*memberPlanItem*/
        ctx[0].planId
      )
    }
  });
  copybuttongroup1 = new CopyButtonGroup({
    props: {
      labelText: "Priority",
      buttonText: (
        /*memberPlanItem*/
        ctx[0].priority
      )
    }
  });
  return {
    c() {
      create_component(copybuttongroup0.$$.fragment);
      t = space();
      create_component(copybuttongroup1.$$.fragment);
    },
    m(target, anchor) {
      mount_component(copybuttongroup0, target, anchor);
      insert(target, t, anchor);
      mount_component(copybuttongroup1, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const copybuttongroup0_changes = {};
      if (dirty & /*memberPlanItem*/
      1)
        copybuttongroup0_changes.buttonText = /*memberPlanItem*/
        ctx2[0].planId;
      copybuttongroup0.$set(copybuttongroup0_changes);
      const copybuttongroup1_changes = {};
      if (dirty & /*memberPlanItem*/
      1)
        copybuttongroup1_changes.buttonText = /*memberPlanItem*/
        ctx2[0].priority;
      copybuttongroup1.$set(copybuttongroup1_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(copybuttongroup0.$$.fragment, local);
      transition_in(copybuttongroup1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(copybuttongroup0.$$.fragment, local);
      transition_out(copybuttongroup1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(copybuttongroup0, detaching);
      if (detaching)
        detach(t);
      destroy_component(copybuttongroup1, detaching);
    }
  };
}
function create_if_block_1$6(ctx) {
  let copybuttongroup0;
  let t0;
  let copybuttongroup1;
  let t1;
  let copybuttongroup2;
  let t2;
  let copybuttongroup3;
  let t3;
  let copybuttongroup4;
  let t4;
  let copybuttongroup5;
  let t5;
  let copybuttongroup6;
  let t6;
  let copybuttongroup7;
  let t7;
  let copybuttongroup8;
  let current;
  copybuttongroup0 = new CopyButtonGroup({
    props: {
      labelText: "ID",
      buttonText: (
        /*memberPlanItem*/
        ctx[0].planId
      )
    }
  });
  copybuttongroup1 = new CopyButtonGroup({
    props: {
      labelText: "Priority",
      buttonText: (
        /*memberPlanItem*/
        ctx[0].priority
      )
    }
  });
  copybuttongroup2 = new CopyButtonGroup({
    props: {
      labelText: "Price Name",
      buttonText: (
        /*memberPlanItem*/
        ctx[0].priceDetails.priceName
      )
    }
  });
  copybuttongroup3 = new CopyButtonGroup({
    props: {
      labelText: "Amount",
      buttonText: (
        /*memberPlanItem*/
        ctx[0].priceDetails.amount
      )
    }
  });
  copybuttongroup4 = new CopyButtonGroup({
    props: {
      labelText: "Interval",
      buttonText: (
        /*memberPlanItem*/
        ctx[0].priceDetails.interval.type
      )
    }
  });
  copybuttongroup5 = new CopyButtonGroup({
    props: {
      labelText: "Inteval Count",
      buttonText: (
        /*memberPlanItem*/
        ctx[0].priceDetails.interval.count
      )
    }
  });
  copybuttongroup6 = new CopyButtonGroup({
    props: {
      labelText: "Type",
      buttonText: (
        /*memberPlanItem*/
        ctx[0].priceDetails.type
      )
    }
  });
  copybuttongroup7 = new CopyButtonGroup({
    props: {
      labelText: "Currency",
      buttonText: (
        /*memberPlanItem*/
        ctx[0].priceDetails.currency
      )
    }
  });
  copybuttongroup8 = new CopyButtonGroup({
    props: {
      labelText: "Plan Name",
      buttonText: (
        /*memberPlanItem*/
        ctx[0].planName
      )
    }
  });
  return {
    c() {
      create_component(copybuttongroup0.$$.fragment);
      t0 = space();
      create_component(copybuttongroup1.$$.fragment);
      t1 = space();
      create_component(copybuttongroup2.$$.fragment);
      t2 = space();
      create_component(copybuttongroup3.$$.fragment);
      t3 = space();
      create_component(copybuttongroup4.$$.fragment);
      t4 = space();
      create_component(copybuttongroup5.$$.fragment);
      t5 = space();
      create_component(copybuttongroup6.$$.fragment);
      t6 = space();
      create_component(copybuttongroup7.$$.fragment);
      t7 = space();
      create_component(copybuttongroup8.$$.fragment);
    },
    m(target, anchor) {
      mount_component(copybuttongroup0, target, anchor);
      insert(target, t0, anchor);
      mount_component(copybuttongroup1, target, anchor);
      insert(target, t1, anchor);
      mount_component(copybuttongroup2, target, anchor);
      insert(target, t2, anchor);
      mount_component(copybuttongroup3, target, anchor);
      insert(target, t3, anchor);
      mount_component(copybuttongroup4, target, anchor);
      insert(target, t4, anchor);
      mount_component(copybuttongroup5, target, anchor);
      insert(target, t5, anchor);
      mount_component(copybuttongroup6, target, anchor);
      insert(target, t6, anchor);
      mount_component(copybuttongroup7, target, anchor);
      insert(target, t7, anchor);
      mount_component(copybuttongroup8, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const copybuttongroup0_changes = {};
      if (dirty & /*memberPlanItem*/
      1)
        copybuttongroup0_changes.buttonText = /*memberPlanItem*/
        ctx2[0].planId;
      copybuttongroup0.$set(copybuttongroup0_changes);
      const copybuttongroup1_changes = {};
      if (dirty & /*memberPlanItem*/
      1)
        copybuttongroup1_changes.buttonText = /*memberPlanItem*/
        ctx2[0].priority;
      copybuttongroup1.$set(copybuttongroup1_changes);
      const copybuttongroup2_changes = {};
      if (dirty & /*memberPlanItem*/
      1)
        copybuttongroup2_changes.buttonText = /*memberPlanItem*/
        ctx2[0].priceDetails.priceName;
      copybuttongroup2.$set(copybuttongroup2_changes);
      const copybuttongroup3_changes = {};
      if (dirty & /*memberPlanItem*/
      1)
        copybuttongroup3_changes.buttonText = /*memberPlanItem*/
        ctx2[0].priceDetails.amount;
      copybuttongroup3.$set(copybuttongroup3_changes);
      const copybuttongroup4_changes = {};
      if (dirty & /*memberPlanItem*/
      1)
        copybuttongroup4_changes.buttonText = /*memberPlanItem*/
        ctx2[0].priceDetails.interval.type;
      copybuttongroup4.$set(copybuttongroup4_changes);
      const copybuttongroup5_changes = {};
      if (dirty & /*memberPlanItem*/
      1)
        copybuttongroup5_changes.buttonText = /*memberPlanItem*/
        ctx2[0].priceDetails.interval.count;
      copybuttongroup5.$set(copybuttongroup5_changes);
      const copybuttongroup6_changes = {};
      if (dirty & /*memberPlanItem*/
      1)
        copybuttongroup6_changes.buttonText = /*memberPlanItem*/
        ctx2[0].priceDetails.type;
      copybuttongroup6.$set(copybuttongroup6_changes);
      const copybuttongroup7_changes = {};
      if (dirty & /*memberPlanItem*/
      1)
        copybuttongroup7_changes.buttonText = /*memberPlanItem*/
        ctx2[0].priceDetails.currency;
      copybuttongroup7.$set(copybuttongroup7_changes);
      const copybuttongroup8_changes = {};
      if (dirty & /*memberPlanItem*/
      1)
        copybuttongroup8_changes.buttonText = /*memberPlanItem*/
        ctx2[0].planName;
      copybuttongroup8.$set(copybuttongroup8_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(copybuttongroup0.$$.fragment, local);
      transition_in(copybuttongroup1.$$.fragment, local);
      transition_in(copybuttongroup2.$$.fragment, local);
      transition_in(copybuttongroup3.$$.fragment, local);
      transition_in(copybuttongroup4.$$.fragment, local);
      transition_in(copybuttongroup5.$$.fragment, local);
      transition_in(copybuttongroup6.$$.fragment, local);
      transition_in(copybuttongroup7.$$.fragment, local);
      transition_in(copybuttongroup8.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(copybuttongroup0.$$.fragment, local);
      transition_out(copybuttongroup1.$$.fragment, local);
      transition_out(copybuttongroup2.$$.fragment, local);
      transition_out(copybuttongroup3.$$.fragment, local);
      transition_out(copybuttongroup4.$$.fragment, local);
      transition_out(copybuttongroup5.$$.fragment, local);
      transition_out(copybuttongroup6.$$.fragment, local);
      transition_out(copybuttongroup7.$$.fragment, local);
      transition_out(copybuttongroup8.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(copybuttongroup0, detaching);
      if (detaching)
        detach(t0);
      destroy_component(copybuttongroup1, detaching);
      if (detaching)
        detach(t1);
      destroy_component(copybuttongroup2, detaching);
      if (detaching)
        detach(t2);
      destroy_component(copybuttongroup3, detaching);
      if (detaching)
        detach(t3);
      destroy_component(copybuttongroup4, detaching);
      if (detaching)
        detach(t4);
      destroy_component(copybuttongroup5, detaching);
      if (detaching)
        detach(t5);
      destroy_component(copybuttongroup6, detaching);
      if (detaching)
        detach(t6);
      destroy_component(copybuttongroup7, detaching);
      if (detaching)
        detach(t7);
      destroy_component(copybuttongroup8, detaching);
    }
  };
}
function create_fragment$9(ctx) {
  let div2;
  let div0;
  let button;
  let span0;
  let current_block_type_index;
  let if_block0;
  let t0;
  let t1;
  let span1;
  let arrowicon;
  let t2;
  let div1;
  let div2_class_value;
  let div2_id_value;
  let current;
  let mounted;
  let dispose;
  const if_block_creators = [create_if_block_3$4, create_else_block_2];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*memberPlanItem*/
      ctx2[0] && /*memberPlanItem*/
      ctx2[0].priceDetails
    )
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  function select_block_type_1(ctx2, dirty) {
    if (
      /*memberPlanItem*/
      ctx2[0] && /*memberPlanItem*/
      ctx2[0].priceDetails
    )
      return create_if_block_2$5;
    return create_else_block_1;
  }
  let current_block_type = select_block_type_1(ctx);
  let if_block1 = current_block_type(ctx);
  arrowicon = new ArrowIcon({
    props: {
      style: "transform: rotate(" + /*openMemberPlanItem*/
      (ctx[1] ? "180deg" : "0deg") + ")"
    }
  });
  let if_block2 = (
    /*openMemberPlanItem*/
    ctx[1] && create_if_block$7(ctx)
  );
  return {
    c() {
      div2 = element("div");
      div0 = element("div");
      button = element("button");
      span0 = element("span");
      if_block0.c();
      t0 = space();
      if_block1.c();
      t1 = space();
      span1 = element("span");
      create_component(arrowicon.$$.fragment);
      t2 = space();
      div1 = element("div");
      if (if_block2)
        if_block2.c();
      attr(span0, "class", "ms-member-plan-item__icon svelte-1dd5p02");
      attr(span1, "class", "ms-member-plan-item__arrow svelte-1dd5p02");
      attr(button, "class", "ms-member-plan-item__tab svelte-1dd5p02");
      attr(button, "data-cy", "member-plan-item-button");
      attr(div0, "class", "ms-member-plan-item__tabs svelte-1dd5p02");
      attr(div1, "class", "ms-member-plan-item__content svelte-1dd5p02");
      attr(div2, "class", div2_class_value = "ms-member-plan-item " + addTypeClass(
        /*memberPlanItem*/
        ctx[0]
      ) + " svelte-1dd5p02");
      attr(div2, "id", div2_id_value = /*memberPlanItem*/
      ctx[0].id);
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      append(div2, div0);
      append(div0, button);
      append(button, span0);
      if_blocks[current_block_type_index].m(span0, null);
      append(button, t0);
      if_block1.m(button, null);
      append(button, t1);
      append(button, span1);
      mount_component(arrowicon, span1, null);
      append(div2, t2);
      append(div2, div1);
      if (if_block2)
        if_block2.m(div1, null);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler*/
          ctx[3]
        );
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index !== previous_block_index) {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block0 = if_blocks[current_block_type_index];
        if (!if_block0) {
          if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block0.c();
        }
        transition_in(if_block0, 1);
        if_block0.m(span0, null);
      }
      if (current_block_type === (current_block_type = select_block_type_1(ctx2)) && if_block1) {
        if_block1.p(ctx2, dirty);
      } else {
        if_block1.d(1);
        if_block1 = current_block_type(ctx2);
        if (if_block1) {
          if_block1.c();
          if_block1.m(button, t1);
        }
      }
      const arrowicon_changes = {};
      if (dirty & /*openMemberPlanItem*/
      2)
        arrowicon_changes.style = "transform: rotate(" + /*openMemberPlanItem*/
        (ctx2[1] ? "180deg" : "0deg") + ")";
      arrowicon.$set(arrowicon_changes);
      if (
        /*openMemberPlanItem*/
        ctx2[1]
      ) {
        if (if_block2) {
          if_block2.p(ctx2, dirty);
          if (dirty & /*openMemberPlanItem*/
          2) {
            transition_in(if_block2, 1);
          }
        } else {
          if_block2 = create_if_block$7(ctx2);
          if_block2.c();
          transition_in(if_block2, 1);
          if_block2.m(div1, null);
        }
      } else if (if_block2) {
        group_outros();
        transition_out(if_block2, 1, 1, () => {
          if_block2 = null;
        });
        check_outros();
      }
      if (!current || dirty & /*memberPlanItem*/
      1 && div2_class_value !== (div2_class_value = "ms-member-plan-item " + addTypeClass(
        /*memberPlanItem*/
        ctx2[0]
      ) + " svelte-1dd5p02")) {
        attr(div2, "class", div2_class_value);
      }
      if (!current || dirty & /*memberPlanItem*/
      1 && div2_id_value !== (div2_id_value = /*memberPlanItem*/
      ctx2[0].id)) {
        attr(div2, "id", div2_id_value);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block0);
      transition_in(arrowicon.$$.fragment, local);
      transition_in(if_block2);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(arrowicon.$$.fragment, local);
      transition_out(if_block2);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div2);
      if_blocks[current_block_type_index].d();
      if_block1.d();
      destroy_component(arrowicon);
      if (if_block2)
        if_block2.d();
      mounted = false;
      dispose();
    }
  };
}
function addTypeClass(memberPlanItem) {
  if (memberPlanItem && memberPlanItem.priceDetails) {
    return "ms-member-plan-item--paid";
  } else {
    return "ms-member-plan-item--free";
  }
}
function instance$7($$self, $$props, $$invalidate) {
  let { memberPlanItem } = $$props;
  let openMemberPlanItem = false;
  function showMemberPlanItemContent() {
    $$invalidate(1, openMemberPlanItem = !openMemberPlanItem);
  }
  const click_handler = () => showMemberPlanItemContent();
  $$self.$$set = ($$props2) => {
    if ("memberPlanItem" in $$props2)
      $$invalidate(0, memberPlanItem = $$props2.memberPlanItem);
  };
  return [memberPlanItem, openMemberPlanItem, showMemberPlanItemContent, click_handler];
}
var MemberPlanItem = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$7, create_fragment$9, safe_not_equal, { memberPlanItem: 0 }, add_css$6);
  }
};
function add_css$5(target) {
  append_styles(target, "svelte-1612fls", ".ms-member-tab__header.svelte-1612fls{margin-bottom:12px}.ms-member-tab-status.svelte-1612fls{display:flex;align-items:center;padding:6px 12px;border:1px solid #e06657;border-radius:4px}.ms-member-tab-status--active.svelte-1612fls{border-color:#5c9d6f}.ms-member-tab-status__indicator.svelte-1612fls{width:10px;height:10px;border-radius:50%;margin-right:10px;background-color:rgb(224, 102, 87)}.ms-member-tab-status__indicator--active.svelte-1612fls{background-color:#5c9d6f}.ms-member-tab-status__button.svelte-1612fls{font-size:11px;line-height:1;margin-left:auto;padding:4px;border:1px solid #5c5c5c;border-radius:4px;background-color:#444;color:#fff;cursor:pointer}.ms-member-tab__section.svelte-1612fls{padding-bottom:6px;margin-bottom:12px;border-bottom:1px solid #535353}.ms-member-tab__section.svelte-1612fls:last-child{border-bottom:none;margin-bottom:0}.ms-code-block.svelte-1612fls{background-color:#000;color:#fff;padding:4px 8px;border-radius:4px;overflow:auto;border:1px solid #4b4b4b;font-size:10px}");
}
function get_each_context$3(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[11] = list[i];
  return child_ctx;
}
function get_each_context_1$2(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[14] = list[i];
  return child_ctx;
}
function get_each_context_2(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[11] = list[i];
  return child_ctx;
}
function create_else_block$2(ctx) {
  let div;
  let t1;
  let button;
  let mounted;
  let dispose;
  return {
    c() {
      div = element("div");
      div.textContent = "You are Logged Out";
      t1 = space();
      button = element("button");
      button.textContent = "Login";
      attr(div, "class", "ms-member-tab-status__text");
      attr(button, "class", "ms-member-tab-status__button svelte-1612fls");
      attr(button, "data-cy", "member-login-button");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      insert(target, t1, anchor);
      insert(target, button, anchor);
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler_1*/
          ctx[7]
        );
        mounted = true;
      }
    },
    p: noop,
    d(detaching) {
      if (detaching)
        detach(div);
      if (detaching)
        detach(t1);
      if (detaching)
        detach(button);
      mounted = false;
      dispose();
    }
  };
}
function create_if_block_6$1(ctx) {
  let div;
  let t1;
  let button;
  let mounted;
  let dispose;
  return {
    c() {
      div = element("div");
      div.textContent = "You are Logged In";
      t1 = space();
      button = element("button");
      button.textContent = "Logout";
      attr(div, "class", "ms-member-tab-status__text");
      attr(button, "class", "ms-member-tab-status__button svelte-1612fls");
      attr(button, "data-cy", "member-logout-button");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      insert(target, t1, anchor);
      insert(target, button, anchor);
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler*/
          ctx[6]
        );
        mounted = true;
      }
    },
    p: noop,
    d(detaching) {
      if (detaching)
        detach(div);
      if (detaching)
        detach(t1);
      if (detaching)
        detach(button);
      mounted = false;
      dispose();
    }
  };
}
function create_if_block$6(ctx) {
  let div0;
  let copybuttongroup0;
  let t0;
  let copybuttongroup1;
  let t1;
  let copybuttongroup2;
  let t2;
  let copybuttongroup3;
  let t3;
  let show_if_1 = (
    /*$InspectorStore*/
    ctx[0].memberData.customFields && Object.keys(
      /*$InspectorStore*/
      ctx[0].memberData.customFields
    ).some(
      /*func*/
      ctx[5]
    )
  );
  let t4;
  let t5;
  let show_if = (
    /*$InspectorStore*/
    ctx[0].memberData.metaData && Object.keys(
      /*$InspectorStore*/
      ctx[0].memberData.metaData
    ).length > 0
  );
  let t6;
  let t7;
  let div2;
  let sectionheader;
  let t8;
  let div1;
  let pre;
  let code;
  let t9_value = JSON.stringify(
    /*$InspectorStore*/
    ctx[0].memberData,
    null,
    2
  ) + "";
  let t9;
  let current;
  copybuttongroup0 = new CopyButtonGroup({
    props: {
      labelText: "Member ID",
      buttonText: (
        /*$InspectorStore*/
        ctx[0].memberData.id
      ),
      cypress: "member-id"
    }
  });
  copybuttongroup1 = new CopyButtonGroup({
    props: {
      labelText: "Email",
      buttonText: (
        /*$InspectorStore*/
        ctx[0].memberData.auth.email
      ),
      cypress: "member-email"
    }
  });
  copybuttongroup2 = new CopyButtonGroup({
    props: {
      labelText: "Created Date",
      buttonText: readableDate(
        /*$InspectorStore*/
        ctx[0].memberData.createdAt
      ),
      cypress: "member-created-date"
    }
  });
  copybuttongroup3 = new CopyButtonGroup({
    props: {
      labelText: "Verified",
      buttonText: (
        /*$InspectorStore*/
        ctx[0].memberData.verified
      ),
      cypress: "member-verified"
    }
  });
  let if_block0 = show_if_1 && create_if_block_4$2(ctx);
  let if_block1 = (
    /*memberPlanData*/
    ctx[2].length > 0 && create_if_block_3$3(ctx)
  );
  let if_block2 = show_if && create_if_block_2$4(ctx);
  let if_block3 = (
    /*memberJSON*/
    ctx[1] && /*memberJSON*/
    ctx[1].data && create_if_block_1$5(ctx)
  );
  sectionheader = new SectionHeader({
    props: { titleText: "Member Data (raw)" }
  });
  return {
    c() {
      div0 = element("div");
      create_component(copybuttongroup0.$$.fragment);
      t0 = space();
      create_component(copybuttongroup1.$$.fragment);
      t1 = space();
      create_component(copybuttongroup2.$$.fragment);
      t2 = space();
      create_component(copybuttongroup3.$$.fragment);
      t3 = space();
      if (if_block0)
        if_block0.c();
      t4 = space();
      if (if_block1)
        if_block1.c();
      t5 = space();
      if (if_block2)
        if_block2.c();
      t6 = space();
      if (if_block3)
        if_block3.c();
      t7 = space();
      div2 = element("div");
      create_component(sectionheader.$$.fragment);
      t8 = space();
      div1 = element("div");
      pre = element("pre");
      code = element("code");
      t9 = text(t9_value);
      attr(div0, "class", "ms-member-tab__section svelte-1612fls");
      attr(div0, "data-cy", "member-section-required");
      attr(pre, "class", "ms-code-block svelte-1612fls");
      attr(div1, "class", "ms-app-tab__section__content");
      attr(div1, "data-cy", "app-section-all-data-content");
      attr(div2, "class", "ms-app-tab__section");
      attr(div2, "data-cy", "app-section-all-data");
    },
    m(target, anchor) {
      insert(target, div0, anchor);
      mount_component(copybuttongroup0, div0, null);
      append(div0, t0);
      mount_component(copybuttongroup1, div0, null);
      append(div0, t1);
      mount_component(copybuttongroup2, div0, null);
      append(div0, t2);
      mount_component(copybuttongroup3, div0, null);
      insert(target, t3, anchor);
      if (if_block0)
        if_block0.m(target, anchor);
      insert(target, t4, anchor);
      if (if_block1)
        if_block1.m(target, anchor);
      insert(target, t5, anchor);
      if (if_block2)
        if_block2.m(target, anchor);
      insert(target, t6, anchor);
      if (if_block3)
        if_block3.m(target, anchor);
      insert(target, t7, anchor);
      insert(target, div2, anchor);
      mount_component(sectionheader, div2, null);
      append(div2, t8);
      append(div2, div1);
      append(div1, pre);
      append(pre, code);
      append(code, t9);
      current = true;
    },
    p(ctx2, dirty) {
      const copybuttongroup0_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        copybuttongroup0_changes.buttonText = /*$InspectorStore*/
        ctx2[0].memberData.id;
      copybuttongroup0.$set(copybuttongroup0_changes);
      const copybuttongroup1_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        copybuttongroup1_changes.buttonText = /*$InspectorStore*/
        ctx2[0].memberData.auth.email;
      copybuttongroup1.$set(copybuttongroup1_changes);
      const copybuttongroup2_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        copybuttongroup2_changes.buttonText = readableDate(
          /*$InspectorStore*/
          ctx2[0].memberData.createdAt
        );
      copybuttongroup2.$set(copybuttongroup2_changes);
      const copybuttongroup3_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        copybuttongroup3_changes.buttonText = /*$InspectorStore*/
        ctx2[0].memberData.verified;
      copybuttongroup3.$set(copybuttongroup3_changes);
      if (dirty & /*$InspectorStore*/
      1)
        show_if_1 = /*$InspectorStore*/
        ctx2[0].memberData.customFields && Object.keys(
          /*$InspectorStore*/
          ctx2[0].memberData.customFields
        ).some(
          /*func*/
          ctx2[5]
        );
      if (show_if_1) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
          if (dirty & /*$InspectorStore*/
          1) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_4$2(ctx2);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(t4.parentNode, t4);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      if (
        /*memberPlanData*/
        ctx2[2].length > 0
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty & /*memberPlanData*/
          4) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block_3$3(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(t5.parentNode, t5);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
      if (dirty & /*$InspectorStore*/
      1)
        show_if = /*$InspectorStore*/
        ctx2[0].memberData.metaData && Object.keys(
          /*$InspectorStore*/
          ctx2[0].memberData.metaData
        ).length > 0;
      if (show_if) {
        if (if_block2) {
          if_block2.p(ctx2, dirty);
          if (dirty & /*$InspectorStore*/
          1) {
            transition_in(if_block2, 1);
          }
        } else {
          if_block2 = create_if_block_2$4(ctx2);
          if_block2.c();
          transition_in(if_block2, 1);
          if_block2.m(t6.parentNode, t6);
        }
      } else if (if_block2) {
        group_outros();
        transition_out(if_block2, 1, 1, () => {
          if_block2 = null;
        });
        check_outros();
      }
      if (
        /*memberJSON*/
        ctx2[1] && /*memberJSON*/
        ctx2[1].data
      ) {
        if (if_block3) {
          if_block3.p(ctx2, dirty);
          if (dirty & /*memberJSON*/
          2) {
            transition_in(if_block3, 1);
          }
        } else {
          if_block3 = create_if_block_1$5(ctx2);
          if_block3.c();
          transition_in(if_block3, 1);
          if_block3.m(t7.parentNode, t7);
        }
      } else if (if_block3) {
        group_outros();
        transition_out(if_block3, 1, 1, () => {
          if_block3 = null;
        });
        check_outros();
      }
      if ((!current || dirty & /*$InspectorStore*/
      1) && t9_value !== (t9_value = JSON.stringify(
        /*$InspectorStore*/
        ctx2[0].memberData,
        null,
        2
      ) + ""))
        set_data(t9, t9_value);
    },
    i(local) {
      if (current)
        return;
      transition_in(copybuttongroup0.$$.fragment, local);
      transition_in(copybuttongroup1.$$.fragment, local);
      transition_in(copybuttongroup2.$$.fragment, local);
      transition_in(copybuttongroup3.$$.fragment, local);
      transition_in(if_block0);
      transition_in(if_block1);
      transition_in(if_block2);
      transition_in(if_block3);
      transition_in(sectionheader.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(copybuttongroup0.$$.fragment, local);
      transition_out(copybuttongroup1.$$.fragment, local);
      transition_out(copybuttongroup2.$$.fragment, local);
      transition_out(copybuttongroup3.$$.fragment, local);
      transition_out(if_block0);
      transition_out(if_block1);
      transition_out(if_block2);
      transition_out(if_block3);
      transition_out(sectionheader.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div0);
      destroy_component(copybuttongroup0);
      destroy_component(copybuttongroup1);
      destroy_component(copybuttongroup2);
      destroy_component(copybuttongroup3);
      if (detaching)
        detach(t3);
      if (if_block0)
        if_block0.d(detaching);
      if (detaching)
        detach(t4);
      if (if_block1)
        if_block1.d(detaching);
      if (detaching)
        detach(t5);
      if (if_block2)
        if_block2.d(detaching);
      if (detaching)
        detach(t6);
      if (if_block3)
        if_block3.d(detaching);
      if (detaching)
        detach(t7);
      if (detaching)
        detach(div2);
      destroy_component(sectionheader);
    }
  };
}
function create_if_block_4$2(ctx) {
  let div;
  let sectionheader;
  let t0;
  let t1;
  let buttonlink;
  let current;
  sectionheader = new SectionHeader({
    props: {
      titleText: "Custom Fields",
      editURL: `https://app.memberstack.com/apps/${/*$InspectorStore*/
      ctx[0].appData.id}/members/${/*$InspectorStore*/
      ctx[0].memberData.id}/profile`
    }
  });
  let each_value_2 = Object.keys(
    /*$InspectorStore*/
    ctx[0].memberData.customFields
  );
  let each_blocks = [];
  for (let i = 0; i < each_value_2.length; i += 1) {
    each_blocks[i] = create_each_block_2(get_each_context_2(ctx, each_value_2, i));
  }
  const out = (i) => transition_out(each_blocks[i], 1, 1, () => {
    each_blocks[i] = null;
  });
  buttonlink = new ButtonLink({
    props: {
      link: "https://docs.memberstack.com/hc/en-us/articles/7389502579355",
      text: "Documentation"
    }
  });
  return {
    c() {
      div = element("div");
      create_component(sectionheader.$$.fragment);
      t0 = space();
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      t1 = space();
      create_component(buttonlink.$$.fragment);
      attr(div, "class", "ms-member-tab__section svelte-1612fls");
      attr(div, "data-cy", "member-section-custom-fields");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(sectionheader, div, null);
      append(div, t0);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(div, null);
        }
      }
      append(div, t1);
      mount_component(buttonlink, div, null);
      current = true;
    },
    p(ctx2, dirty) {
      const sectionheader_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        sectionheader_changes.editURL = `https://app.memberstack.com/apps/${/*$InspectorStore*/
        ctx2[0].appData.id}/members/${/*$InspectorStore*/
        ctx2[0].memberData.id}/profile`;
      sectionheader.$set(sectionheader_changes);
      if (dirty & /*Object, $InspectorStore*/
      1) {
        each_value_2 = Object.keys(
          /*$InspectorStore*/
          ctx2[0].memberData.customFields
        );
        let i;
        for (i = 0; i < each_value_2.length; i += 1) {
          const child_ctx = get_each_context_2(ctx2, each_value_2, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
            transition_in(each_blocks[i], 1);
          } else {
            each_blocks[i] = create_each_block_2(child_ctx);
            each_blocks[i].c();
            transition_in(each_blocks[i], 1);
            each_blocks[i].m(div, t1);
          }
        }
        group_outros();
        for (i = each_value_2.length; i < each_blocks.length; i += 1) {
          out(i);
        }
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(sectionheader.$$.fragment, local);
      for (let i = 0; i < each_value_2.length; i += 1) {
        transition_in(each_blocks[i]);
      }
      transition_in(buttonlink.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(sectionheader.$$.fragment, local);
      each_blocks = each_blocks.filter(Boolean);
      for (let i = 0; i < each_blocks.length; i += 1) {
        transition_out(each_blocks[i]);
      }
      transition_out(buttonlink.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      destroy_component(sectionheader);
      destroy_each(each_blocks, detaching);
      destroy_component(buttonlink);
    }
  };
}
function create_if_block_5$1(ctx) {
  let copybuttongroup;
  let current;
  copybuttongroup = new CopyButtonGroup({
    props: {
      labelText: (
        /*key*/
        ctx[11]
      ),
      buttonText: (
        /*$InspectorStore*/
        ctx[0].memberData.customFields[
          /*key*/
          ctx[11]
        ]
      ),
      cypress: `custom-field-${/*key*/
      ctx[11]}`
    }
  });
  return {
    c() {
      create_component(copybuttongroup.$$.fragment);
    },
    m(target, anchor) {
      mount_component(copybuttongroup, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const copybuttongroup_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        copybuttongroup_changes.labelText = /*key*/
        ctx2[11];
      if (dirty & /*$InspectorStore*/
      1)
        copybuttongroup_changes.buttonText = /*$InspectorStore*/
        ctx2[0].memberData.customFields[
          /*key*/
          ctx2[11]
        ];
      if (dirty & /*$InspectorStore*/
      1)
        copybuttongroup_changes.cypress = `custom-field-${/*key*/
        ctx2[11]}`;
      copybuttongroup.$set(copybuttongroup_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(copybuttongroup.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(copybuttongroup.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(copybuttongroup, detaching);
    }
  };
}
function create_each_block_2(ctx) {
  let if_block_anchor;
  let current;
  let if_block = (
    /*$InspectorStore*/
    ctx[0].memberData.customFields[
      /*key*/
      ctx[11]
    ] !== "" && /*$InspectorStore*/
    ctx[0].memberData.customFields[
      /*key*/
      ctx[11]
    ] !== null && create_if_block_5$1(ctx)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      if (
        /*$InspectorStore*/
        ctx2[0].memberData.customFields[
          /*key*/
          ctx2[11]
        ] !== "" && /*$InspectorStore*/
        ctx2[0].memberData.customFields[
          /*key*/
          ctx2[11]
        ] !== null
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
          if (dirty & /*$InspectorStore*/
          1) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block_5$1(ctx2);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (if_block)
        if_block.d(detaching);
      if (detaching)
        detach(if_block_anchor);
    }
  };
}
function create_if_block_3$3(ctx) {
  let div;
  let sectionheader;
  let t0;
  let copybuttongroup;
  let t1;
  let current;
  sectionheader = new SectionHeader({
    props: {
      titleText: "Plans",
      editURL: `https://app.memberstack.com/apps/${/*$InspectorStore*/
      ctx[0].appData.id}/members/${/*$InspectorStore*/
      ctx[0].memberData.id}/profile`
    }
  });
  copybuttongroup = new CopyButtonGroup({
    props: {
      labelText: "Stripe ID",
      buttonText: (
        /*$InspectorStore*/
        ctx[0].memberData.stripeCustomerId
      )
    }
  });
  let each_value_1 = (
    /*memberPlanData*/
    ctx[2]
  );
  let each_blocks = [];
  for (let i = 0; i < each_value_1.length; i += 1) {
    each_blocks[i] = create_each_block_1$2(get_each_context_1$2(ctx, each_value_1, i));
  }
  const out = (i) => transition_out(each_blocks[i], 1, 1, () => {
    each_blocks[i] = null;
  });
  return {
    c() {
      div = element("div");
      create_component(sectionheader.$$.fragment);
      t0 = space();
      create_component(copybuttongroup.$$.fragment);
      t1 = space();
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      attr(div, "class", "ms-member-tab__section svelte-1612fls");
      attr(div, "data-cy", "member-section-plans");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(sectionheader, div, null);
      append(div, t0);
      mount_component(copybuttongroup, div, null);
      append(div, t1);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(div, null);
        }
      }
      current = true;
    },
    p(ctx2, dirty) {
      const sectionheader_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        sectionheader_changes.editURL = `https://app.memberstack.com/apps/${/*$InspectorStore*/
        ctx2[0].appData.id}/members/${/*$InspectorStore*/
        ctx2[0].memberData.id}/profile`;
      sectionheader.$set(sectionheader_changes);
      const copybuttongroup_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        copybuttongroup_changes.buttonText = /*$InspectorStore*/
        ctx2[0].memberData.stripeCustomerId;
      copybuttongroup.$set(copybuttongroup_changes);
      if (dirty & /*memberPlanData*/
      4) {
        each_value_1 = /*memberPlanData*/
        ctx2[2];
        let i;
        for (i = 0; i < each_value_1.length; i += 1) {
          const child_ctx = get_each_context_1$2(ctx2, each_value_1, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
            transition_in(each_blocks[i], 1);
          } else {
            each_blocks[i] = create_each_block_1$2(child_ctx);
            each_blocks[i].c();
            transition_in(each_blocks[i], 1);
            each_blocks[i].m(div, null);
          }
        }
        group_outros();
        for (i = each_value_1.length; i < each_blocks.length; i += 1) {
          out(i);
        }
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(sectionheader.$$.fragment, local);
      transition_in(copybuttongroup.$$.fragment, local);
      for (let i = 0; i < each_value_1.length; i += 1) {
        transition_in(each_blocks[i]);
      }
      current = true;
    },
    o(local) {
      transition_out(sectionheader.$$.fragment, local);
      transition_out(copybuttongroup.$$.fragment, local);
      each_blocks = each_blocks.filter(Boolean);
      for (let i = 0; i < each_blocks.length; i += 1) {
        transition_out(each_blocks[i]);
      }
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      destroy_component(sectionheader);
      destroy_component(copybuttongroup);
      destroy_each(each_blocks, detaching);
    }
  };
}
function create_each_block_1$2(ctx) {
  let memberplanitem;
  let current;
  memberplanitem = new MemberPlanItem({
    props: {
      memberPlanItem: (
        /*planConnection*/
        ctx[14]
      )
    }
  });
  return {
    c() {
      create_component(memberplanitem.$$.fragment);
    },
    m(target, anchor) {
      mount_component(memberplanitem, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const memberplanitem_changes = {};
      if (dirty & /*memberPlanData*/
      4)
        memberplanitem_changes.memberPlanItem = /*planConnection*/
        ctx2[14];
      memberplanitem.$set(memberplanitem_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(memberplanitem.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(memberplanitem.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(memberplanitem, detaching);
    }
  };
}
function create_if_block_2$4(ctx) {
  let div;
  let sectionheader;
  let t0;
  let t1;
  let buttonlink;
  let current;
  sectionheader = new SectionHeader({
    props: {
      titleText: "Meta Data",
      editURL: `https://app.memberstack.com/apps/${/*$InspectorStore*/
      ctx[0].appData.id}/members/${/*$InspectorStore*/
      ctx[0].memberData.id}/profile`
    }
  });
  let each_value = Object.keys(
    /*$InspectorStore*/
    ctx[0].memberData.metaData
  );
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$3(get_each_context$3(ctx, each_value, i));
  }
  const out = (i) => transition_out(each_blocks[i], 1, 1, () => {
    each_blocks[i] = null;
  });
  buttonlink = new ButtonLink({
    props: {
      link: "https://docs.memberstack.com/hc/en-us/articles/7389627062299-Custom-Fields-vs-Metadata-vs-JSON",
      text: "Documentation"
    }
  });
  return {
    c() {
      div = element("div");
      create_component(sectionheader.$$.fragment);
      t0 = space();
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      t1 = space();
      create_component(buttonlink.$$.fragment);
      attr(div, "class", "ms-member-tab__section svelte-1612fls");
      attr(div, "data-cy", "member-section-meta-data");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(sectionheader, div, null);
      append(div, t0);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(div, null);
        }
      }
      append(div, t1);
      mount_component(buttonlink, div, null);
      current = true;
    },
    p(ctx2, dirty) {
      const sectionheader_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        sectionheader_changes.editURL = `https://app.memberstack.com/apps/${/*$InspectorStore*/
        ctx2[0].appData.id}/members/${/*$InspectorStore*/
        ctx2[0].memberData.id}/profile`;
      sectionheader.$set(sectionheader_changes);
      if (dirty & /*Object, $InspectorStore*/
      1) {
        each_value = Object.keys(
          /*$InspectorStore*/
          ctx2[0].memberData.metaData
        );
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context$3(ctx2, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
            transition_in(each_blocks[i], 1);
          } else {
            each_blocks[i] = create_each_block$3(child_ctx);
            each_blocks[i].c();
            transition_in(each_blocks[i], 1);
            each_blocks[i].m(div, t1);
          }
        }
        group_outros();
        for (i = each_value.length; i < each_blocks.length; i += 1) {
          out(i);
        }
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(sectionheader.$$.fragment, local);
      for (let i = 0; i < each_value.length; i += 1) {
        transition_in(each_blocks[i]);
      }
      transition_in(buttonlink.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(sectionheader.$$.fragment, local);
      each_blocks = each_blocks.filter(Boolean);
      for (let i = 0; i < each_blocks.length; i += 1) {
        transition_out(each_blocks[i]);
      }
      transition_out(buttonlink.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      destroy_component(sectionheader);
      destroy_each(each_blocks, detaching);
      destroy_component(buttonlink);
    }
  };
}
function create_each_block$3(ctx) {
  let copybuttongroup;
  let current;
  copybuttongroup = new CopyButtonGroup({
    props: {
      labelText: (
        /*key*/
        ctx[11]
      ),
      buttonText: (
        /*$InspectorStore*/
        ctx[0].memberData.metaData[
          /*key*/
          ctx[11]
        ]
      ),
      cypress: `meta-data-${/*key*/
      ctx[11]}`
    }
  });
  return {
    c() {
      create_component(copybuttongroup.$$.fragment);
    },
    m(target, anchor) {
      mount_component(copybuttongroup, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const copybuttongroup_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        copybuttongroup_changes.labelText = /*key*/
        ctx2[11];
      if (dirty & /*$InspectorStore*/
      1)
        copybuttongroup_changes.buttonText = /*$InspectorStore*/
        ctx2[0].memberData.metaData[
          /*key*/
          ctx2[11]
        ];
      if (dirty & /*$InspectorStore*/
      1)
        copybuttongroup_changes.cypress = `meta-data-${/*key*/
        ctx2[11]}`;
      copybuttongroup.$set(copybuttongroup_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(copybuttongroup.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(copybuttongroup.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(copybuttongroup, detaching);
    }
  };
}
function create_if_block_1$5(ctx) {
  let div;
  let sectionheader;
  let t0;
  let pre;
  let code;
  let t1_value = JSON.stringify(
    /*memberJSON*/
    ctx[1].data,
    null,
    2
  ) + "";
  let t1;
  let t2;
  let buttonlink;
  let current;
  sectionheader = new SectionHeader({
    props: {
      titleText: "Member JSON",
      editURL: `https://app.memberstack.com/apps/${/*$InspectorStore*/
      ctx[0].appData.id}/members/${/*$InspectorStore*/
      ctx[0].memberData.id}/profile`
    }
  });
  buttonlink = new ButtonLink({
    props: {
      link: "https://docs.memberstack.com/hc/en-us/articles/7389627062299-Custom-Fields-vs-Metadata-vs-JSON",
      text: "Documentation"
    }
  });
  return {
    c() {
      div = element("div");
      create_component(sectionheader.$$.fragment);
      t0 = space();
      pre = element("pre");
      code = element("code");
      t1 = text(t1_value);
      t2 = space();
      create_component(buttonlink.$$.fragment);
      attr(pre, "class", "ms-code-block svelte-1612fls");
      attr(div, "class", "ms-member-tab__section svelte-1612fls");
      attr(div, "data-cy", "member-section-json");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(sectionheader, div, null);
      append(div, t0);
      append(div, pre);
      append(pre, code);
      append(code, t1);
      append(div, t2);
      mount_component(buttonlink, div, null);
      current = true;
    },
    p(ctx2, dirty) {
      const sectionheader_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        sectionheader_changes.editURL = `https://app.memberstack.com/apps/${/*$InspectorStore*/
        ctx2[0].appData.id}/members/${/*$InspectorStore*/
        ctx2[0].memberData.id}/profile`;
      sectionheader.$set(sectionheader_changes);
      if ((!current || dirty & /*memberJSON*/
      2) && t1_value !== (t1_value = JSON.stringify(
        /*memberJSON*/
        ctx2[1].data,
        null,
        2
      ) + ""))
        set_data(t1, t1_value);
    },
    i(local) {
      if (current)
        return;
      transition_in(sectionheader.$$.fragment, local);
      transition_in(buttonlink.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(sectionheader.$$.fragment, local);
      transition_out(buttonlink.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      destroy_component(sectionheader);
      destroy_component(buttonlink);
    }
  };
}
function create_fragment$8(ctx) {
  let div2;
  let div1;
  let div0;
  let t0;
  let t1;
  let if_block1_anchor;
  let current;
  function select_block_type(ctx2, dirty) {
    if (
      /*isLoggedIn*/
      ctx2[3]
    )
      return create_if_block_6$1;
    return create_else_block$2;
  }
  let current_block_type = select_block_type(ctx);
  let if_block0 = current_block_type(ctx);
  let if_block1 = (
    /*isLoggedIn*/
    ctx[3] && create_if_block$6(ctx)
  );
  return {
    c() {
      div2 = element("div");
      div1 = element("div");
      div0 = element("div");
      t0 = space();
      if_block0.c();
      t1 = space();
      if (if_block1)
        if_block1.c();
      if_block1_anchor = empty();
      attr(div0, "class", "ms-member-tab-status__indicator svelte-1612fls");
      toggle_class(
        div0,
        "ms-member-tab-status__indicator--active",
        /*isLoggedIn*/
        ctx[3]
      );
      attr(div1, "class", "ms-member-tab-status svelte-1612fls");
      attr(div1, "data-cy", "member-tab-status");
      toggle_class(
        div1,
        "ms-member-tab-status--active",
        /*isLoggedIn*/
        ctx[3]
      );
      attr(div2, "class", "ms-member-tab__header svelte-1612fls");
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      append(div2, div1);
      append(div1, div0);
      append(div1, t0);
      if_block0.m(div1, null);
      insert(target, t1, anchor);
      if (if_block1)
        if_block1.m(target, anchor);
      insert(target, if_block1_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (!current || dirty & /*isLoggedIn*/
      8) {
        toggle_class(
          div0,
          "ms-member-tab-status__indicator--active",
          /*isLoggedIn*/
          ctx2[3]
        );
      }
      if (current_block_type === (current_block_type = select_block_type(ctx2)) && if_block0) {
        if_block0.p(ctx2, dirty);
      } else {
        if_block0.d(1);
        if_block0 = current_block_type(ctx2);
        if (if_block0) {
          if_block0.c();
          if_block0.m(div1, null);
        }
      }
      if (!current || dirty & /*isLoggedIn*/
      8) {
        toggle_class(
          div1,
          "ms-member-tab-status--active",
          /*isLoggedIn*/
          ctx2[3]
        );
      }
      if (
        /*isLoggedIn*/
        ctx2[3]
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty & /*isLoggedIn*/
          8) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block$6(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block1);
      current = true;
    },
    o(local) {
      transition_out(if_block1);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div2);
      if_block0.d();
      if (detaching)
        detach(t1);
      if (if_block1)
        if_block1.d(detaching);
      if (detaching)
        detach(if_block1_anchor);
    }
  };
}
function readableDate(date) {
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric"
  };
  return new Date(date).toLocaleDateString(void 0, options);
}
function logoutMember() {
  return __async(this, null, function* () {
    yield window.$memberstackDom.logout();
    location.reload();
  });
}
function instance$6($$self, $$props, $$invalidate) {
  let isLoggedIn;
  let memberPlanData;
  let $InspectorStore;
  component_subscribe($$self, InspectorStore, ($$value) => $$invalidate(0, $InspectorStore = $$value));
  let memberJSON = null;
  onMount(() => __async(this, null, function* () {
    if (!$InspectorStore.memberData)
      return;
    if (!isLoggedIn)
      return;
    try {
      $$invalidate(1, memberJSON = yield window.$memberstackDom.getMemberJSON());
    } catch (error) {
      console.error("Failed to fetch member JSON:", error);
    }
  }));
  const findPlan = (planId) => $InspectorStore.appData.plans.find((plan) => plan.id === planId);
  const findPrice = (plan, priceId) => plan.prices.find((price) => price.id === priceId);
  const getPlanAndPriceDetails = (memberData, appData) => {
    const results = [];
    if (!memberData || !memberData.planConnections || !appData)
      return results;
    memberData.planConnections.forEach((connection) => {
      const plan = findPlan(connection.planId);
      if (plan) {
        const result = {
          planId: plan.id,
          planName: plan.name,
          priority: plan.priority || 0,
          priceDetails: null
        };
        if (connection.payment && connection.payment.priceId) {
          const price = findPrice(plan, connection.payment.priceId);
          if (price) {
            result.priceDetails = {
              priceId: price.id,
              priceName: price.name,
              type: price.type,
              amount: price.amount,
              currency: price.currency,
              interval: price.interval
            };
          }
        }
        results.push(result);
      }
    });
    return results;
  };
  function openLoginModal() {
    window.$memberstackDom.openModal("LOGIN").then((loginData) => {
      console.log("User logged in!", loginData);
      window.$memberstackDom.hideModal();
      UpdateMemberData();
    });
  }
  const func2 = (key) => $InspectorStore.memberData.customFields[key] !== "" && $InspectorStore.memberData.customFields[key] !== null;
  const click_handler = () => logoutMember();
  const click_handler_1 = () => openLoginModal();
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$InspectorStore*/
    1) {
      $$invalidate(3, isLoggedIn = $InspectorStore.memberData && $InspectorStore.memberData.id);
    }
    if ($$self.$$.dirty & /*$InspectorStore*/
    1) {
      $$invalidate(2, memberPlanData = getPlanAndPriceDetails($InspectorStore.memberData, $InspectorStore.appData));
    }
  };
  return [
    $InspectorStore,
    memberJSON,
    memberPlanData,
    isLoggedIn,
    openLoginModal,
    func2,
    click_handler,
    click_handler_1
  ];
}
var MemberTab = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$6, create_fragment$8, safe_not_equal, {}, add_css$5);
  }
};
function create_fragment$7(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm240-200q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80Z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "viewBox", "160 -920 640 840");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var LockIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$7, safe_not_equal, {});
  }
};
function add_css$4(target) {
  append_styles(target, "svelte-rd0m2l", ".ms-app-gated-content-item.svelte-rd0m2l{width:100%;background-color:#444;border:1px solid #5c5c5c;border-radius:4px;flex-wrap:wrap;margin-bottom:0.5em;display:flex;transition:height 0.2s ease-in-out;overflow:hidden}.ms-app-gated-content-item__tabs.svelte-rd0m2l{display:flex;align-items:stretch;justify-content:space-between;width:100%}.ms-app-gated-content-item__tab.svelte-rd0m2l{gap:6px;padding:4px;display:flex;align-items:center;background-color:transparent;transition:background-color 0.2s ease-in-out;width:100%;line-height:1}.ms-app-gated-content-item__icon.svelte-rd0m2l{width:22px;height:22px;display:flex;align-items:center;justify-content:center;background-color:#be822e;border-radius:3px;color:#fff;padding:2px}.ms-app-gated-content-item__icon svg{width:100%;height:100%}.ms-app-gated-content-item__arrow.svelte-rd0m2l{margin-left:auto;margin-right:8px;width:8px;transition:transform 0.2s ease-in-out}.ms-app-gated-content-item__content.svelte-rd0m2l{width:100%}.ms-app-gated-content-item__wrapper.svelte-rd0m2l{background-color:#292929;width:100%;padding:8px}.ms-app-gated-content-item__group.svelte-rd0m2l{background:#373737;padding:4px;margin-bottom:6px;border-radius:4px}.ms-app-gated-content-item__group-title.svelte-rd0m2l{font-size:9px;line-height:1;background:#444;padding:6px;margin-bottom:6px;border:1px solid #4b4b4b;border-radius:4px;display:inline-block}");
}
function get_each_context$2(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[4] = list[i];
  return child_ctx;
}
function get_each_context_1$1(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[7] = list[i];
  return child_ctx;
}
function create_if_block$5(ctx) {
  let div3;
  let copybuttongroup0;
  let t0;
  let div2;
  let div0;
  let t2;
  let div1;
  let t3;
  let copybuttongroup1;
  let t4;
  let current_block_type_index;
  let if_block;
  let div3_transition;
  let current;
  copybuttongroup0 = new CopyButtonGroup({
    props: {
      labelText: "Key",
      buttonText: (
        /*appGatedContentItem*/
        ctx[0].key
      )
    }
  });
  let each_value_1 = (
    /*appGatedContentItem*/
    ctx[0].urls
  );
  let each_blocks = [];
  for (let i = 0; i < each_value_1.length; i += 1) {
    each_blocks[i] = create_each_block_1$1(get_each_context_1$1(ctx, each_value_1, i));
  }
  const out = (i) => transition_out(each_blocks[i], 1, 1, () => {
    each_blocks[i] = null;
  });
  copybuttongroup1 = new CopyButtonGroup({
    props: {
      labelText: "Access Denied",
      buttonText: "/" + /*appGatedContentItem*/
      ctx[0].redirect
    }
  });
  const if_block_creators = [create_if_block_1$4, create_else_block$1];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*appGatedContentItem*/
      ctx2[0].plans && /*appGatedContentItem*/
      ctx2[0].plans.length > 0
    )
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      div3 = element("div");
      create_component(copybuttongroup0.$$.fragment);
      t0 = space();
      div2 = element("div");
      div0 = element("div");
      div0.textContent = "Gated Pages & Folders";
      t2 = space();
      div1 = element("div");
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      t3 = space();
      create_component(copybuttongroup1.$$.fragment);
      t4 = space();
      if_block.c();
      attr(div0, "class", "ms-app-gated-content-item__group-title svelte-rd0m2l");
      attr(div2, "class", "ms-app-gated-content-item__group svelte-rd0m2l");
      attr(div3, "class", "ms-app-gated-content-item__wrapper svelte-rd0m2l");
      attr(div3, "data-cy", "app-gated-content-item-content-wrapper");
    },
    m(target, anchor) {
      insert(target, div3, anchor);
      mount_component(copybuttongroup0, div3, null);
      append(div3, t0);
      append(div3, div2);
      append(div2, div0);
      append(div2, t2);
      append(div2, div1);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(div1, null);
        }
      }
      append(div3, t3);
      mount_component(copybuttongroup1, div3, null);
      append(div3, t4);
      if_blocks[current_block_type_index].m(div3, null);
      current = true;
    },
    p(ctx2, dirty) {
      const copybuttongroup0_changes = {};
      if (dirty & /*appGatedContentItem*/
      1)
        copybuttongroup0_changes.buttonText = /*appGatedContentItem*/
        ctx2[0].key;
      copybuttongroup0.$set(copybuttongroup0_changes);
      if (dirty & /*appGatedContentItem*/
      1) {
        each_value_1 = /*appGatedContentItem*/
        ctx2[0].urls;
        let i;
        for (i = 0; i < each_value_1.length; i += 1) {
          const child_ctx = get_each_context_1$1(ctx2, each_value_1, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
            transition_in(each_blocks[i], 1);
          } else {
            each_blocks[i] = create_each_block_1$1(child_ctx);
            each_blocks[i].c();
            transition_in(each_blocks[i], 1);
            each_blocks[i].m(div1, null);
          }
        }
        group_outros();
        for (i = each_value_1.length; i < each_blocks.length; i += 1) {
          out(i);
        }
        check_outros();
      }
      const copybuttongroup1_changes = {};
      if (dirty & /*appGatedContentItem*/
      1)
        copybuttongroup1_changes.buttonText = "/" + /*appGatedContentItem*/
        ctx2[0].redirect;
      copybuttongroup1.$set(copybuttongroup1_changes);
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(div3, null);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(copybuttongroup0.$$.fragment, local);
      for (let i = 0; i < each_value_1.length; i += 1) {
        transition_in(each_blocks[i]);
      }
      transition_in(copybuttongroup1.$$.fragment, local);
      transition_in(if_block);
      if (local) {
        add_render_callback(() => {
          if (!current)
            return;
          if (!div3_transition)
            div3_transition = create_bidirectional_transition(div3, slide, { duration: 300 }, true);
          div3_transition.run(1);
        });
      }
      current = true;
    },
    o(local) {
      transition_out(copybuttongroup0.$$.fragment, local);
      each_blocks = each_blocks.filter(Boolean);
      for (let i = 0; i < each_blocks.length; i += 1) {
        transition_out(each_blocks[i]);
      }
      transition_out(copybuttongroup1.$$.fragment, local);
      transition_out(if_block);
      if (local) {
        if (!div3_transition)
          div3_transition = create_bidirectional_transition(div3, slide, { duration: 300 }, false);
        div3_transition.run(0);
      }
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div3);
      destroy_component(copybuttongroup0);
      destroy_each(each_blocks, detaching);
      destroy_component(copybuttongroup1);
      if_blocks[current_block_type_index].d();
      if (detaching && div3_transition)
        div3_transition.end();
    }
  };
}
function create_each_block_1$1(ctx) {
  let copybuttongroup;
  let current;
  copybuttongroup = new CopyButtonGroup({
    props: {
      labelText: (
        /*url*/
        ctx[7].filter
      ),
      buttonText: "/" + /*url*/
      ctx[7].url
    }
  });
  return {
    c() {
      create_component(copybuttongroup.$$.fragment);
    },
    m(target, anchor) {
      mount_component(copybuttongroup, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const copybuttongroup_changes = {};
      if (dirty & /*appGatedContentItem*/
      1)
        copybuttongroup_changes.labelText = /*url*/
        ctx2[7].filter;
      if (dirty & /*appGatedContentItem*/
      1)
        copybuttongroup_changes.buttonText = "/" + /*url*/
        ctx2[7].url;
      copybuttongroup.$set(copybuttongroup_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(copybuttongroup.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(copybuttongroup.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(copybuttongroup, detaching);
    }
  };
}
function create_else_block$1(ctx) {
  let div2;
  let div0;
  let t1;
  let div1;
  let copybuttongroup;
  let current;
  copybuttongroup = new CopyButtonGroup({
    props: {
      labelText: "All Members",
      buttonText: "true"
    }
  });
  return {
    c() {
      div2 = element("div");
      div0 = element("div");
      div0.textContent = "Grant Access to...";
      t1 = space();
      div1 = element("div");
      create_component(copybuttongroup.$$.fragment);
      attr(div0, "class", "ms-app-gated-content-item__group-title svelte-rd0m2l");
      attr(div2, "class", "ms-app-gated-content-item__group svelte-rd0m2l");
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      append(div2, div0);
      append(div2, t1);
      append(div2, div1);
      mount_component(copybuttongroup, div1, null);
      current = true;
    },
    p: noop,
    i(local) {
      if (current)
        return;
      transition_in(copybuttongroup.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(copybuttongroup.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div2);
      destroy_component(copybuttongroup);
    }
  };
}
function create_if_block_1$4(ctx) {
  let div2;
  let div0;
  let t1;
  let div1;
  let current;
  let each_value = (
    /*appGatedContentItem*/
    ctx[0].plans
  );
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$2(get_each_context$2(ctx, each_value, i));
  }
  const out = (i) => transition_out(each_blocks[i], 1, 1, () => {
    each_blocks[i] = null;
  });
  return {
    c() {
      div2 = element("div");
      div0 = element("div");
      div0.textContent = "Grant Access to...";
      t1 = space();
      div1 = element("div");
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      attr(div0, "class", "ms-app-gated-content-item__group-title svelte-rd0m2l");
      attr(div2, "class", "ms-app-gated-content-item__group svelte-rd0m2l");
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      append(div2, div0);
      append(div2, t1);
      append(div2, div1);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(div1, null);
        }
      }
      current = true;
    },
    p(ctx2, dirty) {
      if (dirty & /*appGatedContentItem*/
      1) {
        each_value = /*appGatedContentItem*/
        ctx2[0].plans;
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context$2(ctx2, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
            transition_in(each_blocks[i], 1);
          } else {
            each_blocks[i] = create_each_block$2(child_ctx);
            each_blocks[i].c();
            transition_in(each_blocks[i], 1);
            each_blocks[i].m(div1, null);
          }
        }
        group_outros();
        for (i = each_value.length; i < each_blocks.length; i += 1) {
          out(i);
        }
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      for (let i = 0; i < each_value.length; i += 1) {
        transition_in(each_blocks[i]);
      }
      current = true;
    },
    o(local) {
      each_blocks = each_blocks.filter(Boolean);
      for (let i = 0; i < each_blocks.length; i += 1) {
        transition_out(each_blocks[i]);
      }
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div2);
      destroy_each(each_blocks, detaching);
    }
  };
}
function create_each_block$2(ctx) {
  let copybuttongroup;
  let current;
  copybuttongroup = new CopyButtonGroup({
    props: {
      labelText: "Plan",
      buttonText: (
        /*plan*/
        ctx[4].id
      )
    }
  });
  return {
    c() {
      create_component(copybuttongroup.$$.fragment);
    },
    m(target, anchor) {
      mount_component(copybuttongroup, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const copybuttongroup_changes = {};
      if (dirty & /*appGatedContentItem*/
      1)
        copybuttongroup_changes.buttonText = /*plan*/
        ctx2[4].id;
      copybuttongroup.$set(copybuttongroup_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(copybuttongroup.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(copybuttongroup.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(copybuttongroup, detaching);
    }
  };
}
function create_fragment$6(ctx) {
  let div2;
  let div0;
  let button;
  let span0;
  let lockicon;
  let t0;
  let t1_value = (
    /*appGatedContentItem*/
    ctx[0].name + ""
  );
  let t1;
  let t2;
  let span1;
  let arrowicon;
  let t3;
  let div1;
  let div2_id_value;
  let current;
  let mounted;
  let dispose;
  lockicon = new LockIcon({});
  arrowicon = new ArrowIcon({
    props: {
      style: "transform: rotate(" + /*openAppGatedContentItem*/
      (ctx[1] ? "180deg" : "0deg") + ")"
    }
  });
  let if_block = (
    /*openAppGatedContentItem*/
    ctx[1] && create_if_block$5(ctx)
  );
  return {
    c() {
      div2 = element("div");
      div0 = element("div");
      button = element("button");
      span0 = element("span");
      create_component(lockicon.$$.fragment);
      t0 = space();
      t1 = text(t1_value);
      t2 = space();
      span1 = element("span");
      create_component(arrowicon.$$.fragment);
      t3 = space();
      div1 = element("div");
      if (if_block)
        if_block.c();
      attr(span0, "class", "ms-app-gated-content-item__icon svelte-rd0m2l");
      attr(span1, "class", "ms-app-gated-content-item__arrow svelte-rd0m2l");
      attr(button, "class", "ms-app-gated-content-item__tab svelte-rd0m2l");
      attr(button, "data-cy", "app-gated-content-item-button");
      attr(div0, "class", "ms-app-gated-content-item__tabs svelte-rd0m2l");
      attr(div1, "class", "ms-app-gated-content-item__content svelte-rd0m2l");
      attr(div1, "data-cy", "app-gated-content-item-content");
      attr(div2, "class", "ms-app-gated-content-item svelte-rd0m2l");
      attr(div2, "id", div2_id_value = /*appGatedContentItem*/
      ctx[0].key);
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      append(div2, div0);
      append(div0, button);
      append(button, span0);
      mount_component(lockicon, span0, null);
      append(button, t0);
      append(button, t1);
      append(button, t2);
      append(button, span1);
      mount_component(arrowicon, span1, null);
      append(div2, t3);
      append(div2, div1);
      if (if_block)
        if_block.m(div1, null);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler*/
          ctx[3]
        );
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if ((!current || dirty & /*appGatedContentItem*/
      1) && t1_value !== (t1_value = /*appGatedContentItem*/
      ctx2[0].name + ""))
        set_data(t1, t1_value);
      const arrowicon_changes = {};
      if (dirty & /*openAppGatedContentItem*/
      2)
        arrowicon_changes.style = "transform: rotate(" + /*openAppGatedContentItem*/
        (ctx2[1] ? "180deg" : "0deg") + ")";
      arrowicon.$set(arrowicon_changes);
      if (
        /*openAppGatedContentItem*/
        ctx2[1]
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
          if (dirty & /*openAppGatedContentItem*/
          2) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$5(ctx2);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(div1, null);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
      if (!current || dirty & /*appGatedContentItem*/
      1 && div2_id_value !== (div2_id_value = /*appGatedContentItem*/
      ctx2[0].key)) {
        attr(div2, "id", div2_id_value);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(lockicon.$$.fragment, local);
      transition_in(arrowicon.$$.fragment, local);
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(lockicon.$$.fragment, local);
      transition_out(arrowicon.$$.fragment, local);
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div2);
      destroy_component(lockicon);
      destroy_component(arrowicon);
      if (if_block)
        if_block.d();
      mounted = false;
      dispose();
    }
  };
}
function instance$5($$self, $$props, $$invalidate) {
  let { appGatedContentItem } = $$props;
  let openAppGatedContentItem = false;
  function showAppGatedContentItemContent() {
    $$invalidate(1, openAppGatedContentItem = !openAppGatedContentItem);
  }
  const click_handler = () => showAppGatedContentItemContent();
  $$self.$$set = ($$props2) => {
    if ("appGatedContentItem" in $$props2)
      $$invalidate(0, appGatedContentItem = $$props2.appGatedContentItem);
  };
  return [
    appGatedContentItem,
    openAppGatedContentItem,
    showAppGatedContentItemContent,
    click_handler
  ];
}
var AppGatedContentItem = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$5, create_fragment$6, safe_not_equal, { appGatedContentItem: 0 }, add_css$4);
  }
};
function create_fragment$5(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z");
      attr(svg, "aria-hidden", "true");
      attr(svg, "viewBox", "3 7 18 10");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(svg);
    }
  };
}
var FieldsIcon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$5, safe_not_equal, {});
  }
};
function add_css$3(target) {
  append_styles(target, "svelte-k3hu84", ".ms-app-custom-fields-item.svelte-k3hu84{width:100%;background-color:#444;border:1px solid #5c5c5c;border-radius:4px;flex-wrap:wrap;margin-bottom:0.5em;display:flex;transition:height 0.2s ease-in-out;overflow:hidden}.ms-app-custom-fields-item__tabs.svelte-k3hu84{display:flex;align-items:stretch;justify-content:space-between;width:100%}.ms-app-custom-fields-item__tab.svelte-k3hu84{gap:6px;padding:4px;display:flex;align-items:center;background-color:transparent;transition:background-color 0.2s ease-in-out;width:100%;line-height:1}.ms-app-custom-fields-item__icon.svelte-k3hu84{width:22px;height:22px;display:flex;align-items:center;justify-content:center;background-color:#292929;border-radius:3px;color:#fff;padding:2px}.ms-app-custom-fields-item__icon svg{width:100%;height:100%}.ms-app-custom-fields-item__arrow.svelte-k3hu84{margin-left:auto;margin-right:8px;width:8px;transition:transform 0.2s ease-in-out}.ms-app-custom-fields-item__content.svelte-k3hu84{width:100%}.ms-app-custom-fields-item__wrapper.svelte-k3hu84{background-color:#292929;width:100%;padding:8px}");
}
function create_if_block$4(ctx) {
  let div;
  let t0;
  let t1;
  let t2;
  let div_transition;
  let current;
  let if_block0 = (
    /*appCustomFieldItem*/
    ctx[0].key && create_if_block_4$1(ctx)
  );
  let if_block1 = (
    /*appCustomFieldItem*/
    (ctx[0].order || /*appCustomFieldItem*/
    ctx[0].order === 0) && create_if_block_3$2(ctx)
  );
  let if_block2 = (
    /*appCustomFieldItem*/
    ctx[0].hidden && create_if_block_2$3(ctx)
  );
  let if_block3 = (
    /*appCustomFieldItem*/
    ctx[0].visibility && create_if_block_1$3(ctx)
  );
  return {
    c() {
      div = element("div");
      if (if_block0)
        if_block0.c();
      t0 = space();
      if (if_block1)
        if_block1.c();
      t1 = space();
      if (if_block2)
        if_block2.c();
      t2 = space();
      if (if_block3)
        if_block3.c();
      attr(div, "class", "ms-app-custom-fields-item__wrapper svelte-k3hu84");
      attr(div, "data-cy", "app-custom-fields-item-content-wrapper");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      if (if_block0)
        if_block0.m(div, null);
      append(div, t0);
      if (if_block1)
        if_block1.m(div, null);
      append(div, t1);
      if (if_block2)
        if_block2.m(div, null);
      append(div, t2);
      if (if_block3)
        if_block3.m(div, null);
      current = true;
    },
    p(ctx2, dirty) {
      if (
        /*appCustomFieldItem*/
        ctx2[0].key
      ) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
          if (dirty & /*appCustomFieldItem*/
          1) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_4$1(ctx2);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(div, t0);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      if (
        /*appCustomFieldItem*/
        ctx2[0].order || /*appCustomFieldItem*/
        ctx2[0].order === 0
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty & /*appCustomFieldItem*/
          1) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block_3$2(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(div, t1);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
      if (
        /*appCustomFieldItem*/
        ctx2[0].hidden
      ) {
        if (if_block2) {
          if_block2.p(ctx2, dirty);
          if (dirty & /*appCustomFieldItem*/
          1) {
            transition_in(if_block2, 1);
          }
        } else {
          if_block2 = create_if_block_2$3(ctx2);
          if_block2.c();
          transition_in(if_block2, 1);
          if_block2.m(div, t2);
        }
      } else if (if_block2) {
        group_outros();
        transition_out(if_block2, 1, 1, () => {
          if_block2 = null;
        });
        check_outros();
      }
      if (
        /*appCustomFieldItem*/
        ctx2[0].visibility
      ) {
        if (if_block3) {
          if_block3.p(ctx2, dirty);
          if (dirty & /*appCustomFieldItem*/
          1) {
            transition_in(if_block3, 1);
          }
        } else {
          if_block3 = create_if_block_1$3(ctx2);
          if_block3.c();
          transition_in(if_block3, 1);
          if_block3.m(div, null);
        }
      } else if (if_block3) {
        group_outros();
        transition_out(if_block3, 1, 1, () => {
          if_block3 = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block0);
      transition_in(if_block1);
      transition_in(if_block2);
      transition_in(if_block3);
      if (local) {
        add_render_callback(() => {
          if (!current)
            return;
          if (!div_transition)
            div_transition = create_bidirectional_transition(div, slide, { duration: 300 }, true);
          div_transition.run(1);
        });
      }
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(if_block1);
      transition_out(if_block2);
      transition_out(if_block3);
      if (local) {
        if (!div_transition)
          div_transition = create_bidirectional_transition(div, slide, { duration: 300 }, false);
        div_transition.run(0);
      }
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      if (if_block0)
        if_block0.d();
      if (if_block1)
        if_block1.d();
      if (if_block2)
        if_block2.d();
      if (if_block3)
        if_block3.d();
      if (detaching && div_transition)
        div_transition.end();
    }
  };
}
function create_if_block_4$1(ctx) {
  let copybuttongroup;
  let current;
  copybuttongroup = new CopyButtonGroup({
    props: {
      labelText: "Key",
      buttonText: (
        /*appCustomFieldItem*/
        ctx[0].key.toString()
      )
    }
  });
  return {
    c() {
      create_component(copybuttongroup.$$.fragment);
    },
    m(target, anchor) {
      mount_component(copybuttongroup, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const copybuttongroup_changes = {};
      if (dirty & /*appCustomFieldItem*/
      1)
        copybuttongroup_changes.buttonText = /*appCustomFieldItem*/
        ctx2[0].key.toString();
      copybuttongroup.$set(copybuttongroup_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(copybuttongroup.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(copybuttongroup.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(copybuttongroup, detaching);
    }
  };
}
function create_if_block_3$2(ctx) {
  let copybuttongroup;
  let current;
  copybuttongroup = new CopyButtonGroup({
    props: {
      labelText: "Order",
      buttonText: (
        /*appCustomFieldItem*/
        ctx[0].order.toString()
      )
    }
  });
  return {
    c() {
      create_component(copybuttongroup.$$.fragment);
    },
    m(target, anchor) {
      mount_component(copybuttongroup, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const copybuttongroup_changes = {};
      if (dirty & /*appCustomFieldItem*/
      1)
        copybuttongroup_changes.buttonText = /*appCustomFieldItem*/
        ctx2[0].order.toString();
      copybuttongroup.$set(copybuttongroup_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(copybuttongroup.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(copybuttongroup.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(copybuttongroup, detaching);
    }
  };
}
function create_if_block_2$3(ctx) {
  let copybuttongroup;
  let current;
  copybuttongroup = new CopyButtonGroup({
    props: {
      labelText: "Hidden",
      buttonText: (
        /*appCustomFieldItem*/
        ctx[0].hidden.toString()
      )
    }
  });
  return {
    c() {
      create_component(copybuttongroup.$$.fragment);
    },
    m(target, anchor) {
      mount_component(copybuttongroup, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const copybuttongroup_changes = {};
      if (dirty & /*appCustomFieldItem*/
      1)
        copybuttongroup_changes.buttonText = /*appCustomFieldItem*/
        ctx2[0].hidden.toString();
      copybuttongroup.$set(copybuttongroup_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(copybuttongroup.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(copybuttongroup.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(copybuttongroup, detaching);
    }
  };
}
function create_if_block_1$3(ctx) {
  let copybuttongroup;
  let current;
  copybuttongroup = new CopyButtonGroup({
    props: {
      labelText: "Visibility",
      buttonText: (
        /*appCustomFieldItem*/
        ctx[0].visibility.toString()
      )
    }
  });
  return {
    c() {
      create_component(copybuttongroup.$$.fragment);
    },
    m(target, anchor) {
      mount_component(copybuttongroup, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const copybuttongroup_changes = {};
      if (dirty & /*appCustomFieldItem*/
      1)
        copybuttongroup_changes.buttonText = /*appCustomFieldItem*/
        ctx2[0].visibility.toString();
      copybuttongroup.$set(copybuttongroup_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(copybuttongroup.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(copybuttongroup.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(copybuttongroup, detaching);
    }
  };
}
function create_fragment$4(ctx) {
  let div2;
  let div0;
  let button;
  let span0;
  let fieldsicon;
  let t0;
  let t1_value = (
    /*appCustomFieldItem*/
    ctx[0].label + ""
  );
  let t1;
  let t2;
  let span1;
  let arrowicon;
  let t3;
  let div1;
  let current;
  let mounted;
  let dispose;
  fieldsicon = new FieldsIcon({});
  arrowicon = new ArrowIcon({
    props: {
      style: "transform: rotate(" + /*openAppCustomFieldItem*/
      (ctx[1] ? "180deg" : "0deg") + ")"
    }
  });
  let if_block = (
    /*openAppCustomFieldItem*/
    ctx[1] && create_if_block$4(ctx)
  );
  return {
    c() {
      div2 = element("div");
      div0 = element("div");
      button = element("button");
      span0 = element("span");
      create_component(fieldsicon.$$.fragment);
      t0 = space();
      t1 = text(t1_value);
      t2 = space();
      span1 = element("span");
      create_component(arrowicon.$$.fragment);
      t3 = space();
      div1 = element("div");
      if (if_block)
        if_block.c();
      attr(span0, "class", "ms-app-custom-fields-item__icon svelte-k3hu84");
      attr(span1, "class", "ms-app-custom-fields-item__arrow svelte-k3hu84");
      attr(button, "class", "ms-app-custom-fields-item__tab svelte-k3hu84");
      attr(button, "data-cy", "app-custom-fields-item-button");
      attr(div0, "class", "ms-app-custom-fields-item__tabs svelte-k3hu84");
      attr(div1, "class", "ms-app-custom-fields-item__content svelte-k3hu84");
      attr(div1, "data-cy", "app-custom-fields-item-content");
      attr(div2, "class", "ms-app-custom-fields-item svelte-k3hu84");
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      append(div2, div0);
      append(div0, button);
      append(button, span0);
      mount_component(fieldsicon, span0, null);
      append(button, t0);
      append(button, t1);
      append(button, t2);
      append(button, span1);
      mount_component(arrowicon, span1, null);
      append(div2, t3);
      append(div2, div1);
      if (if_block)
        if_block.m(div1, null);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler*/
          ctx[3]
        );
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if ((!current || dirty & /*appCustomFieldItem*/
      1) && t1_value !== (t1_value = /*appCustomFieldItem*/
      ctx2[0].label + ""))
        set_data(t1, t1_value);
      const arrowicon_changes = {};
      if (dirty & /*openAppCustomFieldItem*/
      2)
        arrowicon_changes.style = "transform: rotate(" + /*openAppCustomFieldItem*/
        (ctx2[1] ? "180deg" : "0deg") + ")";
      arrowicon.$set(arrowicon_changes);
      if (
        /*openAppCustomFieldItem*/
        ctx2[1]
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
          if (dirty & /*openAppCustomFieldItem*/
          2) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$4(ctx2);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(div1, null);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(fieldsicon.$$.fragment, local);
      transition_in(arrowicon.$$.fragment, local);
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(fieldsicon.$$.fragment, local);
      transition_out(arrowicon.$$.fragment, local);
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div2);
      destroy_component(fieldsicon);
      destroy_component(arrowicon);
      if (if_block)
        if_block.d();
      mounted = false;
      dispose();
    }
  };
}
function instance$4($$self, $$props, $$invalidate) {
  let { appCustomFieldItem } = $$props;
  let openAppCustomFieldItem = false;
  function showAppCustomFieldItemContent() {
    $$invalidate(1, openAppCustomFieldItem = !openAppCustomFieldItem);
  }
  const click_handler = () => showAppCustomFieldItemContent();
  $$self.$$set = ($$props2) => {
    if ("appCustomFieldItem" in $$props2)
      $$invalidate(0, appCustomFieldItem = $$props2.appCustomFieldItem);
  };
  return [
    appCustomFieldItem,
    openAppCustomFieldItem,
    showAppCustomFieldItemContent,
    click_handler
  ];
}
var AppCustomFieldItem = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$4, create_fragment$4, safe_not_equal, { appCustomFieldItem: 0 }, add_css$3);
  }
};
function add_css$2(target) {
  append_styles(target, "svelte-1yhhrhe", ".ms-app-tab__header.svelte-1yhhrhe.svelte-1yhhrhe{margin-bottom:12px;display:flex}.ms-app-tab_header_link.svelte-1yhhrhe.svelte-1yhhrhe{display:flex;align-items:center;color:#bebebe;text-decoration:none}.ms-app-tab_header_link.svelte-1yhhrhe.svelte-1yhhrhe:hover{color:#fff}.ms-app-tab__header__indicator.svelte-1yhhrhe.svelte-1yhhrhe{width:4px;height:100%;border-radius:2px;margin-right:10px;background-color:#efd350}.ms-app-tab__header__text.svelte-1yhhrhe.svelte-1yhhrhe{font-size:10px;line-height:14px}.ms-app-tab__header__text.svelte-1yhhrhe span.svelte-1yhhrhe{text-decoration:underline;color:#fff}.ms-app-tab__section.svelte-1yhhrhe.svelte-1yhhrhe{padding-bottom:6px;margin-bottom:12px;border-bottom:1px solid #535353}.ms-app-tab__section.svelte-1yhhrhe.svelte-1yhhrhe:last-child{border-bottom:none;margin-bottom:0}.ms-code-block.svelte-1yhhrhe.svelte-1yhhrhe{background-color:#000;color:#fff;padding:4px 8px;border-radius:4px;overflow:auto;border:1px solid #4b4b4b;font-size:10px;max-height:420px}.ms-code-block--short.svelte-1yhhrhe.svelte-1yhhrhe{max-height:175px}");
}
function get_each_context$1(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[1] = list[i];
  return child_ctx;
}
function get_each_context_1(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[4] = list[i];
  return child_ctx;
}
function create_if_block_3$1(ctx) {
  let div;
  let sectionheader;
  let t0;
  let t1;
  let buttonlink;
  let current;
  sectionheader = new SectionHeader({
    props: {
      titleText: "Custom Fields",
      editURL: `https://app.memberstack.com/apps/${/*$InspectorStore*/
      ctx[0].appData.id}/members`
    }
  });
  let each_value_1 = (
    /*$InspectorStore*/
    ctx[0].appData.customFields
  );
  let each_blocks = [];
  for (let i = 0; i < each_value_1.length; i += 1) {
    each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
  }
  const out = (i) => transition_out(each_blocks[i], 1, 1, () => {
    each_blocks[i] = null;
  });
  buttonlink = new ButtonLink({
    props: {
      link: "https://docs.memberstack.com/hc/en-us/articles/7389502579355",
      text: "Documentation"
    }
  });
  return {
    c() {
      div = element("div");
      create_component(sectionheader.$$.fragment);
      t0 = space();
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      t1 = space();
      create_component(buttonlink.$$.fragment);
      attr(div, "class", "ms-app-tab__section svelte-1yhhrhe");
      attr(div, "data-cy", "app-section-custom-fields");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(sectionheader, div, null);
      append(div, t0);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(div, null);
        }
      }
      append(div, t1);
      mount_component(buttonlink, div, null);
      current = true;
    },
    p(ctx2, dirty) {
      const sectionheader_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        sectionheader_changes.editURL = `https://app.memberstack.com/apps/${/*$InspectorStore*/
        ctx2[0].appData.id}/members`;
      sectionheader.$set(sectionheader_changes);
      if (dirty & /*$InspectorStore*/
      1) {
        each_value_1 = /*$InspectorStore*/
        ctx2[0].appData.customFields;
        let i;
        for (i = 0; i < each_value_1.length; i += 1) {
          const child_ctx = get_each_context_1(ctx2, each_value_1, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
            transition_in(each_blocks[i], 1);
          } else {
            each_blocks[i] = create_each_block_1(child_ctx);
            each_blocks[i].c();
            transition_in(each_blocks[i], 1);
            each_blocks[i].m(div, t1);
          }
        }
        group_outros();
        for (i = each_value_1.length; i < each_blocks.length; i += 1) {
          out(i);
        }
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(sectionheader.$$.fragment, local);
      for (let i = 0; i < each_value_1.length; i += 1) {
        transition_in(each_blocks[i]);
      }
      transition_in(buttonlink.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(sectionheader.$$.fragment, local);
      each_blocks = each_blocks.filter(Boolean);
      for (let i = 0; i < each_blocks.length; i += 1) {
        transition_out(each_blocks[i]);
      }
      transition_out(buttonlink.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      destroy_component(sectionheader);
      destroy_each(each_blocks, detaching);
      destroy_component(buttonlink);
    }
  };
}
function create_each_block_1(ctx) {
  let appcustomfielditem;
  let current;
  appcustomfielditem = new AppCustomFieldItem({
    props: {
      appCustomFieldItem: (
        /*customField*/
        ctx[4]
      )
    }
  });
  return {
    c() {
      create_component(appcustomfielditem.$$.fragment);
    },
    m(target, anchor) {
      mount_component(appcustomfielditem, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const appcustomfielditem_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        appcustomfielditem_changes.appCustomFieldItem = /*customField*/
        ctx2[4];
      appcustomfielditem.$set(appcustomfielditem_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(appcustomfielditem.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(appcustomfielditem.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(appcustomfielditem, detaching);
    }
  };
}
function create_if_block_2$2(ctx) {
  let div;
  let sectionheader;
  let t0;
  let t1;
  let buttonlink;
  let current;
  sectionheader = new SectionHeader({
    props: {
      titleText: "Gated Content",
      editURL: `https://app.memberstack.com/apps/${/*$InspectorStore*/
      ctx[0].appData.id}/gated-content`
    }
  });
  let each_value = (
    /*$InspectorStore*/
    ctx[0].appData.contentGroups
  );
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$1(get_each_context$1(ctx, each_value, i));
  }
  const out = (i) => transition_out(each_blocks[i], 1, 1, () => {
    each_blocks[i] = null;
  });
  buttonlink = new ButtonLink({
    props: {
      link: "https://docs.memberstack.com/hc/en-us/articles/7402927868443-Gated-Content",
      text: "Documentation"
    }
  });
  return {
    c() {
      div = element("div");
      create_component(sectionheader.$$.fragment);
      t0 = space();
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      t1 = space();
      create_component(buttonlink.$$.fragment);
      attr(div, "class", "ms-app-tab__section svelte-1yhhrhe");
      attr(div, "data-cy", "app-section-gated-content");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(sectionheader, div, null);
      append(div, t0);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(div, null);
        }
      }
      append(div, t1);
      mount_component(buttonlink, div, null);
      current = true;
    },
    p(ctx2, dirty) {
      const sectionheader_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        sectionheader_changes.editURL = `https://app.memberstack.com/apps/${/*$InspectorStore*/
        ctx2[0].appData.id}/gated-content`;
      sectionheader.$set(sectionheader_changes);
      if (dirty & /*$InspectorStore*/
      1) {
        each_value = /*$InspectorStore*/
        ctx2[0].appData.contentGroups;
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context$1(ctx2, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
            transition_in(each_blocks[i], 1);
          } else {
            each_blocks[i] = create_each_block$1(child_ctx);
            each_blocks[i].c();
            transition_in(each_blocks[i], 1);
            each_blocks[i].m(div, t1);
          }
        }
        group_outros();
        for (i = each_value.length; i < each_blocks.length; i += 1) {
          out(i);
        }
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(sectionheader.$$.fragment, local);
      for (let i = 0; i < each_value.length; i += 1) {
        transition_in(each_blocks[i]);
      }
      transition_in(buttonlink.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(sectionheader.$$.fragment, local);
      each_blocks = each_blocks.filter(Boolean);
      for (let i = 0; i < each_blocks.length; i += 1) {
        transition_out(each_blocks[i]);
      }
      transition_out(buttonlink.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div);
      destroy_component(sectionheader);
      destroy_each(each_blocks, detaching);
      destroy_component(buttonlink);
    }
  };
}
function create_each_block$1(ctx) {
  let appgatedcontentitem;
  let current;
  appgatedcontentitem = new AppGatedContentItem({
    props: {
      appGatedContentItem: (
        /*contentGroup*/
        ctx[1]
      )
    }
  });
  return {
    c() {
      create_component(appgatedcontentitem.$$.fragment);
    },
    m(target, anchor) {
      mount_component(appgatedcontentitem, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const appgatedcontentitem_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        appgatedcontentitem_changes.appGatedContentItem = /*contentGroup*/
        ctx2[1];
      appgatedcontentitem.$set(appgatedcontentitem_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(appgatedcontentitem.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(appgatedcontentitem.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(appgatedcontentitem, detaching);
    }
  };
}
function create_if_block_1$2(ctx) {
  let div1;
  let sectionheader;
  let t0;
  let div0;
  let copybuttongroup0;
  let t1;
  let copybuttongroup1;
  let current;
  sectionheader = new SectionHeader({
    props: {
      titleText: "Branding",
      editURL: `https://app.memberstack.com/apps/${/*$InspectorStore*/
      ctx[0].appData.id}/settings/design`
    }
  });
  copybuttongroup0 = new CopyButtonGroup({
    props: {
      labelText: "Color",
      buttonText: (
        /*$InspectorStore*/
        ctx[0].appData.branding.colors.lightMode.primaryButton
      ),
      cypress: `branding-color`
    }
  });
  copybuttongroup1 = new CopyButtonGroup({
    props: {
      labelText: "Logo",
      buttonText: (
        /*$InspectorStore*/
        ctx[0].appData.branding.logo
      ),
      cypress: `branding-logo`
    }
  });
  return {
    c() {
      div1 = element("div");
      create_component(sectionheader.$$.fragment);
      t0 = space();
      div0 = element("div");
      create_component(copybuttongroup0.$$.fragment);
      t1 = space();
      create_component(copybuttongroup1.$$.fragment);
      attr(div0, "class", "ms-app-tab__section__content");
      attr(div0, "data-cy", "app-section-branding-content");
      attr(div1, "class", "ms-app-tab__section svelte-1yhhrhe");
      attr(div1, "data-cy", "app-section-branding");
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      mount_component(sectionheader, div1, null);
      append(div1, t0);
      append(div1, div0);
      mount_component(copybuttongroup0, div0, null);
      append(div0, t1);
      mount_component(copybuttongroup1, div0, null);
      current = true;
    },
    p(ctx2, dirty) {
      const sectionheader_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        sectionheader_changes.editURL = `https://app.memberstack.com/apps/${/*$InspectorStore*/
        ctx2[0].appData.id}/settings/design`;
      sectionheader.$set(sectionheader_changes);
      const copybuttongroup0_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        copybuttongroup0_changes.buttonText = /*$InspectorStore*/
        ctx2[0].appData.branding.colors.lightMode.primaryButton;
      copybuttongroup0.$set(copybuttongroup0_changes);
      const copybuttongroup1_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        copybuttongroup1_changes.buttonText = /*$InspectorStore*/
        ctx2[0].appData.branding.logo;
      copybuttongroup1.$set(copybuttongroup1_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(sectionheader.$$.fragment, local);
      transition_in(copybuttongroup0.$$.fragment, local);
      transition_in(copybuttongroup1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(sectionheader.$$.fragment, local);
      transition_out(copybuttongroup0.$$.fragment, local);
      transition_out(copybuttongroup1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div1);
      destroy_component(sectionheader);
      destroy_component(copybuttongroup0);
      destroy_component(copybuttongroup1);
    }
  };
}
function create_if_block$3(ctx) {
  let div1;
  let sectionheader;
  let t0;
  let div0;
  let pre;
  let code;
  let t1_value = JSON.stringify(
    /*$InspectorStore*/
    ctx[0].appData.plans,
    null,
    2
  ) + "";
  let t1;
  let t2;
  let buttonlink;
  let current;
  sectionheader = new SectionHeader({
    props: {
      titleText: "Plans (raw)",
      editURL: `https://app.memberstack.com/apps/${/*$InspectorStore*/
      ctx[0].appData.id}/plans`
    }
  });
  buttonlink = new ButtonLink({
    props: {
      link: "https://docs.memberstack.com/hc/en-us/articles/7384849448091-Getting-Started-with-Plans-Prices",
      text: "Documentation"
    }
  });
  return {
    c() {
      div1 = element("div");
      create_component(sectionheader.$$.fragment);
      t0 = space();
      div0 = element("div");
      pre = element("pre");
      code = element("code");
      t1 = text(t1_value);
      t2 = space();
      create_component(buttonlink.$$.fragment);
      attr(pre, "class", "ms-code-block ms-code-block--short svelte-1yhhrhe");
      attr(div0, "class", "ms-app-tab__section__content");
      attr(div0, "data-cy", "app-section-plans-content");
      attr(div1, "class", "ms-app-tab__section svelte-1yhhrhe");
      attr(div1, "data-cy", "app-section-plans");
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      mount_component(sectionheader, div1, null);
      append(div1, t0);
      append(div1, div0);
      append(div0, pre);
      append(pre, code);
      append(code, t1);
      append(div1, t2);
      mount_component(buttonlink, div1, null);
      current = true;
    },
    p(ctx2, dirty) {
      const sectionheader_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        sectionheader_changes.editURL = `https://app.memberstack.com/apps/${/*$InspectorStore*/
        ctx2[0].appData.id}/plans`;
      sectionheader.$set(sectionheader_changes);
      if ((!current || dirty & /*$InspectorStore*/
      1) && t1_value !== (t1_value = JSON.stringify(
        /*$InspectorStore*/
        ctx2[0].appData.plans,
        null,
        2
      ) + ""))
        set_data(t1, t1_value);
    },
    i(local) {
      if (current)
        return;
      transition_in(sectionheader.$$.fragment, local);
      transition_in(buttonlink.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(sectionheader.$$.fragment, local);
      transition_out(buttonlink.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div1);
      destroy_component(sectionheader);
      destroy_component(buttonlink);
    }
  };
}
function create_fragment$3(ctx) {
  let div2;
  let t8;
  let div3;
  let copybuttongroup0;
  let t9;
  let copybuttongroup1;
  let t10;
  let t11;
  let t12;
  let div5;
  let sectionheader0;
  let t13;
  let div4;
  let buttonlink0;
  let t14;
  let buttonlink1;
  let t15;
  let buttonlink2;
  let t16;
  let buttonlink3;
  let t17;
  let buttonlink4;
  let t18;
  let buttonlink5;
  let t19;
  let buttonlink6;
  let t20;
  let t21;
  let t22;
  let div7;
  let sectionheader1;
  let t23;
  let div6;
  let pre;
  let code;
  let t24_value = JSON.stringify(
    /*$InspectorStore*/
    ctx[0].appData,
    null,
    2
  ) + "";
  let t24;
  let current;
  copybuttongroup0 = new CopyButtonGroup({
    props: {
      labelText: "Name",
      buttonText: (
        /*$InspectorStore*/
        ctx[0].appData.name
      ),
      cypress: "app-name"
    }
  });
  copybuttongroup1 = new CopyButtonGroup({
    props: {
      labelText: "App ID",
      buttonText: (
        /*$InspectorStore*/
        ctx[0].appData.id
      ),
      cypress: "app-id"
    }
  });
  let if_block0 = (
    /*$InspectorStore*/
    ctx[0].appData.customFields.length > 0 && create_if_block_3$1(ctx)
  );
  let if_block1 = (
    /*$InspectorStore*/
    ctx[0].appData.contentGroups && /*$InspectorStore*/
    ctx[0].appData.contentGroups.length > 0 && create_if_block_2$2(ctx)
  );
  sectionheader0 = new SectionHeader({
    props: {
      titleText: "Authentication",
      editURL: `https://app.memberstack.com/apps/${/*$InspectorStore*/
      ctx[0].appData.id}/plans`
    }
  });
  buttonlink0 = new ButtonLink({
    props: {
      link: "https://docs.memberstack.com/hc/en-us/articles/14052704355483",
      text: "Passwordless Login",
      status: (
        /*$InspectorStore*/
        ctx[0].appData.additionalAuthMethods.passwordless.enabled
      )
    }
  });
  buttonlink1 = new ButtonLink({
    props: {
      link: "https://docs.memberstack.com/hc/en-us/articles/8327236548379-Google-Authentication",
      text: "Google",
      status: (
        /*$InspectorStore*/
        ctx[0].appData.authProviders.some(func)
      )
    }
  });
  buttonlink2 = new ButtonLink({
    props: {
      link: "https://docs.memberstack.com/hc/en-us/articles/9116286679195-Facebook-Authentication",
      text: "Facebook",
      status: (
        /*$InspectorStore*/
        ctx[0].appData.authProviders.some(func_1)
      )
    }
  });
  buttonlink3 = new ButtonLink({
    props: {
      link: "https://docs.memberstack.com/hc/en-us/articles/9128407335835-LinkedIn-Authentication",
      text: "LinkedIn",
      status: (
        /*$InspectorStore*/
        ctx[0].appData.authProviders.some(func_2)
      )
    }
  });
  buttonlink4 = new ButtonLink({
    props: {
      link: "https://docs.memberstack.com/hc/en-us/articles/9151726845339-Dribbble-Authentication",
      text: "Dribble",
      status: (
        /*$InspectorStore*/
        ctx[0].appData.authProviders.some(func_3)
      )
    }
  });
  buttonlink5 = new ButtonLink({
    props: {
      link: "https://docs.memberstack.com/hc/en-us/articles/9151679451803-Spotify-Authentication",
      text: "Spotify",
      status: (
        /*$InspectorStore*/
        ctx[0].appData.authProviders.some(func_4)
      )
    }
  });
  buttonlink6 = new ButtonLink({
    props: {
      link: "https://docs.memberstack.com/hc/en-us/articles/9151629563291-GitHub-Authentication",
      text: "Github",
      status: (
        /*$InspectorStore*/
        ctx[0].appData.authProviders.some(func_5)
      )
    }
  });
  let if_block2 = (
    /*$InspectorStore*/
    ctx[0].appData.branding && create_if_block_1$2(ctx)
  );
  let if_block3 = (
    /*$InspectorStore*/
    ctx[0].appData.plans.length > 0 && create_if_block$3(ctx)
  );
  sectionheader1 = new SectionHeader({ props: { titleText: "App Data (raw)" } });
  return {
    c() {
      div2 = element("div");
      div2.innerHTML = `<a class="ms-app-tab_header_link svelte-1yhhrhe" href="https://docs.memberstack.com/hc/en-us/articles/7595262385819-Managing-Test-Mode-and-Live-Mode" target="_blank"><div class="ms-app-tab__header__indicator svelte-1yhhrhe"></div> 

    <div class="ms-app-tab__header__text svelte-1yhhrhe">This domain is in <span class="svelte-1yhhrhe">Test Mode</span>. <br/>
      Click here when you&#39;re ready to <br/> 
      <span class="svelte-1yhhrhe">Go Live</span> and sign up real members.</div></a>`;
      t8 = space();
      div3 = element("div");
      create_component(copybuttongroup0.$$.fragment);
      t9 = space();
      create_component(copybuttongroup1.$$.fragment);
      t10 = space();
      if (if_block0)
        if_block0.c();
      t11 = space();
      if (if_block1)
        if_block1.c();
      t12 = space();
      div5 = element("div");
      create_component(sectionheader0.$$.fragment);
      t13 = space();
      div4 = element("div");
      create_component(buttonlink0.$$.fragment);
      t14 = space();
      create_component(buttonlink1.$$.fragment);
      t15 = space();
      create_component(buttonlink2.$$.fragment);
      t16 = space();
      create_component(buttonlink3.$$.fragment);
      t17 = space();
      create_component(buttonlink4.$$.fragment);
      t18 = space();
      create_component(buttonlink5.$$.fragment);
      t19 = space();
      create_component(buttonlink6.$$.fragment);
      t20 = space();
      if (if_block2)
        if_block2.c();
      t21 = space();
      if (if_block3)
        if_block3.c();
      t22 = space();
      div7 = element("div");
      create_component(sectionheader1.$$.fragment);
      t23 = space();
      div6 = element("div");
      pre = element("pre");
      code = element("code");
      t24 = text(t24_value);
      attr(div2, "class", "ms-app-tab__header svelte-1yhhrhe");
      attr(div3, "class", "ms-app-tab__section svelte-1yhhrhe");
      attr(div3, "data-cy", "app-section-required");
      attr(div4, "class", "ms-app-tab__section__content ms-app-tab__section__content--auth");
      attr(div4, "data-cy", "app-section-authentication-content");
      attr(div5, "class", "ms-app-tab__section svelte-1yhhrhe");
      attr(div5, "data-cy", "app-section-authentication");
      attr(pre, "class", "ms-code-block svelte-1yhhrhe");
      attr(div6, "class", "ms-app-tab__section__content");
      attr(div6, "data-cy", "app-section-all-data-content");
      attr(div7, "class", "ms-app-tab__section svelte-1yhhrhe");
      attr(div7, "data-cy", "app-section-all-data");
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      insert(target, t8, anchor);
      insert(target, div3, anchor);
      mount_component(copybuttongroup0, div3, null);
      append(div3, t9);
      mount_component(copybuttongroup1, div3, null);
      insert(target, t10, anchor);
      if (if_block0)
        if_block0.m(target, anchor);
      insert(target, t11, anchor);
      if (if_block1)
        if_block1.m(target, anchor);
      insert(target, t12, anchor);
      insert(target, div5, anchor);
      mount_component(sectionheader0, div5, null);
      append(div5, t13);
      append(div5, div4);
      mount_component(buttonlink0, div4, null);
      append(div4, t14);
      mount_component(buttonlink1, div4, null);
      append(div4, t15);
      mount_component(buttonlink2, div4, null);
      append(div4, t16);
      mount_component(buttonlink3, div4, null);
      append(div4, t17);
      mount_component(buttonlink4, div4, null);
      append(div4, t18);
      mount_component(buttonlink5, div4, null);
      append(div4, t19);
      mount_component(buttonlink6, div4, null);
      insert(target, t20, anchor);
      if (if_block2)
        if_block2.m(target, anchor);
      insert(target, t21, anchor);
      if (if_block3)
        if_block3.m(target, anchor);
      insert(target, t22, anchor);
      insert(target, div7, anchor);
      mount_component(sectionheader1, div7, null);
      append(div7, t23);
      append(div7, div6);
      append(div6, pre);
      append(pre, code);
      append(code, t24);
      current = true;
    },
    p(ctx2, [dirty]) {
      const copybuttongroup0_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        copybuttongroup0_changes.buttonText = /*$InspectorStore*/
        ctx2[0].appData.name;
      copybuttongroup0.$set(copybuttongroup0_changes);
      const copybuttongroup1_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        copybuttongroup1_changes.buttonText = /*$InspectorStore*/
        ctx2[0].appData.id;
      copybuttongroup1.$set(copybuttongroup1_changes);
      if (
        /*$InspectorStore*/
        ctx2[0].appData.customFields.length > 0
      ) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
          if (dirty & /*$InspectorStore*/
          1) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_3$1(ctx2);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(t11.parentNode, t11);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      if (
        /*$InspectorStore*/
        ctx2[0].appData.contentGroups && /*$InspectorStore*/
        ctx2[0].appData.contentGroups.length > 0
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty & /*$InspectorStore*/
          1) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block_2$2(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(t12.parentNode, t12);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
      const sectionheader0_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        sectionheader0_changes.editURL = `https://app.memberstack.com/apps/${/*$InspectorStore*/
        ctx2[0].appData.id}/plans`;
      sectionheader0.$set(sectionheader0_changes);
      const buttonlink0_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        buttonlink0_changes.status = /*$InspectorStore*/
        ctx2[0].appData.additionalAuthMethods.passwordless.enabled;
      buttonlink0.$set(buttonlink0_changes);
      const buttonlink1_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        buttonlink1_changes.status = /*$InspectorStore*/
        ctx2[0].appData.authProviders.some(func);
      buttonlink1.$set(buttonlink1_changes);
      const buttonlink2_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        buttonlink2_changes.status = /*$InspectorStore*/
        ctx2[0].appData.authProviders.some(func_1);
      buttonlink2.$set(buttonlink2_changes);
      const buttonlink3_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        buttonlink3_changes.status = /*$InspectorStore*/
        ctx2[0].appData.authProviders.some(func_2);
      buttonlink3.$set(buttonlink3_changes);
      const buttonlink4_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        buttonlink4_changes.status = /*$InspectorStore*/
        ctx2[0].appData.authProviders.some(func_3);
      buttonlink4.$set(buttonlink4_changes);
      const buttonlink5_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        buttonlink5_changes.status = /*$InspectorStore*/
        ctx2[0].appData.authProviders.some(func_4);
      buttonlink5.$set(buttonlink5_changes);
      const buttonlink6_changes = {};
      if (dirty & /*$InspectorStore*/
      1)
        buttonlink6_changes.status = /*$InspectorStore*/
        ctx2[0].appData.authProviders.some(func_5);
      buttonlink6.$set(buttonlink6_changes);
      if (
        /*$InspectorStore*/
        ctx2[0].appData.branding
      ) {
        if (if_block2) {
          if_block2.p(ctx2, dirty);
          if (dirty & /*$InspectorStore*/
          1) {
            transition_in(if_block2, 1);
          }
        } else {
          if_block2 = create_if_block_1$2(ctx2);
          if_block2.c();
          transition_in(if_block2, 1);
          if_block2.m(t21.parentNode, t21);
        }
      } else if (if_block2) {
        group_outros();
        transition_out(if_block2, 1, 1, () => {
          if_block2 = null;
        });
        check_outros();
      }
      if (
        /*$InspectorStore*/
        ctx2[0].appData.plans.length > 0
      ) {
        if (if_block3) {
          if_block3.p(ctx2, dirty);
          if (dirty & /*$InspectorStore*/
          1) {
            transition_in(if_block3, 1);
          }
        } else {
          if_block3 = create_if_block$3(ctx2);
          if_block3.c();
          transition_in(if_block3, 1);
          if_block3.m(t22.parentNode, t22);
        }
      } else if (if_block3) {
        group_outros();
        transition_out(if_block3, 1, 1, () => {
          if_block3 = null;
        });
        check_outros();
      }
      if ((!current || dirty & /*$InspectorStore*/
      1) && t24_value !== (t24_value = JSON.stringify(
        /*$InspectorStore*/
        ctx2[0].appData,
        null,
        2
      ) + ""))
        set_data(t24, t24_value);
    },
    i(local) {
      if (current)
        return;
      transition_in(copybuttongroup0.$$.fragment, local);
      transition_in(copybuttongroup1.$$.fragment, local);
      transition_in(if_block0);
      transition_in(if_block1);
      transition_in(sectionheader0.$$.fragment, local);
      transition_in(buttonlink0.$$.fragment, local);
      transition_in(buttonlink1.$$.fragment, local);
      transition_in(buttonlink2.$$.fragment, local);
      transition_in(buttonlink3.$$.fragment, local);
      transition_in(buttonlink4.$$.fragment, local);
      transition_in(buttonlink5.$$.fragment, local);
      transition_in(buttonlink6.$$.fragment, local);
      transition_in(if_block2);
      transition_in(if_block3);
      transition_in(sectionheader1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(copybuttongroup0.$$.fragment, local);
      transition_out(copybuttongroup1.$$.fragment, local);
      transition_out(if_block0);
      transition_out(if_block1);
      transition_out(sectionheader0.$$.fragment, local);
      transition_out(buttonlink0.$$.fragment, local);
      transition_out(buttonlink1.$$.fragment, local);
      transition_out(buttonlink2.$$.fragment, local);
      transition_out(buttonlink3.$$.fragment, local);
      transition_out(buttonlink4.$$.fragment, local);
      transition_out(buttonlink5.$$.fragment, local);
      transition_out(buttonlink6.$$.fragment, local);
      transition_out(if_block2);
      transition_out(if_block3);
      transition_out(sectionheader1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div2);
      if (detaching)
        detach(t8);
      if (detaching)
        detach(div3);
      destroy_component(copybuttongroup0);
      destroy_component(copybuttongroup1);
      if (detaching)
        detach(t10);
      if (if_block0)
        if_block0.d(detaching);
      if (detaching)
        detach(t11);
      if (if_block1)
        if_block1.d(detaching);
      if (detaching)
        detach(t12);
      if (detaching)
        detach(div5);
      destroy_component(sectionheader0);
      destroy_component(buttonlink0);
      destroy_component(buttonlink1);
      destroy_component(buttonlink2);
      destroy_component(buttonlink3);
      destroy_component(buttonlink4);
      destroy_component(buttonlink5);
      destroy_component(buttonlink6);
      if (detaching)
        detach(t20);
      if (if_block2)
        if_block2.d(detaching);
      if (detaching)
        detach(t21);
      if (if_block3)
        if_block3.d(detaching);
      if (detaching)
        detach(t22);
      if (detaching)
        detach(div7);
      destroy_component(sectionheader1);
    }
  };
}
var func = (provider) => provider.provider === "google";
var func_1 = (provider) => provider.provider === "facebook";
var func_2 = (provider) => provider.provider === "linkedin";
var func_3 = (provider) => provider.provider === "dribbble";
var func_4 = (provider) => provider.provider === "spotify";
var func_5 = (provider) => provider.provider === "github";
function instance$3($$self, $$props, $$invalidate) {
  let $InspectorStore;
  component_subscribe($$self, InspectorStore, ($$value) => $$invalidate(0, $InspectorStore = $$value));
  $InspectorStore.appData.customFields.sort((a, b) => {
    if (a.order === null)
      return 1;
    if (b.order === null)
      return -1;
    return a.order - b.order;
  });
  return [$InspectorStore];
}
var AppTab = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$3, create_fragment$3, safe_not_equal, {}, add_css$2);
  }
};
function add_css$1(target) {
  append_styles(target, "svelte-1nz7e18", ".ms-inspector-sidebar.svelte-1nz7e18 .svelte-1nz7e18.svelte-1nz7e18{box-sizing:border-box;font-family:Plus Jakarta Sans, sans-serif !important;line-height:1.5em;font-size:11px !important}.ms-inspector-sidebar.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18{position:fixed;top:0;right:0;bottom:0;width:242px;color:#fff;font-family:Plus Jakarta Sans, sans-serif !important;line-height:1.5em;font-size:11px !important;background:#292929;border-left:1px solid #000;box-shadow:0 0 10px rgba(0, 0, 0, 0.1);z-index:2147483648 !important}.ms-inspector-sidebar--left.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18{left:0;right:auto;border-right:1px solid #000}.ms-inspector-sidebar__container.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18{position:relative;height:100%;display:flex;flex-direction:column}.ms-inspector-sidebar__tabs.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18{display:flex;gap:7px;padding:0 7px;border-bottom:1px solid #4f4f4f}.ms-inspector-sidebar__tab.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18{display:flex;align-items:center;padding:17px 2px;height:30px;background-color:#292929;color:#fff;border:none;cursor:pointer;border-bottom:2px solid transparent}.ms-inspector-sidebar__tab--active.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18{border-bottom:2px solid #c1c1c1;font-weight:700}.ms-inspector-sidebar__count.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18{display:inline-block;border-radius:4px;background-color:#444;text-align:center;border:0.5px solid #535353;margin-right:0.5em;padding:0 3px}.ms-inspector-sidebar__member-status.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18{display:inline-block;width:10px;height:10px;border-radius:50%;background-color:rgb(224, 102, 87);margin-right:5px}.ms-inspector-sidebar__member-status--active.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18{background-color:#5c9d6f}.ms-inspector-sidebar__content.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18{padding:7px;overflow-y:auto;flex-grow:1}.ms-inspector-footer.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18{display:flex;align-items:stretch;justify-content:space-between;border-top:1px solid #4f4f4f;color:#919191}.ms-inspector-footer__link.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18{text-decoration:none;border-right:1px solid #4f4f4f;position:relative;display:flex;align-items:center;justify-content:center;width:100%;padding:7px;transition:all 0.2s ease-in-out}.ms-inspector-footer__link.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18:last-child{border-right:none}.ms-inspector-footer__link.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18:hover{color:#fff;background-color:#444}.ms-inspector-footer__link.svelte-1nz7e18:hover .ms-inspector-footer__label.svelte-1nz7e18.svelte-1nz7e18{display:block}.ms-inspector-footer__link.svelte-1nz7e18:hover .ms-inspector-footer__icon.svelte-1nz7e18.svelte-1nz7e18{color:#fff}.ms-inspector-footer__icon.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18{width:2em;height:2em;display:flex;align-items:center;justify-content:center;color:#919191;font-size:15px;font-weight:700}.ms-inspector-footer__label.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18{font-size:11px;font-weight:700;width:90px;text-align:center;display:none;position:absolute;top:-25px;left:50%;transform:translateX(-50%);color:#fff}.ms-inspector-footer__text.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;border-radius:3px;padding-left:0.8em;padding-right:0.8em;background-color:#292929}.ms-inspector-sidebar__side-switcher.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18{position:absolute;top:0;bottom:0;left:-30px;display:none;align-items:center}.ms-inspector-sidebar.svelte-1nz7e18:hover .ms-inspector-sidebar__side-switcher.svelte-1nz7e18.svelte-1nz7e18{display:flex}.ms-inspector-sidebar--left.svelte-1nz7e18 .ms-inspector-sidebar__side-switcher.svelte-1nz7e18.svelte-1nz7e18{left:auto;right:-30px}.ms-inspector-sidebar__side-switcher-button.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18{display:flex;align-items:center;justify-content:center;width:30px;height:30px;background-color:#292929;border:none;cursor:pointer;border-radius:4px 0px 0px 4px}.ms-inspector-sidebar--left.svelte-1nz7e18 .ms-inspector-sidebar__side-switcher-button.svelte-1nz7e18.svelte-1nz7e18{border-radius:0px 4px 4px 0px}.ms-inspector-sidebar__side-switcher-button-icon.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18{width:13px;height:13px;display:flex;align-items:center;justify-content:center;color:#fff}.ms-inspector-sidebar__side-switcher-button-icon.svelte-1nz7e18 svg.svelte-1nz7e18.svelte-1nz7e18{transform:rotate(90deg)}.ms-inspector-sidebar__label.svelte-1nz7e18.svelte-1nz7e18.svelte-1nz7e18{position:absolute;top:50%;transform:translateY(-50%);left:-90px;display:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;border-radius:3px;padding-left:0.8em;padding-right:0.8em;background-color:#292929}.ms-inspector-sidebar--left.svelte-1nz7e18 .ms-inspector-sidebar__label.svelte-1nz7e18.svelte-1nz7e18{left:auto;right:-90px}.ms-inspector-sidebar.svelte-1nz7e18:hover .ms-inspector-sidebar__side-switcher-button.svelte-1nz7e18:hover+.ms-inspector-sidebar__label.svelte-1nz7e18{display:inline-block}");
}
function get_each_context(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[8] = list[i];
  return child_ctx;
}
function create_if_block_2$1(ctx) {
  let apptab;
  let current;
  apptab = new AppTab({});
  return {
    c() {
      create_component(apptab.$$.fragment);
    },
    m(target, anchor) {
      mount_component(apptab, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(apptab.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(apptab.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(apptab, detaching);
    }
  };
}
function create_if_block_1$1(ctx) {
  let membertab;
  let current;
  membertab = new MemberTab({});
  return {
    c() {
      create_component(membertab.$$.fragment);
    },
    m(target, anchor) {
      mount_component(membertab, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(membertab.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(membertab.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(membertab, detaching);
    }
  };
}
function create_if_block$2(ctx) {
  let inspectortab;
  let current;
  inspectortab = new InspectorTab({});
  return {
    c() {
      create_component(inspectortab.$$.fragment);
    },
    m(target, anchor) {
      mount_component(inspectortab, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(inspectortab.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(inspectortab.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(inspectortab, detaching);
    }
  };
}
function create_each_block(ctx) {
  let a;
  let div0;
  let switch_instance;
  let t0;
  let div1;
  let span;
  let t1_value = (
    /*footerItem*/
    ctx[8].label + ""
  );
  let t1;
  let t2;
  let current;
  var switch_value = (
    /*footerItem*/
    ctx[8].icon
  );
  function switch_props(ctx2) {
    return {};
  }
  if (switch_value) {
    switch_instance = construct_svelte_component(switch_value, switch_props());
  }
  return {
    c() {
      a = element("a");
      div0 = element("div");
      if (switch_instance)
        create_component(switch_instance.$$.fragment);
      t0 = space();
      div1 = element("div");
      span = element("span");
      t1 = text(t1_value);
      t2 = space();
      attr(div0, "class", "ms-inspector-footer__icon svelte-1nz7e18");
      attr(span, "class", "ms-inspector-footer__text svelte-1nz7e18");
      attr(div1, "class", "ms-inspector-footer__label svelte-1nz7e18");
      attr(
        a,
        "href",
        /*footerItem*/
        ctx[8].link
      );
      attr(a, "target", "_blank");
      attr(a, "class", "ms-inspector-footer__link svelte-1nz7e18");
    },
    m(target, anchor) {
      insert(target, a, anchor);
      append(a, div0);
      if (switch_instance)
        mount_component(switch_instance, div0, null);
      append(a, t0);
      append(a, div1);
      append(div1, span);
      append(span, t1);
      append(a, t2);
      current = true;
    },
    p(ctx2, dirty) {
      if (switch_value !== (switch_value = /*footerItem*/
      ctx2[8].icon)) {
        if (switch_instance) {
          group_outros();
          const old_component = switch_instance;
          transition_out(old_component.$$.fragment, 1, 0, () => {
            destroy_component(old_component, 1);
          });
          check_outros();
        }
        if (switch_value) {
          switch_instance = construct_svelte_component(switch_value, switch_props());
          create_component(switch_instance.$$.fragment);
          transition_in(switch_instance.$$.fragment, 1);
          mount_component(switch_instance, div0, null);
        } else {
          switch_instance = null;
        }
      }
    },
    i(local) {
      if (current)
        return;
      if (switch_instance)
        transition_in(switch_instance.$$.fragment, local);
      current = true;
    },
    o(local) {
      if (switch_instance)
        transition_out(switch_instance.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(a);
      if (switch_instance)
        destroy_component(switch_instance);
    }
  };
}
function create_fragment$2(ctx) {
  let aside;
  let div3;
  let div0;
  let button0;
  let span0;
  let t0_value = (
    /*$InspectorStore*/
    (ctx[0].inspectorData.length || 0) + ""
  );
  let t0;
  let t1;
  let span1;
  let t3;
  let button1;
  let span2;
  let t4;
  let span3;
  let t6;
  let button2;
  let t8;
  let div1;
  let current_block_type_index;
  let if_block;
  let t9;
  let div2;
  let div3_transition;
  let t10;
  let div5;
  let button3;
  let t11;
  let div4;
  let aside_transition;
  let current;
  let mounted;
  let dispose;
  const if_block_creators = [create_if_block$2, create_if_block_1$1, create_if_block_2$1];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*$InspectorStore*/
      ctx2[0].showTab === "inspector"
    )
      return 0;
    if (
      /*$InspectorStore*/
      ctx2[0].showTab === "member"
    )
      return 1;
    if (
      /*$InspectorStore*/
      ctx2[0].showTab === "app"
    )
      return 2;
    return -1;
  }
  if (~(current_block_type_index = select_block_type(ctx))) {
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  }
  let each_value = (
    /*footerItems*/
    ctx[1]
  );
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
  }
  const out = (i) => transition_out(each_blocks[i], 1, 1, () => {
    each_blocks[i] = null;
  });
  return {
    c() {
      aside = element("aside");
      div3 = element("div");
      div0 = element("div");
      button0 = element("button");
      span0 = element("span");
      t0 = text(t0_value);
      t1 = space();
      span1 = element("span");
      span1.textContent = "Inspector";
      t3 = space();
      button1 = element("button");
      span2 = element("span");
      t4 = space();
      span3 = element("span");
      span3.textContent = "Member";
      t6 = space();
      button2 = element("button");
      button2.innerHTML = `<span class="svelte-1nz7e18">App</span>`;
      t8 = space();
      div1 = element("div");
      if (if_block)
        if_block.c();
      t9 = space();
      div2 = element("div");
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      t10 = space();
      div5 = element("div");
      button3 = element("button");
      button3.innerHTML = `<span class="ms-inspector-sidebar__side-switcher-button-icon svelte-1nz7e18"><svg xmlns="http://www.w3.org/2000/svg" class="svg-icon svelte-1nz7e18" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1"><path d="M396.8 160H262.4v448H64l262.4 256 262.4-256h-192z" fill="#C9C9C9" class="svelte-1nz7e18"></path><path d="M697.6 160l-262.4 256h192v448h134.4v-448H960z" fill="#C9C9C9" class="svelte-1nz7e18"></path></svg></span>`;
      t11 = space();
      div4 = element("div");
      div4.innerHTML = `<span class="ms-inspector-sidebar__text svelte-1nz7e18">Switch Sides</span>`;
      attr(span0, "class", "ms-inspector-sidebar__count svelte-1nz7e18");
      attr(span1, "class", "svelte-1nz7e18");
      attr(button0, "class", "ms-inspector-sidebar__tab svelte-1nz7e18");
      attr(button0, "data-cy", "inspector-sidebar-inspector-tab");
      toggle_class(
        button0,
        "ms-inspector-sidebar__tab--active",
        /*$InspectorStore*/
        ctx[0].showTab === "inspector"
      );
      attr(span2, "class", "ms-inspector-sidebar__member-status svelte-1nz7e18");
      toggle_class(
        span2,
        "ms-inspector-sidebar__member-status--active",
        /*$InspectorStore*/
        ctx[0].memberData && /*$InspectorStore*/
        ctx[0].memberData.id
      );
      attr(span3, "class", "svelte-1nz7e18");
      attr(button1, "class", "ms-inspector-sidebar__tab svelte-1nz7e18");
      attr(button1, "data-cy", "inspector-sidebar-member-tab");
      toggle_class(
        button1,
        "ms-inspector-sidebar__tab--active",
        /*$InspectorStore*/
        ctx[0].showTab === "member"
      );
      attr(button2, "class", "ms-inspector-sidebar__tab svelte-1nz7e18");
      attr(button2, "data-cy", "inspector-sidebar-app-tab");
      toggle_class(
        button2,
        "ms-inspector-sidebar__tab--active",
        /*$InspectorStore*/
        ctx[0].showTab === "app"
      );
      attr(div0, "class", "ms-inspector-sidebar__tabs svelte-1nz7e18");
      attr(div1, "class", "ms-inspector-sidebar__content svelte-1nz7e18");
      attr(div2, "class", "ms-inspector-footer svelte-1nz7e18");
      attr(div3, "class", "ms-inspector-sidebar__container svelte-1nz7e18");
      attr(button3, "class", "ms-inspector-sidebar__side-switcher-button svelte-1nz7e18");
      attr(button3, "data-cy", "inspector-sidebar-switch-side-button");
      attr(div4, "class", "ms-inspector-sidebar__label svelte-1nz7e18");
      attr(div5, "class", "ms-inspector-sidebar__side-switcher svelte-1nz7e18");
      attr(aside, "class", "ms-inspector-sidebar svelte-1nz7e18");
      attr(aside, "data-cy", "inspector-sidebar");
      toggle_class(
        aside,
        "ms-inspector-sidebar--left",
        /*$InspectorStore*/
        ctx[0].showSide === "left"
      );
    },
    m(target, anchor) {
      insert(target, aside, anchor);
      append(aside, div3);
      append(div3, div0);
      append(div0, button0);
      append(button0, span0);
      append(span0, t0);
      append(button0, t1);
      append(button0, span1);
      append(div0, t3);
      append(div0, button1);
      append(button1, span2);
      append(button1, t4);
      append(button1, span3);
      append(div0, t6);
      append(div0, button2);
      append(div3, t8);
      append(div3, div1);
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].m(div1, null);
      }
      append(div3, t9);
      append(div3, div2);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(div2, null);
        }
      }
      append(aside, t10);
      append(aside, div5);
      append(div5, button3);
      append(div5, t11);
      append(div5, div4);
      current = true;
      if (!mounted) {
        dispose = [
          listen(
            button0,
            "click",
            /*click_handler*/
            ctx[4]
          ),
          listen(
            button1,
            "click",
            /*click_handler_1*/
            ctx[5]
          ),
          listen(
            button2,
            "click",
            /*click_handler_2*/
            ctx[6]
          ),
          listen(
            button3,
            "click",
            /*click_handler_3*/
            ctx[7]
          )
        ];
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if ((!current || dirty & /*$InspectorStore*/
      1) && t0_value !== (t0_value = /*$InspectorStore*/
      (ctx2[0].inspectorData.length || 0) + ""))
        set_data(t0, t0_value);
      if (!current || dirty & /*$InspectorStore*/
      1) {
        toggle_class(
          button0,
          "ms-inspector-sidebar__tab--active",
          /*$InspectorStore*/
          ctx2[0].showTab === "inspector"
        );
      }
      if (!current || dirty & /*$InspectorStore*/
      1) {
        toggle_class(
          span2,
          "ms-inspector-sidebar__member-status--active",
          /*$InspectorStore*/
          ctx2[0].memberData && /*$InspectorStore*/
          ctx2[0].memberData.id
        );
      }
      if (!current || dirty & /*$InspectorStore*/
      1) {
        toggle_class(
          button1,
          "ms-inspector-sidebar__tab--active",
          /*$InspectorStore*/
          ctx2[0].showTab === "member"
        );
      }
      if (!current || dirty & /*$InspectorStore*/
      1) {
        toggle_class(
          button2,
          "ms-inspector-sidebar__tab--active",
          /*$InspectorStore*/
          ctx2[0].showTab === "app"
        );
      }
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index !== previous_block_index) {
        if (if_block) {
          group_outros();
          transition_out(if_blocks[previous_block_index], 1, 1, () => {
            if_blocks[previous_block_index] = null;
          });
          check_outros();
        }
        if (~current_block_type_index) {
          if_block = if_blocks[current_block_type_index];
          if (!if_block) {
            if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
            if_block.c();
          }
          transition_in(if_block, 1);
          if_block.m(div1, null);
        } else {
          if_block = null;
        }
      }
      if (dirty & /*footerItems*/
      2) {
        each_value = /*footerItems*/
        ctx2[1];
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context(ctx2, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
            transition_in(each_blocks[i], 1);
          } else {
            each_blocks[i] = create_each_block(child_ctx);
            each_blocks[i].c();
            transition_in(each_blocks[i], 1);
            each_blocks[i].m(div2, null);
          }
        }
        group_outros();
        for (i = each_value.length; i < each_blocks.length; i += 1) {
          out(i);
        }
        check_outros();
      }
      if (!current || dirty & /*$InspectorStore*/
      1) {
        toggle_class(
          aside,
          "ms-inspector-sidebar--left",
          /*$InspectorStore*/
          ctx2[0].showSide === "left"
        );
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      for (let i = 0; i < each_value.length; i += 1) {
        transition_in(each_blocks[i]);
      }
      add_render_callback(() => {
        if (!current)
          return;
        if (!div3_transition)
          div3_transition = create_bidirectional_transition(div3, fade, { duration: 400 }, true);
        div3_transition.run(1);
      });
      if (local) {
        add_render_callback(() => {
          if (!current)
            return;
          if (!aside_transition)
            aside_transition = create_bidirectional_transition(aside, slide, { duration: 150, axis: "x" }, true);
          aside_transition.run(1);
        });
      }
      current = true;
    },
    o(local) {
      transition_out(if_block);
      each_blocks = each_blocks.filter(Boolean);
      for (let i = 0; i < each_blocks.length; i += 1) {
        transition_out(each_blocks[i]);
      }
      if (!div3_transition)
        div3_transition = create_bidirectional_transition(div3, fade, { duration: 400 }, false);
      div3_transition.run(0);
      if (local) {
        if (!aside_transition)
          aside_transition = create_bidirectional_transition(aside, slide, { duration: 150, axis: "x" }, false);
        aside_transition.run(0);
      }
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(aside);
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].d();
      }
      destroy_each(each_blocks, detaching);
      if (detaching && div3_transition)
        div3_transition.end();
      if (detaching && aside_transition)
        aside_transition.end();
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$2($$self, $$props, $$invalidate) {
  let $InspectorStore;
  component_subscribe($$self, InspectorStore, ($$value) => $$invalidate(0, $InspectorStore = $$value));
  onDestroy(() => {
    removeXrays();
  });
  let footerItems = [
    {
      label: "Help Center",
      link: "https://docs.memberstack.com/hc/en-us",
      icon: HelpIcon
    },
    {
      label: "AI Bot",
      link: "https://rey.memberstack.com/",
      icon: AIIcon
    },
    {
      label: "Components",
      link: "https://www.memberstack.com/webflow-components",
      icon: ComponentsIcon
    },
    {
      label: "Forums",
      link: "https://docs.memberstack.com/hc/en-us/community/posts",
      icon: ForumsIcon
    },
    {
      label: "Slack",
      link: "https://www.memberstack.com/slack",
      icon: SlackIcon
    }
  ];
  function changeTab(tab) {
    SetShowTab(tab);
  }
  function switchSide() {
    if ($InspectorStore.showSide === "right") {
      SetShowSide("left");
    } else {
      SetShowSide("right");
    }
  }
  const click_handler = () => changeTab("inspector");
  const click_handler_1 = () => changeTab("member");
  const click_handler_2 = () => changeTab("app");
  const click_handler_3 = () => switchSide();
  return [
    $InspectorStore,
    footerItems,
    changeTab,
    switchSide,
    click_handler,
    click_handler_1,
    click_handler_2,
    click_handler_3
  ];
}
var InspectorSidebar = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$2, create_fragment$2, safe_not_equal, {}, add_css$1);
  }
};
function create_if_block$1(ctx) {
  let inspectorsidebar;
  let current;
  inspectorsidebar = new InspectorSidebar({});
  return {
    c() {
      create_component(inspectorsidebar.$$.fragment);
    },
    m(target, anchor) {
      mount_component(inspectorsidebar, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(inspectorsidebar.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(inspectorsidebar.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(inspectorsidebar, detaching);
    }
  };
}
function create_fragment$1(ctx) {
  let inspectorbadge;
  let t;
  let if_block_anchor;
  let current;
  inspectorbadge = new InspectorBadge({});
  let if_block = (
    /*$InspectorStore*/
    ctx[0].showSidebar && create_if_block$1()
  );
  return {
    c() {
      create_component(inspectorbadge.$$.fragment);
      t = space();
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      mount_component(inspectorbadge, target, anchor);
      insert(target, t, anchor);
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (
        /*$InspectorStore*/
        ctx2[0].showSidebar
      ) {
        if (if_block) {
          if (dirty & /*$InspectorStore*/
          1) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$1();
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(inspectorbadge.$$.fragment, local);
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(inspectorbadge.$$.fragment, local);
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      destroy_component(inspectorbadge, detaching);
      if (detaching)
        detach(t);
      if (if_block)
        if_block.d(detaching);
      if (detaching)
        detach(if_block_anchor);
    }
  };
}
function instance$1($$self, $$props, $$invalidate) {
  let $InspectorStore;
  component_subscribe($$self, InspectorStore, ($$value) => $$invalidate(0, $InspectorStore = $$value));
  onMount(() => {
    checker();
  });
  return [$InspectorStore];
}
var TestMode = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$1, create_fragment$1, safe_not_equal, {});
  }
};
function add_css(target) {
  append_styles(target, "svelte-1blpd87", '@import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");.svelte-1blpd87{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}#msOverlay.svelte-1blpd87{position:fixed;display:flex;justify-content:center;align-items:center;width:100%;height:100%;top:0;left:0;right:0;bottom:0;background-color:rgba(0, 0, 0, 0.5);z-index:99999;overflow-y:auto;overflow-x:hidden;font-family:"Plus Jakarta Sans", sans-serif;padding:5vh 5vw}.--hide{display:none}.--flex-h-center{display:flex;align-items:center}.ms__loader{position:relative;z-index:10000000}#msLoader path{fill:#007ace}.ms__profile__loader{position:absolute;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center;background:rgb(255 255 255 / 75%)}.ms-modal{box-sizing:border-box;margin:auto;min-width:0;position:relative;outline:none;background:white;border-radius:16px;box-shadow:2px 2px 12px rgb(0 0 0 / 10%);width:360px;color:rgb(10, 10, 10)}.ms-modal--profile{width:700px}.ms-modal__close{box-sizing:border-box;margin:0;min-width:0;position:absolute;top:6px;right:6px;z-index:10;line-height:0}.ms-modal__close button{appearance:none;padding:0;outline:none;width:42px;padding:15px;border:0;background:transparent;cursor:pointer;color:#5c5c5c}.ms-modal__close button:hover{color:#0a0a0a}.ms-modal__back{box-sizing:border-box;margin:0;min-width:0;position:absolute;top:16px;left:16px;z-index:10;line-height:0}.ms-modal__back button{appearance:none;padding:0;outline:none;width:12px;border:0;background:transparent;cursor:pointer;color:#5c5c5c}\n      .ms-modal__back button:hover,\n      .ms-modal__profile-back button:hover\n    {color:#0a0a0a}.ms-modal__back svg{height:12px}.ms-modal__profile-back button{appearance:none;padding:5px;margin-right:6px;outline:none;width:25px;height:25px;border:0;background:transparent;cursor:pointer;color:#5c5c5c;display:flex;align-items:stretch;justify-content:center}.ms-modal__profile-back--mobile{box-sizing:border-box;margin:0;min-width:0;position:absolute;top:16px;left:16px;z-index:10;line-height:0}.ms-modal__profile-back--mobile button{appearance:none;padding:0;outline:none;height:11px;width:7px;border:0;background:transparent;cursor:pointer;color:#5c5c5c}.ms-modal__profile-back--mobile button:hover{color:#0a0a0a}.ms-modal__header{display:flex;align-items:center;padding:12px}.ms-modal__header--mobile{display:flex;padding:42px 42px 16px 42px;flex-direction:column;flex-wrap:wrap;justify-content:center;align-items:center}.ms-modal__header--center{display:flex;flex-direction:column;flex-wrap:wrap;justify-content:center;align-items:center}.ms-modal__content{padding:28px 28px 20px;width:100%;box-sizing:border-box;margin:0 auto}.ms-modal__content--profile{padding:0;display:flex;flex-wrap:wrap;align-content:stretch;align-items:stretch;border-top:1px solid #dddddd}.ms-modal__content-left{display:flex;flex-direction:column;align-items:flex-start;padding:20px;border-right:1px solid #dddddd;min-width:160px}.ms-modal__content-right{padding:20px;flex-grow:1;height:55vh;min-height:300px;overflow-y:auto;position:relative;transition:height 0.3s ease-in-out}.ms-modal__content-right h3{margin-top:40px !important;margin-bottom:10px !important;font-size:18px !important;line-height:1em !important;font-weight:700 !important}.ms-modal__content--mobile{padding:12px;flex-grow:1;height:42vh;min-height:300px;overflow-y:auto;position:relative;transition:height 0.3s ease-in-out}.ms-modal__mobile-profile-nav{display:flex;flex-direction:column;align-content:center;align-items:stretch;flex-wrap:nowrap}.ms-modal__mobile-profile-nav button{display:flex;flex-direction:row;align-content:center;align-items:center;flex-wrap:nowrap;justify-content:space-between;padding:12px;width:100%;margin-bottom:10px}.ms-modal__figure{margin:8px auto;display:flex;position:relative;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;flex-shrink:0;line-height:1}.ms-modal__figure--profile{width:24px;height:24px;padding:0px;margin:0px 8px 0px 0px}.ms-modal__figure--mobile{margin:0px 0px 8px 0px}.ms-modal__figure img, .ms-modal__figure svg{width:auto;height:100%;max-height:42px;text-align:center;object-fit:cover;color:transparent}.ms-modal__title-container{display:flex;justify-content:space-between;align-items:center;margin-bottom:24px}.ms-modal__title{margin-bottom:36px;margin-top:0;text-align:center;font-size:24px;line-height:32px;font-weight:700}.ms-modal__title--profile{margin-bottom:0px}.ms-modal__title-group{display:flex;align-items:center}.ms-modal__title--sub-text{margin-bottom:8px}.ms-modal__text{font-weight:500;font-size:16px;line-height:28px;text-align:center;margin:0 0 20px 0}.ms-modal__regular-button{color:#fff;padding:8px;border-radius:4px;border:none;font-weight:700;font-size:14px;line-height:16px;cursor:pointer;display:flex;align-items:center}.ms-modal__regular-button svg{height:16px;margin-left:6px}.ms-modal__regular-button--left-icon svg{margin-right:6px;margin-left:0px}.ms-modal__regular-button--right-icon svg{margin-left:6px;margin-right:0px}.ms-modal__regular-button--margin-right{margin-right:12px}.ms-modal__text-button{color:#fff;background-color:transparent;padding:8px;border-radius:4px;border:none;font-weight:700;font-size:14px;line-height:16px;cursor:pointer;display:flex;align-items:center}.ms-modal__card{box-shadow:0 0 #0000, 0 0 #0000, 0 0 #0000, 0 0 #0000,\n      0px 2px 2px rgba(0, 0, 0, 0.04);padding:12px;display:flex;flex-direction:row;margin-bottom:12px;border:1px solid rgb(221, 221, 221);border-radius:10px;box-sizing:border-box;width:100%;cursor:default;background:rgb(255, 255, 255);align-items:center;justify-content:space-between}.ms-form{width:100% !important;min-width:0 !important;padding:0 !important;display:block !important}.ms-form__group{margin-bottom:20px}.ms-form__flex{display:flex;justify-content:space-between;align-content:center}.ms-form__flex--centered{justify-content:center}.ms-form__label{margin-bottom:4px;margin-top:0px;font-size:14px;line-height:24px;font-weight:700;text-align:left}.ms-form__fieldset{display:flex;justify-content:space-between;padding:0;border:none}.ms-form__input{box-sizing:border-box;margin:0px;border:1px solid rgb(201, 201, 201);border-radius:6px;font-size:16px;font-weight:400;padding:15px;width:100%}.ms-form__password-container{display:flex;justify-content:space-between;align-content:center;box-sizing:border-box;margin:0px;border:1px solid rgb(201, 201, 201);border-radius:6px;width:100%}.ms-form__password-container:focus-within{border:1px solid rgb(0, 68, 252);outline:rgb(0, 68, 252) solid 1px}.ms-form__password-container:focus-within input{outline:none;border-color:rgb(201, 201, 201);box-shadow:none}.ms-form__input--password{border:none}.ms-form__input--token{font-weight:500;font-size:24.19px;line-height:32px;text-align:center;color:#000000;padding:9px;max-width:42px}.ms-form__show-toggle{cursor:pointer;background:transparent;border-radius:0px 6px 6px 0px;padding:0px 8px;display:flex;align-items:center}.ms-form__eye{display:block;width:22px}.ms-form__eye-slash{display:block;width:22px}.ms-form__error{font-weight:500;font-size:12px;line-height:16px;color:#e40023;margin-top:4px;display:flex;align-items:baseline}.ms-form__error svg{width:10px;height:10px;margin-right:5px}.ms-form__label--right a{color:rgb(10, 10, 10) !important;text-decoration:none;font-weight:400}.ms-form__button{border-radius:6px;font-weight:700;font-size:16px;padding-left:22px;padding-right:22px;height:52px;border:none;display:block;width:100%;background-color:rgb(41, 98, 255);color:#fff;transition:background-color 0.5s ease;cursor:pointer}.ms-form__button:hover{background-color:#0745ff}.ms-form__button:disabled{background-color:#96c0fe;color:#fff;pointer-events:none;display:flex;justify-content:center;align-items:center}.ms-form__button--text{background-color:transparent;padding:0px;height:auto;margin-bottom:0px;margin-top:0px;font-size:14px;line-height:28px;font-weight:500;color:#0a0a0a;opacity:0.8}.ms-form__button--text:hover{background-color:transparent}.ms-form__button--top-spacing{margin-top:10px}#msFormLoader path{fill:#fff}a.ms-form__link, div.ms-form__link{margin-top:8px;font-weight:500;font-size:14px;line-height:24px;color:rgb(10, 10, 10);text-decoration:none;opacity:0.8;cursor:pointer}.ms-modal__cancel-button{background:#f6f6f6;color:#828282;padding:8px;margin-right:8px;border-radius:4px;border:none;font-weight:700;font-size:14px;line-height:16px;cursor:pointer}.ms-modal__save-button{background:#2962ff;color:#fff;padding:8px;border-radius:4px;border:none;font-weight:700;font-size:14px;line-height:16px;cursor:pointer}.ms-modal__save-button:disabled{background:#80a1fc;color:#fff;cursor:default;opacity:0.4}.ms-modal__save-button--large{padding:12px;font-weight:700;font-size:14px;line-height:16px;width:100%}.ms-modal__outline-button{display:block !important;background:#fff;color:#0a0a0a;font-weight:700;font-size:14px;line-height:16px;padding:8px;margin-right:8px;border-radius:4px;border:1px solid #dddddd;cursor:pointer}.ms-modal__outline-button svg{display:inline !important;height:15px;margin-right:6px}.ms-modal__outline-button--mobile{width:100%}.ms-modal__button-label{margin-bottom:4px;margin-top:0px;font-size:14px;line-height:28px;font-weight:500}.ms-modal__profile-option{cursor:pointer;margin-bottom:20px;font-weight:500;font-size:16px;line-height:28px;background:transparent;border:none;padding:0px}.ms-modal__profile-option svg{display:inline !important;height:14px;margin-right:8px}.ms-modal__profile-option:hover{color:#2962ff}.ms-modal__profile-option--active{color:#2962ff}.ms-modal__profile-image-container{display:flex;justify-content:flex-start;width:100%;margin-bottom:21px;align-items:center;flex-direction:row;gap:12px}.ms-modal__profile-image{width:42px;height:42px;border-radius:50%;object-fit:cover;overflow:hidden;background:#ddd;border:1px solid #c9c9c9;display:flex;justify-content:center;align-items:center}.ms-modal__profile-image img{width:100%;height:100%;object-fit:cover}.ms-modal__social-button{display:flex;align-items:center;justify-content:center;width:100%;height:52px;border-radius:6px;font-weight:700;font-size:16px;line-height:28px;color:#0a0a0a;background:none;border:1px solid #c9c9c9;cursor:pointer;margin-bottom:8px}\n      .ms-modal__social-button img,\n      .ms-modal__social-button svg\n    {height:16px;margin-right:8px;width:auto}.ms-modal__social-button[disabled]{background:#f6f6f6}.ms-modal__social-divider{display:flex;align-items:center;margin:20px 0px}.ms-modal__divider-line{text-align:center;background:#dddddd;height:1px;width:100%}.ms-modal__divider-text{padding:0px 4px}.ms-modal__footer{text-align:center;width:100%;box-sizing:border-box;margin:0;min-width:0;background:#f6f6f6;padding-top:10px;padding-bottom:10px;border-bottom-left-radius:16px;border-bottom-right-radius:16px;border-top:1px solid;border-top-color:#dddddd;font-size:12px;line-height:16px;font-weight:500}.ms-modal__footer a{color:rgb(10, 10, 10);text-decoration:none;display:flex;justify-content:center;align-items:center}.ms-modal__footer svg{height:12px;width:12px;margin-right:5.5px}');
}
function create_if_block_11(ctx) {
  let testmode;
  let current;
  testmode = new TestMode({});
  return {
    c() {
      create_component(testmode.$$.fragment);
    },
    m(target, anchor) {
      mount_component(testmode, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current)
        return;
      transition_in(testmode.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(testmode.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(testmode, detaching);
    }
  };
}
function create_if_block(ctx) {
  let main;
  let current_block_type_index;
  let if_block;
  let current;
  let mounted;
  let dispose;
  const if_block_creators = [
    create_if_block_1,
    create_if_block_2,
    create_if_block_3,
    create_if_block_4,
    create_if_block_5,
    create_if_block_6,
    create_if_block_7,
    create_if_block_8,
    create_if_block_10
  ];
  const if_blocks = [];
  function select_block_type_1(ctx2, dirty) {
    if (
      /*showLoader*/
      ctx2[4]
    )
      return 0;
    if (
      /*display*/
      ctx2[0] === "login"
    )
      return 1;
    if (
      /*display*/
      ctx2[0] === "signup"
    )
      return 2;
    if (
      /*display*/
      ctx2[0] === "forgot_password"
    )
      return 3;
    if (
      /*display*/
      ctx2[0] === "reset_password"
    )
      return 4;
    if (
      /*display*/
      ctx2[0] === "reset_password_success"
    )
      return 5;
    if (
      /*display*/
      ctx2[0] === "passwordless_token"
    )
      return 6;
    if (
      /*display*/
      ctx2[0] === "profile"
    )
      return 7;
    if (
      /*display*/
      ctx2[0] === "test_card"
    )
      return 8;
    return -1;
  }
  if (~(current_block_type_index = select_block_type_1(ctx))) {
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  }
  return {
    c() {
      main = element("main");
      if (if_block)
        if_block.c();
      attr(main, "id", "msOverlay");
      attr(main, "class", "svelte-1blpd87");
    },
    m(target, anchor) {
      insert(target, main, anchor);
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].m(main, null);
      }
      current = true;
      if (!mounted) {
        dispose = listen(
          main,
          "mousedown",
          /*closeModalOutside*/
          ctx[6]
        );
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type_1(ctx2);
      if (current_block_type_index === previous_block_index) {
        if (~current_block_type_index) {
          if_blocks[current_block_type_index].p(ctx2, dirty);
        }
      } else {
        if (if_block) {
          group_outros();
          transition_out(if_blocks[previous_block_index], 1, 1, () => {
            if_blocks[previous_block_index] = null;
          });
          check_outros();
        }
        if (~current_block_type_index) {
          if_block = if_blocks[current_block_type_index];
          if (!if_block) {
            if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
            if_block.c();
          } else {
            if_block.p(ctx2, dirty);
          }
          transition_in(if_block, 1);
          if_block.m(main, null);
        } else {
          if_block = null;
        }
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(main);
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].d();
      }
      mounted = false;
      dispose();
    }
  };
}
function create_if_block_10(ctx) {
  let testcardmodal;
  let updating_display;
  let updating_params;
  let current;
  function testcardmodal_display_binding(value) {
    ctx[20](value);
  }
  function testcardmodal_params_binding(value) {
    ctx[21](value);
  }
  let testcardmodal_props = {
    closeModal: (
      /*closeModal*/
      ctx[5]
    ),
    onSuccessSubmit: (
      /*onSuccess*/
      ctx[2]
    )
  };
  if (
    /*display*/
    ctx[0] !== void 0
  ) {
    testcardmodal_props.display = /*display*/
    ctx[0];
  }
  if (
    /*params*/
    ctx[1] !== void 0
  ) {
    testcardmodal_props.params = /*params*/
    ctx[1];
  }
  testcardmodal = new TestCardModal({ props: testcardmodal_props });
  binding_callbacks.push(() => bind(testcardmodal, "display", testcardmodal_display_binding));
  binding_callbacks.push(() => bind(testcardmodal, "params", testcardmodal_params_binding));
  return {
    c() {
      create_component(testcardmodal.$$.fragment);
    },
    m(target, anchor) {
      mount_component(testcardmodal, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const testcardmodal_changes = {};
      if (dirty & /*onSuccess*/
      4)
        testcardmodal_changes.onSuccessSubmit = /*onSuccess*/
        ctx2[2];
      if (!updating_display && dirty & /*display*/
      1) {
        updating_display = true;
        testcardmodal_changes.display = /*display*/
        ctx2[0];
        add_flush_callback(() => updating_display = false);
      }
      if (!updating_params && dirty & /*params*/
      2) {
        updating_params = true;
        testcardmodal_changes.params = /*params*/
        ctx2[1];
        add_flush_callback(() => updating_params = false);
      }
      testcardmodal.$set(testcardmodal_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(testcardmodal.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(testcardmodal.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(testcardmodal, detaching);
    }
  };
}
function create_if_block_8(ctx) {
  let mediaquery;
  let current;
  mediaquery = new MediaQuery({
    props: {
      query: "(max-width: 520px)",
      $$slots: {
        default: [
          create_default_slot,
          ({ matches }) => ({ 26: matches }),
          ({ matches }) => matches ? 67108864 : 0
        ]
      },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(mediaquery.$$.fragment);
    },
    m(target, anchor) {
      mount_component(mediaquery, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const mediaquery_changes = {};
      if (dirty & /*$$scope, onSuccess, member, display, matches*/
      201326605) {
        mediaquery_changes.$$scope = { dirty, ctx: ctx2 };
      }
      mediaquery.$set(mediaquery_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(mediaquery.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(mediaquery.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(mediaquery, detaching);
    }
  };
}
function create_if_block_7(ctx) {
  let passwordlesstokenmodal;
  let updating_display;
  let updating_params;
  let current;
  function passwordlesstokenmodal_display_binding(value) {
    ctx[16](value);
  }
  function passwordlesstokenmodal_params_binding(value) {
    ctx[17](value);
  }
  let passwordlesstokenmodal_props = {
    closeModal: (
      /*closeModal*/
      ctx[5]
    ),
    onSuccess: (
      /*onSuccess*/
      ctx[2]
    )
  };
  if (
    /*display*/
    ctx[0] !== void 0
  ) {
    passwordlesstokenmodal_props.display = /*display*/
    ctx[0];
  }
  if (
    /*params*/
    ctx[1] !== void 0
  ) {
    passwordlesstokenmodal_props.params = /*params*/
    ctx[1];
  }
  passwordlesstokenmodal = new PasswordlessTokenModal({ props: passwordlesstokenmodal_props });
  binding_callbacks.push(() => bind(passwordlesstokenmodal, "display", passwordlesstokenmodal_display_binding));
  binding_callbacks.push(() => bind(passwordlesstokenmodal, "params", passwordlesstokenmodal_params_binding));
  return {
    c() {
      create_component(passwordlesstokenmodal.$$.fragment);
    },
    m(target, anchor) {
      mount_component(passwordlesstokenmodal, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const passwordlesstokenmodal_changes = {};
      if (dirty & /*onSuccess*/
      4)
        passwordlesstokenmodal_changes.onSuccess = /*onSuccess*/
        ctx2[2];
      if (!updating_display && dirty & /*display*/
      1) {
        updating_display = true;
        passwordlesstokenmodal_changes.display = /*display*/
        ctx2[0];
        add_flush_callback(() => updating_display = false);
      }
      if (!updating_params && dirty & /*params*/
      2) {
        updating_params = true;
        passwordlesstokenmodal_changes.params = /*params*/
        ctx2[1];
        add_flush_callback(() => updating_params = false);
      }
      passwordlesstokenmodal.$set(passwordlesstokenmodal_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(passwordlesstokenmodal.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(passwordlesstokenmodal.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(passwordlesstokenmodal, detaching);
    }
  };
}
function create_if_block_6(ctx) {
  let passwordsuccessmodal;
  let updating_display;
  let current;
  function passwordsuccessmodal_display_binding(value) {
    ctx[15](value);
  }
  let passwordsuccessmodal_props = { closeModal: (
    /*closeModal*/
    ctx[5]
  ) };
  if (
    /*display*/
    ctx[0] !== void 0
  ) {
    passwordsuccessmodal_props.display = /*display*/
    ctx[0];
  }
  passwordsuccessmodal = new PassSuccessModal({ props: passwordsuccessmodal_props });
  binding_callbacks.push(() => bind(passwordsuccessmodal, "display", passwordsuccessmodal_display_binding));
  return {
    c() {
      create_component(passwordsuccessmodal.$$.fragment);
    },
    m(target, anchor) {
      mount_component(passwordsuccessmodal, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const passwordsuccessmodal_changes = {};
      if (!updating_display && dirty & /*display*/
      1) {
        updating_display = true;
        passwordsuccessmodal_changes.display = /*display*/
        ctx2[0];
        add_flush_callback(() => updating_display = false);
      }
      passwordsuccessmodal.$set(passwordsuccessmodal_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(passwordsuccessmodal.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(passwordsuccessmodal.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(passwordsuccessmodal, detaching);
    }
  };
}
function create_if_block_5(ctx) {
  let passwordtokenmodal;
  let updating_display;
  let current;
  function passwordtokenmodal_display_binding(value) {
    ctx[14](value);
  }
  let passwordtokenmodal_props = {
    closeModal: (
      /*closeModal*/
      ctx[5]
    ),
    onSuccessPasswordReset: (
      /*onSuccess*/
      ctx[2]
    )
  };
  if (
    /*display*/
    ctx[0] !== void 0
  ) {
    passwordtokenmodal_props.display = /*display*/
    ctx[0];
  }
  passwordtokenmodal = new PassTokenModal({ props: passwordtokenmodal_props });
  binding_callbacks.push(() => bind(passwordtokenmodal, "display", passwordtokenmodal_display_binding));
  return {
    c() {
      create_component(passwordtokenmodal.$$.fragment);
    },
    m(target, anchor) {
      mount_component(passwordtokenmodal, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const passwordtokenmodal_changes = {};
      if (dirty & /*onSuccess*/
      4)
        passwordtokenmodal_changes.onSuccessPasswordReset = /*onSuccess*/
        ctx2[2];
      if (!updating_display && dirty & /*display*/
      1) {
        updating_display = true;
        passwordtokenmodal_changes.display = /*display*/
        ctx2[0];
        add_flush_callback(() => updating_display = false);
      }
      passwordtokenmodal.$set(passwordtokenmodal_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(passwordtokenmodal.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(passwordtokenmodal.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(passwordtokenmodal, detaching);
    }
  };
}
function create_if_block_4(ctx) {
  let passwordresetmodal;
  let updating_display;
  let current;
  function passwordresetmodal_display_binding(value) {
    ctx[13](value);
  }
  let passwordresetmodal_props = { closeModal: (
    /*closeModal*/
    ctx[5]
  ) };
  if (
    /*display*/
    ctx[0] !== void 0
  ) {
    passwordresetmodal_props.display = /*display*/
    ctx[0];
  }
  passwordresetmodal = new PassResetModal({ props: passwordresetmodal_props });
  binding_callbacks.push(() => bind(passwordresetmodal, "display", passwordresetmodal_display_binding));
  return {
    c() {
      create_component(passwordresetmodal.$$.fragment);
    },
    m(target, anchor) {
      mount_component(passwordresetmodal, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const passwordresetmodal_changes = {};
      if (!updating_display && dirty & /*display*/
      1) {
        updating_display = true;
        passwordresetmodal_changes.display = /*display*/
        ctx2[0];
        add_flush_callback(() => updating_display = false);
      }
      passwordresetmodal.$set(passwordresetmodal_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(passwordresetmodal.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(passwordresetmodal.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(passwordresetmodal, detaching);
    }
  };
}
function create_if_block_3(ctx) {
  let signupmodal;
  let updating_display;
  let updating_params;
  let current;
  function signupmodal_display_binding(value) {
    ctx[11](value);
  }
  function signupmodal_params_binding(value) {
    ctx[12](value);
  }
  let signupmodal_props = {
    closeModal: (
      /*closeModal*/
      ctx[5]
    ),
    onSuccessSignup: (
      /*onSuccess*/
      ctx[2]
    )
  };
  if (
    /*display*/
    ctx[0] !== void 0
  ) {
    signupmodal_props.display = /*display*/
    ctx[0];
  }
  if (
    /*params*/
    ctx[1] !== void 0
  ) {
    signupmodal_props.params = /*params*/
    ctx[1];
  }
  signupmodal = new SignupModal({ props: signupmodal_props });
  binding_callbacks.push(() => bind(signupmodal, "display", signupmodal_display_binding));
  binding_callbacks.push(() => bind(signupmodal, "params", signupmodal_params_binding));
  return {
    c() {
      create_component(signupmodal.$$.fragment);
    },
    m(target, anchor) {
      mount_component(signupmodal, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const signupmodal_changes = {};
      if (dirty & /*onSuccess*/
      4)
        signupmodal_changes.onSuccessSignup = /*onSuccess*/
        ctx2[2];
      if (!updating_display && dirty & /*display*/
      1) {
        updating_display = true;
        signupmodal_changes.display = /*display*/
        ctx2[0];
        add_flush_callback(() => updating_display = false);
      }
      if (!updating_params && dirty & /*params*/
      2) {
        updating_params = true;
        signupmodal_changes.params = /*params*/
        ctx2[1];
        add_flush_callback(() => updating_params = false);
      }
      signupmodal.$set(signupmodal_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(signupmodal.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(signupmodal.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(signupmodal, detaching);
    }
  };
}
function create_if_block_2(ctx) {
  let loginmodal;
  let updating_display;
  let updating_params;
  let current;
  function loginmodal_display_binding(value) {
    ctx[9](value);
  }
  function loginmodal_params_binding(value) {
    ctx[10](value);
  }
  let loginmodal_props = {
    closeModal: (
      /*closeModal*/
      ctx[5]
    ),
    onSuccessLogin: (
      /*onSuccess*/
      ctx[2]
    )
  };
  if (
    /*display*/
    ctx[0] !== void 0
  ) {
    loginmodal_props.display = /*display*/
    ctx[0];
  }
  if (
    /*params*/
    ctx[1] !== void 0
  ) {
    loginmodal_props.params = /*params*/
    ctx[1];
  }
  loginmodal = new LoginModal({ props: loginmodal_props });
  binding_callbacks.push(() => bind(loginmodal, "display", loginmodal_display_binding));
  binding_callbacks.push(() => bind(loginmodal, "params", loginmodal_params_binding));
  return {
    c() {
      create_component(loginmodal.$$.fragment);
    },
    m(target, anchor) {
      mount_component(loginmodal, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const loginmodal_changes = {};
      if (dirty & /*onSuccess*/
      4)
        loginmodal_changes.onSuccessLogin = /*onSuccess*/
        ctx2[2];
      if (!updating_display && dirty & /*display*/
      1) {
        updating_display = true;
        loginmodal_changes.display = /*display*/
        ctx2[0];
        add_flush_callback(() => updating_display = false);
      }
      if (!updating_params && dirty & /*params*/
      2) {
        updating_params = true;
        loginmodal_changes.params = /*params*/
        ctx2[1];
        add_flush_callback(() => updating_params = false);
      }
      loginmodal.$set(loginmodal_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(loginmodal.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(loginmodal.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(loginmodal, detaching);
    }
  };
}
function create_if_block_1(ctx) {
  let loader;
  let current;
  loader = new Loader({});
  return {
    c() {
      create_component(loader.$$.fragment);
    },
    m(target, anchor) {
      mount_component(loader, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current)
        return;
      transition_in(loader.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(loader.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(loader, detaching);
    }
  };
}
function create_else_block(ctx) {
  let profilemodal;
  let updating_display;
  let current;
  function profilemodal_display_binding(value) {
    ctx[19](value);
  }
  let profilemodal_props = {
    closeModal: (
      /*closeModal*/
      ctx[5]
    ),
    onSuccessLogout: (
      /*onSuccess*/
      ctx[2]
    ),
    member: (
      /*member*/
      ctx[3]
    )
  };
  if (
    /*display*/
    ctx[0] !== void 0
  ) {
    profilemodal_props.display = /*display*/
    ctx[0];
  }
  profilemodal = new ProfileModal({ props: profilemodal_props });
  binding_callbacks.push(() => bind(profilemodal, "display", profilemodal_display_binding));
  return {
    c() {
      create_component(profilemodal.$$.fragment);
    },
    m(target, anchor) {
      mount_component(profilemodal, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const profilemodal_changes = {};
      if (dirty & /*onSuccess*/
      4)
        profilemodal_changes.onSuccessLogout = /*onSuccess*/
        ctx2[2];
      if (dirty & /*member*/
      8)
        profilemodal_changes.member = /*member*/
        ctx2[3];
      if (!updating_display && dirty & /*display*/
      1) {
        updating_display = true;
        profilemodal_changes.display = /*display*/
        ctx2[0];
        add_flush_callback(() => updating_display = false);
      }
      profilemodal.$set(profilemodal_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(profilemodal.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(profilemodal.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(profilemodal, detaching);
    }
  };
}
function create_if_block_9(ctx) {
  let mobileprofilemodal;
  let updating_display;
  let current;
  function mobileprofilemodal_display_binding(value) {
    ctx[18](value);
  }
  let mobileprofilemodal_props = {
    closeModal: (
      /*closeModal*/
      ctx[5]
    ),
    onSuccessLogout: (
      /*onSuccess*/
      ctx[2]
    ),
    member: (
      /*member*/
      ctx[3]
    )
  };
  if (
    /*display*/
    ctx[0] !== void 0
  ) {
    mobileprofilemodal_props.display = /*display*/
    ctx[0];
  }
  mobileprofilemodal = new MobileProfileModal({ props: mobileprofilemodal_props });
  binding_callbacks.push(() => bind(mobileprofilemodal, "display", mobileprofilemodal_display_binding));
  return {
    c() {
      create_component(mobileprofilemodal.$$.fragment);
    },
    m(target, anchor) {
      mount_component(mobileprofilemodal, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const mobileprofilemodal_changes = {};
      if (dirty & /*onSuccess*/
      4)
        mobileprofilemodal_changes.onSuccessLogout = /*onSuccess*/
        ctx2[2];
      if (dirty & /*member*/
      8)
        mobileprofilemodal_changes.member = /*member*/
        ctx2[3];
      if (!updating_display && dirty & /*display*/
      1) {
        updating_display = true;
        mobileprofilemodal_changes.display = /*display*/
        ctx2[0];
        add_flush_callback(() => updating_display = false);
      }
      mobileprofilemodal.$set(mobileprofilemodal_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(mobileprofilemodal.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(mobileprofilemodal.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(mobileprofilemodal, detaching);
    }
  };
}
function create_default_slot(ctx) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block_9, create_else_block];
  const if_blocks = [];
  function select_block_type_2(ctx2, dirty) {
    if (
      /*matches*/
      ctx2[26]
    )
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type_2(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type_2(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if_blocks[current_block_type_index].d(detaching);
      if (detaching)
        detach(if_block_anchor);
    }
  };
}
function create_fragment(ctx) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block, create_if_block_11];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*display*/
      ctx2[0] !== "inspector"
    )
      return 0;
    if (
      /*display*/
      ctx2[0] === "inspector"
    )
      return 1;
    return -1;
  }
  if (~(current_block_type_index = select_block_type(ctx))) {
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  }
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].m(target, anchor);
      }
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if (~current_block_type_index) {
          if_blocks[current_block_type_index].p(ctx2, dirty);
        }
      } else {
        if (if_block) {
          group_outros();
          transition_out(if_blocks[previous_block_index], 1, 1, () => {
            if_blocks[previous_block_index] = null;
          });
          check_outros();
        }
        if (~current_block_type_index) {
          if_block = if_blocks[current_block_type_index];
          if (!if_block) {
            if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
            if_block.c();
          } else {
            if_block.p(ctx2, dirty);
          }
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        } else {
          if_block = null;
        }
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].d(detaching);
      }
      if (detaching)
        detach(if_block_anchor);
    }
  };
}
function instance($$self, $$props, $$invalidate) {
  let showLoader2;
  let { display = "login" } = $$props;
  let { onSuccess } = $$props;
  let { params } = $$props;
  let appLoading = true;
  let memberLoading = display === "profile" ? true : false;
  let member;
  function setAppStore(data) {
    AppStore.update(() => data);
    TextStore.set({ text: data.ssoText || {} });
  }
  function closeModal() {
    $$invalidate(7, appLoading = true);
    onSuccess({ type: "CLOSED" });
    const modal2 = document.querySelector("#msOverlay");
    if (modal2) {
      modal2.remove();
    }
  }
  function closeModalOutside(e) {
    if (e.target.id === "msOverlay") {
      closeModal();
    }
  }
  const getApp = () => __async(this, null, function* () {
    const { data } = yield window.$memberstackDom.getApp();
    setAppStore(data);
  });
  function checkApp() {
    return __async(this, null, function* () {
      if (params && params.app) {
        setAppStore(params.app);
      } else {
        yield getApp();
      }
      $$invalidate(7, appLoading = false);
      $$invalidate(4, showLoader2 = false);
    });
  }
  const getMember = () => __async(this, null, function* () {
    const { data } = yield window.$memberstackDom.getCurrentMember();
    $$invalidate(8, memberLoading = false);
    $$invalidate(3, member = data);
    if (display === "profile" && !data) {
      closeModal();
      throw new Error("Member not logged in");
    }
  });
  onMount(() => {
    checkApp();
    if (display === "profile") {
      getMember();
    }
  });
  function loginmodal_display_binding(value) {
    display = value;
    $$invalidate(0, display);
  }
  function loginmodal_params_binding(value) {
    params = value;
    $$invalidate(1, params);
  }
  function signupmodal_display_binding(value) {
    display = value;
    $$invalidate(0, display);
  }
  function signupmodal_params_binding(value) {
    params = value;
    $$invalidate(1, params);
  }
  function passwordresetmodal_display_binding(value) {
    display = value;
    $$invalidate(0, display);
  }
  function passwordtokenmodal_display_binding(value) {
    display = value;
    $$invalidate(0, display);
  }
  function passwordsuccessmodal_display_binding(value) {
    display = value;
    $$invalidate(0, display);
  }
  function passwordlesstokenmodal_display_binding(value) {
    display = value;
    $$invalidate(0, display);
  }
  function passwordlesstokenmodal_params_binding(value) {
    params = value;
    $$invalidate(1, params);
  }
  function mobileprofilemodal_display_binding(value) {
    display = value;
    $$invalidate(0, display);
  }
  function profilemodal_display_binding(value) {
    display = value;
    $$invalidate(0, display);
  }
  function testcardmodal_display_binding(value) {
    display = value;
    $$invalidate(0, display);
  }
  function testcardmodal_params_binding(value) {
    params = value;
    $$invalidate(1, params);
  }
  $$self.$$set = ($$props2) => {
    if ("display" in $$props2)
      $$invalidate(0, display = $$props2.display);
    if ("onSuccess" in $$props2)
      $$invalidate(2, onSuccess = $$props2.onSuccess);
    if ("params" in $$props2)
      $$invalidate(1, params = $$props2.params);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*appLoading, memberLoading*/
    384) {
      $$invalidate(4, showLoader2 = appLoading || memberLoading);
    }
  };
  return [
    display,
    params,
    onSuccess,
    member,
    showLoader2,
    closeModal,
    closeModalOutside,
    appLoading,
    memberLoading,
    loginmodal_display_binding,
    loginmodal_params_binding,
    signupmodal_display_binding,
    signupmodal_params_binding,
    passwordresetmodal_display_binding,
    passwordtokenmodal_display_binding,
    passwordsuccessmodal_display_binding,
    passwordlesstokenmodal_display_binding,
    passwordlesstokenmodal_params_binding,
    mobileprofilemodal_display_binding,
    profilemodal_display_binding,
    testcardmodal_display_binding,
    testcardmodal_params_binding
  ];
}
var Main = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance, create_fragment, safe_not_equal, { display: 0, onSuccess: 2, params: 1 }, add_css);
  }
};

// src/methods/dom/methods.ts
var initDefaultMessageBox = () => {
  initCSS();
  addSuccessBox();
  addErrorBox();
};
var showMessage = (msg, isError) => __async(void 0, null, function* () {
  if (!msg)
    return;
  yield new Promise((resolve) => {
    if (document.readyState !== "loading") {
      resolve(true);
    } else {
      document.addEventListener("DOMContentLoaded", function(event) {
        resolve(true);
      });
    }
  });
  if (!document.querySelector("[data-ms-message='success']")) {
    initDefaultMessageBox();
  }
  let messageBox;
  if (isError) {
    messageBox = document.querySelector("[data-ms-message='error']");
  } else {
    messageBox = document.querySelector("[data-ms-message='success']");
  }
  const messageTextBox = messageBox.querySelector("[data-ms-message-text]");
  if (messageTextBox) {
    messageTextBox.innerHTML = msg;
  }
  messageBox.style.display = "block";
  const closeBtn = messageBox.querySelector("[data-ms-message-close]");
  closeBtn == null ? void 0 : closeBtn.addEventListener("click", () => {
    messageBox.style.display = "none";
  });
  setTimeout(() => {
    messageBox.style.display = "none";
  }, 7e3);
});
var showLoader = (element2) => {
  if (element2) {
    element2.style.display = "block";
    return;
  }
  const cssEl = document.createElement("style");
  const css = ".ms__loader { width: 100%; height: 100%; overflow: hidden; position: fixed; top: 0; left: 0; display: flex; justify-content: center; align-items: center; z-index: 10000000; } #msLoader path { fill: #007ace; }";
  cssEl.appendChild(document.createTextNode(css));
  document.head.appendChild(cssEl);
  const loaderHTML = '<?xml version="1.0"?><div class="ms__loader"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="msLoader" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" style="enable-background: new 0 0 50 50; z-index:1000000" xml:space="preserve"><path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"/></path></svg></div>';
  const div = document.createElement("div");
  div.setAttribute("data-ms-loader", "true");
  div.innerHTML = loaderHTML;
  if (document.readyState !== "loading") {
    document.body.appendChild(div);
  } else {
    document.addEventListener("DOMContentLoaded", function(event) {
      document.body.appendChild(div);
    });
  }
};
var hideLoader = (element2) => {
  var _a;
  if (element2) {
    element2.style.display = "none";
    return;
  }
  (_a = document.querySelector("[data-ms-loader]")) == null ? void 0 : _a.remove();
};
var modal;
var openModal = (_0, ..._1) => __async(void 0, [_0, ..._1], function* (type, params = {}) {
  let resolveModal;
  const modalPromise = new Promise((resolve) => {
    resolveModal = resolve;
  });
  modal = new Main({
    target: document.body,
    props: {
      display: type.toLowerCase(),
      params,
      onSuccess: resolveModal
    }
  });
  return modalPromise;
});
var hideModal = () => {
  try {
    modal == null ? void 0 : modal.$destroy();
  } catch (e) {
  }
};

// src/utils/cookies.ts
import Cookie from "js-cookie";
var memberAuthTokenName = "_ms-mid";
function isLocalStorageAvailable() {
  try {
    localStorage.setItem("test", "test");
    localStorage.removeItem("test");
    return true;
  } catch (e) {
    return false;
  }
}
var localStorageAvailable = isLocalStorageAvailable();
var useCookies = false;
var setCookieOnRootDomain = false;
var apiDomain;
var setUseCookies = (setCookieOnRoot) => {
  useCookies = true;
  if (setCookieOnRoot)
    setCookieOnRootDomain = true;
};
var setApiDomain = (domain) => {
  apiDomain = domain;
};
var extractDomainFromHostname = (hostname) => {
  const hostnameParts = hostname.split(".");
  const isCountryCodeTLD = hostnameParts.length >= 3 && hostnameParts[hostnameParts.length - 2].length <= 3;
  if (isCountryCodeTLD) {
    return hostnameParts.slice(-3).join(".");
  } else {
    return hostnameParts.slice(-2).join(".");
  }
};
var useCookiesValid = () => {
  if (!useCookies)
    return false;
  if (setCookieOnRootDomain) {
    const apiDomainHost = extractDomainFromHostname(apiDomain);
    const currentHost = extractDomainFromHostname(window.location.hostname);
    return apiDomainHost === currentHost;
  }
  return true;
};
var setMemberToken = (token, expires) => {
  if (localStorageAvailable && useCookiesValid() === false) {
    localStorage.setItem(memberAuthTokenName, token);
  } else {
    const domain = extractDomainFromHostname(window.location.hostname);
    Cookie.set(memberAuthTokenName, token, __spreadValues({
      expires: expires && Number(expires) || 14,
      sameSite: "strict"
    }, setCookieOnRootDomain && { domain }));
  }
};
var removeMemberToken = () => {
  if (localStorageAvailable) {
    localStorage.removeItem(memberAuthTokenName);
  }
  const domain = extractDomainFromHostname(window.location.hostname);
  Cookie.set(memberAuthTokenName, "", __spreadValues({
    expires: -1,
    sameSite: "strict"
  }, setCookieOnRootDomain && { domain }));
  Cookie.set(memberAuthTokenName, "", {
    expires: -1,
    sameSite: "strict"
  });
};
var getMemberToken = () => {
  if (localStorageAvailable) {
    const memAuthToken = localStorage.getItem(memberAuthTokenName);
    if (memAuthToken)
      return memAuthToken;
  }
  return Cookie.get(memberAuthTokenName);
};
var setMemberTokenIfAvailable = () => {
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search);
    const memberToken = urlParams.get("memberToken");
    if (memberToken)
      setMemberToken(memberToken);
  }
};

// src/methods/requests/requests.ts
import axios from "axios";

// src/constants/endpoints.ts
var endpoints = {
  API: "https://client.memberstack.com"
};

// src/methods/requests/requests.ts
var createRequestHandler = ({
  publicKey,
  appId,
  token,
  customEndpoint
}) => {
  return {
    sendRequest: (data, options) => __async(void 0, null, function* () {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      try {
        const { url } = data;
        const memberToken = getMemberToken();
        const authHeader = [
          (_b = (_a = data.headers) == null ? void 0 : _a["Authorization"]) == null ? void 0 : _b.replace("Bearer ", ""),
          memberToken,
          options == null ? void 0 : options.token
        ].find((x) => x);
        const formattedUrl = `${customEndpoint || endpoints.API}${url}`;
        const res = yield axios({
          method: data.method,
          data: data.data,
          url: formattedUrl,
          headers: __spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues({}, authHeader && { authorization: `Bearer ${authHeader}` }), publicKey && { ["X-API-Key" /* API_KEY */]: publicKey }), appId && { ["X-APP-ID" /* APP_ID */]: appId }), {
            ["X-User-Agent" /* USER_AGENT */]: "@memberstack/client@1.2.0"
          }), data.contentType && { "Content-Type": data.contentType }),
          withCredentials: true
        });
        if ((_c = res == null ? void 0 : res.headers) == null ? void 0 : _c["ms-mid"]) {
          token = res.headers["ms-mid"];
        }
        if ((_d = res == null ? void 0 : res.data) == null ? void 0 : _d.error) {
          if (res.data.error.name === "JsonWebTokenError") {
            throw {
              code: "client/invalid-token",
              message: "An invalid token has been provided. Please make sure the token is valid."
            };
          }
          throw (_e = res.data) == null ? void 0 : _e.error;
        }
        return res == null ? void 0 : res.data;
      } catch (e) {
        if (!e.response)
          throw e;
        throw ((_g = (_f = e.response) == null ? void 0 : _f.data) == null ? void 0 : _g.error) || ((_h = e.response) == null ? void 0 : _h.data);
      }
    })
  };
};

// src/auth/index.ts
var createObservable = () => {
  const observer = /* @__PURE__ */ new Map();
  return {
    subscribe: (key, fn) => {
      if (typeof fn !== "function")
        return;
      return observer.set(key, fn);
    },
    unsubscribe: (key) => {
      return observer.delete(key);
    },
    notify: (data) => {
      return [...observer.values()].forEach((fn) => fn(data));
    }
  };
};
var observable = createObservable();
var getPersistedMember = () => {
  return JSON.parse(localStorage == null ? void 0 : localStorage.getItem("_ms-mem"));
};
var setPersistedMember = (member) => {
  if (member) {
    const data = JSON.stringify(member);
    if (data)
      localStorage == null ? void 0 : localStorage.setItem("_ms-mem", data);
    observable.notify(member);
  }
};
var updatePersistedMember = (member) => {
  if (member) {
    const data = JSON.stringify(member);
    if (data)
      localStorage == null ? void 0 : localStorage.setItem("_ms-mem", data);
  } else {
    localStorage == null ? void 0 : localStorage.removeItem("_ms-mem");
    removeMemberToken();
  }
};
var unsetPersistedMember = () => {
  localStorage == null ? void 0 : localStorage.removeItem("_ms-mem");
  removeMemberToken();
  observable.notify(null);
};
var onAuthChange = (cb) => {
  const id = Math.floor(Math.random() * 1e3);
  observable.subscribe(id, cb);
  return {
    unsubscribe: () => observable.unsubscribe(id)
  };
};

// src/methods/requests/index.ts
function getSessionDurationDays(unixTimestampMillis) {
  const now2 = Date.now();
  const differenceMillis = unixTimestampMillis - now2;
  return Math.ceil(differenceMillis / (24 * 60 * 60 * 1e3));
}
var addHeaders = (options) => __spreadValues({}, (options == null ? void 0 : options.token) && {
  Authorization: `Bearer ${options.token}`
});
var promiseResolve;
var promiseReject;
var receiveMessage = (event) => {
  var _a;
  const { data, origin } = event;
  if (API_ENDPOINT !== origin)
    return;
  if ((_a = data == null ? void 0 : data.data) == null ? void 0 : _a.member) {
    const sessionDurationDays = getSessionDurationDays(data.data.tokens.expires);
    setPersistedMember(data.data.member);
    setMemberToken(data.data.tokens.accessToken, sessionDurationDays);
  }
  if (data == null ? void 0 : data.error) {
    promiseReject(data.error);
  }
  promiseResolve(data);
};
var windowObjectReference = null;
var previousUrl = null;
var openSignInWindow = (url, name) => __async(void 0, null, function* () {
  window.removeEventListener("message", receiveMessage);
  const dualScreenLeft = window.screenLeft !== void 0 ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !== void 0 ? window.screenTop : window.screenY;
  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
  const systemZoom = width / window.screen.availWidth;
  const left = (width - 600) / 2 / systemZoom + dualScreenLeft;
  const top = (height - 700) / 2 / systemZoom + dualScreenTop;
  const strWindowFeatures = `toolbar=no, menubar=no, width=${600 / systemZoom}, height=${700 / systemZoom}, top=${top}, left=${left}`;
  if (windowObjectReference === null || windowObjectReference.closed) {
    windowObjectReference = window.open(url, name, strWindowFeatures);
  } else if (previousUrl !== url) {
    windowObjectReference = window.open(url, name, strWindowFeatures);
    windowObjectReference.focus();
  } else {
    windowObjectReference.focus();
  }
  window.addEventListener("message", (event) => receiveMessage(event), false);
  previousUrl = url;
  window.addEventListener("beforeunload", () => {
    windowObjectReference == null ? void 0 : windowObjectReference.close();
  });
  return new Promise((resolve, reject) => {
    promiseResolve = resolve;
    promiseReject = reject;
  });
});
var API_ENDPOINT;
var initRequest = ({
  publicKey,
  appId,
  token,
  domain
  //sessionDurationDays
}) => {
  const { sendRequest } = createRequestHandler({
    publicKey,
    token,
    customEndpoint: domain,
    appId
  });
  API_ENDPOINT = domain;
  return {
    postIsTyping(params) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "POST" /* POST */,
          url: `/comments/posts/typing`,
          data: {
            channelKey: params.channelKey
          }
        });
      });
    },
    getChannelInfo(params) {
      return __async(this, null, function* () {
        const queryParams = new URLSearchParams({
          channelKey: params.channelKey
        });
        return sendRequest({
          method: "GET" /* GET */,
          url: `/comments/channels/info?${queryParams}`
        });
      });
    },
    subscribeToChannel(params) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "POST" /* POST */,
          url: `/comments/channels/manage-subscription`,
          data: {
            channelKey: params.channelKey,
            action: params.action
          }
        });
      });
    },
    getPosts(params) {
      return __async(this, null, function* () {
        const queryParams = new URLSearchParams(__spreadValues(__spreadValues(__spreadValues({
          channelKey: params.channelKey
        }, params.after && {
          after: params.after
        }), params.order && {
          order: params.order
        }), params.limit && {
          limit: params.limit.toString()
        }));
        return sendRequest({
          method: "GET" /* GET */,
          url: `/comments/posts?${queryParams}`
        });
      });
    },
    getThreads(params) {
      return __async(this, null, function* () {
        const queryParams = new URLSearchParams(__spreadValues(__spreadValues(__spreadValues({
          postId: params.postId
        }, params.after && {
          after: params.after
        }), params.order && {
          order: params.order
        }), params.limit && {
          limit: params.limit.toString()
        }));
        return sendRequest({
          method: "GET" /* GET */,
          url: `/comments/threads?${queryParams}`
        });
      });
    },
    createPost(params) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "POST" /* POST */,
          url: `/comments/posts`,
          data: {
            channelKey: params.channelKey,
            content: params.content,
            _url: window.location.origin + window.location.pathname
          }
        });
      });
    },
    updatePost(params) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "PATCH" /* PATCH */,
          url: `/comments/posts/${params.postId}/update`,
          data: {
            content: params.content
          }
        });
      });
    },
    postVote(params) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "POST" /* POST */,
          url: `/comments/posts/${params.postId}/vote`,
          data: {
            vote: params.vote
          }
        });
      });
    },
    deletePost(params) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "DELETE" /* DELETE */,
          url: `/comments/posts/${params.postId}`
        });
      });
    },
    createThread(params) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "POST" /* POST */,
          url: `/comments/threads`,
          data: {
            postId: params.postId,
            content: params.content
          }
        });
      });
    },
    updateThread(params) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "PATCH" /* PATCH */,
          url: `/comments/threads/${params.threadId}/update`,
          data: {
            content: params.content
          }
        });
      });
    },
    // vote thread
    threadVote(params) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "POST" /* POST */,
          url: `/comments/threads/${params.threadId}/vote`,
          data: {
            vote: params.vote
          }
        });
      });
    },
    deleteThread(params) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "DELETE" /* DELETE */,
          url: `/comments/threads/${params.threadId}`
        });
      });
    },
    getSecureContent(params) {
      return __async(this, null, function* () {
        const data = yield sendRequest({
          method: "POST" /* POST */,
          url: "/secure-content",
          data: {
            contentId: params.contentId
          }
        });
        return data;
      });
    },
    signupWithProvider(params) {
      return __async(this, null, function* () {
        const customFields = encodeURIComponent(params.customFields ? JSON.stringify(params.customFields) : "{}");
        const plans = encodeURIComponent(params.plans ? JSON.stringify(params.plans) : "[]");
        const queryParams = new URLSearchParams(__spreadProps(__spreadValues({
          provider: params.provider,
          customFields,
          plans,
          appId
        }, publicKey && {
          publicKey
        }), {
          origin: window.location.hostname
        }));
        return openSignInWindow(`${domain}/auth-provider/signup?${queryParams}`, "signup");
      });
    },
    loginWithProvider(params) {
      return __async(this, null, function* () {
        const allowSignup = encodeURIComponent(params.allowSignup === true ? true : false);
        const queryParams = new URLSearchParams(__spreadProps(__spreadValues({
          provider: params.provider,
          appId
        }, publicKey && {
          publicKey
        }), {
          origin: window.location.hostname,
          allowSignup
        }));
        return openSignInWindow(`${domain}/auth-provider/login?${queryParams}`, "login");
      });
    },
    connectProvider(params) {
      return __async(this, null, function* () {
        const queryParams = new URLSearchParams(__spreadProps(__spreadValues({
          provider: params.provider,
          appId
        }, publicKey && {
          publicKey
        }), {
          member: getMemberToken(),
          origin: window.location.hostname
        }));
        return openSignInWindow(`${domain}/auth-provider/connect?${queryParams}`, "connect");
      });
    },
    disconnectProvider(params) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "POST" /* POST */,
          url: "/member/disconnect-provider",
          data: {
            provider: params.provider
          }
        });
      });
    },
    getAppAndMember(params) {
      return __async(this, null, function* () {
        const queryParams = new URLSearchParams({
          // @ts-ignore
          includeSSOText: window == null ? void 0 : window.ssoUI,
          trackPageView: params == null ? void 0 : params.trackPageView
        });
        return sendRequest({
          method: "GET" /* GET */,
          url: `/app-member?${queryParams}`
        });
      });
    },
    getApp() {
      return __async(this, null, function* () {
        const queryParams = new URLSearchParams({
          // @ts-ignore
          includeSSOText: window == null ? void 0 : window.ssoUI
        });
        return sendRequest({
          method: "GET" /* GET */,
          url: `/app?${queryParams}`
        });
      });
    },
    loginMemberEmailPassword(params, options) {
      return __async(this, null, function* () {
        const data = yield sendRequest({
          method: "POST" /* POST */,
          url: `/auth/login`,
          data: {
            email: params.email,
            password: params.password,
            options
          }
        });
        const sessionDurationDays = getSessionDurationDays(data.data.tokens.expires);
        setPersistedMember(data.data.member);
        setMemberToken(data.data.tokens.accessToken, sessionDurationDays);
        return data;
      });
    },
    sendMemberLoginPasswordlessEmail(params, options) {
      return __async(this, null, function* () {
        return yield sendRequest({
          method: "POST" /* POST */,
          url: `/auth/passwordless/login/send`,
          data: {
            email: params.email
          }
        });
      });
    },
    sendMemberSignupPasswordlessEmail(params, options) {
      return __async(this, null, function* () {
        return yield sendRequest({
          method: "POST" /* POST */,
          url: `/auth/passwordless/signup/send`,
          data: {
            email: params.email
          }
        });
      });
    },
    loginMemberPasswordless(params, options) {
      return __async(this, null, function* () {
        const data = yield sendRequest({
          method: "POST" /* POST */,
          url: `/auth/passwordless/login`,
          data: {
            passwordlessToken: params.passwordlessToken,
            email: params.email,
            options
          }
        });
        const sessionDurationDays = getSessionDurationDays(data.data.tokens.expires);
        setPersistedMember(data.data.member);
        setMemberToken(data.data.tokens.accessToken, sessionDurationDays);
        return data;
      });
    },
    getPlan(params) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "GET" /* GET */,
          url: `/app/plans/${params.planId}`
        });
      });
    },
    getPlans() {
      return __async(this, null, function* () {
        const { data } = yield sendRequest({
          method: "GET" /* GET */,
          url: `/app`
        });
        return {
          data: data.plans
        };
      });
    },
    getRestrictedUrlGroups() {
      return __async(this, null, function* () {
        const { data } = yield sendRequest({
          method: "GET" /* GET */,
          url: `/app`
        });
        return {
          data: data.contentGroups
        };
      });
    },
    getCurrentMember(options) {
      return __async(this, null, function* () {
        const memberToken = getMemberToken();
        if (!memberToken)
          return { data: null };
        const getMemberRequest = sendRequest({
          method: "GET" /* GET */,
          url: `/member`,
          headers: addHeaders(options)
        });
        function setMember() {
          return __async(this, null, function* () {
            const data = yield getMemberRequest;
            updatePersistedMember(data.data);
          });
        }
        setMember();
        if ((options == null ? void 0 : options.useCache) === true) {
          const member = getPersistedMember();
          return { data: member };
        } else {
          return getMemberRequest;
        }
      });
    },
    getMemberJSON(options) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "GET" /* GET */,
          url: `/member/json`,
          headers: addHeaders(options)
        });
      });
    },
    updateMemberJSON(params, options) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "POST" /* POST */,
          url: `/member/json`,
          data: {
            json: params.json
          },
          headers: addHeaders(options)
        });
      });
    },
    addPlan(params, options) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "POST" /* POST */,
          url: `/member/plans/add`,
          data: {
            planId: params.planId
          },
          headers: addHeaders(options)
        });
      });
    },
    purchasePlansWithCheckout(params, options) {
      return __async(this, null, function* () {
        function getRedirectURL(URL) {
          let redirectUrl = window.location.href;
          const urlParam = URL;
          if (urlParam) {
            if (urlParam.indexOf("http://") === 0 || urlParam.indexOf("https://") === 0) {
              redirectUrl = urlParam;
            } else {
              redirectUrl = window.location.origin + urlParam;
            }
          }
          return redirectUrl;
        }
        const success_url = params.successUrl ? getRedirectURL(params.successUrl) : void 0;
        const cancel_url = getRedirectURL(params.cancelUrl);
        const request = yield sendRequest({
          method: "POST" /* POST */,
          url: `/member/plans/create-checkout-session`,
          data: {
            priceId: params.priceId,
            couponId: params.couponId,
            metadataForCheckout: params.metadataForCheckout,
            //window.location requires dom
            success_url,
            cancel_url,
            origin_url: window.location.href
          },
          headers: addHeaders(options)
        });
        if (params.autoRedirect === false) {
          return request;
        }
        window.location.href = request.data.url;
      });
    },
    // used for plan updates
    launchStripeCustomerPortal(params, options) {
      return __async(this, null, function* () {
        function getRedirectURL(URL) {
          let redirectUrl = window.location.href;
          const urlParam = URL;
          if (urlParam) {
            if (urlParam.indexOf("http://") === 0 || urlParam.indexOf("https://") === 0) {
              redirectUrl = urlParam;
            } else {
              redirectUrl = window.location.origin + urlParam;
            }
          }
          return redirectUrl;
        }
        const returnUrl = (params == null ? void 0 : params.returnUrl) ? getRedirectURL(params.returnUrl) : void 0;
        const request = yield sendRequest({
          method: "POST" /* POST */,
          url: `/member/create-billing-portal-session`,
          data: __spreadValues({
            //window.location requires dom
            return_url: returnUrl,
            origin_url: window.location.href
          }, params && {
            priceIds: params.priceIds,
            configuration: params.configuration
          }),
          headers: addHeaders(options)
        });
        if ((params == null ? void 0 : params.autoRedirect) === false) {
          return request;
        }
        window.location.href = request.data.url;
      });
    },
    removePlan(params, options) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "POST" /* POST */,
          url: `/member/plans/remove`,
          data: {
            planId: params.planId
          },
          headers: addHeaders(options)
        });
      });
    },
    updateMember(params, options) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "POST" /* POST */,
          url: `/member`,
          data: __spreadValues({}, params.customFields && { customFields: params.customFields }),
          headers: addHeaders(options)
        });
      });
    },
    updateMemberAuth(params, options) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "POST" /* POST */,
          url: `/member-auth`,
          data: __spreadValues(__spreadValues(__spreadValues({}, params.email && { email: params.email }), params.oldPassword && { oldPassword: params.oldPassword }), params.newPassword && { newPassword: params.newPassword }),
          headers: addHeaders(options)
        });
      });
    },
    setPassword(params, options) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "POST" /* POST */,
          url: `/member/set-password`,
          data: {
            password: params.password
          },
          headers: addHeaders(options)
        });
      });
    },
    signupMemberPasswordless(params, options) {
      return __async(this, null, function* () {
        var _a2, _b;
        const data = yield sendRequest({
          method: "POST" /* POST */,
          url: `/auth/signup?isPasswordless=true`,
          data: __spreadValues(__spreadProps(__spreadValues({
            email: params.email,
            customFields: params.customFields,
            passwordlessToken: params.passwordlessToken,
            metaData: params.metaData
          }, params.plans && { plans: params.plans }), {
            //internal use only
            origin_domain: window.location.origin,
            options
          }), ((_a2 = window.Rewardful) == null ? void 0 : _a2.referral) && {
            rewardfulData: {
              // @ts-ignore
              referral: window.Rewardful.referral,
              // @ts-ignore
              coupon: (_b = window.Rewardful.coupon) == null ? void 0 : _b.id
            }
          })
        });
        const sessionDurationDays = getSessionDurationDays(data.data.tokens.expires);
        setPersistedMember(data.data.member);
        setMemberToken(data.data.tokens.accessToken, sessionDurationDays);
        return data;
      });
    },
    signupMemberEmailPassword(params, options) {
      return __async(this, null, function* () {
        var _a2, _b;
        const data = yield sendRequest({
          method: "POST" /* POST */,
          url: `/auth/signup`,
          data: __spreadValues(__spreadProps(__spreadValues({
            email: params.email,
            password: params.password,
            customFields: params.customFields,
            metaData: params.metaData,
            captchaToken: params.captchaToken,
            inviteToken: params.inviteToken
          }, params.plans && { plans: params.plans }), {
            //internal use only
            origin_domain: window.location.origin,
            options
          }), ((_a2 = window.Rewardful) == null ? void 0 : _a2.referral) && {
            rewardfulData: {
              // @ts-ignore
              referral: window.Rewardful.referral,
              // @ts-ignore
              coupon: (_b = window.Rewardful.coupon) == null ? void 0 : _b.id
            }
          })
        });
        const sessionDurationDays = getSessionDurationDays(data.data.tokens.expires);
        setPersistedMember(data.data.member);
        setMemberToken(data.data.tokens.accessToken, sessionDurationDays);
        return data;
      });
    },
    joinTeam(params, options) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "POST" /* POST */,
          url: `/member/team/join`,
          data: {
            inviteToken: params.inviteToken
          },
          headers: addHeaders(options)
        });
      });
    },
    getTeam(params, options) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "GET" /* GET */,
          url: `/member/team/${params.teamId}`,
          headers: addHeaders(options)
        });
      });
    },
    removeMemberFromTeam(params, options) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "POST" /* POST */,
          url: `/member/team/remove-member`,
          data: {
            teamId: params.teamId,
            memberId: params.memberId
          },
          headers: addHeaders(options)
        });
      });
    },
    generateInviteToken(params, options) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "POST" /* POST */,
          url: `/member/team/generate-invite-link`,
          data: {
            teamId: params.teamId
          },
          headers: addHeaders(options)
        });
      });
    },
    updateMemberProfileImage(params) {
      return __async(this, null, function* () {
        if (params.profileImage) {
          const formData = new FormData();
          formData.append("profileImage", params.profileImage);
          return sendRequest({
            method: "POST" /* POST */,
            url: `/member/profile-image`,
            data: formData,
            contentType: "multipart/form-data"
          });
        }
      });
    },
    sendMemberVerificationEmail() {
      return __async(this, null, function* () {
        return sendRequest({
          method: "POST" /* POST */,
          url: `/auth/send-email-verification`,
          data: {
            //internal use only
            origin_domain: window.location.origin
          }
        });
      });
    },
    sendMemberResetPasswordEmail(params) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "POST" /* POST */,
          url: `/auth/send-reset-password-email`,
          data: {
            email: params.email
          }
        });
      });
    },
    resetMemberPassword(params) {
      return __async(this, null, function* () {
        return sendRequest({
          method: "POST" /* POST */,
          url: `/auth/reset-password`,
          data: {
            token: params.token,
            newPassword: params.newPassword
          }
        });
      });
    },
    logout(options) {
      return __async(this, null, function* () {
        const data = yield sendRequest({
          method: "POST" /* POST */,
          url: `/member/logout`,
          headers: addHeaders(options)
        });
        unsetPersistedMember();
        return data;
      });
    }
  };
};

// src/methods/index.ts
var captchaReadyPromise = new Promise((resolve) => {
  if (typeof window !== "undefined") {
    window._hcaptchaReady = resolve;
  }
});
var methods = {
  openModal,
  hideModal,
  _hideLoader: hideLoader,
  _showLoader: showLoader,
  _showMessage: showMessage,
  getMemberCookie: getMemberToken,
  onAuthChange,
  _captchaReady: captchaReadyPromise
};
function init2(props) {
  const apiDomain2 = props.domain || endpoints.API;
  setApiDomain(apiDomain2);
  if (props.useCookies)
    setUseCookies(props.setCookieOnRootDomain);
  setMemberTokenIfAvailable();
  const requests = initRequest({
    publicKey: props.publicKey,
    appId: props.appId,
    token: getMemberToken(),
    domain: apiDomain2
  });
  const allMethods = Object.assign(methods, requests);
  if (typeof window !== "undefined") {
    window.$memberstackDom = allMethods;
  }
  return allMethods;
}
var methods_default = { init: (props) => init2(props) };

// src/index.ts
var src_default = { init: methods_default.init };
export {
  src_default as default
};
